/* eslint-disable */
// This file is auto-generated by sbegen, do not edit!
// If you want to re-generate this file:
// - clone the Ava repo, cd to the root directory (follow the instructions in the README for your env setup)
// - run 'make regen_gocode'
// - open 'gocode/sbe/types.ts' and copy the output to the normal location in Ava-UI

export const AddressRoutingTypeEnum = {
  /** Fiat routing info type */
  Fiat: 'Fiat',
  /** Crypto routing info type */
  Crypto: 'Crypto',
} as const;
export type AddressRoutingTypeEnum = (typeof AddressRoutingTypeEnum)[keyof typeof AddressRoutingTypeEnum];

export const AggregationTypeEnum = {
  /** System */
  System: 'System',
  /** Customer */
  Customer: 'Customer',
  /** User */
  User: 'User',
} as const;
export type AggregationTypeEnum = (typeof AggregationTypeEnum)[keyof typeof AggregationTypeEnum];

export const AggregationWindowEnum = {
  /** One month */
  AggregationWindow_1MO: 'AggregationWindow_1MO',
  /** One week */
  AggregationWindow_1W: 'AggregationWindow_1W',
  /** One day */
  AggregationWindow_1D: 'AggregationWindow_1D',
  /** Last 7 days */
  AggregationWindow_L7D: 'AggregationWindow_L7D',
  /** Last 30 days */
  AggregationWindow_L30D: 'AggregationWindow_L30D',
  /** Month to Date */
  AggregationWindow_MTD: 'AggregationWindow_MTD',
  /** Week to Date */
  AggregationWindow_WTD: 'AggregationWindow_WTD',
} as const;
export type AggregationWindowEnum = (typeof AggregationWindowEnum)[keyof typeof AggregationWindowEnum];

export const AggregatorDebugFlagEnum = {
  /** Pass Debug Flag to Aggregator ViewModel */
  Debug: 'Debug',
  /** Include Stale Markets in MarketDataSnapshot */
  IncludeStale: 'IncludeStale',
  /** Include market status in ReferenceRateSnapshot */
  RefRateIncludeMarkets: 'RefRateIncludeMarkets',
  /** Include Variance in ReferenceRateSnapshot */
  RefRateIncludeVariance: 'RefRateIncludeVariance',
  /** Include SpreadMeasure in ReferenceRateSnapshot */
  RefRateIncludeSpreadMeasure: 'RefRateIncludeSpreadMeasure',
} as const;
export type AggregatorDebugFlagEnum = (typeof AggregatorDebugFlagEnum)[keyof typeof AggregatorDebugFlagEnum];

export const AggressorFlagEnum = {
  /** Passive */
  Passive: 'Passive',
  /** Active */
  Active: 'Active',
  /** Dealer */
  Dealer: 'Dealer',
} as const;
export type AggressorFlagEnum = (typeof AggressorFlagEnum)[keyof typeof AggressorFlagEnum];

export const AlgoConfigurationParameterEnum = {
  /** Number of resting levels */
  NumRestingLevels: 'NumRestingLevels',
  /** Sweep dealer markets */
  SweepDealerMarkets: 'SweepDealerMarkets',
  /** Trade size multiplier */
  TradeSizeMultiplier: 'TradeSizeMultiplier',
  /** Child order slippage */
  ChildOrderSlippage: 'ChildOrderSlippage',
  /** Anti gaming exclude small sizes */
  AntiGamingExcludeSmallSizes: 'AntiGamingExcludeSmallSizes',
  /** Sweep dealer markets */
  AntiGamingPriceLevelMinAgeMillis: 'AntiGamingPriceLevelMinAgeMillis',
  /** Anti gaming min size adjustment */
  AntiGamingMinSizeAdjustment: 'AntiGamingMinSizeAdjustment',
  /** Anti gaming max levels to skip */
  AntiGamingMaxLevelsToSkip: 'AntiGamingMaxLevelsToSkip',
  /** Anti gaming only skip top levels */
  AntiGamingOnlySkipTopLevels: 'AntiGamingOnlySkipTopLevels',
  /** Deeper resting levels enabled */
  DeeperRestingLevelsEnabled: 'DeeperRestingLevelsEnabled',
  /** Auto reschedule behind ratio threshold */
  AutoRescheduleBehindRatioThreshold: 'AutoRescheduleBehindRatioThreshold',
  /** Auto reschedule tob size multiplier */
  AutoRescheduleTobSizeMultiplier: 'AutoRescheduleTobSizeMultiplier',
  /** Auto reschedule max attempt */
  AutoRescheduleMaxAttempt: 'AutoRescheduleMaxAttempt',
  /** Auto reschedule disable period millis */
  AutoRescheduleDisablePeriodMillis: 'AutoRescheduleDisablePeriodMillis',
  /** Auto reschedule wait period millis */
  AutoRescheduleWaitPeriodMillis: 'AutoRescheduleWaitPeriodMillis',
  /** Crossing agent max levels to consider for clip size */
  CrossingAgentMaxLevelsToConsiderForClipSize: 'CrossingAgentMaxLevelsToConsiderForClipSize',
  /** Crossing agent max clip size multiplier */
  CrossingAgentMaxClipSizeMultiplier: 'CrossingAgentMaxClipSizeMultiplier',
  /** Crossing agent max price through slippage */
  CrossingAgentMaxPriceThroughSlippage: 'CrossingAgentMaxPriceThroughSlippage',
  /** Crossing agent max size variance */
  CrossingAgentSizeVariance: 'CrossingAgentSizeVariance',
  /** Crossing agent min trade size in usd */
  CrossingAgentMinTradeSizeInUSD: 'CrossingAgentMinTradeSizeInUSD',
  /** Trade size throttle millis */
  TradeSizeThrottleMillis: 'TradeSizeThrottleMillis',
  /** Price protection disabled */
  PriceProtectionDisabled: 'PriceProtectionDisabled',
  /** Price protection exclusion threshold */
  PriceProtectionExclusionThreshold: 'PriceProtectionExclusionThreshold',
  /** Price protection passive price update seconds */
  PriceProtectionPassivePriceUpdateSeconds: 'PriceProtectionPassivePriceUpdateSeconds',
  /** Price protection passive leeway spread multiplier */
  PriceProtectionPassiveLeewaySpreadMultiplier: 'PriceProtectionPassiveLeewaySpreadMultiplier',
  /** Price protection aggressive price update seconds */
  PriceProtectionAggressivePriceUpdateSeconds: 'PriceProtectionAggressivePriceUpdateSeconds',
  /** Price protection aggressive leeway spread multiplier */
  PriceProtectionAggressiveLeewaySpreadMultiplier: 'PriceProtectionAggressiveLeewaySpreadMultiplier',
  /** Price protection SOR bps threshold */
  PriceProtectionSORThresholdBps: 'PriceProtectionSORThresholdBps',
  /** Price protection SOR usd loss threshold */
  PriceProtectionSORLossThresholdUsd: 'PriceProtectionSORLossThresholdUsd',
  /** Multileg max rest outside bps threshold */
  MultilegMaxRestOutsideThresholdBps: 'MultilegMaxRestOutsideThresholdBps',
  /** Multileg limit random resting qty USD threshold */
  MultilegLimitRandomRestingQtyThresholdUSD: 'MultilegLimitRandomRestingQtyThresholdUSD',
  /** Max percent of order ahead */
  MaxPercentOfOrderAhead: 'MaxPercentOfOrderAhead',
  /** Max percent of order behind */
  MaxPercentOfOrderBehind: 'MaxPercentOfOrderBehind',
  /** Max seconds ahead of schedule */
  MaxSecondsAheadOfSchedule: 'MaxSecondsAheadOfSchedule',
  /** Max seconds behind schedule */
  MaxSecondsBehindSchedule: 'MaxSecondsBehindSchedule',
  /** Max percent leg behind to hedge */
  MaxPercentLegBehindToHedge: 'MaxPercentLegBehindToHedge',
  /** Max percent of volume behind */
  MaxPercentOfVolumeBehind: 'MaxPercentOfVolumeBehind',
  /** Min target participation rate */
  MinTargetParticipationRate: 'MinTargetParticipationRate',
  /** Mid target participate rate */
  MidTargetParticipationRate: 'MidTargetParticipationRate',
  /** Max target participate rate */
  MaxTargetParticipationRate: 'MaxTargetParticipationRate',
  /** Minimum market volume predictability percentage */
  MinimumMarketVolumePredictabilityPercentage: 'MinimumMarketVolumePredictabilityPercentage',
  /** Enable conditional crossing based on spread changes for algo orders */
  EnableReactiveSpreadCrossing: 'EnableReactiveSpreadCrossing',
  /** Minimum spread multiplier */
  ReactiveSpreadMinMultiplier: 'ReactiveSpreadMinMultiplier',
  /** Maximum spread multiplier */
  ReactiveSpreadMaxMultiplier: 'ReactiveSpreadMaxMultiplier',
  /** Disable parallel lower bound for TWAPs */
  DisableTwapParallelLowerBound: 'DisableTwapParallelLowerBound',
  /** When set, the highest supported TimeInForce value is used for crossing child orders */
  UseHighestTimeInForceForCrossing: 'UseHighestTimeInForceForCrossing',
  /** Enable price cap for TWAP resting orders */
  EnableTwapRestingPriceCap: 'EnableTwapRestingPriceCap',
  /** Minimum USD amount required for resting */
  MinRestingSizeInUSD: 'MinRestingSizeInUSD',
  /** Aggressive child orders should be aligned or not */
  AlignAggressiveChildOrders: 'AlignAggressiveChildOrders',
  /** Mean response time for a given market when aligning child orders */
  MeanMarketResponseTimeMillis: 'MeanMarketResponseTimeMillis',
  /** Threshold for reduce first resting orders to activate the feature */
  ReduceFirstRestingThresholdActivate: 'ReduceFirstRestingThresholdActivate',
  /** Threshold for reduce first resting orders to deactivate the feature */
  ReduceFirstRestingThresholdDeactivate: 'ReduceFirstRestingThresholdDeactivate',
  /** Percentage of the full order qty to use as a threshold for clip based algos when there is residual quantity */
  ClipBasedResidualQtyThreshold: 'ClipBasedResidualQtyThreshold',
  /** Clean up period millis (as used in TWAP/VWAP) */
  CleanUpPeriod: 'CleanUpPeriod',
  /** A factor exposure limit to be adjusted with before calculating available exposure */
  ExposureLimitFactor: 'ExposureLimitFactor',
} as const;
export type AlgoConfigurationParameterEnum =
  (typeof AlgoConfigurationParameterEnum)[keyof typeof AlgoConfigurationParameterEnum];

export const AlgoInstructionsEnum = {
  /** PostOnly */
  PostOnly: 'PostOnly',
  /** Iceberg */
  Iceberg: 'Iceberg',
  /** FullAmount */
  FullAmount: 'FullAmount',
  /** Passthrough */
  Passthrough: 'Passthrough',
  /** LegCrossingToInitiate */
  LegCrossingToInitiate: 'LegCrossingToInitiate',
  /** LegRestingToInitiate */
  LegRestingToInitiate: 'LegRestingToInitiate',
  /** LegRestPegged */
  LegRestPegged: 'LegRestPegged',
  /** LegHedgePassivePegged */
  LegHedgePassivePegged: 'LegHedgePassivePegged',
  /** LegHedgeAggressiveAtMarket */
  LegHedgeAggressiveAtMarket: 'LegHedgeAggressiveAtMarket',
  /** LegRestingAgainstPassiveExit */
  LegRestingAgainstPassiveExit: 'LegRestingAgainstPassiveExit',
  /** MakerOnly */
  MakerOnly: 'MakerOnly',
} as const;
export type AlgoInstructionsEnum = (typeof AlgoInstructionsEnum)[keyof typeof AlgoInstructionsEnum];

export const AlgoTypeEnum = {
  /** Default strategy type */
  Base: 'Base',
  /** TWAP strategy */
  TWAP: 'TWAP',
  /** Pegged strategy */
  Pegged: 'Pegged',
  /** TimeSliced strategy */
  TimeSliced: 'TimeSliced',
  /** SteadyPace strategy */
  SteadyPace: 'SteadyPace',
  /** Percentage of volume strategy */
  POV: 'POV',
  /** Volume weighted average strategy */
  VWAP: 'VWAP',
  /** Scaled order strategy */
  Scaled: 'Scaled',
} as const;
export type AlgoTypeEnum = (typeof AlgoTypeEnum)[keyof typeof AlgoTypeEnum];

export const AllocationReasonEnum = {
  /** OpportunisticSpread */
  OpportunisticSpread: 'OpportunisticSpread',
  /** OpportunisticCross */
  OpportunisticCross: 'OpportunisticCross',
  /** SnipeBasedOnBounds */
  SnipeBasedOnBounds: 'SnipeBasedOnBounds',
  /** SweepBasedOnBounds */
  SweepBasedOnBounds: 'SweepBasedOnBounds',
} as const;
export type AllocationReasonEnum = (typeof AllocationReasonEnum)[keyof typeof AllocationReasonEnum];

export const AllocationRequestTypeEnum = {
  /** New */
  New: 'New',
  /** Update */
  Update: 'Update',
  /** Close */
  Close: 'Close',
} as const;
export type AllocationRequestTypeEnum = (typeof AllocationRequestTypeEnum)[keyof typeof AllocationRequestTypeEnum];

export const AllocationStatusEnum = {
  /** Open */
  Open: 'Open',
  /** Closed */
  Closed: 'Closed',
} as const;
export type AllocationStatusEnum = (typeof AllocationStatusEnum)[keyof typeof AllocationStatusEnum];

export const AllocationTypeEnum = {
  /** Resting */
  Resting: 'Resting',
  /** Crossing */
  Crossing: 'Crossing',
} as const;
export type AllocationTypeEnum = (typeof AllocationTypeEnum)[keyof typeof AllocationTypeEnum];

export const AllocationValueTypeEnum = {
  /** Percentage */
  Percentage: 'Percentage',
  /** Quantity */
  Quantity: 'Quantity',
} as const;
export type AllocationValueTypeEnum = (typeof AllocationValueTypeEnum)[keyof typeof AllocationValueTypeEnum];

export const AnalyticsOrderDepthEnum = {
  /** Parent */
  Parent: 'Parent',
  /** Child */
  Child: 'Child',
} as const;
export type AnalyticsOrderDepthEnum = (typeof AnalyticsOrderDepthEnum)[keyof typeof AnalyticsOrderDepthEnum];

export const AnalyticsSpreadTypeEnum = {
  /** BidHalfSpread */
  BidHalfSpread: 'BidHalfSpread',
  /** AskHalfSpread */
  AskHalfSpread: 'AskHalfSpread',
  /** RFQHalfSpread */
  RFQHalfSpread: 'RFQHalfSpread',
} as const;
export type AnalyticsSpreadTypeEnum = (typeof AnalyticsSpreadTypeEnum)[keyof typeof AnalyticsSpreadTypeEnum];

export const ApiPermissionActionEnum = {
  /** All */
  All: 'All',
  /** Read */
  Read: 'Read',
  /** Write */
  Write: 'Write',
  /** Admin */
  Admin: 'Admin',
} as const;
export type ApiPermissionActionEnum = (typeof ApiPermissionActionEnum)[keyof typeof ApiPermissionActionEnum];

export const ApprovalDecisionEnum = {
  /** Request approved */
  Approved: 'Approved',
  /** Request denied */
  Denied: 'Denied',
} as const;
export type ApprovalDecisionEnum = (typeof ApprovalDecisionEnum)[keyof typeof ApprovalDecisionEnum];

export const ApprovalDecisionDeniedReasonEnum = {
  /** Child command risks overfilling parent order */
  AvailableQtyViolation: 'AvailableQtyViolation',
  /** Child command targets market not allowed by parent order */
  MarketViolation: 'MarketViolation',
  /** Child command currency does not match parent order currency units */
  CurrencyMismatch: 'CurrencyMismatch',
  /** Child command settle date does not match parent */
  SettleDateMismatch: 'SettleDateMismatch',
  /** Child command subaccount does not match parent */
  SubAccountMismatch: 'SubAccountMismatch',
  /** Child risk cannot be opened at this care order status */
  StatusViolation: 'StatusViolation',
  /** Child command side does not match parent order side */
  SideViolation: 'SideViolation',
} as const;
export type ApprovalDecisionDeniedReasonEnum =
  (typeof ApprovalDecisionDeniedReasonEnum)[keyof typeof ApprovalDecisionDeniedReasonEnum];

export const ArchivedStatusEnum = {
  /** order is not archived */
  UnArchived: 'UnArchived',
  /** order is archived */
  Archived: 'Archived',
} as const;
export type ArchivedStatusEnum = (typeof ArchivedStatusEnum)[keyof typeof ArchivedStatusEnum];

export const AssetTransactionActionEnum = {
  /** New */
  New: 'New',
  /** Updated */
  Updated: 'Updated',
  /** Canceled */
  Canceled: 'Canceled',
  /** AmendDelta */
  AmendDelta: 'AmendDelta',
  /** Moved to Settled status */
  Settled: 'Settled',
  /** Resubmitted for SubAccount allocation inference */
  Resubmitted: 'Resubmitted',
} as const;
export type AssetTransactionActionEnum = (typeof AssetTransactionActionEnum)[keyof typeof AssetTransactionActionEnum];

export const AssetTransactionAllocationStatusEnum = {
  /** Unset initial state */
  Unallocated: 'Unallocated',
  /** Inferred based on account mappings and position sizes */
  Inferred: 'Inferred',
  /** Manually set by a user */
  Manual: 'Manual',
  /** Explicitly left unallocated by allocation control rule */
  ExplicitlyUnallocated: 'ExplicitlyUnallocated',
  /** Attempted, but unallocated because no rules applied */
  ImplicitlyUnallocated: 'ImplicitlyUnallocated',
  /** Can be allocated / inferred  */
  PendingSettlement: 'PendingSettlement',
} as const;
export type AssetTransactionAllocationStatusEnum =
  (typeof AssetTransactionAllocationStatusEnum)[keyof typeof AssetTransactionAllocationStatusEnum];

export const AssetTransactionPriceSourceEnum = {
  /** Price source not specified (default value) */
  Unspecified: 'Unspecified',
  /** Talos defined market mid-point */
  Internal: 'Internal',
  /** Provided by the user, exchange, etc */
  External: 'External',
} as const;
export type AssetTransactionPriceSourceEnum =
  (typeof AssetTransactionPriceSourceEnum)[keyof typeof AssetTransactionPriceSourceEnum];

export const AssetTransactionSettlementStatusEnum = {
  /** Settled, previously unseen */
  Settled: 'Settled',
  /** Unsettled */
  Unsettled: 'Unsettled',
  /** DEPRECATED. This value is no longer used. */
  SettledButWasUnsettled: 'SettledButWasUnsettled',
} as const;
export type AssetTransactionSettlementStatusEnum =
  (typeof AssetTransactionSettlementStatusEnum)[keyof typeof AssetTransactionSettlementStatusEnum];

export const AssetTransactionSourceTypeEnum = {
  /** Received from external source */
  External: 'External',
  /** Generated based on a trade */
  Trade: 'Trade',
  /** Generated by a recon */
  Recon: 'Recon',
  /** Generated manually */
  Manual: 'Manual',
  /** Generated internally */
  Internal: 'Internal',
} as const;
export type AssetTransactionSourceTypeEnum =
  (typeof AssetTransactionSourceTypeEnum)[keyof typeof AssetTransactionSourceTypeEnum];

export const AssetTransactionTypeEnum = {
  /** Misc transactions that affect balances */
  Misc: 'Misc',
  /** Derivative funding event. May affect RealizedPnL */
  Funding: 'Funding',
  /** PnL realization event */
  RealizedPnL: 'RealizedPnL',
  /** DEPRECATED. These are ignored in the ledger. They remain in the schema definition so we can still parse historical data that uses this. Gateways should never produce these; for actual fees associated with a trade, put the fee on the trade instead; otherwise, look for another suitable Fee asset transaction type. */
  TradingFee: 'TradingFee',
  /** Delivery fees. */
  DeliveryFee: 'DeliveryFee',
  /** Settlement fees. */
  SettlementFee: 'SettlementFee',
  /** Deposits. */
  Deposit: 'Deposit',
  /** Withdrawals. */
  Withdrawal: 'Withdrawal',
  /** Transfers. */
  Transfer: 'Transfer',
  /** Deposit fees. */
  DepositFee: 'DepositFee',
  /** Withdrawal fees. */
  WithdrawalFee: 'WithdrawalFee',
  /** Transfer fees. */
  TransferFee: 'TransferFee',
  /** [DEPRECATED AND UNUSED. These are silently dropped in the ledger.] Balance change due to spot trade */
  SpotTrade: 'SpotTrade',
  /** Transfer fees. */
  Liquidation: 'Liquidation',
  /** Transfer fees. */
  LiquidationFee: 'LiquidationFee',
  /** Unrealized (floating) PnL */
  UnrealizedPnL: 'UnrealizedPnL',
  /** Delivery of a deliverable contract (e.g. Options/Futures). Affects position. */
  Delivery: 'Delivery',
  /** Recon adjustment */
  ReconAdjustment: 'ReconAdjustment',
  /** Reward from staked assets */
  StakingReward: 'StakingReward',
  /** Fee for reward from staked assets */
  StakingRewardFee: 'StakingRewardFee',
  /** Settlement / credit reset */
  Settlement: 'Settlement',
  /** Preliminary amount for creating shares of a fund. */
  PreliminaryCreate: 'PreliminaryCreate',
  /** Final amount for creating shares of a fund. */
  FinalCreate: 'FinalCreate',
  /** Preliminary amount for redeeming shares of a fund. */
  PreliminaryRedeem: 'PreliminaryRedeem',
  /** Final amount for redeeming shares of a fund. */
  FinalRedeem: 'FinalRedeem',
  /** Management fee charged for managing a fund. */
  ManagementFee: 'ManagementFee',
  /** Interest paid or charged for cash held in a deposit savings account. */
  DepositInterest: 'DepositInterest',
  /** Miscellaneous fee. */
  MiscFee: 'MiscFee',
  /** Cash disbursement (lender side) or receipt (borrower side) at loan origination or drawdown. */
  LoanPrincipal: 'LoanPrincipal',
  /** Return of principal by the borrower. */
  LoanPrincipalRepayment: 'LoanPrincipalRepayment',
  /** Collateral transferred to secure the loan, from borrower to lender. */
  CollateralPost: 'CollateralPost',
  /** Full return of collateral to borrower at loan termination. */
  CollateralRelease: 'CollateralRelease',
  /** Return of the original collateral asset to the borrower / repo seller. */
  CollateralSubstitutionOut: 'CollateralSubstitutionOut',
  /** Receipt of the replacement collateral asset (swap of collateral). */
  CollateralSubstitutionIn: 'CollateralSubstitutionIn',
  /** Coupon / interest payment when it settles. */
  LoanInterest: 'LoanInterest',
  /** Penalty cash payment when an interest or principal payment is overdue. Configured as Late Fee % on the MLA. */
  LateFee: 'LateFee',
  /** Penalty for early repayment. */
  PrepaymentFee: 'PrepaymentFee',
  /** One-time fee charged at loan origination. */
  OriginationFee: 'OriginationFee',
  /** Cash settlement of a margin call on a repo (alternative to posting additional collateral). */
  CashMarginPayment: 'CashMarginPayment',
  /** Income earned on collateral during the life of a repo (e.g. staking rewards on ETH, coupon on a tokenised bond) passed through to the original owner. */
  ManufacturedPayment: 'ManufacturedPayment',
  /** Cash received from selling seized collateral after a default. For loans: output of the liquidation process. For repos: close-out netting settlement. Net amount may result in a payment to the defaulting party (excess) or a claim against them (shortfall). */
  LiquidationProceeds: 'LiquidationProceeds',
  /** An externally sourced reconciliation adjustment that affects balances. */
  ExternalReconAdjustment: 'ExternalReconAdjustment',
  /** Creation of fund shares in exchange for a basket of constituent assets rather than cash. */
  InKindCreate: 'InKindCreate',
  /** Redemption of fund shares in exchange for a basket of constituent assets rather than cash. */
  InKindRedeem: 'InKindRedeem',
  /** PnL event for when marking derivative positions. */
  MarkToMarketPnL: 'MarkToMarketPnL',
  /** Fee charged by the dealer to its customer on a customer withdrawal. Internal only; distinct from WithdrawalFee, which is reported by a custody provider or venue. */
  CustomerWithdrawalFee: 'CustomerWithdrawalFee',
} as const;
export type AssetTransactionTypeEnum = (typeof AssetTransactionTypeEnum)[keyof typeof AssetTransactionTypeEnum];

export const AssetTransactionUpdateStatusEnum = {
  /** The update was successful. */
  OK: 'OK',
  /** The update was for an asset transaction that doesn't exist. */
  NotFound: 'NotFound',
  /** The update conflicted with the current state of the asset transaction. */
  Conflict: 'Conflict',
  /** The update arguments were invalid. */
  InvalidArgument: 'InvalidArgument',
  /** Something went wrong with handling the request. */
  InternalError: 'InternalError',
  /** The request was for a ClReqID already seen. */
  DuplicateRequest: 'DuplicateRequest',
} as const;
export type AssetTransactionUpdateStatusEnum =
  (typeof AssetTransactionUpdateStatusEnum)[keyof typeof AssetTransactionUpdateStatusEnum];

export const AuditLogEventTypeEnum = {
  /** All */
  All: 'All',
  /** MarketConnection */
  MarketConnection: 'MarketConnection',
  /** TradingLimit */
  TradingLimit: 'TradingLimit',
  /** Counterparty */
  Counterparty: 'Counterparty',
  /** UserCredential */
  UserCredential: 'UserCredential',
  /** Subaccount */
  Subaccount: 'Subaccount',
  /** ApiPermissionFilter */
  ApiPermissionFilter: 'ApiPermissionFilter',
  /** User */
  User: 'User',
  /** UserRole */
  UserRole: 'UserRole',
  /** ApiKey */
  ApiKey: 'ApiKey',
  /** ApiKeyRole */
  ApiKeyRole: 'ApiKeyRole',
  /** UserSession */
  UserSession: 'UserSession',
} as const;
export type AuditLogEventTypeEnum = (typeof AuditLogEventTypeEnum)[keyof typeof AuditLogEventTypeEnum];

export const BalanceEntryTypeEnum = {
  /** Balance Reset */
  BalanceReset: 'BalanceReset',
  /** Balance Update */
  BalanceUpdate: 'BalanceUpdate',
  /** Balance Stale */
  BalanceStale: 'BalanceStale',
  /** Balance Keepalive */
  BalanceKeepalive: 'BalanceKeepalive',
  /** Trades Offline */
  BalanceOffline: 'BalanceOffline',
} as const;
export type BalanceEntryTypeEnum = (typeof BalanceEntryTypeEnum)[keyof typeof BalanceEntryTypeEnum];

export const BalanceTransactionInitiatorEnum = {
  /** Balance transaction request was initiated by the customer */
  Customer: 'Customer',
  /** Balance transaction request was initiated by the dealer */
  Dealer: 'Dealer',
  /** Balance transaction was created from incoming transfer */
  Transfer: 'Transfer',
} as const;
export type BalanceTransactionInitiatorEnum =
  (typeof BalanceTransactionInitiatorEnum)[keyof typeof BalanceTransactionInitiatorEnum];

export const BasketConstituentTypeEnum = {
  /** Values are absolute quantities, e.g. 0.2 BTC and 5 ETH. */
  Quantity: 'Quantity',
} as const;
export type BasketConstituentTypeEnum = (typeof BasketConstituentTypeEnum)[keyof typeof BasketConstituentTypeEnum];

export const BookTypeEnum = {
  /** Raw market data */
  Raw: 'Raw',
  /** Market data is taker fee aware */
  TakerFeeAware: 'TakerFeeAware',
  /** Market data is maker fee aware */
  MakerFeeAware: 'MakerFeeAware',
} as const;
export type BookTypeEnum = (typeof BookTypeEnum)[keyof typeof BookTypeEnum];

export const BoolEnum = {
  /** True value */
  True: 'True',
  /** False value */
  False: 'False',
} as const;
export type BoolEnum = (typeof BoolEnum)[keyof typeof BoolEnum];

export const CareFillSourceTypeEnum = {
  /** A working order allocated its fills */
  WorkingOrder: 'WorkingOrder',
  /** Filled by a direct OMS child order */
  ChildOrder: 'ChildOrder',
  /** Filled by a manual command */
  ManualFill: 'ManualFill',
} as const;
export type CareFillSourceTypeEnum = (typeof CareFillSourceTypeEnum)[keyof typeof CareFillSourceTypeEnum];

export const CheckpointTypeEnum = {
  /** When checkpointing is done by trade timestamp */
  TimeBased: 'TimeBased',
  /** When checkpointing is done with a monotonically increasing execution ID */
  SequenceBased: 'SequenceBased',
} as const;
export type CheckpointTypeEnum = (typeof CheckpointTypeEnum)[keyof typeof CheckpointTypeEnum];

export const ClientFIXAdminActionEnum = {
  /** Bounce the session and reset both sequence numbers, starting a new FIX session */
  ResetSeqNum: 'ResetSeqNum',
} as const;
export type ClientFIXAdminActionEnum = (typeof ClientFIXAdminActionEnum)[keyof typeof ClientFIXAdminActionEnum];

export const ClientFIXAdminStatusEnum = {
  /** The owning gateway armed the directive and bounced the session. Sequence numbers change when the counterparty logs on again */
  Accepted: 'Accepted',
  /** The action was understood but could not be applied; see Text */
  Rejected: 'Rejected',
  /** The gateway owns the connection but has no FIX session store for it */
  NotFound: 'NotFound',
} as const;
export type ClientFIXAdminStatusEnum = (typeof ClientFIXAdminStatusEnum)[keyof typeof ClientFIXAdminStatusEnum];

export const ClosePriceTypeEnum = {
  /** Price of the instrument */
  Instrument: 'Instrument',
  /** Price of the underlying symbol */
  Underlying: 'Underlying',
} as const;
export type ClosePriceTypeEnum = (typeof ClosePriceTypeEnum)[keyof typeof ClosePriceTypeEnum];

export const CollateralHealthStatusEnum = {
  /** No collateral asset or zero pledged collateral */
  Unsecured: 'Unsecured',
  /** Collateral value exceeds the release threshold */
  Release: 'Release',
  /** Collateral value is within maintenance threshold */
  Healthy: 'Healthy',
  /** Collateral value is between maintenance and margin call thresholds */
  Warning: 'Warning',
  /** Shortfall meets or exceeds the minimum transfer amount */
  MarginCall: 'MarginCall',
  /** Collateral value is below the liquidation threshold */
  LiquidationRisk: 'LiquidationRisk',
} as const;
export type CollateralHealthStatusEnum = (typeof CollateralHealthStatusEnum)[keyof typeof CollateralHealthStatusEnum];

export const CommissionCalculationTypeEnum = {
  /** All In commission calculation type */
  AllIn: 'AllIn',
  /** Daily commission calculation type */
  Daily: 'Daily',
} as const;
export type CommissionCalculationTypeEnum =
  (typeof CommissionCalculationTypeEnum)[keyof typeof CommissionCalculationTypeEnum];

export const ConfirmFieldAuthorityEnum = {
  /** Only the system has authority to set the related field */
  System: 'System',
  /** Any participant has authority to set the related field */
  Any: 'Any',
  /** Only the taker has authority to set the related field */
  Taker: 'Taker',
  /** Only the maker has authority to set the related field */
  Maker: 'Maker',
} as const;
export type ConfirmFieldAuthorityEnum = (typeof ConfirmFieldAuthorityEnum)[keyof typeof ConfirmFieldAuthorityEnum];

export const ConfirmFieldNegotiabilityEnum = {
  /** Cannot vary per transaction */
  Constant: 'Constant',
  /** Can be set once per transaction */
  Immutable: 'Immutable',
  /** Can be set multiple time per transaction  */
  Negotiable: 'Negotiable',
} as const;
export type ConfirmFieldNegotiabilityEnum =
  (typeof ConfirmFieldNegotiabilityEnum)[keyof typeof ConfirmFieldNegotiabilityEnum];

export const ConnectionCapabilitiesEnum = {
  /** MarketDepth */
  MarketData: 'MarketData',
  /** Orders */
  Orders: 'Orders',
  /** RFQ */
  RFQ: 'RFQ',
  /** Balances */
  Balances: 'Balances',
  /** Transfers */
  Transfers: 'Transfers',
  /** No capabilities. Useful in modes to remove capabilities */
  None: 'None',
} as const;
export type ConnectionCapabilitiesEnum = (typeof ConnectionCapabilitiesEnum)[keyof typeof ConnectionCapabilitiesEnum];

export const ConnectionDetailsEnum = {
  /** Market Data Depth */
  MarketDataDepth: 'MarketDataDepth',
  /** Market Data Trades */
  MarketDataTrades: 'MarketDataTrades',
  /** Orders Requests */
  OrdersRequests: 'OrdersRequests',
  /** Orders Updates */
  OrdersUpdates: 'OrdersUpdates',
  /** Balances Updates */
  BalanceUpdates: 'BalanceUpdates',
  /** Trades Updates */
  TradesUpdates: 'TradesUpdates',
  /** RFQ Requests */
  RFQ: 'RFQ',
  /** Transfers */
  Transfers: 'Transfers',
  /** Orders Updates Per Symbol */
  OrdersUpdatesPerSymbol: 'OrdersUpdatesPerSymbol',
  /** Trades Updates Per Symbol */
  TradesUpdatesPerSymbol: 'TradesUpdatesPerSymbol',
  /** Fees */
  Fees: 'Fees',
  /** Margins */
  Margins: 'Margins',
  /** Trade Recovery */
  TradesRecovery: 'TradesRecovery',
  /** Asset Transactions */
  AssetTransactions: 'AssetTransactions',
  /** Care Orders Requests */
  CareOrdersRequests: 'CareOrdersRequests',
  /** Care Orders Updates */
  CareOrdersUpdates: 'CareOrdersUpdates',
  /** Customer Orders Requests */
  CustomerOrdersRequests: 'CustomerOrdersRequests',
  /** Customer Orders Updates */
  CustomerOrdersUpdates: 'CustomerOrdersUpdates',
  /** Customer Market Data Depth */
  CustomerMarketDataDepth: 'CustomerMarketDataDepth',
  /** Customer RFQ */
  CustomerRFQ: 'CustomerRFQ',
  /** External-venue clearing (e.g. Kalshi block trade clearing) */
  Clearing: 'Clearing',
} as const;
export type ConnectionDetailsEnum = (typeof ConnectionDetailsEnum)[keyof typeof ConnectionDetailsEnum];

export const ConnectionErrorCodeEnum = {
  /** No error */
  None: 'None',
  /** General error */
  GeneralError: 'GeneralError',
  /** Bad credentials were provided */
  BadCredentials: 'BadCredentials',
  /** Connection is unsupported by this gateway */
  UnsupportedConnection: 'UnsupportedConnection',
} as const;
export type ConnectionErrorCodeEnum = (typeof ConnectionErrorCodeEnum)[keyof typeof ConnectionErrorCodeEnum];

export const ConnectionModeEnum = {
  /** Up */
  Up: 'Up',
  /** Down */
  Down: 'Down',
} as const;
export type ConnectionModeEnum = (typeof ConnectionModeEnum)[keyof typeof ConnectionModeEnum];

export const ConnectionStatusEnum = {
  /** Connection is initializing */
  Starting: 'Starting',
  /** Connection is up */
  Online: 'Online',
  /** Connection keepalive */
  Keepalive: 'Keepalive',
  /** Connection is down */
  Offline: 'Offline',
  /** Connection had an error */
  Error: 'Error',
  /** Connection is stopping */
  Stopping: 'Stopping',
  /** Connection is stale */
  Stale: 'Stale',
  /** Connection is unavailable */
  Unavailable: 'Unavailable',
  /** Connection is not in session */
  NotInSession: 'NotInSession',
  /** Connection is disabled */
  Disabled: 'Disabled',
  /** Connection is rate limited */
  RateLimited: 'RateLimited',
} as const;
export type ConnectionStatusEnum = (typeof ConnectionStatusEnum)[keyof typeof ConnectionStatusEnum];

export const ConnectionTypeEnum = {
  /** Market Data Depth */
  MarketDataDepth: 'MarketDataDepth',
  /** Market Data Trades */
  MarketDataTrades: 'MarketDataTrades',
  /** Orders Requests */
  OrdersRequests: 'OrdersRequests',
  /** Orders Updates */
  OrdersUpdates: 'OrdersUpdates',
  /** Balances Updates */
  BalanceUpdates: 'BalanceUpdates',
  /** Trades Updates */
  TradesUpdates: 'TradesUpdates',
  /** RFQ Requests */
  RFQ: 'RFQ',
  /** Transfers */
  Transfers: 'Transfers',
} as const;
export type ConnectionTypeEnum = (typeof ConnectionTypeEnum)[keyof typeof ConnectionTypeEnum];

export const ContactMethodEnum = {
  /** Email contact info */
  Email: 'Email',
  /** Phone contact info */
  Phone: 'Phone',
  /** Mailing contact info */
  Mailing: 'Mailing',
  /** Other contact info */
  Other: 'Other',
} as const;
export type ContactMethodEnum = (typeof ContactMethodEnum)[keyof typeof ContactMethodEnum];

export const ContactPurposeEnum = {
  /** Trade / transaction confirmation */
  Confirmation: 'Confirmation',
  /** Margin related */
  Margin: 'Margin',
  /** Settlement related */
  Settlement: 'Settlement',
  /** Legal related */
  Legal: 'Legal',
  /** Trader */
  Trader: 'Trader',
  /** Sales Representative */
  SalesRep: 'SalesRep',
  /** Operations */
  Operations: 'Operations',
  /** Miscellaneous */
  Other: 'Other',
} as const;
export type ContactPurposeEnum = (typeof ContactPurposeEnum)[keyof typeof ContactPurposeEnum];

export const ConversionSourceUnitEnum = {
  /** The quantity to be converted is expressed in default units (i.e. in currency if asset is a currency, or in contracts/position currency if asset is a security */
  Default: 'Default',
  /** The quantity to be converted is expressed in the base currency of the security (only valid if asset is a security) */
  BaseCurrency: 'BaseCurrency',
  /** The quantity to be converted is expressed in the quote currency of the security (only valid if asset is a security) */
  QuoteCurrency: 'QuoteCurrency',
} as const;
export type ConversionSourceUnitEnum = (typeof ConversionSourceUnitEnum)[keyof typeof ConversionSourceUnitEnum];

export const CounterpartyRoleEnum = {
  /** Buy */
  Buyer: 'Buyer',
  /** Sell */
  Seller: 'Seller',
  /** Borrow */
  Borrower: 'Borrower',
  /** Lend */
  Lender: 'Lender',
} as const;
export type CounterpartyRoleEnum = (typeof CounterpartyRoleEnum)[keyof typeof CounterpartyRoleEnum];

export const CounterpartyTypeEnum = {
  /** Exchange */
  Exchange: 'Exchange',
  /** Dealer */
  Dealer: 'Dealer',
  /** Custodian */
  Custodian: 'Custodian',
  /** Customer */
  Customer: 'Customer',
  /** AuthorizedParticipant */
  AuthorizedParticipant: 'AuthorizedParticipant',
} as const;
export type CounterpartyTypeEnum = (typeof CounterpartyTypeEnum)[keyof typeof CounterpartyTypeEnum];

export const CounterpartyWorkflowTypeEnum = {
  /** OTC / Deal workflows */
  OTC: 'OTC',
} as const;
export type CounterpartyWorkflowTypeEnum =
  (typeof CounterpartyWorkflowTypeEnum)[keyof typeof CounterpartyWorkflowTypeEnum];

export const CptySettlementTypeEnum = {
  /** Settled in quote currency */
  Cash: 'Cash',
  /** Settled in constituent assets */
  InKind: 'InKind',
} as const;
export type CptySettlementTypeEnum = (typeof CptySettlementTypeEnum)[keyof typeof CptySettlementTypeEnum];

export const CsaCustodialArrangementEnum = {
  /** Bilateral */
  Bilateral: 'Bilateral',
  /** Triparty */
  Triparty: 'Triparty',
} as const;
export type CsaCustodialArrangementEnum =
  (typeof CsaCustodialArrangementEnum)[keyof typeof CsaCustodialArrangementEnum];

export const CsaRequestStatusEnum = {
  /** Created Successfully */
  Created: 'Created',
  /** Error Occured */
  Error: 'Error',
  /** Updated Successfully */
  Updated: 'Updated',
  /** Deleted Successfully */
  Deleted: 'Deleted',
  /** Invalid or failed validation */
  Rejected: 'Rejected',
} as const;
export type CsaRequestStatusEnum = (typeof CsaRequestStatusEnum)[keyof typeof CsaRequestStatusEnum];

export const CurrencyRebaseModeEnum = {
  /** Base */
  Base: 'Base',
  /** Rebased */
  Rebased: 'Rebased',
} as const;
export type CurrencyRebaseModeEnum = (typeof CurrencyRebaseModeEnum)[keyof typeof CurrencyRebaseModeEnum];

export const CurrencyTagEnum = {
  /** Fiat */
  Fiat: 'Fiat',
  /** StableCoin */
  StableCoin: 'StableCoin',
  /** TokenizedAsset */
  TokenizedAsset: 'TokenizedAsset',
  /** StakedAsset */
  StakedAsset: 'StakedAsset',
} as const;
export type CurrencyTagEnum = (typeof CurrencyTagEnum)[keyof typeof CurrencyTagEnum];

export const CustodianSignSchemeEnum = {
  /** ERC-191 personal-message signing with secp256k1 */
  Erc191: 'Erc191',
} as const;
export type CustodianSignSchemeEnum = (typeof CustodianSignSchemeEnum)[keyof typeof CustodianSignSchemeEnum];

export const CustodianSignStatusEnum = {
  /** The payload was signed successfully */
  Success: 'Success',
  /** Signing failed at the custody gateway level */
  InternalError: 'InternalError',
  /** Signing failed at the external custody provider level */
  ExternalError: 'ExternalError',
} as const;
export type CustodianSignStatusEnum = (typeof CustodianSignStatusEnum)[keyof typeof CustodianSignStatusEnum];

export const CustodianTxActionEnum = {
  /** Native or token transfer */
  Transfer: 'Transfer',
  /** Wrap native token (e.g. ETH to WETH) */
  Wrap: 'Wrap',
  /** Unwrap token (e.g. WETH to ETH) */
  Unwrap: 'Unwrap',
  /** Supply asset to lending protocol (e.g. Aave) */
  Supply: 'Supply',
  /** Withdraw asset from lending protocol (e.g. Aave) */
  Withdraw: 'Withdraw',
} as const;
export type CustodianTxActionEnum = (typeof CustodianTxActionEnum)[keyof typeof CustodianTxActionEnum];

export const CustodianTxStatusEnum = {
  /** Received */
  Received: 'Received',
  /** Signed */
  Signed: 'Signed',
  /** Submitted */
  Submitted: 'Submitted',
  /** Pending */
  Pending: 'Pending',
  /** Confirmed */
  Confirmed: 'Confirmed',
  /** Failed */
  Failed: 'Failed',
  /** Rejected */
  Rejected: 'Rejected',
} as const;
export type CustodianTxStatusEnum = (typeof CustodianTxStatusEnum)[keyof typeof CustodianTxStatusEnum];

export const CustomInstrumentDeleteRequestStatusEnum = {
  /** Security has been disabled */
  Disabled: 'Disabled',
  /** Security has been obliterated */
  Obliterated: 'Obliterated',
  /** An error occurred while processing the request */
  Error: 'Error',
} as const;
export type CustomInstrumentDeleteRequestStatusEnum =
  (typeof CustomInstrumentDeleteRequestStatusEnum)[keyof typeof CustomInstrumentDeleteRequestStatusEnum];

export const CustomInstrumentRequestStatusEnum = {
  /** A new Custom Instrument has been created */
  Created: 'Created',
  /** A matching Custom Instrument has been found */
  LookedUp: 'LookedUp',
  /** An error occurred while processing the request */
  Error: 'Error',
  /** Custom Instrument has been updated */
  Updated: 'Updated',
  /** The request was invalid or failed validation */
  Rejected: 'Rejected',
} as const;
export type CustomInstrumentRequestStatusEnum =
  (typeof CustomInstrumentRequestStatusEnum)[keyof typeof CustomInstrumentRequestStatusEnum];

export const CustomInstrumentRequestTypeEnum = {
  /** Request to create/lookup a multileg instrument */
  Multileg: 'Multileg',
  /** Request to create/lookup an option contract */
  Option: 'Option',
  /** Request to create/lookup an OTC instrument */
  OTC: 'OTC',
  /** Request to create/lookup a general custom instrument */
  Generic: 'Generic',
} as const;
export type CustomInstrumentRequestTypeEnum =
  (typeof CustomInstrumentRequestTypeEnum)[keyof typeof CustomInstrumentRequestTypeEnum];

export const CustomerAccountConfigurationKeyEnum = {
  /** Leverage */
  Leverage: 'Leverage',
  /** MarginTrading */
  MarginTrading: 'MarginTrading',
  /** MarginStressFactor */
  MarginStressFactor: 'MarginStressFactor',
  /** FundingSchedule */
  FundingSchedule: 'FundingSchedule',
  /** MarginCallThreshold */
  MarginCallThreshold: 'MarginCallThreshold',
  /** LiquidationThreshold */
  LiquidationThreshold: 'LiquidationThreshold',
  /** SendGrid template ID for emails */
  EmailTemplateID: 'EmailTemplateID',
  /** EnablePassThroughMarketOrders */
  EnablePassThroughMarketOrders: 'EnablePassThroughMarketOrders',
  /** MaximumExposure */
  MaximumExposure: 'MaximumExposure',
  /** MaximumExposureCurrency */
  MaximumExposureCurrency: 'MaximumExposureCurrency',
  /** FillRoundingOrder */
  FillRoundingOrder: 'FillRoundingOrder',
  /** MarkPriceSource */
  MarkPriceSource: 'MarkPriceSource',
  /** SynthesizeCustomerRFQ */
  SynthesizeCustomerRFQ: 'SynthesizeCustomerRFQ',
  /** PassFeeRebatesToCustomer */
  PassFeeRebatesToCustomer: 'PassFeeRebatesToCustomer',
  /** PositionConstraint */
  PositionConstraint: 'PositionConstraint',
  /** MarkToMarketSchedule */
  MarkToMarketSchedule: 'MarkToMarketSchedule',
  /** Time in force for the hedge of a customer FOK market order */
  MarketOrderFOKHedgeTIF: 'MarketOrderFOKHedgeTIF',
  /** Time in force for the hedge of a customer FOK limit order */
  LimitOrderFOKHedgeTIF: 'LimitOrderFOKHedgeTIF',
  /** Time in force for the hedge of a customer stop-market order */
  StopMarketOrderHedgeTIF: 'StopMarketOrderHedgeTIF',
  /** Time in force for the hedge of a customer multileg market order */
  MultilegMarketOrderHedgeTiF: 'MultilegMarketOrderHedgeTiF',
  /** Time in force for the hedge of a customer multileg GTC order */
  MultilegGTCOrderHedgeTiF: 'MultilegGTCOrderHedgeTiF',
  /** Use the hedge time in force when checking available markets */
  CheckForAvailableMarketsUsingHedgeTif: 'CheckForAvailableMarketsUsingHedgeTif',
  /** Duration a multileg hedge order is kept open */
  HedgeMultilegOrderDuration: 'HedgeMultilegOrderDuration',
  /** Duration an IOC order is kept open before cancellation */
  IOCDuration: 'IOCDuration',
} as const;
export type CustomerAccountConfigurationKeyEnum =
  (typeof CustomerAccountConfigurationKeyEnum)[keyof typeof CustomerAccountConfigurationKeyEnum];

export const CustomerAddressStatusEnum = {
  /** Customer address in pending confirmation state */
  Pending: 'Pending',
  /** Customer address in confirmed state */
  Confirmed: 'Confirmed',
} as const;
export type CustomerAddressStatusEnum = (typeof CustomerAddressStatusEnum)[keyof typeof CustomerAddressStatusEnum];

export const CustomerAddressTypeEnum = {
  /** Address for withdrawals */
  Withdrawal: 'Withdrawal',
  /** Address for deposits */
  Deposit: 'Deposit',
} as const;
export type CustomerAddressTypeEnum = (typeof CustomerAddressTypeEnum)[keyof typeof CustomerAddressTypeEnum];

export const CustomerAlertScopeEnum = {
  /** System */
  System: 'System',
  /** Order */
  Order: 'Order',
} as const;
export type CustomerAlertScopeEnum = (typeof CustomerAlertScopeEnum)[keyof typeof CustomerAlertScopeEnum];

export const CustomerBalanceTransactionStatusEnum = {
  /** PendingApproval */
  PendingApproval: 'PendingApproval',
  /** Rejected */
  Rejected: 'Rejected',
  /** PendingTransfer */
  PendingTransfer: 'PendingTransfer',
  /** Completed */
  Completed: 'Completed',
  /** Completed */
  Canceled: 'Canceled',
  /** Transfer has been initiated (gateway accepted the transfer request) */
  TransferInitiated: 'TransferInitiated',
  /** Transfer has been registered (request passed the validation and transfer request has been sent) */
  TransferRegistered: 'TransferRegistered',
  /** Transfer has been sent to blockchain and have txHash. Waiting for block confirmations */
  TransferPendingBlockchainConfirmation: 'TransferPendingBlockchainConfirmation',
  /** Initial status during automation */
  New: 'New',
} as const;
export type CustomerBalanceTransactionStatusEnum =
  (typeof CustomerBalanceTransactionStatusEnum)[keyof typeof CustomerBalanceTransactionStatusEnum];

export const CustomerBalanceTransactionTypeEnum = {
  /** Customer initiated withdrawal */
  Withdrawal: 'Withdrawal',
  /** Customer initiated deposit */
  Deposit: 'Deposit',
  /** A forced customer withdrawal that can take the amount into negative */
  ForceWithdrawal: 'ForceWithdrawal',
} as const;
export type CustomerBalanceTransactionTypeEnum =
  (typeof CustomerBalanceTransactionTypeEnum)[keyof typeof CustomerBalanceTransactionTypeEnum];

export const CustomerContextTypeEnum = {
  /** Customer context generated on new order */
  NewOrder: 'NewOrder',
  /** Customer context generated on order modification */
  OrderModification: 'OrderModification',
  /** Customer context generated when falling back to Riskless Principal */
  SwitchToRiskless: 'SwitchToRiskless',
  /** Customer context generated when order is triggered */
  OrderTriggered: 'OrderTriggered',
} as const;
export type CustomerContextTypeEnum = (typeof CustomerContextTypeEnum)[keyof typeof CustomerContextTypeEnum];

export const CustomerExecutionStrategyEnum = {
  /** Execute with a Cover and Deal Strategy */
  RisklessPrincipal: 'RisklessPrincipal',
  /** Execute Customer Order Unhedged */
  OrderAcceptance: 'OrderAcceptance',
} as const;
export type CustomerExecutionStrategyEnum =
  (typeof CustomerExecutionStrategyEnum)[keyof typeof CustomerExecutionStrategyEnum];

export const CustomerLedgerUpdateTypeEnum = {
  /** Set Balance */
  Set: 'Set',
  /** Submit a Deposit Transaction */
  Deposit: 'Deposit',
  /** Submit a Withdraw Transaction */
  Withdraw: 'Withdraw',
  /** Customer Trade Resulting in Balance Transaction */
  Trade: 'Trade',
  /** Customer Trade Cancel */
  TradeCancel: 'TradeCancel',
  /** Customer Trade Amend */
  TradeAmend: 'TradeAmend',
  /** Charge a fee for customer trade */
  TradingFee: 'TradingFee',
  /** Unsettled trade resulting in balance transaction */
  Unsettled: 'Unsettled',
  /** RealizedPnL resulting in balance transaction */
  RealizedPnL: 'RealizedPnL',
  /** Funding event resulting in balance transaction */
  Funding: 'Funding',
  /** PnL event for when marking derivative positions. */
  MarkToMarketPnL: 'MarkToMarketPnL',
} as const;
export type CustomerLedgerUpdateTypeEnum =
  (typeof CustomerLedgerUpdateTypeEnum)[keyof typeof CustomerLedgerUpdateTypeEnum];

export const CustomerLockSourceEnum = {
  /** Internal */
  Internal: 'Internal',
  /** External */
  External: 'External',
} as const;
export type CustomerLockSourceEnum = (typeof CustomerLockSourceEnum)[keyof typeof CustomerLockSourceEnum];

export const CustomerLockStatusEnum = {
  /** Dispatched */
  Dispatched: 'Dispatched',
  /** Approved */
  Approved: 'Approved',
  /** Rejected */
  Rejected: 'Rejected',
  /** Closed */
  Closed: 'Closed',
  /** TimedOut */
  TimedOut: 'TimedOut',
  /** Updated */
  Updated: 'Updated',
} as const;
export type CustomerLockStatusEnum = (typeof CustomerLockStatusEnum)[keyof typeof CustomerLockStatusEnum];

export const CustomerMarginNotificationTypeEnum = {
  /** MarginCall */
  MarginCall: 'MarginCall',
  /** Liquidation */
  Liquidation: 'Liquidation',
  /** All */
  All: 'All',
} as const;
export type CustomerMarginNotificationTypeEnum =
  (typeof CustomerMarginNotificationTypeEnum)[keyof typeof CustomerMarginNotificationTypeEnum];

export const CustomerOrderExecutionRuleTypeEnum = {
  /** Rule type for an ExecutionStrategy */
  ExecutionStrategy: 'ExecutionStrategy',
  /** Rule type for an RFQProtocol */
  RFQProtocol: 'RFQProtocol',
} as const;
export type CustomerOrderExecutionRuleTypeEnum =
  (typeof CustomerOrderExecutionRuleTypeEnum)[keyof typeof CustomerOrderExecutionRuleTypeEnum];

export const CustomerOrderPayPreviewStatusEnum = {
  /** Completed */
  Completed: 'Completed',
  /** Failed */
  Failed: 'Failed',
  /** Staled */
  Staled: 'Staled',
} as const;
export type CustomerOrderPayPreviewStatusEnum =
  (typeof CustomerOrderPayPreviewStatusEnum)[keyof typeof CustomerOrderPayPreviewStatusEnum];

export const CustomerOrderPreviewTypeEnum = {
  /** The preview is requested for a CustomerNewOrderSingle */
  NewOrderSingle: 'NewOrderSingle',
  /** The preview is requested for a CustomerOrderCancelReplace */
  OrderCancelReplace: 'OrderCancelReplace',
  /** The preview is requested for a customer execution */
  ExecutionReport: 'ExecutionReport',
} as const;
export type CustomerOrderPreviewTypeEnum =
  (typeof CustomerOrderPreviewTypeEnum)[keyof typeof CustomerOrderPreviewTypeEnum];

export const CustomerOrderSummaryActionEnum = {
  /** New */
  New: 'New',
  /** OrderFill */
  OrderFill: 'OrderFill',
  /** OrderCancel */
  OrderCancel: 'OrderCancel',
  /** HedgeTrade */
  HedgeTrade: 'HedgeTrade',
  /** HedgeTradeUpdate */
  HedgeTradeUpdate: 'HedgeTradeUpdate',
  /** HedgeTradeCancel */
  HedgeTradeCancel: 'HedgeTradeCancel',
  /** TradeUpdate */
  TradeUpdate: 'TradeUpdate',
  /** TradeCancel */
  TradeCancel: 'TradeCancel',
  /** Trade */
  Trade: 'Trade',
  /** DoneForDay */
  DoneForDay: 'DoneForDay',
  /** Regenerate */
  Regenerate: 'Regenerate',
} as const;
export type CustomerOrderSummaryActionEnum =
  (typeof CustomerOrderSummaryActionEnum)[keyof typeof CustomerOrderSummaryActionEnum];

export const CustomerPermissionActionEnum = {
  /** Read */
  Read: 'Read',
  /** Write */
  Write: 'Write',
  /** Admin */
  Admin: 'Admin',
} as const;
export type CustomerPermissionActionEnum =
  (typeof CustomerPermissionActionEnum)[keyof typeof CustomerPermissionActionEnum];

export const CustomerQuotePricingActionEnum = {
  /** Submit the pricing */
  Submit: 'Submit',
  /** Preview the pricing without submitting */
  Preview: 'Preview',
} as const;
export type CustomerQuotePricingActionEnum =
  (typeof CustomerQuotePricingActionEnum)[keyof typeof CustomerQuotePricingActionEnum];

export const CustomerResourceEnum = {
  /** Websocket Subscription: Security */
  WSSecuritySub: 'WSSecuritySub',
  /** Websocket Subscription: Currency */
  WSCurrencySub: 'WSCurrencySub',
  /** Websocket Subscription: CurrencyConversion */
  WSCurrencyConversionSub: 'WSCurrencyConversionSub',
  /** Websocket Subscription: MarketDataSnapshot */
  WSMarketDataSnapshotSub: 'WSMarketDataSnapshotSub',
  /** Websocket Subscription: OHLCV */
  WSOHLCVSub: 'WSOHLCVSub',
  /** Websocket Subscription: Balance */
  WSBalanceSub: 'WSBalanceSub',
  /** Websocket Subscription: Exposure */
  WSExposureSub: 'WSExposureSub',
  /** Websocket Subscription: Order */
  WSOrderSub: 'WSOrderSub',
  /** Websocket Subscription: ExecutionReport */
  WSExecutionReportSub: 'WSExecutionReportSub',
  /** Websocket Subscription: Trade */
  WSTradeSub: 'WSTradeSub',
  /** Websocket Subscription: Quote */
  WSQuoteSub: 'WSQuoteSub',
  /** Websocket Subscription: User */
  WSUserSub: 'WSUserSub',
  /** Websocket Subscription: MarketAccount */
  WSMarketAccountSub: 'WSMarketAccountSub',
  /** Websocket Subscription: MaxOrderSizeLimit */
  WSMaxOrderSizeLimitSub: 'WSMaxOrderSizeLimitSub',
  /** Websocket Command: NewOrderSingle */
  WSNewOrderSingle: 'WSNewOrderSingle',
  /** Websocket Command: OrderCancelRequest */
  WSOrderCancelRequest: 'WSOrderCancelRequest',
  /** Websocket Command: OrderCancelReplaceRequest */
  WSOrderCancelReplaceRequest: 'WSOrderCancelReplaceRequest',
  /** Websocket Command: QuoteRequest */
  WSQuoteRequest: 'WSQuoteRequest',
  /** Websocket Command: QuoteCancelRequest */
  WSQuoteCancelRequest: 'WSQuoteCancelRequest',
  /** Websocket Command: OrderControlRequest */
  WSOrderControlRequest: 'WSOrderControlRequest',
  /** Websocket Command: UserConfig */
  WSUserConfig: 'WSUserConfig',
  /** REST Request - GET: OHLCV */
  REST_GET_OHLCV: 'REST_GET_OHLCV',
  /** REST Request - GET: ApiKeys */
  REST_GET_ApiKeys: 'REST_GET_ApiKeys',
  /** REST Request - POST: ApiKey */
  REST_POST_ApiKey: 'REST_POST_ApiKey',
  /** REST Request - DELETE: ApiKey */
  REST_DELETE_ApiKey: 'REST_DELETE_ApiKey',
  /** Websocket Subscription - BalanceTransaction */
  WSBalanceTransactionSub: 'WSBalanceTransactionSub',
  /** Websocket Command - NewWithdrawRequest */
  WSNewWithdrawRequest: 'WSNewWithdrawRequest',
  /** REST Request - PATCH: ApiKey Permissions */
  REST_PATCH_ApiKey_Perms: 'REST_PATCH_ApiKey_Perms',
  /** FIX Message - NewOrderSingle */
  FIXNewOrderSingle: 'FIXNewOrderSingle',
  /** FIX Message - OrderCancelRequest */
  FIXOrderCancelRequest: 'FIXOrderCancelRequest',
  /** FIX Message - OrderCancelReplaceRequest */
  FIXOrderCancelReplaceRequest: 'FIXOrderCancelReplaceRequest',
  /** FIX Message - MarketDataSnapshot */
  FIXMarketDataRequest: 'FIXMarketDataRequest',
  /** FIX Message - SecurityListRequest */
  FIXSecurityListRequest: 'FIXSecurityListRequest',
  /** FIX Message - ExecutionReport */
  FIXExecutionReport: 'FIXExecutionReport',
  /** FIX Message - CancelReject */
  FIXCancelReject: 'FIXCancelReject',
  /** REST Request - PATCH: ApiKey */
  REST_PATCH_ApiKey: 'REST_PATCH_ApiKey',
  /** Websocket Command - NewDepositRequest */
  WSNewDepositRequest: 'WSNewDepositRequest',
  /** Websocket Subscription: Address */
  WSAddressSub: 'WSAddressSub',
  /** REST Request - GET: Address */
  REST_GET_Address: 'REST_GET_Address',
  /** REST Request - POST: Address */
  REST_POST_Address: 'REST_POST_Address',
  /** REST Request - GET: Users */
  REST_GET_Users: 'REST_GET_Users',
  /** Websocket Subscription: Ping */
  WSPing: 'WSPing',
  /** FIX Message - QuoteRequest */
  FIXQuoteRequest: 'FIXQuoteRequest',
  /** FIX Message - QuoteRequestReject */
  FIXQuoteRequestReject: 'FIXQuoteRequestReject',
  /** FIX Message - Quote */
  FIXQuote: 'FIXQuote',
  /** FIX Message - QuoteCancel */
  FIXQuoteCancel: 'FIXQuoteCancel',
  /** Websocket Subscription: Position */
  WSPositionSub: 'WSPositionSub',
  /** Websocket Subscription: FundingEvent */
  WSFundingEventSub: 'WSFundingEventSub',
  /** Websocket Subscription: FeeTier */
  WSFeeTier: 'WSFeeTier',
  /** Websocket Subscription: CurrentFeeTier */
  WSCurrentFeeTier: 'WSCurrentFeeTier',
  /** REST Request - POST: Max order amount */
  REST_POST_MaxOrderAmount: 'REST_POST_MaxOrderAmount',
  /** REST Request - POST: Order pay preview */
  REST_POST_OrderPayPreview: 'REST_POST_OrderPayPreview',
  /** REST Request - POST: Deposit */
  REST_POST_Deposit: 'REST_POST_Deposit',
  /** REST Request - POST: Withdrawal */
  REST_POST_Withdrawal: 'REST_POST_Withdrawal',
  /** Websocket Subscription: Margin */
  WSMarginSub: 'WSMarginSub',
  /** Websocket Subscription: Sparkline */
  WSSparklineSub: 'WSSparklineSub',
  /** REST Request - GET: Order leverage */
  REST_GET_OrderLeverage: 'REST_GET_OrderLeverage',
  /** Websocket Subscription: AssetTransaction */
  WSAssetTransactionSub: 'WSAssetTransactionSub',
} as const;
export type CustomerResourceEnum = (typeof CustomerResourceEnum)[keyof typeof CustomerResourceEnum];

export const CustomerRiskApprovalStatusEnum = {
  /** Order or QuoteRequest is approved for trading */
  Approved: 'Approved',
  /** Order or QuoteRequest is rejected */
  Rejected: 'Rejected',
  /** Order or QuoteRequest is pending approval */
  Pending: 'Pending',
} as const;
export type CustomerRiskApprovalStatusEnum =
  (typeof CustomerRiskApprovalStatusEnum)[keyof typeof CustomerRiskApprovalStatusEnum];

export const CustomerTransactionRejectReasonEnum = {
  /** Exceeds balances */
  ExceedsBalances: 'ExceedsBalances',
  /** Validation error */
  ValidationError: 'ValidationError',
  /** Internal error */
  InternalError: 'InternalError',
  /** Related transfer was rejected */
  TransferRejected: 'TransferRejected',
} as const;
export type CustomerTransactionRejectReasonEnum =
  (typeof CustomerTransactionRejectReasonEnum)[keyof typeof CustomerTransactionRejectReasonEnum];

export const CustomerViewCancelTypeEnum = {
  /** Cancel a single request */
  Request: 'Request',
  /** Cancel all requests for a customer */
  Customer: 'Customer',
  /** Cancel all requests for a client */
  Client: 'Client',
  /** Cancel all requests for a customer session */
  Session: 'Session',
} as const;
export type CustomerViewCancelTypeEnum = (typeof CustomerViewCancelTypeEnum)[keyof typeof CustomerViewCancelTypeEnum];

export const CustomerWorkflowEnum = {
  /** Order Actions Originating from the System */
  System: 'System',
  /** Order Actions Originating from the Whitelabel RFQ Workflow */
  WhitelabelRFQ: 'WhitelabelRFQ',
  /** Order Actions Originating from the Whitelabel Order Workflow */
  WhitelabelOrder: 'WhitelabelOrder',
  /** Order Actions Originating from the CustomerAPI RFQ Workflow */
  CustomerAPIRFQ: 'CustomerAPIRFQ',
  /** Order Actions from the CustomerAPI Order Workflow */
  CustomerAPIOrder: 'CustomerAPIOrder',
  /** Order Actions Originating from the Sales RFQ Workflow */
  SalesRFQ: 'SalesRFQ',
  /** Order Actions Originating from the Sales Orders Workflow */
  SalesOrder: 'SalesOrder',
  /** Order Actions Originating from Non-Sales DealerProxy RFQ Workflow */
  DealerProxyRFQ: 'DealerProxyRFQ',
  /** Order Actions Originating from Non-Sales DealerProxy Order Workflow */
  DealerProxyOrder: 'DealerProxyOrder',
  /** Order Actions originating from the Mobile WL RFQ Workflow */
  MobileWhitelabelRFQ: 'MobileWhitelabelRFQ',
  /** Order Actions originating from the Mobile WL Order Workflow */
  MobileWhitelabelOrder: 'MobileWhitelabelOrder',
  /** Order Actions originating from the Customer FIX Order Workflow */
  CustomerFIXOrder: 'CustomerFIXOrder',
  /** Order Actions originating from the Customer FIX RFQ Workflow */
  CustomerFIXRFQ: 'CustomerFIXRFQ',
} as const;
export type CustomerWorkflowEnum = (typeof CustomerWorkflowEnum)[keyof typeof CustomerWorkflowEnum];

export const CxlRejReasonEnum = {
  /** UnknownOrder */
  UnknownOrder: 'UnknownOrder',
  /** Broker */
  Broker: 'Broker',
  /** OrderAlreadyInPendingCancelOrPendingReplaceStatus */
  OrderAlreadyInPendingCancelOrPendingReplaceStatus: 'OrderAlreadyInPendingCancelOrPendingReplaceStatus',
  /** DuplicateClOrdID */
  DuplicateClOrdID: 'DuplicateClOrdID',
  /** TooLateToCancel */
  TooLateToCancel: 'TooLateToCancel',
  /** StaleRequest */
  StaleRequest: 'StaleRequest',
  /** RateLimit */
  RateLimit: 'RateLimit',
  /** InvalidStrategy */
  InvalidStrategy: 'InvalidStrategy',
  /** InternalError */
  InternalError: 'InternalError',
  /** AmbiguousMarketAccount */
  AmbiguousMarketAccount: 'AmbiguousMarketAccount',
  /** OrderExceedsLimit */
  OrderExceedsLimit: 'OrderExceedsLimit',
  /** SubAccountPermission */
  SubAccountPermission: 'SubAccountPermission',
  /** SelfTradePrevention */
  SelfTradePrevention: 'SelfTradePrevention',
  /** CommandApprovalRequestDenied */
  CommandApprovalRequestDenied: 'CommandApprovalRequestDenied',
  /** StrategyNotPermitted */
  StrategyNotPermitted: 'StrategyNotPermitted',
  /** Other */
  Other: 'Other',
} as const;
export type CxlRejReasonEnum = (typeof CxlRejReasonEnum)[keyof typeof CxlRejReasonEnum];

export const CxlRejResponseToEnum = {
  /** OrderCancelRequest */
  OrderCancelRequest: 'OrderCancelRequest',
  /** OrderCancelReplaceRequest */
  OrderCancelReplaceRequest: 'OrderCancelReplaceRequest',
  /** OrderPauseRequest */
  OrderPauseRequest: 'OrderPauseRequest',
  /** OrderResumeRequest */
  OrderResumeRequest: 'OrderResumeRequest',
  /** OrderAdminRequest */
  OrderAdminRequest: 'OrderAdminRequest',
} as const;
export type CxlRejResponseToEnum = (typeof CxlRejResponseToEnum)[keyof typeof CxlRejResponseToEnum];

export const DEPRECATED_OTCCashflowStatusEnum = {
  /** Pending */
  Pending: 'Pending',
  /** Completed */
  Completed: 'Completed',
} as const;
export type DEPRECATED_OTCCashflowStatusEnum =
  (typeof DEPRECATED_OTCCashflowStatusEnum)[keyof typeof DEPRECATED_OTCCashflowStatusEnum];

export const DEPRECATED_OTCCashflowTypeEnum = {
  /** Fixed rate interest payment */
  FixedRate: 'FixedRate',
  /** Index linked interest payment */
  IndexLinked: 'IndexLinked',
  /** Accrued index linked interest payment */
  AccruedIndexLinked: 'AccruedIndexLinked',
  /** Zero coupon principal payment */
  ZeroCoupon: 'ZeroCoupon',
  /** Any other cashflow type */
  Other: 'Other',
} as const;
export type DEPRECATED_OTCCashflowTypeEnum =
  (typeof DEPRECATED_OTCCashflowTypeEnum)[keyof typeof DEPRECATED_OTCCashflowTypeEnum];

export const DayCountConventionEnum = {
  /** Actual/360 Day count convention */
  Actual360: 'Actual360',
  /** Actual/365 Day count convention */
  Actual365: 'Actual365',
  /** Actual/365F calculation type */
  Actual365f: 'Actual365f',
  /** Actual/Actual calculation type */
  ActualActual: 'ActualActual',
  /** 30/360 calculation type */
  Thirty360: 'Thirty360',
  /** Actual/Actual/Treasury calculation type */
  ActualActualTreasury: 'ActualActualTreasury',
} as const;
export type DayCountConventionEnum = (typeof DayCountConventionEnum)[keyof typeof DayCountConventionEnum];

export const DealActionEnum = {
  /** Create an initial deal */
  Create: 'Create',
  /** Update deal details */
  Update: 'Update',
  /** Activate the deal. Transactions will be generated unless the deal is awaiting start / fixing */
  Activate: 'Activate',
  /** Close. No future transactions expected */
  Close: 'Close',
  /** Validate the deal request */
  ValidateDeal: 'ValidateDeal',
  /** Compute default values for the deal request */
  ComputeDefaults: 'ComputeDefaults',
  /** Compute strike fixings for the deal */
  ComputeStrikeFixings: 'ComputeStrikeFixings',
  /** Expire the deal */
  Expire: 'Expire',
  /** Update the size of a live deal */
  DealUpdateSize: 'DealUpdateSize',
} as const;
export type DealActionEnum = (typeof DealActionEnum)[keyof typeof DealActionEnum];

export const DealDefaultableValuesEnum = {
  /** Effective time */
  EffectiveTime: 'EffectiveTime',
  /** Settle time */
  SettleTime: 'SettleTime',
  /** Expiry (Maturity) time */
  ExpiryTime: 'ExpiryTime',
} as const;
export type DealDefaultableValuesEnum = (typeof DealDefaultableValuesEnum)[keyof typeof DealDefaultableValuesEnum];

export const DealEventTypeEnum = {
  /** Booking a new trade */
  New: 'New',
  /** Partially or fully reducing the position notional */
  Unwind: 'Unwind',
  /** Voiding an erroneous trade */
  Cancel: 'Cancel',
  /** Expiration of a dated contract */
  Expiration: 'Expiration',
  /** Exercise of an option */
  Exercise: 'Exercise',
  /** Contract requiring a specific fixing to be valued */
  Fixing: 'Fixing',
  /** Update to collateral information including amount, type and valuation */
  CollateralUpdate: 'CollateralUpdate',
  /** Margin request due to inadequate collateral, including liquidation tracking */
  MarginCall: 'MarginCall',
  /** Fiat cash-settlement off-platform and payment tracking */
  Settlement: 'Settlement',
} as const;
export type DealEventTypeEnum = (typeof DealEventTypeEnum)[keyof typeof DealEventTypeEnum];

export const DealRequestStatusEnum = {
  /** Created Successfully */
  Created: 'Created',
  /** Error Occured */
  Error: 'Error',
  /** Updated Successfully */
  Updated: 'Updated',
  /** Invalid or failed input / sanity checks */
  Rejected: 'Rejected',
  /** Deal validation performed successfully */
  Validated: 'Validated',
  /** Deal validation failed */
  ValidationFailed: 'ValidationFailed',
  /** Deal defaulting computed successfully */
  DefaultsComputed: 'DefaultsComputed',
  /** Computing deal defaults failed */
  DefaultingFailed: 'DefaultingFailed',
  /** Strike fixings computed successfully */
  StrikeFixingsComputed: 'StrikeFixingsComputed',
  /** Computing strike fixings failed */
  StrikeFixingsFailed: 'StrikeFixingsFailed',
} as const;
export type DealRequestStatusEnum = (typeof DealRequestStatusEnum)[keyof typeof DealRequestStatusEnum];

export const DealStatusEnum = {
  /** Deal is pending */
  Pending: 'Pending',
  /** Deal is new, awaiting start / fixing */
  New: 'New',
  /** Deal is active */
  Live: 'Live',
  /** Deal has been canceled */
  Canceled: 'Canceled',
  /** Deal reached expiry */
  Expired: 'Expired',
} as const;
export type DealStatusEnum = (typeof DealStatusEnum)[keyof typeof DealStatusEnum];

export const DecisionLogTypeEnum = {
  /** NewDecision */
  NewDecision: 'NewDecision',
  /** Periodic */
  Periodic: 'Periodic',
} as const;
export type DecisionLogTypeEnum = (typeof DecisionLogTypeEnum)[keyof typeof DecisionLogTypeEnum];

export const DecisionStatusEnum = {
  /** Order routing decision is running normally */
  Active: 'Active',
  /** Order routing decision is paused */
  Paused: 'Paused',
  /** Order routing decision is pending pausing */
  PendingPause: 'PendingPause',
  /** Order routing decision is pending resuming */
  PendingResume: 'PendingResume',
  /** Waiting for start time */
  WaitingForStartTime: 'WaitingForStartTime',
  /** Waiting for trigger */
  WaitingForTrigger: 'WaitingForTrigger',
  /** Staged order executes once user resumes order */
  Staged: 'Staged',
  /** Order routing decision is temporarily paused by the system due to error(s) */
  SystemPaused: 'SystemPaused',
  /** Order routing decision is pending external approval */
  PendingApproval: 'PendingApproval',
  /** Order routing decision is pending activation */
  PendingActivation: 'PendingActivation',
  /** Order routing decision for a pending replace is awaiting external approval */
  PendingReplaceApproval: 'PendingReplaceApproval',
  /** Order routing decision is pending custom instrument creation */
  PendingInstrumentCreation: 'PendingInstrumentCreation',
} as const;
export type DecisionStatusEnum = (typeof DecisionStatusEnum)[keyof typeof DecisionStatusEnum];

export const DedupModelEntryTypeEnum = {
  /** Entry is part of the current lookback period. */
  Current: 'Current',
  /** Entry is part of the previous lookback period. */
  Previous: 'Previous',
} as const;
export type DedupModelEntryTypeEnum = (typeof DedupModelEntryTypeEnum)[keyof typeof DedupModelEntryTypeEnum];

export const DeleteOperationEnum = {
  /** Disabled, a soft-delete */
  Disable: 'Disable',
  /** Full or hard-delete */
  Delete: 'Delete',
} as const;
export type DeleteOperationEnum = (typeof DeleteOperationEnum)[keyof typeof DeleteOperationEnum];

export const DeprecatedApplicationEventTypeEnum = {
  /** Startup */
  Startup: 'Startup',
  /** Shutdown */
  Shutdown: 'Shutdown',
  /** Error */
  Error: 'Error',
} as const;
export type DeprecatedApplicationEventTypeEnum =
  (typeof DeprecatedApplicationEventTypeEnum)[keyof typeof DeprecatedApplicationEventTypeEnum];

export const DeprecatedCustomInstrumentSnapshotRequestStatusEnum = {
  /** Snapshot start */
  SnapshotStart: 'SnapshotStart',
  /** Snapshot end */
  SnapshotEnd: 'SnapshotEnd',
  /** An error occurred while processing the request */
  Error: 'Error',
} as const;
export type DeprecatedCustomInstrumentSnapshotRequestStatusEnum =
  (typeof DeprecatedCustomInstrumentSnapshotRequestStatusEnum)[keyof typeof DeprecatedCustomInstrumentSnapshotRequestStatusEnum];

export const DepthTypeEnum = {
  /** Price levels */
  Price: 'Price',
  /** VWAP levels */
  VWAP: 'VWAP',
  /** Interpolated levels */
  Interpolated: 'Interpolated',
} as const;
export type DepthTypeEnum = (typeof DepthTypeEnum)[keyof typeof DepthTypeEnum];

export const DerivativeMetricTypeEnum = {
  /** DeltaPerUnit */
  DeltaPerUnit: 'DeltaPerUnit',
  /** Delta */
  Delta: 'Delta',
  /** Gamma */
  Gamma: 'Gamma',
  /** Vega */
  Vega: 'Vega',
  /** Theta */
  Theta: 'Theta',
  /** MarkPrice */
  MarkPrice: 'MarkPrice',
} as const;
export type DerivativeMetricTypeEnum = (typeof DerivativeMetricTypeEnum)[keyof typeof DerivativeMetricTypeEnum];

export const DerivativeSettlementTypeEnum = {
  /** Cash Settlement */
  Cash: 'Cash',
  /** Physical Settlement */
  Physical: 'Physical',
} as const;
export type DerivativeSettlementTypeEnum =
  (typeof DerivativeSettlementTypeEnum)[keyof typeof DerivativeSettlementTypeEnum];

export const DynamicPartitionGroupEnum = {
  /** Aggregator partition group */
  Aggregator: 'Aggregator',
  /** Customer market data partition group */
  CustomerMarketData: 'CustomerMarketData',
  /** Multileg market data partition group */
  MultilegMarketData: 'MultilegMarketData',
} as const;
export type DynamicPartitionGroupEnum = (typeof DynamicPartitionGroupEnum)[keyof typeof DynamicPartitionGroupEnum];

export const ESignGatewayEventTypeEnum = {
  /** Sent */
  Sent: 'Sent',
  /** Signed */
  Signed: 'Signed',
  /** Completed */
  Completed: 'Completed',
  /** Declined */
  Declined: 'Declined',
  /** Error */
  Error: 'Error',
  /** Voided */
  Voided: 'Voided',
  /** Expired */
  Expired: 'Expired',
} as const;
export type ESignGatewayEventTypeEnum = (typeof ESignGatewayEventTypeEnum)[keyof typeof ESignGatewayEventTypeEnum];

export const ESignRecipientStatusEnum = {
  /** PendingSignature */
  PendingSignature: 'PendingSignature',
  /** Signed */
  Signed: 'Signed',
  /** Rejected */
  Rejected: 'Rejected',
} as const;
export type ESignRecipientStatusEnum = (typeof ESignRecipientStatusEnum)[keyof typeof ESignRecipientStatusEnum];

export const ESignStatusEnum = {
  /** PendingCreate */
  PendingCreate: 'PendingCreate',
  /** PendingSignatures */
  PendingSignatures: 'PendingSignatures',
  /** Completed */
  Completed: 'Completed',
  /** Declined */
  Declined: 'Declined',
  /** Error */
  Error: 'Error',
  /** Voided */
  Voided: 'Voided',
  /** Expired */
  Expired: 'Expired',
} as const;
export type ESignStatusEnum = (typeof ESignStatusEnum)[keyof typeof ESignStatusEnum];

export const EntityMaintenanceActionEnum = {
  /** Add or update the item with this key */
  Create: 'Create',
  /** Add or update the item with this key */
  Update: 'Update',
} as const;
export type EntityMaintenanceActionEnum =
  (typeof EntityMaintenanceActionEnum)[keyof typeof EntityMaintenanceActionEnum];

export const EntityManagementResultEnum = {
  /** Request accepted and applied */
  Accepted: 'Accepted',
  /** Request target was not found */
  NotFound: 'NotFound',
  /** Request was invalid and was not applied */
  InvalidArgument: 'InvalidArgument',
  /** Request failed due to internal processing error */
  InternalError: 'InternalError',
} as const;
export type EntityManagementResultEnum = (typeof EntityManagementResultEnum)[keyof typeof EntityManagementResultEnum];

export const ErrorActionEnum = {
  /** Cancel */
  Cancel: 'Cancel',
  /** Pause */
  Pause: 'Pause',
} as const;
export type ErrorActionEnum = (typeof ErrorActionEnum)[keyof typeof ErrorActionEnum];

export const EventIndicatorEnum = {
  /** 0=Reserved for future use */
  Reserved1: 'Reserved1',
  /** 0=Reserved for future use */
  Reserved2: 'Reserved2',
  /** 0=Reserved for future use */
  Reserved3: 'Reserved3',
  /** 0=Reserved for future use */
  Reserved4: 'Reserved4',
  /** 1=Message is for tracking internal state and not for external distribution */
  InternalFlag: 'InternalFlag',
  /** 1=Message is sent during recovery process */
  RecoveryFlag: 'RecoveryFlag',
  /** 1=Message is the beginning of a stream or a snapshot */
  ResetFlag: 'ResetFlag',
  /** 0=Last message for the event, 1=Expect more messages for this atomic event */
  ContinuationFlag: 'ContinuationFlag',
} as const;
export type EventIndicatorEnum = (typeof EventIndicatorEnum)[keyof typeof EventIndicatorEnum];

export const EventStatusEnum = {
  /** Event is open for trading */
  Open: 'Open',
  /** Event is closed, resolution pending */
  Closed: 'Closed',
  /** Event has been resolved */
  Resolved: 'Resolved',
} as const;
export type EventStatusEnum = (typeof EventStatusEnum)[keyof typeof EventStatusEnum];

export const ExecTypeEnum = {
  /** New */
  New: 'New',
  /** Trade */
  Trade: 'Trade',
  /** Canceled */
  Canceled: 'Canceled',
  /** Replaced */
  Replaced: 'Replaced',
  /** PendingCancel */
  PendingCancel: 'PendingCancel',
  /** Rejected */
  Rejected: 'Rejected',
  /** PendingNew */
  PendingNew: 'PendingNew',
  /** Restated */
  Restated: 'Restated',
  /** PendingReplace */
  PendingReplace: 'PendingReplace',
  /** DoneForDay */
  DoneForDay: 'DoneForDay',
  /** CancelRejected */
  CancelRejected: 'CancelRejected',
  /** ReplaceRejected */
  ReplaceRejected: 'ReplaceRejected',
  /** Expired */
  Expired: 'Expired',
  /** Stale */
  Stale: 'Stale',
  /** NewRequest */
  NewRequest: 'NewRequest',
  /** ReplaceRequest */
  ReplaceRequest: 'ReplaceRequest',
  /** CancelRequest */
  CancelRequest: 'CancelRequest',
  /** ForceCancelRequest */
  ForceCancelRequest: 'ForceCancelRequest',
  /** ControlRequest */
  ControlRequest: 'ControlRequest',
  /** Updated */
  Updated: 'Updated',
  /** Triggered */
  Triggered: 'Triggered',
  /** PauseRequest */
  PauseRequest: 'PauseRequest',
  /** PendingPause */
  PendingPause: 'PendingPause',
  /** Paused */
  Paused: 'Paused',
  /** PauseRejected */
  PauseRejected: 'PauseRejected',
  /** ResumeRequest */
  ResumeRequest: 'ResumeRequest',
  /** PendingResume */
  PendingResume: 'PendingResume',
  /** Resumed */
  Resumed: 'Resumed',
  /** ResumeRejected */
  ResumeRejected: 'ResumeRejected',
  /** Started */
  Started: 'Started',
  /** PendingRiskCheck */
  PendingRiskCheck: 'PendingRiskCheck',
  /** RiskApproved */
  RiskApproved: 'RiskApproved',
  /** PendingUpdate */
  PendingUpdate: 'PendingUpdate',
  /** UpdateRejected */
  UpdateRejected: 'UpdateRejected',
  /** LegTrade */
  LegTrade: 'LegTrade',
  /** OrderQtyReducedDueToInsufficientPosition */
  QtyReducedInsufficientPosition: 'QtyReducedInsufficientPosition',
} as const;
export type ExecTypeEnum = (typeof ExecTypeEnum)[keyof typeof ExecTypeEnum];

export const ExecTypeReasonEnum = {
  /** OrdQtyReducedBySelfTradePrevention */
  OrdQtyReducedBySelfTradePrevention: 'OrdQtyReducedBySelfTradePrevention',
} as const;
export type ExecTypeReasonEnum = (typeof ExecTypeReasonEnum)[keyof typeof ExecTypeReasonEnum];

export const ExecutionInstructionsEnum = {
  /** reduce only */
  ReduceOnly: 'ReduceOnly',
} as const;
export type ExecutionInstructionsEnum = (typeof ExecutionInstructionsEnum)[keyof typeof ExecutionInstructionsEnum];

export const ExerciseStyleEnum = {
  /** European exercise style */
  European: 'European',
} as const;
export type ExerciseStyleEnum = (typeof ExerciseStyleEnum)[keyof typeof ExerciseStyleEnum];

export const ExposureCalculationTypeEnum = {
  /** The available after applying all exposure limits. */
  BuyingPower: 'BuyingPower',
  /** Calculate NOP in the specified currency. */
  NOP: 'NOP',
  /** Net exposure per currency, and take the absolute value, optionally convert to currency. */
  NOPPerCurrency: 'NOPPerCurrency',
  /** Gross exposure for whole account expressed in the one currency. */
  Gross: 'Gross',
  /** Gross exposure per currency. */
  GrossPerCurrency: 'GrossPerCurrency',
  /** NOP calculated by sum all owed (negative) balances. */
  OwedNOP: 'OwedNOP',
  /** NOP calculated by sum all positive balances. */
  PositiveNOP: 'PositiveNOP',
  /** SDP pass-through exposure from gateways. */
  SDPPassThrough: 'SDPPassThrough',
  /** SDP pass-through per-currency exposure from gateways. */
  SDPPassThroughPerCurrency: 'SDPPassThroughPerCurrency',
  /** Net exposure per currency, and take the absolute value, optionally convert to currency. */
  MarketNOPPerCurrency: 'MarketNOPPerCurrency',
  /** Net exposure based on position */
  NetPosition: 'NetPosition',
  /** Gross exposure based on position */
  GrossPosition: 'GrossPosition',
  /** Net out all positions */
  NetAllPosition: 'NetAllPosition',
  /** Risk limit calculation for derivative positions */
  PositionRiskLimit: 'PositionRiskLimit',
} as const;
export type ExposureCalculationTypeEnum =
  (typeof ExposureCalculationTypeEnum)[keyof typeof ExposureCalculationTypeEnum];

export const ExposureLimitSideTypeEnum = {
  /** Both */
  Both: 'Both',
  /** Long */
  Long: 'Long',
  /** Short */
  Short: 'Short',
} as const;
export type ExposureLimitSideTypeEnum = (typeof ExposureLimitSideTypeEnum)[keyof typeof ExposureLimitSideTypeEnum];

export const ExposureModeEnum = {
  /** Balance */
  Balance: 'Balance',
  /** Credit */
  Credit: 'Credit',
} as const;
export type ExposureModeEnum = (typeof ExposureModeEnum)[keyof typeof ExposureModeEnum];

export const ExposureSourceEnum = {
  /** Internal exposure source. */
  Internal: 'Internal',
  /** External exposure source. */
  External: 'External',
} as const;
export type ExposureSourceEnum = (typeof ExposureSourceEnum)[keyof typeof ExposureSourceEnum];

export const ExposureStatusEnum = {
  /** Online */
  Online: 'Online',
  /** Offline */
  Offline: 'Offline',
} as const;
export type ExposureStatusEnum = (typeof ExposureStatusEnum)[keyof typeof ExposureStatusEnum];

export const ExposureTypeEnum = {
  /** Balance */
  Balance: 'Balance',
  /** Credit */
  Credit: 'Credit',
  /** Margin */
  Margin: 'Margin',
} as const;
export type ExposureTypeEnum = (typeof ExposureTypeEnum)[keyof typeof ExposureTypeEnum];

export const ExpressedOutcomeEnum = {
  /** Yes */
  Yes: 'Yes',
  /** No */
  No: 'No',
} as const;
export type ExpressedOutcomeEnum = (typeof ExpressedOutcomeEnum)[keyof typeof ExpressedOutcomeEnum];

export const ExternalTypeEnum = {
  /** ExternalID assigned by the dealer */
  Dealer: 'Dealer',
  /** ExternalID assigned by the customer user */
  Customer: 'Customer',
  /** ExternalID assigned by the Talos system */
  System: 'System',
} as const;
export type ExternalTypeEnum = (typeof ExternalTypeEnum)[keyof typeof ExternalTypeEnum];

export const FIXFlagsEnum = {
  /** 0=Determines if sequence numbers should be reset when receiving a logon request. Acceptors only. */
  ResetOnLogon: 'ResetOnLogon',
  /** 1=Determines if messages should be saved. */
  PersistMessages: 'PersistMessages',
} as const;
export type FIXFlagsEnum = (typeof FIXFlagsEnum)[keyof typeof FIXFlagsEnum];

export const FeeCalcBasisEnum = {
  /** Fee = rate x notional, the standard linear model */
  Notional: 'Notional',
  /** Fee = rate x contracts x P x (1-P), used by prediction markets like Kalshi where max fee occurs near P=0.5 */
  BinaryOutcomeVariance: 'BinaryOutcomeVariance',
} as const;
export type FeeCalcBasisEnum = (typeof FeeCalcBasisEnum)[keyof typeof FeeCalcBasisEnum];

export const FeeConfigUpdateActionEnum = {
  /** New */
  New: 'New',
  /** Update */
  Update: 'Update',
  /** Delete */
  Delete: 'Delete',
} as const;
export type FeeConfigUpdateActionEnum = (typeof FeeConfigUpdateActionEnum)[keyof typeof FeeConfigUpdateActionEnum];

export const FeeModeEnum = {
  /** Net Fee Mode */
  Net: 'Net',
  /** Calculate for Maker Fees */
  Maker: 'Maker',
  /** Calculate for Taker Fees */
  Taker: 'Taker',
} as const;
export type FeeModeEnum = (typeof FeeModeEnum)[keyof typeof FeeModeEnum];

export const FeeResponseStatusEnum = {
  /** Update has been applied successfully */
  Completed: 'Completed',
  /** Failed to apply the update */
  Rejected: 'Rejected',
  /** An error occurred while trying to apply the update */
  Error: 'Error',
} as const;
export type FeeResponseStatusEnum = (typeof FeeResponseStatusEnum)[keyof typeof FeeResponseStatusEnum];

export const FeeSourceEnum = {
  /** Fee reported by exchange */
  Exchange: 'Exchange',
  /** Fee reported by user */
  Override: 'Override',
} as const;
export type FeeSourceEnum = (typeof FeeSourceEnum)[keyof typeof FeeSourceEnum];

export const FillModeEnum = {
  /** Allocate fills to member COs per WO fill */
  FillPerFill: 'FillPerFill',
  /** Allocate fills to member COs once per WO at terminal */
  FillPerOrder: 'FillPerOrder',
} as const;
export type FillModeEnum = (typeof FillModeEnum)[keyof typeof FillModeEnum];

export const FixedPricingModeEnum = {
  /** Fixed Price for Customer RFQ */
  Price: 'Price',
  /** Fixed Spread for Customer RFQ */
  Spread: 'Spread',
} as const;
export type FixedPricingModeEnum = (typeof FixedPricingModeEnum)[keyof typeof FixedPricingModeEnum];

export const FundingRateConfigurationCalculationModeEnum = {
  /** Absolute */
  Absolute: 'Absolute',
  /** Relative */
  Relative: 'Relative',
} as const;
export type FundingRateConfigurationCalculationModeEnum =
  (typeof FundingRateConfigurationCalculationModeEnum)[keyof typeof FundingRateConfigurationCalculationModeEnum];

export const GatewayTestTypeEnum = {
  /** recovery test */
  Recovery: 'Recovery',
  /** trading test */
  Trading: 'Trading',
  /** continuous trading test */
  ContinuousTrading: 'ContinuousTrading',
  /** gateway certifications */
  Certification: 'Certification',
} as const;
export type GatewayTestTypeEnum = (typeof GatewayTestTypeEnum)[keyof typeof GatewayTestTypeEnum];

export const HedgeActionEnum = {
  /** Indicates the Hedger is Monitoring Unhedged Positions */
  Monitor: 'Monitor',
  /** Indicates the Hedger is Deferring Applying the Hedge Decision Due to Throttle */
  Deferring: 'Deferring',
  /** Action where the Hedger Requests a New Order with Details */
  RequestNewOrder: 'RequestNewOrder',
  /** Action that Indicates a New Hedge Order Has been Submitted and the Hedger is Awaiting Acceptance */
  NewOrderSubmitted: 'NewOrderSubmitted',
  /** Action that Indicates that a Newly Submitted Hedge Order was Rejected */
  NewOrderFailed: 'NewOrderFailed',
  /** Action where the Hedger Requests an Order Modification with Details */
  RequestOrderModification: 'RequestOrderModification',
  /** Action that Indicates an Order Modification Has been Submitted and the Hedger is Awaiting Acceptance */
  OrderModificationSubmitted: 'OrderModificationSubmitted',
  /** Action that Indicates that a Submitted Hedge Order Modification was Rejected */
  OrderModificationFailed: 'OrderModificationFailed',
  /** Action where the Hedger Requests an Order Cancelation with Details */
  RequestOrderCancel: 'RequestOrderCancel',
  /** Action that Indicates an Order Cancelation Has been Submitted and the Hedger is Awaiting Acceptance */
  OrderCancelSubmitted: 'OrderCancelSubmitted',
  /** Action that Indicates that a Submitted Hedge Order Cancelation was Rejected */
  OrderCancelFailed: 'OrderCancelFailed',
  /** Indicates that the Hedge Control needs to Move to an Error State */
  Error: 'Error',
  /** Action Set on CancelToAgress Decision to Indicate that the Cancel Side is Complete */
  OrderCanceled: 'OrderCanceled',
} as const;
export type HedgeActionEnum = (typeof HedgeActionEnum)[keyof typeof HedgeActionEnum];

export const HedgeCommandEnum = {
  /** Indicates a request to kill one or all Hedge Controls */
  Kill: 'Kill',
  /** Indicates a request to activate a currently inactivated Hedge Control */
  Activate: 'Activate',
  /** Indicates a request to synchronize HedgerLedger with SubAccountPositionLedger */
  Synchronize: 'Synchronize',
  /** Triggers a command to log stale HedgerLedger unconfirmed positions */
  LogStalePositions: 'LogStalePositions',
  /** Triggers a command to clear stale HedgerLedger unconfirmed positions */
  ClearStalePositions: 'ClearStalePositions',
  /** Indicates a request to synchronize HedgerLedger with SubAccountPositionLedger and Restart Errored Rules */
  SynchronizeAndRestart: 'SynchronizeAndRestart',
} as const;
export type HedgeCommandEnum = (typeof HedgeCommandEnum)[keyof typeof HedgeCommandEnum];

export const HedgeCommandStatusEnum = {
  /** Indicates the requested command was successful */
  Success: 'Success',
  /** Indicates the requested command failed and an error is supplied */
  Error: 'Error',
} as const;
export type HedgeCommandStatusEnum = (typeof HedgeCommandStatusEnum)[keyof typeof HedgeCommandStatusEnum];

export const HedgeControlErrorCodeEnum = {
  /** Indicates that there is a data consistency issue in the HedgeRule associated with this control */
  InvalidRule: 'InvalidRule',
  /** Indicates that there is a position control with a rule that cannot be found */
  MissingRule: 'MissingRule',
  /** Indicates that a requisite ConversionRate for a given control is missing */
  MissingConversionRate: 'MissingConversionRate',
  /** Indicates that there is a problem with the Ledger position for a control */
  PositionError: 'PositionError',
  /** Indicates that the control had a problem submitting a hedge order command */
  HedgeOrderError: 'HedgeOrderError',
  /** Indicates that there is a problem with the exposure */
  ExposureValidationError: 'ExposureValidationError',
  /** An unexpected server error could be an IO Error */
  InternalServerError: 'InternalServerError',
  /** An error that cannot be conformed to a code - should not be possible */
  UndefinedError: 'UndefinedError',
} as const;
export type HedgeControlErrorCodeEnum = (typeof HedgeControlErrorCodeEnum)[keyof typeof HedgeControlErrorCodeEnum];

export const HedgeControlStatusEnum = {
  /** Indicates this Hedge Control is Currently Disabled */
  Disabled: 'Disabled',
  /** Indicates this Hedge Control is Active and Monitoring for Threshold Breaches */
  Waiting: 'Waiting',
  /** Indicates this Hedge Control is Active and Currently Hedging to Close to Target */
  Hedging: 'Hedging',
  /** Indicates this Hedge Control is in an Error State */
  Error: 'Error',
  /** Indicates this Hedge Control is in progress being disabled */
  Disabling: 'Disabling',
  /** Indicates this Hedge Control has completed hedging */
  Complete: 'Complete',
  /** Hedge control was rejected likely due to faulty setup */
  Rejected: 'Rejected',
  /** Indicates this Hedge Control closed with unhedged qty possible due to errror */
  Incomplete: 'Incomplete',
  /** Indicates this Hedge Control had an error Tripped and may end up going to error state */
  Tripped: 'Tripped',
  /** Indicates this Hedge Control is Synchronizing with the SubAccountPositionLedger */
  Synchronizing: 'Synchronizing',
} as const;
export type HedgeControlStatusEnum = (typeof HedgeControlStatusEnum)[keyof typeof HedgeControlStatusEnum];

export const HedgeControlTypeEnum = {
  /** The requested control is associated with the state of the entire hedger */
  Global: 'Global',
  /** The requested control is associated with a specific Account/Asset Position */
  Position: 'Position',
  /** The requested control is associated with a specific to an order */
  Order: 'Order',
  /** Special Control Type used for Filtering */
  All: 'All',
} as const;
export type HedgeControlTypeEnum = (typeof HedgeControlTypeEnum)[keyof typeof HedgeControlTypeEnum];

export const HedgeDecisionEnum = {
  /** Indicates the Decision is to Continue Monitoring Unhedged Position */
  Monitor: 'Monitor',
  /** Indicates the Decision is to Submit a New Hedge Order */
  NewHedgeOrder: 'NewHedgeOrder',
  /** Indicates the Decision is to Modify the Hedge Order */
  ModifyHedgeOrder: 'ModifyHedgeOrder',
  /** Indicates the Decision is to Modify the Hedge Order */
  CancelHedgeOrder: 'CancelHedgeOrder',
  /** Internal Decision to Order Model Signaling Intent to Make a Hedge Order Decision */
  Hedge: 'Hedge',
  /** Indicates the Decision is to Cancel the existing order and Aggress */
  CancelToAggress: 'CancelToAggress',
  /** Indicates an Issue has Occurred which should Trigger Error Evaluation */
  Trip: 'Trip',
  /** Indicates the Decision is to Move the Hedge Control to Error State */
  Error: 'Error',
} as const;
export type HedgeDecisionEnum = (typeof HedgeDecisionEnum)[keyof typeof HedgeDecisionEnum];

export const HedgeDeltaAttributionEnum = {
  /** Indicates Delta is Initially Due to Position Change Detected in Ledger */
  PositionChange: 'PositionChange',
  /** Indicates Detla is Initially Due to a Mark Change on Conversion */
  MarkChange: 'MarkChange',
  /** Indicates Detla is Due to Hedge Order Fills */
  HedgeOrderFill: 'HedgeOrderFill',
} as const;
export type HedgeDeltaAttributionEnum = (typeof HedgeDeltaAttributionEnum)[keyof typeof HedgeDeltaAttributionEnum];

export const HedgerLedgerStatusEnum = {
  /** Live operating status for HedgerLedger - Hedge Positions can be evaluated */
  Live: 'Live',
  /** HedgerLedger synchronization in progress - Hedge Positions should not be evaluated */
  Synchronizing: 'Synchronizing',
  /** HedgerLedger recon break identified */
  ReconBreak: 'ReconBreak',
} as const;
export type HedgerLedgerStatusEnum = (typeof HedgerLedgerStatusEnum)[keyof typeof HedgerLedgerStatusEnum];

export const HedgingStatusEnum = {
  /** Indicates hedging is enabled */
  Enabled: 'Enabled',
  /** Indicates hedging is disabled */
  Disabled: 'Disabled',
  /** Indicates there was an internal error */
  Error: 'Error',
  /** Indicates hedging status is unknown */
  Unknown: 'Unknown',
} as const;
export type HedgingStatusEnum = (typeof HedgingStatusEnum)[keyof typeof HedgingStatusEnum];

export const IndexMarkSourceEnum = {
  /** The Mark was taken from the official publisher */
  Publisher: 'Publisher',
  /** The Mark was provided by a user initiated command */
  User: 'User',
} as const;
export type IndexMarkSourceEnum = (typeof IndexMarkSourceEnum)[keyof typeof IndexMarkSourceEnum];

export const IndexValueTypeEnum = {
  /** Price value */
  Price: 'Price',
  /** Rate (i.e., percentage) value */
  Rate: 'Rate',
} as const;
export type IndexValueTypeEnum = (typeof IndexValueTypeEnum)[keyof typeof IndexValueTypeEnum];

export const InjectionActionEnum = {
  /** Inject the provided value */
  Inject: 'Inject',
  /** Panic when injection site is reached */
  Panic: 'Panic',
} as const;
export type InjectionActionEnum = (typeof InjectionActionEnum)[keyof typeof InjectionActionEnum];

export const InstrumentCompositionEnum = {
  /** An instrument traded natively with a counterparty */
  Native: 'Native',
  /** An instrument constructed locally composed of one or more native instruments */
  Synthetic: 'Synthetic',
} as const;
export type InstrumentCompositionEnum = (typeof InstrumentCompositionEnum)[keyof typeof InstrumentCompositionEnum];

export const LPSettlementAutoBatchGroupFieldsEnum = {
  /** Group by target MarketAccount. Required */
  MarketAccount: 'MarketAccount',
  /** Group by SettleDeadline */
  SettleDeadline: 'SettleDeadline',
  /** Group by SubAccount(s) */
  SubAccount: 'SubAccount',
} as const;
export type LPSettlementAutoBatchGroupFieldsEnum =
  (typeof LPSettlementAutoBatchGroupFieldsEnum)[keyof typeof LPSettlementAutoBatchGroupFieldsEnum];

export const LPSettlementBatchRequestStatusEnum = {
  /** Successful batch preview response */
  Previewed: 'Previewed',
  /** Batch successfully created */
  Created: 'Created',
  /** Request encountered an error */
  Error: 'Error',
  /** Request validation failed */
  Rejected: 'Rejected',
  /** Batch successfully disbanded */
  Disbanded: 'Disbanded',
  /** Batch successfully updated */
  Updated: 'Updated',
} as const;
export type LPSettlementBatchRequestStatusEnum =
  (typeof LPSettlementBatchRequestStatusEnum)[keyof typeof LPSettlementBatchRequestStatusEnum];

export const LPSettlementBatchRequestTypeEnum = {
  /** Request to preview a batch */
  Preview: 'Preview',
  /** Request to create a batch */
  Create: 'Create',
  /** Request to disband a batch */
  Disband: 'Disband',
  /** Request to add reports to a batch */
  AddTo: 'AddTo',
  /** Request to remove reports from a batch */
  RemoveFrom: 'RemoveFrom',
  /** Automated request to create a batch */
  AutoCreate: 'AutoCreate',
} as const;
export type LPSettlementBatchRequestTypeEnum =
  (typeof LPSettlementBatchRequestTypeEnum)[keyof typeof LPSettlementBatchRequestTypeEnum];

export const LPSettlementBatchSourceEnum = {
  /** User-created settlement batch */
  Manual: 'Manual',
  /** Automatically created settlement batch */
  Automatic: 'Automatic',
} as const;
export type LPSettlementBatchSourceEnum =
  (typeof LPSettlementBatchSourceEnum)[keyof typeof LPSettlementBatchSourceEnum];

export const LPSettlementBatchStatusEnum = {
  /** Settlement batch is created */
  Created: 'Created',
  /** Transactions initiated or received */
  InProgress: 'InProgress',
  /** Settled / completed. All transactions sent / received */
  Settled: 'Settled',
  /** Canceled with partial settlement */
  CanceledPartiallySettled: 'CanceledPartiallySettled',
  /** Discarded */
  Discarded: 'Discarded',
  /** Preview */
  Previewed: 'Previewed',
} as const;
export type LPSettlementBatchStatusEnum =
  (typeof LPSettlementBatchStatusEnum)[keyof typeof LPSettlementBatchStatusEnum];

export const LPSettlementEventTypeEnum = {
  /** Trade (multiple legs) for settlement */
  Trade: 'Trade',
  /** Asset transaction (one-leg) for settlement */
  AssetTransaction: 'AssetTransaction',
} as const;
export type LPSettlementEventTypeEnum = (typeof LPSettlementEventTypeEnum)[keyof typeof LPSettlementEventTypeEnum];

export const LPSettlementInstructionRequestStatusEnum = {
  /** Successfully marked complete */
  Completed: 'Completed',
  /** Request encountered an error */
  Error: 'Error',
  /** Request validation failed */
  Rejected: 'Rejected',
  /** Transfer request sent */
  Initiated: 'Initiated',
} as const;
export type LPSettlementInstructionRequestStatusEnum =
  (typeof LPSettlementInstructionRequestStatusEnum)[keyof typeof LPSettlementInstructionRequestStatusEnum];

export const LPSettlementInstructionRequestTypeEnum = {
  /** Manually mark an instruction or batch complete */
  ManualComplete: 'ManualComplete',
  /** Reread Batches and instructions from the database */
  AdminRereadState: 'AdminRereadState',
  /** Initiate a transfer */
  InitiateTransfer: 'InitiateTransfer',
} as const;
export type LPSettlementInstructionRequestTypeEnum =
  (typeof LPSettlementInstructionRequestTypeEnum)[keyof typeof LPSettlementInstructionRequestTypeEnum];

export const LPSettlementInstructionStatusEnum = {
  /** Preview only */
  Previewed: 'Previewed',
  /** Pending Initiation / Receipt */
  Pending: 'Pending',
  /** Related transaction in progress */
  InFlight: 'InFlight',
  /** Completed */
  Completed: 'Completed',
  /** Related transaction encountered an error */
  Error: 'Error',
  /** Discarded */
  Discarded: 'Discarded',
  /** Related transaction has been requested */
  Requested: 'Requested',
} as const;
export type LPSettlementInstructionStatusEnum =
  (typeof LPSettlementInstructionStatusEnum)[keyof typeof LPSettlementInstructionStatusEnum];

export const LedgerAccountBalanceTypeEnum = {
  /** Current */
  Current: 'Current',
  /** Snapshot */
  Snapshot: 'Snapshot',
} as const;
export type LedgerAccountBalanceTypeEnum =
  (typeof LedgerAccountBalanceTypeEnum)[keyof typeof LedgerAccountBalanceTypeEnum];

export const LedgerAccountTypeEnum = {
  /** MarketAccountLedger */
  MarketAccount: 'MarketAccount',
  /** SubAccountLedger */
  SubAccount: 'SubAccount',
} as const;
export type LedgerAccountTypeEnum = (typeof LedgerAccountTypeEnum)[keyof typeof LedgerAccountTypeEnum];

export const LedgerAssetActionTypeEnum = {
  /** Mark the current derivative position with the provided mark price and generate MarkToMarketPnL. Also sets AvgCost to the provided mark price */
  MarkAndRealizePosition: 'MarkAndRealizePosition',
} as const;
export type LedgerAssetActionTypeEnum = (typeof LedgerAssetActionTypeEnum)[keyof typeof LedgerAssetActionTypeEnum];

export const LedgerUpdateStatusEnum = {
  /** Update is pending approval */
  PendingApproval: 'PendingApproval',
  /** Update has been applied successfully */
  Completed: 'Completed',
  /** Failed to apply the update */
  Rejected: 'Rejected',
  /** An error occurred while trying to apply the update */
  Error: 'Error',
} as const;
export type LedgerUpdateStatusEnum = (typeof LedgerUpdateStatusEnum)[keyof typeof LedgerUpdateStatusEnum];

export const LedgerUpdateTypeEnum = {
  /** Set the balance to a value */
  Balance: 'Balance',
  /** Trade in account */
  Trade: 'Trade',
  /** Charge trading fee from account */
  TradingFee: 'TradingFee',
  /** Set trading fees for account */
  TradingFeeSet: 'TradingFeeSet',
  /** Accumulation of trading fee(s). Only affects the CumFees field */
  TradingFeeAccum: 'TradingFeeAccum',
  /** Adjust the balance by a delta, ie: a transfer in or out of the account */
  BalanceDelta: 'BalanceDelta',
  /** Trade Cancel */
  TradeCancel: 'TradeCancel',
  /** Trade Amend */
  TradeAmend: 'TradeAmend',
  /** Deprecated, do not use. Previous description: Trade allocation to account */
  Allocation: 'Allocation',
  /** Set the Unsettled balance / position */
  Unsettled: 'Unsettled',
  /** Adjust the Unsettled balance / position */
  UnsettledDelta: 'UnsettledDelta',
  /** Set the FundingPnL associated with this ledger */
  FundingPnL: 'FundingPnL',
  /** Adjust the FundingPnL associated with this ledger */
  FundingPnLDelta: 'FundingPnLDelta',
  /** Accumulation of funding-pnl. Only affects the FundingPnL field */
  FundingPnLAccum: 'FundingPnLAccum',
  /** Set the RealizedPnL associated with this ledger */
  RealizedPnL: 'RealizedPnL',
  /** Adjust the RealizedPnL associated with this ledger */
  RealizedPnLDelta: 'RealizedPnLDelta',
  /** Accumulation of realized-pnl. Only affects the RealizedPnL field */
  RealizedPnLAccum: 'RealizedPnLAccum',
  /** A balance delta from Reconciliation */
  ReconAdjustment: 'ReconAdjustment',
  /** A balance delta from Deposit */
  Deposit: 'Deposit',
  /** A balance delta from Withdrawal */
  Withdrawal: 'Withdrawal',
  /** A balance delta fee from a Transfer */
  TransferFee: 'TransferFee',
  /** A balance delta fee from a Transfer */
  Delivery: 'Delivery',
  /** Balance delta for rewards from staked assets */
  StakingReward: 'StakingReward',
  /** Balance delta for fees from staked assets */
  StakingRewardFee: 'StakingRewardFee',
  /** Settlement / credit reset */
  Settlement: 'Settlement',
  /** Preliminary amount for creating shares of a fund. */
  PreliminaryCreate: 'PreliminaryCreate',
  /** Final amount for creating shares of a fund. */
  FinalCreate: 'FinalCreate',
  /** Preliminary amount for redeeming shares of a fund. */
  PreliminaryRedeem: 'PreliminaryRedeem',
  /** Final amount for redeeming shares of a fund. */
  FinalRedeem: 'FinalRedeem',
  /** Management fee charged for managing a fund. */
  ManagementFee: 'ManagementFee',
  /** Interest received for cash held in a deposit savings account. */
  DepositInterest: 'DepositInterest',
  /** Miscellaneous fees. */
  MiscFee: 'MiscFee',
  /** Cash disbursement (lender side) or receipt (borrower side) at loan origination or drawdown. */
  LoanPrincipal: 'LoanPrincipal',
  /** Return of principal by the borrower. */
  LoanPrincipalRepayment: 'LoanPrincipalRepayment',
  /** Collateral transferred to secure the loan, from borrower to lender. */
  CollateralPost: 'CollateralPost',
  /** Full return of collateral to borrower at loan termination. */
  CollateralRelease: 'CollateralRelease',
  /** Return of the original collateral asset to the borrower / repo seller. */
  CollateralSubstitutionOut: 'CollateralSubstitutionOut',
  /** Receipt of the replacement collateral asset (swap of collateral). */
  CollateralSubstitutionIn: 'CollateralSubstitutionIn',
  /** Coupon / interest payment when it settles. */
  LoanInterest: 'LoanInterest',
  /** Penalty cash payment when an interest or principal payment is overdue. Configured as Late Fee % on the MLA. */
  LateFee: 'LateFee',
  /** Penalty for early repayment. */
  PrepaymentFee: 'PrepaymentFee',
  /** One-time fee charged at loan origination. */
  OriginationFee: 'OriginationFee',
  /** Cash settlement of a margin call on a repo (alternative to posting additional collateral). */
  CashMarginPayment: 'CashMarginPayment',
  /** Income earned on collateral during the life of a repo (e.g. staking rewards on ETH, coupon on a tokenised bond) passed through to the original owner. */
  ManufacturedPayment: 'ManufacturedPayment',
  /** Cash received from selling seized collateral after a default. For loans: output of the liquidation process. For repos: close-out netting settlement. Net amount may result in a payment to the defaulting party (excess) or a claim against them (shortfall). */
  LiquidationProceeds: 'LiquidationProceeds',
  /** A balance delta from an external reconciliation adjustment. */
  ExternalReconAdjustment: 'ExternalReconAdjustment',
  /** Balance delta from creating fund shares in exchange for a basket of constituent assets rather than cash. */
  InKindCreate: 'InKindCreate',
  /** Balance delta from redeeming fund shares in exchange for a basket of constituent assets rather than cash. */
  InKindRedeem: 'InKindRedeem',
  /** Adjust the MarkToMarketPnL associated with this ledger. */
  MarkToMarketPnL: 'MarkToMarketPnL',
  /** Accumulation of MarkToMarketPnL. Affects the RealizedPnL field today (no separate field). */
  MarkToMarketPnLAccum: 'MarkToMarketPnLAccum',
} as const;
export type LedgerUpdateTypeEnum = (typeof LedgerUpdateTypeEnum)[keyof typeof LedgerUpdateTypeEnum];

export const LegDirectionEnum = {
  /** Same direction (buy or sell) as the parent order */
  Same: 'Same',
  /** Opposite direction (buy or sell) as the parent order */
  Opposite: 'Opposite',
} as const;
export type LegDirectionEnum = (typeof LegDirectionEnum)[keyof typeof LegDirectionEnum];

export const LendingRelationshipStatusEnum = {
  /** Enabled */
  Enabled: 'Enabled',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type LendingRelationshipStatusEnum =
  (typeof LendingRelationshipStatusEnum)[keyof typeof LendingRelationshipStatusEnum];

export const LimitStatusEnum = {
  /** Valid/ok state */
  Valid: 'Valid',
  /** Invalid/breached state */
  Breached: 'Breached',
} as const;
export type LimitStatusEnum = (typeof LimitStatusEnum)[keyof typeof LimitStatusEnum];

export const LiquidityTypeEnum = {
  /** Indicative liquidity */
  Indicative: 'Indicative',
  /** Firm liquidity */
  Firm: 'Firm',
} as const;
export type LiquidityTypeEnum = (typeof LiquidityTypeEnum)[keyof typeof LiquidityTypeEnum];

export const LoanActionEnum = {
  /** Move the loan to the closed state */
  CloseLoan: 'CloseLoan',
} as const;
export type LoanActionEnum = (typeof LoanActionEnum)[keyof typeof LoanActionEnum];

export const LoanAdminActionEnum = {
  /** Move the loan to the closed state */
  CloseLoan: 'CloseLoan',
} as const;
export type LoanAdminActionEnum = (typeof LoanAdminActionEnum)[keyof typeof LoanAdminActionEnum];

export const LoanCollateralCurrencyStatusEnum = {
  /** Enabled */
  Enabled: 'Enabled',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type LoanCollateralCurrencyStatusEnum =
  (typeof LoanCollateralCurrencyStatusEnum)[keyof typeof LoanCollateralCurrencyStatusEnum];

export const LoanHandlingErrorEnum = {
  /** The requested revision is no longer available. Try again. */
  RevisionConflict: 'RevisionConflict',
  /** A referenced Loan could not be found. */
  UnknownLoan: 'UnknownLoan',
  /** The requested action is not allowed in the current Loan state. */
  InvalidRequest: 'InvalidRequest',
  /** Unexpected system conditions encountered. */
  SystemError: 'SystemError',
  /** An ID that should be unique was reused. */
  DuplicateID: 'DuplicateID',
  /** Request attempted to Handle an Inactive Loan */
  InactiveLoan: 'InactiveLoan',
} as const;
export type LoanHandlingErrorEnum = (typeof LoanHandlingErrorEnum)[keyof typeof LoanHandlingErrorEnum];

export const LoanPaymentTypeEnum = {
  /** Periodic payments */
  Periodic: 'Periodic',
  /** Payment at maturity */
  Bullet: 'Bullet',
} as const;
export type LoanPaymentTypeEnum = (typeof LoanPaymentTypeEnum)[keyof typeof LoanPaymentTypeEnum];

export const LoanPrincipalCurrencyStatusEnum = {
  /** Enabled */
  Enabled: 'Enabled',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type LoanPrincipalCurrencyStatusEnum =
  (typeof LoanPrincipalCurrencyStatusEnum)[keyof typeof LoanPrincipalCurrencyStatusEnum];

export const LoanQuoteAdminActionEnum = {
  /** Move the loan quote to an error state */
  ErrorLoanQuote: 'ErrorLoanQuote',
} as const;
export type LoanQuoteAdminActionEnum = (typeof LoanQuoteAdminActionEnum)[keyof typeof LoanQuoteAdminActionEnum];

export const LoanQuoteRequestTypeEnum = {
  /** A request that results in a non-executable quote. */
  Indicative: 'Indicative',
  /** A request that results in an executable quote. */
  Executable: 'Executable',
} as const;
export type LoanQuoteRequestTypeEnum = (typeof LoanQuoteRequestTypeEnum)[keyof typeof LoanQuoteRequestTypeEnum];

export const LoanQuoteStatusEnum = {
  /** Quote is submitted, pending response. */
  PendingNew: 'PendingNew',
  /** Lender has provided a firm quote which can be accepted or negotiated. */
  LenderFirm: 'LenderFirm',
  /** Borrower has provided a firm quote which can be accepted or negotiated. */
  BorrowerFirm: 'BorrowerFirm',
  /** An error has occurred processing the quote. */
  Error: 'Error',
  /** The quote is filled */
  Filled: 'Filled',
  /** The term sheet has been request from the ESign system and creation and distribution are pending. */
  TermSheetRequested: 'TermSheetRequested',
  /** The ESign system as sent the term sheet to the recipients and awaits signatures. */
  TermSheetSent: 'TermSheetSent',
  /** The term sheet has been signed by all recipients. */
  TermSheetAllSigned: 'TermSheetAllSigned',
  /** Canceled by Initiator */
  Canceled: 'Canceled',
  /** Rejected by Responder */
  Rejected: 'Rejected',
  /** Quote reached EndTime before negotiation finished. */
  Expired: 'Expired',
} as const;
export type LoanQuoteStatusEnum = (typeof LoanQuoteStatusEnum)[keyof typeof LoanQuoteStatusEnum];

export const LoanQuoteTerminationTypeEnum = {
  /** Fixed term */
  Fixed: 'Fixed',
  /** Open term */
  OpenTerm: 'OpenTerm',
} as const;
export type LoanQuoteTerminationTypeEnum =
  (typeof LoanQuoteTerminationTypeEnum)[keyof typeof LoanQuoteTerminationTypeEnum];

export const LoanQuoteValidationErrorEnum = {
  /** The requested revision is no longer available. Try again. */
  RevisionConflict: 'RevisionConflict',
  /** A referenced quote could not be found. */
  UnknownQuote: 'UnknownQuote',
  /** The requested action is not allowed in the current quote state. */
  InvalidRequest: 'InvalidRequest',
  /** Unexpected system conditions encountered. */
  SystemError: 'SystemError',
  /** An ID that should be unique was reused. */
  DuplicateID: 'DuplicateID',
} as const;
export type LoanQuoteValidationErrorEnum =
  (typeof LoanQuoteValidationErrorEnum)[keyof typeof LoanQuoteValidationErrorEnum];

export const LoanSecurityTypeEnum = {
  /** Loan is collateralized */
  Secured: 'Secured',
  /** Loan has no collateral */
  Unsecured: 'Unsecured',
} as const;
export type LoanSecurityTypeEnum = (typeof LoanSecurityTypeEnum)[keyof typeof LoanSecurityTypeEnum];

export const LoanSideEnum = {
  /** Borrow */
  Borrow: 'Borrow',
  /** Lend */
  Lend: 'Lend',
} as const;
export type LoanSideEnum = (typeof LoanSideEnum)[keyof typeof LoanSideEnum];

export const LoanStatusEnum = {
  /** The loan terms are set, has not reached termination, and is in good state for activity. */
  Open: 'Open',
  /** The loan reached termination and will have no further activity. */
  Closed: 'Closed',
  /** An error has occurred processing the loan. */
  Error: 'Error',
} as const;
export type LoanStatusEnum = (typeof LoanStatusEnum)[keyof typeof LoanStatusEnum];

export const LoanTransactionAdminActionEnum = {
  /** Move the loan transaction to an error state */
  ErrorLoanTransaction: 'ErrorLoanTransaction',
} as const;
export type LoanTransactionAdminActionEnum =
  (typeof LoanTransactionAdminActionEnum)[keyof typeof LoanTransactionAdminActionEnum];

export const LoanTransactionHandlingErrorEnum = {
  /** The requested revision is no longer available. Try again. */
  RevisionConflict: 'RevisionConflict',
  /** A referenced Loan Transaction could not be found. */
  UnknownLoanTxn: 'UnknownLoanTxn',
  /** The requested action is not allowed in the current Loan Transaction state. */
  InvalidRequest: 'InvalidRequest',
  /** Unexpected system conditions encountered. */
  SystemError: 'SystemError',
  /** An ID that should be unique was reused. */
  DuplicateID: 'DuplicateID',
  /** An issue was found with at least one market account involved in this transaction */
  MarketAccountError: 'MarketAccountError',
  /** Request attempted to Handle an Inactive Loan Transaction */
  InactiveLoanTransaction: 'InactiveLoanTransaction',
} as const;
export type LoanTransactionHandlingErrorEnum =
  (typeof LoanTransactionHandlingErrorEnum)[keyof typeof LoanTransactionHandlingErrorEnum];

export const LoanTransactionStatusEnum = {
  /** The conversion rate needed to calculate the transaction's amount has been sent. */
  RateRequestSent: 'RateRequestSent',
  /** The transaction's conversion rate request has been acknowledged. The rate is pending. */
  RateRequestAckd: 'RateRequestAckd',
  /** The transaction has been generated and awaits instructions. */
  New: 'New',
  /** The transaction has been reviewed and transfer initiation has been requested. */
  TransferSubmitted: 'TransferSubmitted',
  /** The transfer gateway has acknowledged the transfer request. */
  TransferPending: 'TransferPending',
  /** The transfers gateway has indicated that further auth is required before the transfer can proceed */
  TransferWaitingForExternalAuth: 'TransferWaitingForExternalAuth',
  /** The transfers subsystem has reported that the provider has acknowledged the request. */
  TransferProcessing: 'TransferProcessing',
  /** The transaction and associated transfer has completed successfully. */
  Completed: 'Completed',
  /** The transaction and associated transfer has been rejected. This is triggered by the provider or end-user action at the provider. */
  Rejected: 'Rejected',
  /** The transaction has been canceled. This is triggered by end-user action on the system. */
  Canceled: 'Canceled',
  /** An error has occurred processing the transaction. */
  Error: 'Error',
} as const;
export type LoanTransactionStatusEnum = (typeof LoanTransactionStatusEnum)[keyof typeof LoanTransactionStatusEnum];

export const LoanTransactionTypeEnum = {
  /** The transaction is related to principal. */
  Principal: 'Principal',
  /** The transaction is related to collateral. */
  Collateral: 'Collateral',
} as const;
export type LoanTransactionTypeEnum = (typeof LoanTransactionTypeEnum)[keyof typeof LoanTransactionTypeEnum];

export const LockRequestTypeEnum = {
  /** Lock */
  Lock: 'Lock',
  /** Release */
  Release: 'Release',
} as const;
export type LockRequestTypeEnum = (typeof LockRequestTypeEnum)[keyof typeof LockRequestTypeEnum];

export const LockUnderlyingObjectTypeEnum = {
  /** Order */
  Order: 'Order',
  /** RFQ */
  RFQ: 'RFQ',
  /** Withdrawal */
  Withdrawal: 'Withdrawal',
} as const;
export type LockUnderlyingObjectTypeEnum =
  (typeof LockUnderlyingObjectTypeEnum)[keyof typeof LockUnderlyingObjectTypeEnum];

export const MDEntryTypeEnum = {
  /** Bid */
  Bid: 'Bid',
  /** Offer */
  Offer: 'Offer',
  /** Trade */
  Trade: 'Trade',
  /** Book Reset */
  BookReset: 'BookReset',
  /** Book Stale */
  BookStale: 'BookStale',
  /** Book Keepalive */
  BookKeepalive: 'BookKeepalive',
  /** Trades Reset */
  TradesReset: 'TradesReset',
  /** Trades Stale */
  TradesStale: 'TradesStale',
  /** Trades Keepalive */
  TradesKeepalive: 'TradesKeepalive',
  /** Margin Funding Rate */
  FundingRate: 'FundingRate',
  /** Margin Funding Time */
  FundingTime: 'FundingTime',
  /** Predicted Next Funding Rate */
  PredictedNextFundingRate: 'PredictedNextFundingRate',
  /** Next Funding Time */
  NextFundingTime: 'NextFundingTime',
  /** Volume24h */
  Volume24h: 'Volume24h',
  /** Turnover24h */
  Turnover24h: 'Turnover24h',
  /** Open Interest */
  OpenInterest: 'OpenInterest',
  /** Mark Price */
  MarkPrice: 'MarkPrice',
  /** Open Value */
  OpenValue: 'OpenValue',
  /** Book Offline */
  BookOffline: 'BookOffline',
  /** Trades Offline */
  TradesOffline: 'TradesOffline',
  /** Delta */
  Delta: 'Delta',
  /** Gamma */
  Gamma: 'Gamma',
  /** Vega */
  Vega: 'Vega',
  /** Theta */
  Theta: 'Theta',
  /** Rho */
  Rho: 'Rho',
  /** Mark Price IV */
  MarkPriceIV: 'MarkPriceIV',
  /** Best Bid IV */
  BestBidIV: 'BestBidIV',
  /** Best Bid IV */
  BestOfferIV: 'BestOfferIV',
  /** Underlying Price */
  UnderlyingPrice: 'UnderlyingPrice',
  /** Index Price */
  IndexPrice: 'IndexPrice',
  /** Last Price */
  LastPrice: 'LastPrice',
  /** Minimum Order Price */
  MinOrderPrice: 'MinOrderPrice',
  /** Maximum Order Price */
  MaxOrderPrice: 'MaxOrderPrice',
  /** Funding Rate for Long Positions */
  FundingRateLong: 'FundingRateLong',
  /** Funding Rate for Short Positions */
  FundingRateShort: 'FundingRateShort',
  /** Bid */
  BestBid: 'BestBid',
  /** Offer */
  BestOffer: 'BestOffer',
} as const;
export type MDEntryTypeEnum = (typeof MDEntryTypeEnum)[keyof typeof MDEntryTypeEnum];

export const MDUpdateActionEnum = {
  /** New */
  New: 'New',
  /** Change */
  Change: 'Change',
  /** Delete */
  Delete: 'Delete',
  /** SizeDelta */
  SizeDelta: 'SizeDelta',
} as const;
export type MDUpdateActionEnum = (typeof MDUpdateActionEnum)[keyof typeof MDUpdateActionEnum];

export const MarginAccountTypeEnum = {
  /** Account uses standard margin */
  StandardMargin: 'StandardMargin',
  /** Account uses portfolio margin */
  PortfolioMargin: 'PortfolioMargin',
} as const;
export type MarginAccountTypeEnum = (typeof MarginAccountTypeEnum)[keyof typeof MarginAccountTypeEnum];

export const MarginAllocationTypeEnum = {
  /** Margin collateral is allocated per position */
  Isolated: 'Isolated',
  /** Margin collateral is shared by positions using the same wallet (e.g. BTC wallet) */
  CrossWallet: 'CrossWallet',
  /** Margin collateral is shared by all positions */
  CrossAccount: 'CrossAccount',
} as const;
export type MarginAllocationTypeEnum = (typeof MarginAllocationTypeEnum)[keyof typeof MarginAllocationTypeEnum];

export const MarginCostStatusEnum = {
  /** Margin cost information has been retrieved successfully */
  Success: 'Success',
  /** Margin cost is not supported for this market */
  NotSupported: 'NotSupported',
  /** There was an error processing the margin cost request */
  Error: 'Error',
} as const;
export type MarginCostStatusEnum = (typeof MarginCostStatusEnum)[keyof typeof MarginCostStatusEnum];

export const MarginPortfolioTypeEnum = {
  /** MarketAccount */
  MarketAccount: 'MarketAccount',
  /** SubAccount */
  SubAccount: 'SubAccount',
} as const;
export type MarginPortfolioTypeEnum = (typeof MarginPortfolioTypeEnum)[keyof typeof MarginPortfolioTypeEnum];

export const MarginReportingTypeEnum = {
  /** Equity / IM / MM reported is specific to the Currency specified */
  Currency: 'Currency',
  /** Equity / IM / MM reported is specific to the market account */
  Account: 'Account',
} as const;
export type MarginReportingTypeEnum = (typeof MarginReportingTypeEnum)[keyof typeof MarginReportingTypeEnum];

export const MarketAccountAgreementTypeEnum = {
  /** No agreement */
  None: 'None',
  /** CreditSupportAnnex */
  CSA: 'CSA',
  /** MasterLoanAgreement */
  MLA: 'MLA',
  /** GlobalMasterRepurchaseAgreement */
  GMRA: 'GMRA',
} as const;
export type MarketAccountAgreementTypeEnum =
  (typeof MarketAccountAgreementTypeEnum)[keyof typeof MarketAccountAgreementTypeEnum];

export const MarketAccountCapabilitiesEnum = {
  /** TransferOutgoingSource */
  TransferOutgoingSource: 'TransferOutgoingSource',
  /** TransferIncomingDest */
  TransferIncomingDest: 'TransferIncomingDest',
  /** TransferOutgoingDest */
  TransferOutgoingDest: 'TransferOutgoingDest',
  /** EquityMarginRatioCheckRequired */
  EquityMarginRatioCheckRequired: 'EquityMarginRatioCheckRequired',
  /** TradingRFQNegotiated */
  TradingRFQNegotiated: 'TradingRFQNegotiated',
  /** OTC */
  OTC: 'OTC',
  /** AcceptAllCurrencies */
  AcceptAllCurrencies: 'AcceptAllCurrencies',
} as const;
export type MarketAccountCapabilitiesEnum =
  (typeof MarketAccountCapabilitiesEnum)[keyof typeof MarketAccountCapabilitiesEnum];

export const MarketAccountOwnershipEnum = {
  /** Internal */
  Internal: 'Internal',
  /** External */
  External: 'External',
} as const;
export type MarketAccountOwnershipEnum = (typeof MarketAccountOwnershipEnum)[keyof typeof MarketAccountOwnershipEnum];

export const MarketAccountStatusEnum = {
  /** Active */
  Active: 'Active',
  /** Inactive */
  Inactive: 'Inactive',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type MarketAccountStatusEnum = (typeof MarketAccountStatusEnum)[keyof typeof MarketAccountStatusEnum];

export const MarketAccountTypeEnum = {
  /** Market account which represents a generic gateway. */
  Gateway: 'Gateway',
  /** Market account for trading. */
  Trading: 'Trading',
  /** Market account for transfers / custody. */
  Transfer: 'Transfer',
  /** Market account for DeFi protocol operations. */
  Defi: 'Defi',
  /** Market account for customers. */
  Customer: 'Customer',
  /** Market account for OTC derivatives / deals. */
  OTCDerivatives: 'OTCDerivatives',
  /** Market account for OTC lending / deals. */
  OTCLending: 'OTCLending',
  /** Market account for OTC repo / deals. */
  OTCRepo: 'OTCRepo',
  /** Unknown */
  Unknown: 'Unknown',
} as const;
export type MarketAccountTypeEnum = (typeof MarketAccountTypeEnum)[keyof typeof MarketAccountTypeEnum];

export const MarketFeeModeEnum = {
  /** Fee is charged in the quote currency */
  QuoteCurrency: 'QuoteCurrency',
  /** Fee is charged in the currency received e.g Buy BTC-USD will be charged in BTC */
  ReceiveCurrency: 'ReceiveCurrency',
  /** Fee is charged using ReceiveCurrency mode for maker orders and QuoteCurrency mode for taker orders */
  MakerReceiveTakerQuote: 'MakerReceiveTakerQuote',
  /** Fee is charged in the currency received for positive fees and outgoing currency for negative fees */
  PositiveReceiveNegativeOutgoing: 'PositiveReceiveNegativeOutgoing',
  /** DEPRACATED: Fee is charged in currency that's unrelated to the traded symbol. E.g: always charge fees in USD regardless of traded symbol */
  UnrelatedCurrency: 'UnrelatedCurrency',
  /** Fee is charged in currency in the amount currency of the order. E.g: regular order => Quote, Counter Currency Order => Base */
  AmountCurrency: 'AmountCurrency',
  /** Fee is charged in a specific currency. */
  SpecificCurrency: 'SpecificCurrency',
  /** Fee is charged in the outgoing currency e.g Buy BTC-USD will be charged in USD, Sell will be charged in BTC */
  OutgoingCurrency: 'OutgoingCurrency',
} as const;
export type MarketFeeModeEnum = (typeof MarketFeeModeEnum)[keyof typeof MarketFeeModeEnum];

export const MarketFlagsEnum = {
  /** Indicates if a quote from this market will at exactly the quoted price */
  QuotesFillAtRequestedPrice: 'QuotesFillAtRequestedPrice',
  /** Indicates if the market supports native counter currency */
  SupportsNativeCounterCurrency: 'SupportsNativeCounterCurrency',
  /** Indicates if orders on this market fill at exactly the requested price, e.g. the market does not support price improvement */
  OrdersFillAtRequestedPrice: 'OrdersFillAtRequestedPrice',
  /** Indicates that the exchange market supports credit limits */
  SupportsExchangeCredit: 'SupportsExchangeCredit',
  /** Indicates that the market provides asymmetric limits for trading */
  AsymmetricTradeLimits: 'AsymmetricTradeLimits',
  /** Indicates that the market supports sending average price when sweeping through multiple levels */
  SupportsOrdersAtAveragePrice: 'SupportsOrdersAtAveragePrice',
  /** Indicates that the market requires buy orders in quote and sell orders in base currencies */
  BuyInQuoteSellInBaseCurrency: 'BuyInQuoteSellInBaseCurrency',
  /** Indicates that the market supports margin cost calculation */
  SupportsMarginCost: 'SupportsMarginCost',
  /** Indicates that the market supports reduce only */
  SupportsReduceOnly: 'SupportsReduceOnly',
  /** Indicates that the market supports SpreadToFixing PricingMode */
  SupportsSpreadToFixing: 'SupportsSpreadToFixing',
  /** Indicates that the market will publish a book that incorporates fees */
  SupportsFeeBooks: 'SupportsFeeBooks',
  /** Indicates if the market supports native market orders */
  SupportsNativeMarketOrder: 'SupportsNativeMarketOrder',
  /** Indicates if the market supports order cancel replace requests */
  SupportsOrderCancelReplace: 'SupportsOrderCancelReplace',
  /** Indicates if the market supports stacked (multiple inflight) order cancel replace requests */
  SupportsStackedOrderCancelReplace: 'SupportsStackedOrderCancelReplace',
  /** Indicates that the market supports only 1-way RFQ (not 2-way) */
  SupportsOnlyOneWayRFQ: 'SupportsOnlyOneWayRFQ',
  /** Indicates that the market supports arbitrary price/strike quotes */
  SupportsCustomOptions: 'SupportsCustomOptions',
} as const;
export type MarketFlagsEnum = (typeof MarketFlagsEnum)[keyof typeof MarketFlagsEnum];

export const MarketParameterPropertyEnum = {
  /** ParentStrategy */
  ParentStrategy: 'ParentStrategy',
  /** UnifiedLiquidityConversionRate */
  UnifiedLiquidityConversionRate: 'UnifiedLiquidityConversionRate',
  /** ParentCounterparty */
  ParentCounterparty: 'ParentCounterparty',
  /** PostTradeClearingSymbol */
  PostTradeClearingSymbol: 'PostTradeClearingSymbol',
  /** AllocationReason */
  AllocationReason: 'AllocationReason',
  /** Which balance to use for the order */
  BalanceCurrency: 'BalanceCurrency',
  /** User expressed outcome for prediction outcome orders */
  ExpressedOutcome: 'ExpressedOutcome',
} as const;
export type MarketParameterPropertyEnum =
  (typeof MarketParameterPropertyEnum)[keyof typeof MarketParameterPropertyEnum];

export const MarketTypeEnum = {
  /** Exchange */
  Exchange: 'Exchange',
  /** Dealer */
  Dealer: 'Dealer',
  /** Custodian */
  Custodian: 'Custodian',
  /** External */
  External: 'External',
  /** Internal order-processing algo */
  InternalAlgo: 'InternalAlgo',
  /** Dark pool */
  Dark: 'Dark',
  /** Decentralized finance venue */
  Defi: 'Defi',
} as const;
export type MarketTypeEnum = (typeof MarketTypeEnum)[keyof typeof MarketTypeEnum];

export const MessageDirectionEnum = {
  /** Inbound message */
  Inbound: 'Inbound',
  /** Outbound message */
  Outbound: 'Outbound',
  /** Messages from Talos System to the Gateway */
  InboundFromSystem: 'InboundFromSystem',
  /** Messages to Talos System from the Gateway */
  OutboundToSystem: 'OutboundToSystem',
} as const;
export type MessageDirectionEnum = (typeof MessageDirectionEnum)[keyof typeof MessageDirectionEnum];

export const MessageProcessingRateLimitDefinitionTypeEnum = {
  /** Tallies the number of customer market data snapshot subscriptions */
  CustomerMarketDataSubscription: 'CustomerMarketDataSubscription',
  /** Tallies the number of customer quote requests */
  CustomerQuoteRequests: 'CustomerQuoteRequests',
  /** Tallies the number of customer order requests */
  CustomerOrderRequests: 'CustomerOrderRequests',
} as const;
export type MessageProcessingRateLimitDefinitionTypeEnum =
  (typeof MessageProcessingRateLimitDefinitionTypeEnum)[keyof typeof MessageProcessingRateLimitDefinitionTypeEnum];

export const ModeEnum = {
  /** Enabled/up/on state */
  Enabled: 'Enabled',
  /** Disabled/down/off state */
  Disabled: 'Disabled',
} as const;
export type ModeEnum = (typeof ModeEnum)[keyof typeof ModeEnum];

export const MoneynessBucketEnum = {
  /** Outright */
  Outright: 'Outright',
  /** D10 */
  D10: 'D10',
  /** D25 */
  D25: 'D25',
  /** D50 */
  D50: 'D50',
  /** D75 */
  D75: 'D75',
  /** D90 */
  D90: 'D90',
} as const;
export type MoneynessBucketEnum = (typeof MoneynessBucketEnum)[keyof typeof MoneynessBucketEnum];

export const MonitorScopeEnum = {
  /** All users */
  All: 'All',
  /** Owners and specified users */
  OwnerPlusSpecified: 'OwnerPlusSpecified',
  /** Specified users only */
  SpecifiedOnly: 'SpecifiedOnly',
} as const;
export type MonitorScopeEnum = (typeof MonitorScopeEnum)[keyof typeof MonitorScopeEnum];

export const MultilegReportingTypeEnum = {
  /** Parent */
  Parent: 'Parent',
  /** Leg */
  Leg: 'Leg',
} as const;
export type MultilegReportingTypeEnum = (typeof MultilegReportingTypeEnum)[keyof typeof MultilegReportingTypeEnum];

export const NegotiationStatusEnum = {
  /** Price improvement request has been sent */
  PendingPriceUpdate: 'PendingPriceUpdate',
} as const;
export type NegotiationStatusEnum = (typeof NegotiationStatusEnum)[keyof typeof NegotiationStatusEnum];

export const NormalizedLogTypeEnum = {
  /** GatewayOrderSender */
  GatewayOrderSender: 'GatewayOrderSender',
  /** OMS */
  OMS: 'OMS',
  /** GatewayNewOrderSingle */
  GatewayNewOrderSingle: 'GatewayNewOrderSingle',
  /** GatewayTradeFill */
  GatewayTradeFill: 'GatewayTradeFill',
  /** GatewayOrderRecovery */
  GatewayOrderRecovery: 'GatewayOrderRecovery',
  /** GatewayCancelRequest */
  GatewayCancelRequest: 'GatewayCancelRequest',
  /** ContinuousRecovery */
  ContinuousRecovery: 'ContinuousRecovery',
  /** SystemCancelRequest */
  SystemCancelRequest: 'SystemCancelRequest',
  /** GatewayReplaceRequest */
  GatewayReplaceRequest: 'GatewayReplaceRequest',
  /** SystemCancelReplaceRequest */
  SystemCancelReplaceRequest: 'SystemCancelReplaceRequest',
  /** OrderCancelReject */
  OrderCancelReject: 'OrderCancelReject',
} as const;
export type NormalizedLogTypeEnum = (typeof NormalizedLogTypeEnum)[keyof typeof NormalizedLogTypeEnum];

export const NotificationDeliveryTypeEnum = {
  /** InApp */
  InApp: 'InApp',
  /** Email */
  Email: 'Email',
  /** Slack */
  Slack: 'Slack',
  /** Telegram */
  Telegram: 'Telegram',
} as const;
export type NotificationDeliveryTypeEnum =
  (typeof NotificationDeliveryTypeEnum)[keyof typeof NotificationDeliveryTypeEnum];

export const NotificationSeverityEnum = {
  /** High */
  High: 'High',
  /** Medium */
  Medium: 'Medium',
  /** Low */
  Low: 'Low',
} as const;
export type NotificationSeverityEnum = (typeof NotificationSeverityEnum)[keyof typeof NotificationSeverityEnum];

export const NotificationStateEnum = {
  /** New */
  New: 'New',
  /** Archived */
  Archived: 'Archived',
  /** Withdrawn */
  Withdrawn: 'Withdrawn',
  /** Delivered */
  Delivered: 'Delivered',
  /** Error */
  Error: 'Error',
} as const;
export type NotificationStateEnum = (typeof NotificationStateEnum)[keyof typeof NotificationStateEnum];

export const NotificationSubtypeEnum = {
  /** OrderPaused */
  OrderPaused: 'OrderPaused',
  /** OrderRejected */
  OrderRejected: 'OrderRejected',
  /** OrderFilled */
  OrderFilled: 'OrderFilled',
  /** OrderFilledAndCanceled */
  OrderFilledAndCanceled: 'OrderFilledAndCanceled',
  /** OrderCanceled */
  OrderCanceled: 'OrderCanceled',
  /** OrderOpen */
  OrderOpen: 'OrderOpen',
  /** OrderWaiting */
  OrderWaiting: 'OrderWaiting',
  /** OrderStaged */
  OrderStaged: 'OrderStaged',
  /** OrderSystemPaused */
  OrderSystemPaused: 'OrderSystemPaused',
  /** OrderPendingFix */
  OrderPendingFix: 'OrderPendingFix',
  /** OrderPendingCancel */
  OrderPendingCancel: 'OrderPendingCancel',
  /** OrderPendingReplace */
  OrderPendingReplace: 'OrderPendingReplace',
  /** OrderAllOpen */
  OrderAllOpen: 'OrderAllOpen',
  /** OrderAllFilled */
  OrderAllFilled: 'OrderAllFilled',
  /** OrderAllCanceled */
  OrderAllCanceled: 'OrderAllCanceled',
  /** OrderAllRejected */
  OrderAllRejected: 'OrderAllRejected',
  /** CustomerQuoteFixingNeeded */
  CustomerQuoteFixingNeeded: 'CustomerQuoteFixingNeeded',
  /** CustomerMarginCall */
  CustomerMarginCall: 'CustomerMarginCall',
  /** CustomerLiquidation */
  CustomerLiquidation: 'CustomerLiquidation',
  /** AuditMarketConnection */
  AuditMarketConnection: 'AuditMarketConnection',
  /** AuditTradingLimit */
  AuditTradingLimit: 'AuditTradingLimit',
  /** AuditCounterparty */
  AuditCounterparty: 'AuditCounterparty',
  /** AuditUserCredential */
  AuditUserCredential: 'AuditUserCredential',
  /** AuditSubaccount */
  AuditSubaccount: 'AuditSubaccount',
  /** AuditApiPermissionFilter */
  AuditApiPermissionFilter: 'AuditApiPermissionFilter',
  /** AuditUser */
  AuditUser: 'AuditUser',
  /** AuditUserRole */
  AuditUserRole: 'AuditUserRole',
  /** AuditApiKey */
  AuditApiKey: 'AuditApiKey',
  /** AuditApiKeyRole */
  AuditApiKeyRole: 'AuditApiKeyRole',
  /** AuditUserSessionMorph */
  AuditUserSessionMorph: 'AuditUserSessionMorph',
  /** AuditUserSessionUnmorph */
  AuditUserSessionUnmorph: 'AuditUserSessionUnmorph',
} as const;
export type NotificationSubtypeEnum = (typeof NotificationSubtypeEnum)[keyof typeof NotificationSubtypeEnum];

export const NotificationTypeEnum = {
  /** OrderStatus */
  OrderStatus: 'OrderStatus',
  /** CustomerQuoteStatus */
  CustomerQuoteStatus: 'CustomerQuoteStatus',
  /** CustomerMarginThreshold */
  CustomerMarginThreshold: 'CustomerMarginThreshold',
  /** AuditLog */
  AuditLog: 'AuditLog',
} as const;
export type NotificationTypeEnum = (typeof NotificationTypeEnum)[keyof typeof NotificationTypeEnum];

export const OMSOrderPropertyEnum = {
  /** LowerBound */
  LowerBound: 'LowerBound',
  /** UpperBound */
  UpperBound: 'UpperBound',
  /** TargetQty */
  TargetQty: 'TargetQty',
  /** CrossingFilledQty */
  CrossingFilledQty: 'CrossingFilledQty',
  /** MarketAlloc */
  CrossingAlloc: 'CrossingAlloc',
  /** LimitAlloc */
  RestingAlloc: 'RestingAlloc',
  /** ReferenceRate */
  ReferenceRate: 'ReferenceRate',
  /** TriggerRate */
  TriggerRate: 'TriggerRate',
  /** PriceProtectionRefRate */
  PriceProtectionRefRate: 'PriceProtectionRefRate',
  /** TargetParticipationRate */
  TargetParticipationRate: 'TargetParticipationRate',
  /** RestingSizeVariance */
  RestingSizeVariance: 'RestingSizeVariance',
  /** PassiveFairPrice */
  PassiveFairPrice: 'PassiveFairPrice',
  /** AggressiveFairPrice */
  AggressiveFairPrice: 'AggressiveFairPrice',
  /** MedianSpread */
  MedianSpread: 'MedianSpread',
  /** HedgeBound */
  HedgeBound: 'HedgeBound',
  /** LegLeavesQty */
  LegLeavesQty: 'LegLeavesQty',
  /** LegLeavesAmt */
  LegLeavesAmt: 'LegLeavesAmt',
  /** LegCumQty */
  LegCumQty: 'LegCumQty',
  /** LegCumAmt */
  LegCumAmt: 'LegCumAmt',
  /** LegPendingFillQty */
  LegPendingFillQty: 'LegPendingFillQty',
  /** LegPendingFillPx */
  LegPendingFillPx: 'LegPendingFillPx',
  /** VolumeInLimit */
  VolumeInLimit: 'VolumeInLimit',
  /** Adjustment */
  Adjustment: 'Adjustment',
  /** AheadBehindRatio */
  AheadBehindRatio: 'AheadBehindRatio',
  /** ParentCumQty */
  ParentCumQty: 'ParentCumQty',
  /** RestingAllInPriceCap */
  RestingAllInPriceCap: 'RestingAllInPriceCap',
  /** RestingAllInPriceCapSize */
  RestingAllInPriceCapSize: 'RestingAllInPriceCapSize',
  /** IntervalVolume */
  IntervalVolume: 'IntervalVolume',
  /** IntervalSpreadBps */
  IntervalSpreadBps: 'IntervalSpreadBps',
  /** IntervalVolatilityBps */
  IntervalVolatilityBps: 'IntervalVolatilityBps',
  /** AverageDailyVolume */
  AverageDailyVolume: 'AverageDailyVolume',
  /** AverageDailyVolume */
  AverageDailyVolumePct: 'AverageDailyVolumePct',
  /** OrderAverageDailyVolumePct */
  OrderAverageDailyVolumePct: 'OrderAverageDailyVolumePct',
  /** PredictedParticipationRatePct */
  PredictedParticipationRatePct: 'PredictedParticipationRatePct',
  /** DailySpreadBps */
  DailySpreadBps: 'DailySpreadBps',
  /** DailyVolatilityBps */
  DailyVolatilityBps: 'DailyVolatilityBps',
  /** BinStartTargetQty */
  BinStartTargetQty: 'BinStartTargetQty',
  /** BinEndTargetQty */
  BinEndTargetQty: 'BinEndTargetQty',
  /** BinVolume */
  BinVolume: 'BinVolume',
  /** BinQty */
  BinQty: 'BinQty',
  /** ExpectedResidualQuantity */
  ExpectedResidualQuantity: 'ExpectedResidualQuantity',
  /** CurrentClipSize */
  CurrentClipSize: 'CurrentClipSize',
  /** CurrentClipStartTime */
  CurrentClipStartTime: 'CurrentClipStartTime',
  /** CurrentClipEndTime */
  CurrentClipEndTime: 'CurrentClipEndTime',
  /** IWouldFilledQty */
  IWouldFilledQty: 'IWouldFilledQty',
  /** IWouldAvgPrice */
  IWouldAvgPrice: 'IWouldAvgPrice',
  /** IWouldAvgPriceImprovement */
  IWouldAvgPriceImprovement: 'IWouldAvgPriceImprovement',
  /** IWouldAllInCrossingCap */
  IWouldAllInCrossingCap: 'IWouldAllInCrossingCap',
  /** BestExchangeTopOfBookAllInPrice */
  BestExchangeTopOfBookAllInPrice: 'BestExchangeTopOfBookAllInPrice',
  /** IWouldAlloc */
  IWouldAlloc: 'IWouldAlloc',
  /** Cost of crossing spread to trade */
  SpreadCost: 'SpreadCost',
  /** Participation rate and daily volatility impact */
  TemporaryCost: 'TemporaryCost',
  /** Cost of trading over a duration of time */
  TimeRisk: 'TimeRisk',
  /** Minimum resting size for an algo order */
  AlgoMinRestingSize: 'AlgoMinRestingSize',
  /** Minimum crossing size for an algo order */
  AlgoMinCrossingSize: 'AlgoMinCrossingSize',
  /** Crossing allocation from snipe-bound arrival aware logic */
  SniperAlloc: 'SniperAlloc',
  /** Crossing allocation from sweep-bound arrival aware logic */
  SweepAlloc: 'SweepAlloc',
  /** Calculated quantity to be executed at the end of the algo order */
  ReservedQty: 'ReservedQty',
  /** Snipe bound threshold price for arrival-aware crossing */
  SnipeBound: 'SnipeBound',
  /** Sweep bound threshold price for arrival-aware crossing */
  SweepBound: 'SweepBound',
  /** Snipe bound as basis points */
  SnipeBoundBps: 'SnipeBoundBps',
  /** Sweep bound as basis points */
  SweepBoundBps: 'SweepBoundBps',
  /** Exit-side book move in bps from initiating order send to first fill */
  HedgeMoveBpsSinceInitiating: 'HedgeMoveBpsSinceInitiating',
  /** Exit-side book move in bps from last decision to first fill */
  LegMoveBpsSinceLastDecision: 'LegMoveBpsSinceLastDecision',
  /** Fill quality bps when parent fill matched or beat the intended price at initiation */
  LastFillHitBpsBetter: 'LastFillHitBpsBetter',
  /** Fill quality bps when parent fill was worse than the intended price at initiation */
  LastFillMissBpsWorse: 'LastFillMissBpsWorse',
  /** Composite mid arrival price used for arrival-aware sniper and sweep decisions */
  ArrivalPrice: 'ArrivalPrice',
  /** ID of the multileg decision, to detect when a decision was reused */
  MultilegDecisionID: 'MultilegDecisionID',
  /** Reason for the decision (reactive, forced) */
  DecisionReason: 'DecisionReason',
  /** Reason for blocking taking new position (balances, no_leg_prices, feed_latency, pending_cancel) */
  NewPositionBlockedReason: 'NewPositionBlockedReason',
  /** Volume-weighted signed bps across all quality-evaluated fills; positive means net better than intended, negative means net worse */
  CumFillHitMissVwBps: 'CumFillHitMissVwBps',
  /** Start time of the current TWAP curve/schedule */
  ScheduleStartTime: 'ScheduleStartTime',
  /** Per-leg schedule adjustment for the current TWAP curve */
  LegAdjustment: 'LegAdjustment',
  /** Side-adjusted order book imbalance (OBI) for the leg, computed from the leg's aggregated snapshot */
  OBIFavourability: 'OBIFavourability',
} as const;
export type OMSOrderPropertyEnum = (typeof OMSOrderPropertyEnum)[keyof typeof OMSOrderPropertyEnum];

export const OPAScopeTypeEnum = {
  /** A release containing exclusively data points with one day (1D) aggregation windows */
  OPAScopeType_1D: 'OPAScopeType_1D',
  /** A release containing exclusively data points with one month (1MO) aggregation windows */
  OPAScopeType_1MO: 'OPAScopeType_1MO',
  /** A release containing exclusively data points with last seven days (L7D) aggregation windows */
  OPAScopeType_L7D: 'OPAScopeType_L7D',
  /** A release containing exclusively data points with last thirty days (L30D) aggregation windows */
  OPAScopeType_L30D: 'OPAScopeType_L30D',
  /** A release containing exclusively data points with month-to-date (MTD) aggregation windows */
  OPAScopeType_MTD: 'OPAScopeType_MTD',
  /** A release containing exclusively data points with month-to-date (WTD) aggregation windows */
  OPAScopeType_WTD: 'OPAScopeType_WTD',
  /** A release potentially containing 1D, 1MO, and 1W which make up the full suite of analytics for the month they are in. */
  OPAScopeType_Legacy: 'OPAScopeType_Legacy',
} as const;
export type OPAScopeTypeEnum = (typeof OPAScopeTypeEnum)[keyof typeof OPAScopeTypeEnum];

export const OTCCollateralProductEnum = {
  /** OTC loan (MLA) collateral pool */
  Loan: 'Loan',
  /** OTC repo (GMRA) collateral pool */
  Repo: 'Repo',
} as const;
export type OTCCollateralProductEnum = (typeof OTCCollateralProductEnum)[keyof typeof OTCCollateralProductEnum];

export const OTCCollateralizationModeEnum = {
  /** LoanToValueRatio */
  LoanToValueRatio: 'LoanToValueRatio',
  /** Percent */
  Percent: 'Percent',
} as const;
export type OTCCollateralizationModeEnum =
  (typeof OTCCollateralizationModeEnum)[keyof typeof OTCCollateralizationModeEnum];

export const OTCCouponPeriodStatusEnum = {
  /** Payment has already settled */
  Past: 'Past',
  /** Period ended but payment not yet settled */
  Due: 'Due',
  /** Period is currently accruing */
  Current: 'Current',
  /** Period has not started yet */
  Future: 'Future',
} as const;
export type OTCCouponPeriodStatusEnum = (typeof OTCCouponPeriodStatusEnum)[keyof typeof OTCCouponPeriodStatusEnum];

export const OTCCouponRowSourceEnum = {
  /** Row sourced from gRPC */
  External: 'External',
  /** Row generated by Ava (principal/collateral lifecycle) */
  Internal: 'Internal',
} as const;
export type OTCCouponRowSourceEnum = (typeof OTCCouponRowSourceEnum)[keyof typeof OTCCouponRowSourceEnum];

export const OTCCouponScheduledPaidAmountTypeEnum = {
  /** Amount is fixed from the schedule or from settled fixings */
  Determined: 'Determined',
  /** Amount is a projection (for example an index-linked coupon still awaiting fixings) */
  Estimated: 'Estimated',
} as const;
export type OTCCouponScheduledPaidAmountTypeEnum =
  (typeof OTCCouponScheduledPaidAmountTypeEnum)[keyof typeof OTCCouponScheduledPaidAmountTypeEnum];

export const OTCCouponTypeEnum = {
  /** Interest payment row; cash_paid is non-zero */
  InterestPayment: 'InterestPayment',
  /** Collateral posted at deal start; AT generated synchronously on activation */
  CollateralPosting: 'CollateralPosting',
  /** Principal transferred at deal start; AT generated synchronously on activation */
  PrincipalTransfer: 'PrincipalTransfer',
  /** Collateral returned at deal maturity */
  CollateralReturn: 'CollateralReturn',
  /** Principal returned at deal maturity */
  PrincipalReturn: 'PrincipalReturn',
  /** Accounting-accrual subperiod row; does not generate an asset transaction */
  AccountingAccrual: 'AccountingAccrual',
} as const;
export type OTCCouponTypeEnum = (typeof OTCCouponTypeEnum)[keyof typeof OTCCouponTypeEnum];

export const OTCDefaultSettlementConventionEnum = {
  /** Delivery versus payment */
  DVP: 'DVP',
  /** Free of payment */
  FOP: 'FOP',
} as const;
export type OTCDefaultSettlementConventionEnum =
  (typeof OTCDefaultSettlementConventionEnum)[keyof typeof OTCDefaultSettlementConventionEnum];

export const OTCHolidayBusinessDayConventionEnum = {
  /** Following */
  Following: 'Following',
  /** ModifiedFollowing */
  ModifiedFollowing: 'ModifiedFollowing',
  /** Preceding */
  Preceding: 'Preceding',
  /** ModifiedPreceding */
  ModifiedPreceding: 'ModifiedPreceding',
  /** Nearest */
  Nearest: 'Nearest',
  /** Unadjusted */
  Unadjusted: 'Unadjusted',
  /** HalfMonthModifiedFollowing */
  HalfMonthModifiedFollowing: 'HalfMonthModifiedFollowing',
} as const;
export type OTCHolidayBusinessDayConventionEnum =
  (typeof OTCHolidayBusinessDayConventionEnum)[keyof typeof OTCHolidayBusinessDayConventionEnum];

export const OTCManufacturedPaymentsEnum = {
  /** PassThrough */
  PassThrough: 'PassThrough',
  /** Retain */
  Retain: 'Retain',
} as const;
export type OTCManufacturedPaymentsEnum =
  (typeof OTCManufacturedPaymentsEnum)[keyof typeof OTCManufacturedPaymentsEnum];

export const OTCMarginManagementPolicyEnum = {
  /** MarginCall */
  MarginCall: 'MarginCall',
  /** AutoLiquidation */
  AutoLiquidation: 'AutoLiquidation',
} as const;
export type OTCMarginManagementPolicyEnum =
  (typeof OTCMarginManagementPolicyEnum)[keyof typeof OTCMarginManagementPolicyEnum];

export const OTCNetExposureMethodEnum = {
  /** Gross */
  Gross: 'Gross',
  /** Net */
  Net: 'Net',
} as const;
export type OTCNetExposureMethodEnum = (typeof OTCNetExposureMethodEnum)[keyof typeof OTCNetExposureMethodEnum];

export const OTCSettlementTypeEnum = {
  /** Cash */
  Cash: 'Cash',
  /** Physical */
  Physical: 'Physical',
} as const;
export type OTCSettlementTypeEnum = (typeof OTCSettlementTypeEnum)[keyof typeof OTCSettlementTypeEnum];

export const OTCTriggerEventsEnum = {
  /** A missed payment event */
  MissedPayment: 'MissedPayment',
  /** A missed / late margin call */
  LateMarginCall: 'LateMarginCall',
} as const;
export type OTCTriggerEventsEnum = (typeof OTCTriggerEventsEnum)[keyof typeof OTCTriggerEventsEnum];

export const OnPlatformAnalyticsTierEnum = {
  /** Only the standard set of On-Platform Analytics as established in 2.44 is available to the Customer: Everything but L7D, L30D, MTD, WTD for previous months */
  Standard: 'Standard',
  /** The definition of premium established in release 2.44: New AggregationWindows (L7D, L30D, MTD, WTD), and data availability within a couple days once calcuated (vs waiting a month) */
  Premium: 'Premium',
} as const;
export type OnPlatformAnalyticsTierEnum =
  (typeof OnPlatformAnalyticsTierEnum)[keyof typeof OnPlatformAnalyticsTierEnum];

export const OptionTypeEnum = {
  /** Call option */
  Call: 'Call',
  /** Put option */
  Put: 'Put',
} as const;
export type OptionTypeEnum = (typeof OptionTypeEnum)[keyof typeof OptionTypeEnum];

export const OrdRejReasonEnum = {
  /** UnknownSymbol */
  UnknownSymbol: 'UnknownSymbol',
  /** ExchangeClosed */
  ExchangeClosed: 'ExchangeClosed',
  /** OrderExceedsLimit */
  OrderExceedsLimit: 'OrderExceedsLimit',
  /** TooLateToEnter */
  TooLateToEnter: 'TooLateToEnter',
  /** UnknownOrder */
  UnknownOrder: 'UnknownOrder',
  /** DuplicateOrder */
  DuplicateOrder: 'DuplicateOrder',
  /** StaleRequest */
  StaleRequest: 'StaleRequest',
  /** UnknownMarket */
  UnknownMarket: 'UnknownMarket',
  /** InternalError */
  InternalError: 'InternalError',
  /** BrokerOption */
  BrokerOption: 'BrokerOption',
  /** RateLimit */
  RateLimit: 'RateLimit',
  /** ForceCancel */
  ForceCancel: 'ForceCancel',
  /** ImmediateOrderDidNotCross */
  ImmediateOrderDidNotCross: 'ImmediateOrderDidNotCross',
  /** PostOnlyOrderWouldCross */
  PostOnlyOrderWouldCross: 'PostOnlyOrderWouldCross',
  /** InvalidStrategy */
  InvalidStrategy: 'InvalidStrategy',
  /** QuoteRequestTimeout */
  QuoteRequestTimeout: 'QuoteRequestTimeout',
  /** QuoteExpired */
  QuoteExpired: 'QuoteExpired',
  /** TransientError */
  TransientError: 'TransientError',
  /** RecoveredDoneOrder */
  RecoveredDoneOrder: 'RecoveredDoneOrder',
  /** RemainingSizeTooSmall */
  RemainingSizeTooSmall: 'RemainingSizeTooSmall',
  /** Crossed */
  Crossed: 'Crossed',
  /** FailedToCompleteAllLegs */
  FailedToCompleteAllLegs: 'FailedToCompleteAllLegs',
  /** SelfTradePrevention */
  SelfTradePrevention: 'SelfTradePrevention',
  /** PendingApproval */
  PendingApproval: 'PendingApproval',
  /** InvalidSizeIncrement */
  InvalidSizeIncrement: 'InvalidSizeIncrement',
  /** AmbiguousMarketAccount */
  AmbiguousMarketAccount: 'AmbiguousMarketAccount',
  /** SymbolDisabled */
  SymbolDisabled: 'SymbolDisabled',
  /** NoAvailableMarket */
  NoAvailableMarket: 'NoAvailableMarket',
  /** SubAccountPermission */
  SubAccountPermission: 'SubAccountPermission',
  /** TradingDisabled */
  TradingDisabled: 'TradingDisabled',
  /** InsufficientPositionToReduce */
  InsufficientPositionToReduce: 'InsufficientPositionToReduce',
  /** MarketDoesNotSupportReduceOnly */
  MarketDoesNotSupportReduceOnly: 'MarketDoesNotSupportReduceOnly',
  /** InvalidSymbol */
  InvalidSymbol: 'InvalidSymbol',
  /** InvalidPriceIncrement */
  InvalidPriceIncrement: 'InvalidPriceIncrement',
  /** CommandApprovalRequestDenied */
  CommandApprovalRequestDenied: 'CommandApprovalRequestDenied',
  /** InvalidSettleDate */
  InvalidSettleDate: 'InvalidSettleDate',
  /** StrategyNotPermitted */
  StrategyNotPermitted: 'StrategyNotPermitted',
} as const;
export type OrdRejReasonEnum = (typeof OrdRejReasonEnum)[keyof typeof OrdRejReasonEnum];

export const OrdRiskStatusEnum = {
  /** Legged */
  Legged: 'Legged',
  /** Erroneous */
  Erroneous: 'Erroneous',
} as const;
export type OrdRiskStatusEnum = (typeof OrdRiskStatusEnum)[keyof typeof OrdRiskStatusEnum];

export const OrdStatusEnum = {
  /** New */
  New: 'New',
  /** PartiallyFilled */
  PartiallyFilled: 'PartiallyFilled',
  /** Filled */
  Filled: 'Filled',
  /** Canceled */
  Canceled: 'Canceled',
  /** Replaced */
  Replaced: 'Replaced',
  /** PendingCancel */
  PendingCancel: 'PendingCancel',
  /** Rejected */
  Rejected: 'Rejected',
  /** PendingNew */
  PendingNew: 'PendingNew',
  /** PendingReplace */
  PendingReplace: 'PendingReplace',
  /** DoneForDay */
  DoneForDay: 'DoneForDay',
  /** Holding Until execution of previous legs after which this will turn PendingNew */
  Holding: 'Holding',
  /** Order confirmed in relative pricing, awaiting fixing */
  PendingFix: 'PendingFix',
} as const;
export type OrdStatusEnum = (typeof OrdStatusEnum)[keyof typeof OrdStatusEnum];

export const OrdTypeEnum = {
  /** Market */
  Market: 'Market',
  /** Limit */
  Limit: 'Limit',
  /** RFQ */
  RFQ: 'RFQ',
  /** LimitAllIn */
  LimitAllIn: 'LimitAllIn',
} as const;
export type OrdTypeEnum = (typeof OrdTypeEnum)[keyof typeof OrdTypeEnum];

export const OrderActionSourceEnum = {
  /** System */
  System: 'System',
  /** User */
  User: 'User',
} as const;
export type OrderActionSourceEnum = (typeof OrderActionSourceEnum)[keyof typeof OrderActionSourceEnum];

export const OrderAdminActionEnum = {
  /** force cancel order(s) */
  ForceCancelOrder: 'ForceCancelOrder',
  /** cancel order(s) */
  CancelOrder: 'CancelOrder',
  /** force fill customer order */
  ForceFill: 'ForceFill',
  /** manual fill order */
  ManualFill: 'ManualFill',
  /** disables trading and cancels all active orders */
  DisableAndCancelAll: 'DisableAndCancelAll',
  /** system canceled order due to profit loss */
  ProfitLossCancel: 'ProfitLossCancel',
  /** apply fixing at fixing price */
  ApplyFixing: 'ApplyFixing',
  /** indicate that compliance has released the order for trading */
  ComplianceApproval: 'ComplianceApproval',
} as const;
export type OrderAdminActionEnum = (typeof OrderAdminActionEnum)[keyof typeof OrderAdminActionEnum];

export const OrderBookAdminActionEnum = {
  /** request the orderbook snapshot */
  OrderBookSnapshotRequest: 'OrderBookSnapshotRequest',
  /** force update a checkpoint's time */
  ForceUpdateCheckpoint: 'ForceUpdateCheckpoint',
  /** force cancel order(s) */
  ForceCancelOrder: 'ForceCancelOrder',
  /** validate orderbook state */
  ValidateOrderBook: 'ValidateOrderBook',
  /** request for the orderbook to take a snapshot */
  OrderBookSnapshot: 'OrderBookSnapshot',
  /** restore order */
  RestoreOrder: 'RestoreOrder',
  /** get pending messages for an order via RPC */
  GetPendingMessages: 'GetPendingMessages',
  /** get in-memory fills via RPC */
  GetFills: 'GetFills',
  /** get in-memory trades via RPC */
  GetTrades: 'GetTrades',
  /** get in-memory trade checkpoints via RPC */
  GetTradeCheckpoints: 'GetTradeCheckpoints',
  /** get in-memory orders via RPC */
  GetOrders: 'GetOrders',
} as const;
export type OrderBookAdminActionEnum = (typeof OrderBookAdminActionEnum)[keyof typeof OrderBookAdminActionEnum];

export const OrderControlActionEnum = {
  /** stop making routing decisions and cancel open child orders */
  Pause: 'Pause',
  /** resume making routing decisions */
  Resume: 'Resume',
  /** allow the target order to be worked by traders */
  Activate: 'Activate',
} as const;
export type OrderControlActionEnum = (typeof OrderControlActionEnum)[keyof typeof OrderControlActionEnum];

export const OrderMarketStatusEnum = {
  /** Market is online */
  Online: 'Online',
  /** Market is disabled by user */
  Disabled: 'Disabled',
  /** Market error limit exceeded */
  Error: 'Error',
  /** Order is less than market minimum */
  LessThanMinSize: 'LessThanMinSize',
  /** No crossing size exists on this market */
  NoCrossingSize: 'NoCrossingSize',
  /** Insufficient balances */
  InsufficientBalances: 'InsufficientBalances',
  /** Market data is offline */
  MarketDataOffline: 'MarketDataOffline',
  /** Orders are offline */
  OrdersOffline: 'OrdersOffline',
  /** User has no credentials on this market */
  NoCredentials: 'NoCredentials',
  /** TimeInForce is not supported for this market */
  TimeInForceNotSupported: 'TimeInForceNotSupported',
  /** Exposure limit exceeded */
  ExposureLimitExceeded: 'ExposureLimitExceeded',
  /** Market is not available for trading */
  NotAvailable: 'NotAvailable',
  /** Market data is offline */
  MarketDataStale: 'MarketDataStale',
  /** Market is crossed */
  MarketDataCrossed: 'MarketDataCrossed',
  /** Price is away from the reference price */
  PriceProtection: 'PriceProtection',
  /** PostOnly order would immediately cross */
  PostOnlyOrderWouldCross: 'PostOnlyOrderWouldCross',
  /** Symbol is disabled on this market account ID */
  SymbolDisabled: 'SymbolDisabled',
  /** User has no permission on this market */
  NoPermission: 'NoPermission',
  /** Market has reached MaxAllocationPercentagePerMarket limit */
  MaxAllocationReached: 'MaxAllocationReached',
  /** Market account is disabled by user */
  AccountDisabled: 'AccountDisabled',
  /** Market child order rate limit breached */
  RateLimit: 'RateLimit',
  /** Equity margin ratio limit reached for the market */
  EquityMarginRatioLimitReached: 'EquityMarginRatioLimitReached',
  /** Order is resting too far off the market (deprecated since 843) */
  LimitPriceTooFarOffMarket: 'LimitPriceTooFarOffMarket',
  /** Waiting for market data subscription to complete */
  WaitingForMarketData: 'WaitingForMarketData',
  /** Counter currency not supported for the market */
  CounterCurrencyNotSupported: 'CounterCurrencyNotSupported',
} as const;
export type OrderMarketStatusEnum = (typeof OrderMarketStatusEnum)[keyof typeof OrderMarketStatusEnum];

export const OrderMarketabilityEnum = {
  /** Marketable */
  Marketable: 'Marketable',
  /** Limited */
  Limited: 'Limited',
} as const;
export type OrderMarketabilityEnum = (typeof OrderMarketabilityEnum)[keyof typeof OrderMarketabilityEnum];

export const OrderNotificationMarketCommandEnum = {
  /** DisableMarketAccount */
  DisableMarketAccount: 'DisableMarketAccount',
} as const;
export type OrderNotificationMarketCommandEnum =
  (typeof OrderNotificationMarketCommandEnum)[keyof typeof OrderNotificationMarketCommandEnum];

export const OrderNotificationTypeEnum = {
  /** Info */
  Info: 'Info',
  /** Error */
  Error: 'Error',
  /** Warn */
  Warn: 'Warn',
} as const;
export type OrderNotificationTypeEnum = (typeof OrderNotificationTypeEnum)[keyof typeof OrderNotificationTypeEnum];

export const OrderStatusNotificationTriggerEnum = {
  /** Canceled */
  Canceled: 'Canceled',
  /** Filled */
  Filled: 'Filled',
  /** FilledAndCanceled */
  FilledAndCanceled: 'FilledAndCanceled',
  /** Open */
  Open: 'Open',
  /** Paused */
  Paused: 'Paused',
  /** Rejected */
  Rejected: 'Rejected',
  /** Waiting */
  Waiting: 'Waiting',
  /** Staged */
  Staged: 'Staged',
  /** SystemPaused */
  SystemPaused: 'SystemPaused',
  /** PendingFix */
  PendingFix: 'PendingFix',
  /** PendingCancel */
  PendingCancel: 'PendingCancel',
  /** PendingReplace */
  PendingReplace: 'PendingReplace',
  /** Unknown */
  Unknown: 'Unknown',
  /** AllOpen */
  AllOpen: 'AllOpen',
  /** AllFilled */
  AllFilled: 'AllFilled',
  /** AllCanceled */
  AllCanceled: 'AllCanceled',
  /** AllRejected */
  AllRejected: 'AllRejected',
} as const;
export type OrderStatusNotificationTriggerEnum =
  (typeof OrderStatusNotificationTriggerEnum)[keyof typeof OrderStatusNotificationTriggerEnum];

export const OrderTrajectoryResponseStatusEnum = {
  /** Order trajectory was calculated successfully */
  Success: 'Success',
  /** Error with trajectory calculation */
  Error: 'Error',
} as const;
export type OrderTrajectoryResponseStatusEnum =
  (typeof OrderTrajectoryResponseStatusEnum)[keyof typeof OrderTrajectoryResponseStatusEnum];

export const ParentOrderTypeEnum = {
  /** Parent is a working order */
  WorkingOrder: 'WorkingOrder',
  /** Parent is a care order */
  CareOrder: 'CareOrder',
  /** Parent is a customer order */
  CustomerOrder: 'CustomerOrder',
  /** Parent is an OMS order */
  Order: 'Order',
} as const;
export type ParentOrderTypeEnum = (typeof ParentOrderTypeEnum)[keyof typeof ParentOrderTypeEnum];

export const PartialFillEnum = {
  /** Partial fill is disabled */
  Disabled: 'Disabled',
  /** Partial fill is enabled */
  Enabled: 'Enabled',
} as const;
export type PartialFillEnum = (typeof PartialFillEnum)[keyof typeof PartialFillEnum];

export const ParticipantEntityTypeEnum = {
  /** Organization */
  Organization: 'Organization',
} as const;
export type ParticipantEntityTypeEnum = (typeof ParticipantEntityTypeEnum)[keyof typeof ParticipantEntityTypeEnum];

export const PauseReasonEnum = {
  /** System-paused because the SystemPauseRestingOrders runtime config is enabled */
  SystemPauseRestingOrders: 'SystemPauseRestingOrders',
} as const;
export type PauseReasonEnum = (typeof PauseReasonEnum)[keyof typeof PauseReasonEnum];

export const PayoffTypeEnum = {
  /** Linear */
  Linear: 'Linear',
  /** Inverse */
  Inverse: 'Inverse',
  /** Quanto */
  Quanto: 'Quanto',
} as const;
export type PayoffTypeEnum = (typeof PayoffTypeEnum)[keyof typeof PayoffTypeEnum];

export const PegReferenceTypeEnum = {
  /** Peg to the same side as order */
  Near: 'Near',
  /** Peg to the mid */
  Mid: 'Mid',
} as const;
export type PegReferenceTypeEnum = (typeof PegReferenceTypeEnum)[keyof typeof PegReferenceTypeEnum];

export const PnlLookbackEnum = {
  /** Today */
  Today: 'Today',
  /** 24 hours */
  H24: 'H24',
  /** Week to date */
  WeekToDate: 'WeekToDate',
  /** Seven days */
  D7: 'D7',
  /** Month to date */
  MonthToDate: 'MonthToDate',
  /** 30 days */
  D30: 'D30',
  /** Year to date */
  YearToDate: 'YearToDate',
  /** 365 days */
  D365: 'D365',
} as const;
export type PnlLookbackEnum = (typeof PnlLookbackEnum)[keyof typeof PnlLookbackEnum];

export const PortfolioAdminRequestTypeEnum = {
  /** Reset reconciliation (and balances) for a particular account */
  ReconReset: 'ReconReset',
  /** Recalculate position and position stats as of a given timestamp (TransactTime) */
  PositionRecalc: 'PositionRecalc',
  /** Cancel existing conversion views and rerequest rates */
  ConversionsReset: 'ConversionsReset',
  /** Migrate AvgCost-units to quote-currency and PnL-units to settlement-currency */
  MigrateCurrencyUnits: 'MigrateCurrencyUnits',
  /** Log a snapshot of debug information for MarketAccount Recon */
  ReconDebugSnapshot: 'ReconDebugSnapshot',
  /** Rebase recon base window to the latest gateway truth without publishing breaks */
  ReconRebase: 'ReconRebase',
  /** Rewrite loan securities and deals that still store single-asset collateral fields into the collateral basket shape */
  MigrateLoanCollateralBaskets: 'MigrateLoanCollateralBaskets',
} as const;
export type PortfolioAdminRequestTypeEnum =
  (typeof PortfolioAdminRequestTypeEnum)[keyof typeof PortfolioAdminRequestTypeEnum];

export const PositionAdlRiskTypeEnum = {
  /** None */
  None: 'None',
  /** Low */
  Low: 'Low',
  /** Medium */
  Medium: 'Medium',
  /** High */
  High: 'High',
} as const;
export type PositionAdlRiskTypeEnum = (typeof PositionAdlRiskTypeEnum)[keyof typeof PositionAdlRiskTypeEnum];

export const PositionAssetTypeEnum = {
  /** Spot type */
  Spot: 'Spot',
  /** Perpetual Swap type */
  PerpetualSwap: 'PerpetualSwap',
  /** Future type */
  Future: 'Future',
  /** Basis */
  Basis: 'Basis',
  /** Option type */
  Option: 'Option',
  /** CFD type */
  CFD: 'CFD',
  /** Multileg Synthetic product */
  Synthetic: 'Synthetic',
  /** Calendar Spread product */
  CalendarSpread: 'CalendarSpread',
  /** Exchange Traded Fund */
  ExchangeTradedFund: 'ExchangeTradedFund',
  /** Compound instrument with multiple legs traded as a single atomic unit */
  Compound: 'Compound',
  /** OTC Vanilla Option */
  OTCVanillaOption: 'OTCVanillaOption',
  /** OTC Forward */
  OTCForward: 'OTCForward',
  /** Fixed Rate Loan */
  LoanFixedRate: 'LoanFixedRate',
  /** Floating Rate Loan */
  LoanFloatingRate: 'LoanFloatingRate',
  /** OTC Repo */
  OTCRepo: 'OTCRepo',
  /** Government bond */
  GovernmentBond: 'GovernmentBond',
  /** Share / Equity */
  Share: 'Share',
  /** Prediction Outcome */
  PredictionOutcome: 'PredictionOutcome',
} as const;
export type PositionAssetTypeEnum = (typeof PositionAssetTypeEnum)[keyof typeof PositionAssetTypeEnum];

export const PositionCloseResponseStatusEnum = {
  /** Position close request was processed successfully */
  Success: 'Success',
  /** Position close request had error */
  Error: 'Error',
  /** Position close request rejected */
  Rejected: 'Rejected',
} as const;
export type PositionCloseResponseStatusEnum =
  (typeof PositionCloseResponseStatusEnum)[keyof typeof PositionCloseResponseStatusEnum];

export const PositionLimitScopeEnum = {
  /** All */
  All: 'All',
  /** CoreTrading */
  CoreTrading: 'CoreTrading',
  /** CustomerOrderAcceptance */
  CustomerOrderAcceptance: 'CustomerOrderAcceptance',
} as const;
export type PositionLimitScopeEnum = (typeof PositionLimitScopeEnum)[keyof typeof PositionLimitScopeEnum];

export const PositionSideTypeEnum = {
  /** Both */
  Both: 'Both',
  /** Long */
  Long: 'Long',
  /** Short */
  Short: 'Short',
} as const;
export type PositionSideTypeEnum = (typeof PositionSideTypeEnum)[keyof typeof PositionSideTypeEnum];

export const PositionUpdateSourceEnum = {
  /** Gateway */
  Gateway: 'Gateway',
  /** Internal Live Updates */
  Internal: 'Internal',
} as const;
export type PositionUpdateSourceEnum = (typeof PositionUpdateSourceEnum)[keyof typeof PositionUpdateSourceEnum];

export const PositionUpdateTypeEnum = {
  /** Position Reset */
  PositionReset: 'PositionReset',
  /** Position Update */
  PositionUpdate: 'PositionUpdate',
  /** Position Stale */
  PositionStale: 'PositionStale',
  /** Position Keepalive */
  PositionKeepalive: 'PositionKeepalive',
  /** Position Offline */
  PositionOffline: 'PositionOffline',
} as const;
export type PositionUpdateTypeEnum = (typeof PositionUpdateTypeEnum)[keyof typeof PositionUpdateTypeEnum];

export const PredictionOutcomeEventTypeEnum = {
  /** Binary outcome (Yes/No) */
  Binary: 'Binary',
  /** Categorical outcome (one of many) */
  Categorical: 'Categorical',
} as const;
export type PredictionOutcomeEventTypeEnum =
  (typeof PredictionOutcomeEventTypeEnum)[keyof typeof PredictionOutcomeEventTypeEnum];

export const PrepaymentOptionEnum = {
  /** No prepayment option */
  None: 'None',
  /** Full prepayment option */
  Full: 'Full',
  /** Partial prepayment option */
  Partial: 'Partial',
} as const;
export type PrepaymentOptionEnum = (typeof PrepaymentOptionEnum)[keyof typeof PrepaymentOptionEnum];

export const PresenceEnum = {
  /** Required */
  Required: 'Required',
  /** Optional */
  Optional: 'Optional',
  /** Hidden */
  Hidden: 'Hidden',
  /** TopLevelHidden */
  TopLevelHidden: 'TopLevelHidden',
} as const;
export type PresenceEnum = (typeof PresenceEnum)[keyof typeof PresenceEnum];

export const PriceMarkSourceEnum = {
  /** Talos defined market mid-point */
  Internal: 'Internal',
  /** Externally defined market mid-point */
  External: 'External',
  /** Historic backfill from market data */
  Historic: 'Historic',
  /** Index mark value */
  IndexMark: 'IndexMark',
} as const;
export type PriceMarkSourceEnum = (typeof PriceMarkSourceEnum)[keyof typeof PriceMarkSourceEnum];

export const PriceMarkTagsEnum = {
  /** PriceMark for end-of-day */
  EndOfDay: 'EndOfDay',
} as const;
export type PriceMarkTagsEnum = (typeof PriceMarkTagsEnum)[keyof typeof PriceMarkTagsEnum];

export const PriceOffsetUnitsEnum = {
  /** Price Units */
  PriceUnits: 'PriceUnits',
  /** Basis Points */
  BasisPoints: 'BasisPoints',
  /** Price Increments */
  PriceIncrements: 'PriceIncrements',
} as const;
export type PriceOffsetUnitsEnum = (typeof PriceOffsetUnitsEnum)[keyof typeof PriceOffsetUnitsEnum];

export const PriceProtectionEnum = {
  /** Error */
  Error: 'Error',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type PriceProtectionEnum = (typeof PriceProtectionEnum)[keyof typeof PriceProtectionEnum];

export const PriceReferenceTypeEnum = {
  /** Use the same side of the order */
  Near: 'Near',
  /** Use the far side of the order */
  Far: 'Far',
} as const;
export type PriceReferenceTypeEnum = (typeof PriceReferenceTypeEnum)[keyof typeof PriceReferenceTypeEnum];

export const PricingModeEnum = {
  /** Price is in IV */
  ImpliedVolatility: 'ImpliedVolatility',
  /** Price is in underlying quote currency */
  UnderlyingQuoteCurrency: 'UnderlyingQuoteCurrency',
  /** Price is in spread to index until fixing */
  SpreadToFixing: 'SpreadToFixing',
  /** Price is in basis points */
  BPS: 'BPS',
  /** Price is an absolute value (fixed price) */
  Absolute: 'Absolute',
} as const;
export type PricingModeEnum = (typeof PricingModeEnum)[keyof typeof PricingModeEnum];

export const PricingModesEnum = {
  /** Price is in IV */
  ImpliedVolatility: 'ImpliedVolatility',
  /** Price is in underlying quote currency */
  UnderlyingQuoteCurrency: 'UnderlyingQuoteCurrency',
  /** Price is in spread to index until fixing */
  SpreadToFixing: 'SpreadToFixing',
  /** Price is in basis points */
  BPS: 'BPS',
} as const;
export type PricingModesEnum = (typeof PricingModesEnum)[keyof typeof PricingModesEnum];

export const PricingRuleTypeEnum = {
  /** Counterparty tier */
  Counterparty: 'Counterparty',
  /** AllInTier */
  AllInTier: 'AllInTier',
  /** FeeTier */
  FeeTier: 'FeeTier',
  /** SymbolGroup */
  SymbolGroup: 'SymbolGroup',
  /** Global */
  Global: 'Global',
  /** WithdrawalFeeTier */
  WithdrawalFeeTier: 'WithdrawalFeeTier',
  /** Currency-specific customer currency rule */
  Currency: 'Currency',
} as const;
export type PricingRuleTypeEnum = (typeof PricingRuleTypeEnum)[keyof typeof PricingRuleTypeEnum];

export const ProductTypeEnum = {
  /** Spot type */
  Spot: 'Spot',
  /** Perpetual Swap type */
  PerpetualSwap: 'PerpetualSwap',
  /** Future type */
  Future: 'Future',
  /** Basis */
  Basis: 'Basis',
  /** Option type */
  Option: 'Option',
  /** CFD type */
  CFD: 'CFD',
  /** Multileg Synthetic product */
  Synthetic: 'Synthetic',
  /** Calendar Spread product */
  CalendarSpread: 'CalendarSpread',
  /** Exchange Traded Fund */
  ExchangeTradedFund: 'ExchangeTradedFund',
  /** OTC Product */
  OTC: 'OTC',
  /** Compound instrument with multiple legs traded as a single atomic unit */
  Compound: 'Compound',
  /** Government bond */
  GovernmentBond: 'GovernmentBond',
  /** Share / Equity */
  Share: 'Share',
  /** Prediction outcome for a prediction outcome event */
  PredictionOutcome: 'PredictionOutcome',
} as const;
export type ProductTypeEnum = (typeof ProductTypeEnum)[keyof typeof ProductTypeEnum];

export const QuoteRespTypeEnum = {
  /** Counter / price improvement request */
  Counter: 'Counter',
} as const;
export type QuoteRespTypeEnum = (typeof QuoteRespTypeEnum)[keyof typeof QuoteRespTypeEnum];

export const QuoteStatusEnum = {
  /** Quote request has been sent */
  PendingNew: 'PendingNew',
  /** Quote request has been accepted and venue sends price */
  Open: 'Open',
  /** Cancel quote request has been sent */
  PendingCancel: 'PendingCancel',
  /** Quote was canceled successfully */
  Canceled: 'Canceled',
  /** Quote has been accepted and waiting to be filled */
  PendingFill: 'PendingFill',
  /** Quote has been filled (partially or entirely) */
  Filled: 'Filled',
  /** Quote has been closed */
  Closed: 'Closed',
  /** Quote request has been rejected */
  Rejected: 'Rejected',
  /** Order on this market failed and it is excluded from retry */
  Excluded: 'Excluded',
  /** Order is waiting for the previous legs to fill before being processed */
  Holding: 'Holding',
  /** Transient error */
  TransientError: 'TransientError',
  /** Quote has been accepted and waiting to be fixed */
  PendingFix: 'PendingFix',
} as const;
export type QuoteStatusEnum = (typeof QuoteStatusEnum)[keyof typeof QuoteStatusEnum];

export const QuoteTypeEnum = {
  /** Indicative quote type */
  Indicative: 'Indicative',
  /** Firm quote type */
  Firm: 'Firm',
} as const;
export type QuoteTypeEnum = (typeof QuoteTypeEnum)[keyof typeof QuoteTypeEnum];

export const RFQProtocolEnum = {
  /** Systematic quote pricing source for RFQ */
  Systematic: 'Systematic',
  /** Manual quote pricing source for RFQ */
  Manual: 'Manual',
  /** Synthetically quoted Customer RFQ */
  Synthetic: 'Synthetic',
} as const;
export type RFQProtocolEnum = (typeof RFQProtocolEnum)[keyof typeof RFQProtocolEnum];

export const RFQTradingProtocolEnum = {
  /** Streaming quote trading protocol for RFQ */
  Streaming: 'Streaming',
  /** Negotiated quote trading protocol for RFQ */
  Negotiated: 'Negotiated',
} as const;
export type RFQTradingProtocolEnum = (typeof RFQTradingProtocolEnum)[keyof typeof RFQTradingProtocolEnum];

export const RPCHeaderIndicatorEnum = {
  /** 0=Reserved for future use */
  Reserved1: 'Reserved1',
  /** 0=Reserved for future use */
  Reserved2: 'Reserved2',
  /** 0=Reserved for future use */
  Reserved3: 'Reserved3',
  /** 0=Reserved for future use */
  Reserved4: 'Reserved4',
  /** 0=Reserved for future use */
  Reserved5: 'Reserved5',
  /** 0=Reserved for future use */
  Reserved6: 'Reserved6',
  /** 0=Reserved for future use */
  Reserved7: 'Reserved7',
  /** 1=Last message for the event, 0=Expect more messages */
  CompleteFlag: 'CompleteFlag',
} as const;
export type RPCHeaderIndicatorEnum = (typeof RPCHeaderIndicatorEnum)[keyof typeof RPCHeaderIndicatorEnum];

export const RPCSessionActionEnum = {
  /** New session */
  New: 'New',
  /** Delete session */
  Delete: 'Delete',
} as const;
export type RPCSessionActionEnum = (typeof RPCSessionActionEnum)[keyof typeof RPCSessionActionEnum];

export const RPCSessionStatusEnum = {
  /** Active session */
  Active: 'Active',
  /** Closed session */
  Closed: 'Closed',
  /** Error creating session */
  Error: 'Error',
} as const;
export type RPCSessionStatusEnum = (typeof RPCSessionStatusEnum)[keyof typeof RPCSessionStatusEnum];

export const RateLimitGroupByScopeEnum = {
  /** Requests bucketed based on counterparty ID */
  CounterpartyID: 'CounterpartyID',
  /** Requests bucketed based on customer user ID */
  CustomerUserID: 'CustomerUserID',
  /** Requests bucketed based on the associated market account ID */
  MarketAccountID: 'MarketAccountID',
  /** Requests bucketed based on session */
  SessionID: 'SessionID',
} as const;
export type RateLimitGroupByScopeEnum = (typeof RateLimitGroupByScopeEnum)[keyof typeof RateLimitGroupByScopeEnum];

export const ReconResolutionEnum = {
  /** Unknown */
  Unknown: 'Unknown',
  /** Missing or errored Trades */
  MissedTrade: 'MissedTrade',
  /** Missing or errored Transfers */
  MissedTransfer: 'MissedTransfer',
  /** Missing or errored Fees */
  MissedFees: 'MissedFees',
  /** Initial accepted position */
  InitialPosition: 'InitialPosition',
  /** Below a defined threshold */
  BelowThreshold: 'BelowThreshold',
} as const;
export type ReconResolutionEnum = (typeof ReconResolutionEnum)[keyof typeof ReconResolutionEnum];

export const ReconStateEnum = {
  /** Waiting for manual review */
  PendingReview: 'PendingReview',
  /** Mismatch applied / resolved automatically */
  AutoResolved: 'AutoResolved',
  /** Mismatch ignored by user */
  Ignored: 'Ignored',
  /** Mismatch applied / resolved by a user */
  ManualResolved: 'ManualResolved',
} as const;
export type ReconStateEnum = (typeof ReconStateEnum)[keyof typeof ReconStateEnum];

export const ReconStreamStatusEnum = {
  /** Unknown */
  Unknown: 'Unknown',
  /** Matching including the most recent update */
  Matching: 'Matching',
  /** Matching, ignoring recent known activity */
  LedgerAhead: 'LedgerAhead',
  /** Matching since the most recent mismatch */
  MatchingSinceLatestMismatch: 'MatchingSinceLatestMismatch',
  /** Matching since the most recent mismatch, ignoring recent known activity */
  LedgerAheadSinceLatestMismatch: 'LedgerAheadSinceLatestMismatch',
  /** MarketStale */
  MarketStale: 'MarketStale',
  /** MarketOffline */
  MarketOffline: 'MarketOffline',
} as const;
export type ReconStreamStatusEnum = (typeof ReconStreamStatusEnum)[keyof typeof ReconStreamStatusEnum];

export const ReconTruthTypeEnum = {
  /** Update form external source */
  Update: 'Update',
  /** Bootstrap from 0 or process snapshot */
  Bootstrap: 'Bootstrap',
  /** Keepalive from external source */
  Keepalive: 'Keepalive',
  /** Reset from external source */
  Reset: 'Reset',
} as const;
export type ReconTruthTypeEnum = (typeof ReconTruthTypeEnum)[keyof typeof ReconTruthTypeEnum];

export const RecordAckTypeEnum = {
  /** Error */
  Error: 'Error',
  /** Started */
  Started: 'Started',
  /** Stopped */
  Stopped: 'Stopped',
} as const;
export type RecordAckTypeEnum = (typeof RecordAckTypeEnum)[keyof typeof RecordAckTypeEnum];

export const RecordRequestTypeEnum = {
  /** Start */
  Start: 'Start',
  /** Stop */
  Stop: 'Stop',
} as const;
export type RecordRequestTypeEnum = (typeof RecordRequestTypeEnum)[keyof typeof RecordRequestTypeEnum];

export const ReduceFirstEnum = {
  /** Enabled */
  Enabled: 'Enabled',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type ReduceFirstEnum = (typeof ReduceFirstEnum)[keyof typeof ReduceFirstEnum];

export const ReduceOnlyEnum = {
  /** Enabled */
  Enabled: 'Enabled',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type ReduceOnlyEnum = (typeof ReduceOnlyEnum)[keyof typeof ReduceOnlyEnum];

export const ReplayAckTypeEnum = {
  /** Error */
  Error: 'Error',
  /** Start */
  Start: 'Start',
  /** Backlog */
  Backlog: 'Backlog',
  /** Stop */
  Stop: 'Stop',
} as const;
export type ReplayAckTypeEnum = (typeof ReplayAckTypeEnum)[keyof typeof ReplayAckTypeEnum];

export const ReplayRequestTypeEnum = {
  /** None */
  None: 'None',
  /** Continuous */
  Continuous: 'Continuous',
  /** Catchup */
  Catchup: 'Catchup',
  /** Stop */
  Stop: 'Stop',
  /** Volatile */
  Volatile: 'Volatile',
  /** Recorded */
  Recorded: 'Recorded',
  /** RecordedFromHead */
  RecordedFromHead: 'RecordedFromHead',
} as const;
export type ReplayRequestTypeEnum = (typeof ReplayRequestTypeEnum)[keyof typeof ReplayRequestTypeEnum];

export const RepoDirectionEnum = {
  /** Repo */
  Repo: 'Repo',
  /** ReverseRepo */
  ReverseRepo: 'ReverseRepo',
} as const;
export type RepoDirectionEnum = (typeof RepoDirectionEnum)[keyof typeof RepoDirectionEnum];

export const RequestIndicatorTypeEnum = {
  /** DEPRECATED */
  Direct: 'Direct',
  /** DEPRECATED */
  Algo: 'Algo',
  /** Limit or market orders generated via UI */
  Manual: 'Manual',
  /** Order generated from a non-UI source or a non-limit/market order */
  Auto: 'Auto',
} as const;
export type RequestIndicatorTypeEnum = (typeof RequestIndicatorTypeEnum)[keyof typeof RequestIndicatorTypeEnum];

export const RequestSourceEnum = {
  /** Request is initiated via Talos UI */
  UI: 'UI',
  /** Request is initiated via API */
  API: 'API',
  /** Request is initiated via Position Hedger */
  Hedger: 'Hedger',
  /** Request is initiated via Customer */
  Customer: 'Customer',
  /** Request is initiated via Order Hedger */
  OrderHedger: 'OrderHedger',
  /** Request is initiated via Mobile UI */
  UIMobile: 'UIMobile',
  /** Request is initiated via Bulk Order UI */
  UIBulkOrder: 'UIBulkOrder',
} as const;
export type RequestSourceEnum = (typeof RequestSourceEnum)[keyof typeof RequestSourceEnum];

export const RequestTypeEnum = {
  /** MarketDataDeltas */
  MarketDataDeltas: 'MarketDataDeltas',
  /** MarketDataSnapshot */
  MarketDataSnapshot: 'MarketDataSnapshot',
  /** MarketDataTrades */
  MarketDataTrades: 'MarketDataTrades',
  /** NewOrderSingle */
  NewOrderSingle: 'NewOrderSingle',
  /** OrderCancelRequest */
  OrderCancelRequest: 'OrderCancelRequest',
  /** OrderCancelReplaceRequest */
  OrderCancelReplaceRequest: 'OrderCancelReplaceRequest',
  /** Orders Deltas */
  OrdersDeltas: 'OrdersDeltas',
  /** Orders Snapshot */
  OrdersSnapshot: 'OrdersSnapshot',
  /** Balances Snapshot */
  BalancesSnapshot: 'BalancesSnapshot',
  /** Orders Recovery */
  OrdersRecovery: 'OrdersRecovery',
  /** Fills Recovery */
  FillsRecovery: 'FillsRecovery',
  /** Trade Status */
  TradeStatus: 'TradeStatus',
  /** Reference Rate */
  ReferenceRate: 'ReferenceRate',
} as const;
export type RequestTypeEnum = (typeof RequestTypeEnum)[keyof typeof RequestTypeEnum];

export const ResolutionEnum = {
  /** Live */
  Resolution_Live: 'Resolution_Live',
  /** One second */
  Resolution_1S: 'Resolution_1S',
  /** One minute */
  Resolution_1M: 'Resolution_1M',
  /** One hour */
  Resolution_1H: 'Resolution_1H',
  /** One day */
  Resolution_1D: 'Resolution_1D',
  /** Discrete event */
  Resolution_X: 'Resolution_X',
  /** Five minutes */
  Resolution_5M: 'Resolution_5M',
  /** Four hours */
  Resolution_4H: 'Resolution_4H',
  /** Ten seconds */
  Resolution_10S: 'Resolution_10S',
  /** Ten Minutes */
  Resolution_10M: 'Resolution_10M',
  /** Fifteen minutes */
  Resolution_15M: 'Resolution_15M',
  /** One Month */
  Resolution_1MO: 'Resolution_1MO',
  /** One Week */
  Resolution_1W: 'Resolution_1W',
  /** Thirty Minutes */
  Resolution_30M: 'Resolution_30M',
} as const;
export type ResolutionEnum = (typeof ResolutionEnum)[keyof typeof ResolutionEnum];

export const RiskEvaluationModeEnum = {
  /** Customer orders and RFQs not checked for balances */
  AutoApprove: 'AutoApprove',
  /** Balances are checked for customer orders and RFQs */
  Prefunded: 'Prefunded',
  /** External dealer server has to approve or reject each customer order and RFQ */
  External: 'External',
} as const;
export type RiskEvaluationModeEnum = (typeof RiskEvaluationModeEnum)[keyof typeof RiskEvaluationModeEnum];

export const SecurityOwnerEnum = {
  /** Security is a standard security owned by secmaster */
  Secmaster: 'Secmaster',
  /** Security is a custom security owned by the org */
  Org: 'Org',
} as const;
export type SecurityOwnerEnum = (typeof SecurityOwnerEnum)[keyof typeof SecurityOwnerEnum];

export const SequencerConnectResponseStatusEnum = {
  /** Pending */
  Pending: 'Pending',
  /** Ready */
  Ready: 'Ready',
  /** Error */
  Error: 'Error',
} as const;
export type SequencerConnectResponseStatusEnum =
  (typeof SequencerConnectResponseStatusEnum)[keyof typeof SequencerConnectResponseStatusEnum];

export const ServiceStatusEnum = {
  /** Indicates the Service is Currently Starting */
  Starting: 'Starting',
  /** Indicates the Service is Currently Running */
  Running: 'Running',
  /** Indicates the Service has been Requested to Shutdown */
  Shutdown: 'Shutdown',
} as const;
export type ServiceStatusEnum = (typeof ServiceStatusEnum)[keyof typeof ServiceStatusEnum];

export const SessionEventTypeEnum = {
  /** Session connect */
  Connect: 'Connect',
  /** Session disconnect */
  Disconnect: 'Disconnect',
  /** Session timeout */
  Timeout: 'Timeout',
} as const;
export type SessionEventTypeEnum = (typeof SessionEventTypeEnum)[keyof typeof SessionEventTypeEnum];

export const SessionSourceEnum = {
  /** Websocket */
  Websocket: 'Websocket',
  /** REST */
  REST: 'REST',
  /** FIX */
  FIX: 'FIX',
} as const;
export type SessionSourceEnum = (typeof SessionSourceEnum)[keyof typeof SessionSourceEnum];

export const SettleValueTypeEnum = {
  /** Regular */
  Regular: 'Regular',
  /** Inverted */
  Inverted: 'Inverted',
} as const;
export type SettleValueTypeEnum = (typeof SettleValueTypeEnum)[keyof typeof SettleValueTypeEnum];

export const SettlementBatchRejectReasonEnum = {
  /** Settlement batch is expired */
  BatchExpired: 'BatchExpired',
  /** The batch is invalid */
  InvalidBatch: 'InvalidBatch',
  /** One of the trades is invalid */
  InvalidTrade: 'InvalidTrade',
  /** Internal error */
  InternalError: 'InternalError',
} as const;
export type SettlementBatchRejectReasonEnum =
  (typeof SettlementBatchRejectReasonEnum)[keyof typeof SettlementBatchRejectReasonEnum];

export const SettlementBatchStatusEnum = {
  /** Settlement batch is created but has pending updates */
  Proposed: 'Proposed',
  /** Settlement batch is reified and ready to be settled */
  Initiated: 'Initiated',
  /** Settlement batch is completed */
  Completed: 'Completed',
  /** Settlement batch is rejected */
  Rejected: 'Rejected',
  /** Settlement batch is cancelled */
  Cancelled: 'Cancelled',
} as const;
export type SettlementBatchStatusEnum = (typeof SettlementBatchStatusEnum)[keyof typeof SettlementBatchStatusEnum];

export const SettlementClassEnum = {
  /** None */
  None: 'None',
  /** OTC settlement class */
  OTC: 'OTC',
  /** Customer settlement class */
  Customer: 'Customer',
} as const;
export type SettlementClassEnum = (typeof SettlementClassEnum)[keyof typeof SettlementClassEnum];

export const SettlementInstructionDirectionEnum = {
  /** Outbound direction, e.g., customer withdrawals or settlements to OTCs */
  Outbound: 'Outbound',
  /** Inbound direction, e.g., customer deposits or settlements from OTCs */
  Inbound: 'Inbound',
} as const;
export type SettlementInstructionDirectionEnum =
  (typeof SettlementInstructionDirectionEnum)[keyof typeof SettlementInstructionDirectionEnum];

export const SettlementParentEventTypeEnum = {
  /** Parent is an OMS order */
  Order: 'Order',
  /** Parent is a care order */
  CareOrder: 'CareOrder',
  /** Parent is a deal */
  Deal: 'Deal',
} as const;
export type SettlementParentEventTypeEnum =
  (typeof SettlementParentEventTypeEnum)[keyof typeof SettlementParentEventTypeEnum];

export const SideEnum = {
  /** Buy */
  Buy: 'Buy',
  /** Sell */
  Sell: 'Sell',
} as const;
export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];

export const SizeCounteringEnum = {
  /** Size countering is disabled */
  Disabled: 'Disabled',
  /** Size countering is enabled */
  Enabled: 'Enabled',
} as const;
export type SizeCounteringEnum = (typeof SizeCounteringEnum)[keyof typeof SizeCounteringEnum];

export const SizeModeEnum = {
  /** Expressed in units of currency */
  Currency: 'Currency',
  /** Expressed in multiples of SizeRatios */
  Units: 'Units',
} as const;
export type SizeModeEnum = (typeof SizeModeEnum)[keyof typeof SizeModeEnum];

export const SlippageReferencePriceEnum = {
  /** TWAP */
  TWAP: 'TWAP',
  /** VWAP */
  VWAP: 'VWAP',
  /** Arrival */
  Arrival: 'Arrival',
  /** TalosEstimated */
  TalosEstimated: 'TalosEstimated',
} as const;
export type SlippageReferencePriceEnum = (typeof SlippageReferencePriceEnum)[keyof typeof SlippageReferencePriceEnum];

export const SnapshotBlockEntryTypeEnum = {
  /** Start */
  Start: 'Start',
  /** End */
  End: 'End',
} as const;
export type SnapshotBlockEntryTypeEnum = (typeof SnapshotBlockEntryTypeEnum)[keyof typeof SnapshotBlockEntryTypeEnum];

export const StrategyParameterSettingEnum = {
  /** MaxPercentOfOrderAhead */
  MaxPercentOfOrderAhead: 'MaxPercentOfOrderAhead',
  /** MaxPercentOfOrderBehind */
  MaxPercentOfOrderBehind: 'MaxPercentOfOrderBehind',
  /** MaxSecondsAheadOfSchedule */
  MaxSecondsAheadOfSchedule: 'MaxSecondsAheadOfSchedule',
  /** MaxSecondsBehindSchedule */
  MaxSecondsBehindSchedule: 'MaxSecondsBehindSchedule',
  /** MinTargetParticipationRate */
  MinTargetParticipationRate: 'MinTargetParticipationRate',
  /** MidTargetParticipationRate */
  MidTargetParticipationRate: 'MidTargetParticipationRate',
  /** MaxTargetParticipationRate */
  MaxTargetParticipationRate: 'MaxTargetParticipationRate',
  /** DeeperRestingLevelsMinSkipIntervals */
  DeeperRestingLevelsMinSkipIntervals: 'DeeperRestingLevelsMinSkipIntervals',
  /** MaxPercentLegBehindToHedge */
  MaxPercentLegBehindToHedge: 'MaxPercentLegBehindToHedge',
  /** MaxPercentOfVolumeBehind */
  MaxPercentOfVolumeBehind: 'MaxPercentOfVolumeBehind',
} as const;
export type StrategyParameterSettingEnum =
  (typeof StrategyParameterSettingEnum)[keyof typeof StrategyParameterSettingEnum];

export const StrategyScopeEnum = {
  /** Strategy that can be specified on OMS Orders */
  OrderStrategy: 'OrderStrategy',
  /** Strategy that can be specified as a child of an OrderStrategy - for use in DDH */
  DDHSubStrategy: 'DDHSubStrategy',
  /** Strategy that can configured on a HedgeRule for HedgeOrder execution */
  AutoHedgingStrategy: 'AutoHedgingStrategy',
  /** Strategy that should be hidden from use */
  Hidden: 'Hidden',
} as const;
export type StrategyScopeEnum = (typeof StrategyScopeEnum)[keyof typeof StrategyScopeEnum];

export const StrategyTypeEnum = {
  /** SmartOrderRouter */
  SmartOrderRouter: 'SmartOrderRouter',
  /** Algorithm */
  Algorithm: 'Algorithm',
} as const;
export type StrategyTypeEnum = (typeof StrategyTypeEnum)[keyof typeof StrategyTypeEnum];

export const StrikeTypeEnum = {
  /** Fixed strike type */
  Fixed: 'Fixed',
  /** Delta strike type */
  Delta: 'Delta',
} as const;
export type StrikeTypeEnum = (typeof StrikeTypeEnum)[keyof typeof StrikeTypeEnum];

export const SubAccountPurposeEnum = {
  /** General trading book */
  GeneralTrading: 'GeneralTrading',
  /** Rollup container */
  Rollup: 'Rollup',
  /** Customer risk book */
  CustomerRisk: 'CustomerRisk',
  /** Customer hedge book */
  CustomerHedge: 'CustomerHedge',
  /** Internal trading book */
  InternalTrading: 'InternalTrading',
  /** Loan book */
  Loan: 'Loan',
  /** Collateral book */
  Collateral: 'Collateral',
  /** Income book */
  Income: 'Income',
} as const;
export type SubAccountPurposeEnum = (typeof SubAccountPurposeEnum)[keyof typeof SubAccountPurposeEnum];

export const SubAccountRecalcStatusEnum = {
  /** Recalculation is not running */
  Idle: 'Idle',
  /** Recalculation is pending, scheduled or requested */
  Pending: 'Pending',
  /** Recalculation is currently running */
  InProgress: 'InProgress',
  /** Recalculation completed successfully */
  Complete: 'Complete',
  /** Recalculation encounterred an error */
  Error: 'Error',
  /** Recalculation was rescheduled, i.e., to the latest window */
  Rescheduled: 'Rescheduled',
  /** Recalculation was interrupted (e.g., process restart) */
  Interrupted: 'Interrupted',
  /** No updates received within the stale threshold */
  Stale: 'Stale',
} as const;
export type SubAccountRecalcStatusEnum = (typeof SubAccountRecalcStatusEnum)[keyof typeof SubAccountRecalcStatusEnum];

export const SubAccountReconCheckpointEvalStatusEnum = {
  /** Evaluation completed */
  Done: 'Done',
  /** Requested resolution / changes, pending re-evaluation */
  Pending: 'Pending',
  /** Evaluation is currently in progress */
  InProgress: 'InProgress',
} as const;
export type SubAccountReconCheckpointEvalStatusEnum =
  (typeof SubAccountReconCheckpointEvalStatusEnum)[keyof typeof SubAccountReconCheckpointEvalStatusEnum];

export const SubAccountReconCheckpointStatusEnum = {
  /** Has unatched events or balances */
  Unreconciled: 'Unreconciled',
  /** All events and balances match */
  Reconciled: 'Reconciled',
  /** No longer valid account / grouping */
  Discarded: 'Discarded',
} as const;
export type SubAccountReconCheckpointStatusEnum =
  (typeof SubAccountReconCheckpointStatusEnum)[keyof typeof SubAccountReconCheckpointStatusEnum];

export const SubAccountReconMatchStatusEnum = {
  /** Unmatched */
  Unmatched: 'Unmatched',
  /** Only SubAccount event(s) exist */
  UnmatchedSubAccount: 'UnmatchedSubAccount',
  /** Only MarketAccount event(s) exist */
  UnmatchedMarketAccount: 'UnmatchedMarketAccount',
  /** Events exist and match */
  Matched: 'Matched',
  /** Manually Resolved */
  Resolved: 'Resolved',
  /** No a longer has matching events */
  Discarded: 'Discarded',
  /** Manually ignored, not applied to SubAccounts */
  Ignored: 'Ignored',
} as const;
export type SubAccountReconMatchStatusEnum =
  (typeof SubAccountReconMatchStatusEnum)[keyof typeof SubAccountReconMatchStatusEnum];

export const SubAccountSMPCheckTypeEnum = {
  /** None */
  None: 'None',
  /** RejectNew */
  RejectNew: 'RejectNew',
} as const;
export type SubAccountSMPCheckTypeEnum = (typeof SubAccountSMPCheckTypeEnum)[keyof typeof SubAccountSMPCheckTypeEnum];

export const SubAccountTradeRoutingModeEnum = {
  /** None */
  None: 'None',
  /** Connected config value is a SubAccount name */
  SpecificSubAccount: 'SpecificSubAccount',
  /** Routes trades to the only SubAccount mapped to a MarketAccount. Does not route if there are multiple mappings */
  OnlyMappedSubAccount: 'OnlyMappedSubAccount',
  /** Routes trades to a deterministic (but arbitrary) SubAccount from those mapped to a MarketAccount */
  FirstMappedSubAccount: 'FirstMappedSubAccount',
  /** Allocate evenly to all mapped subaccounts */
  AllMappedSubAccounts: 'AllMappedSubAccounts',
  /** Do not allocate matching transactions to any sub account */
  LeaveUnallocated: 'LeaveUnallocated',
} as const;
export type SubAccountTradeRoutingModeEnum =
  (typeof SubAccountTradeRoutingModeEnum)[keyof typeof SubAccountTradeRoutingModeEnum];

export const SubAccountTypeEnum = {
  /** Base subaccount type book */
  Book: 'Book',
  /** Subaccount type composed of books and/or other rollups */
  Rollup: 'Rollup',
} as const;
export type SubAccountTypeEnum = (typeof SubAccountTypeEnum)[keyof typeof SubAccountTypeEnum];

export const SubProductTypeEnum = {
  /** OTC Vanilla Option */
  OTCVanillaOption: 'OTCVanillaOption',
  /** OTC Forward */
  OTCForward: 'OTCForward',
  /** OTC Fixed Rate Loan */
  OTCFixedRateLoan: 'OTCFixedRateLoan',
  /** OTC Floating Rate Loan */
  OTCFloatingRateLoan: 'OTCFloatingRateLoan',
  /** OTC Repo */
  OTCRepo: 'OTCRepo',
} as const;
export type SubProductTypeEnum = (typeof SubProductTypeEnum)[keyof typeof SubProductTypeEnum];

export const SubscriptionRequestTypeEnum = {
  /** Subscribe */
  Subscribe: 'Subscribe',
  /** Unsubscribe */
  Unsubscribe: 'Unsubscribe',
  /** Snoop */
  Snoop: 'Snoop',
  /** Snapshot */
  Snapshot: 'Snapshot',
} as const;
export type SubscriptionRequestTypeEnum =
  (typeof SubscriptionRequestTypeEnum)[keyof typeof SubscriptionRequestTypeEnum];

export const SuppressPolicyEnum = {
  /** Allows suppression */
  AllowSuppress: 'AllowSuppress',
  /** Disallows suppression */
  DisallowSuppress: 'DisallowSuppress',
} as const;
export type SuppressPolicyEnum = (typeof SuppressPolicyEnum)[keyof typeof SuppressPolicyEnum];

export const SyntheticProductTypeEnum = {
  /** unknown */
  Unknown: 'Unknown',
  /** Synthetic Cross */
  Cross: 'Cross',
  /** Delta-1 Spread */
  Delta1Spread: 'Delta1Spread',
  /** Call Calendar */
  CallCalendarSpread: 'CallCalendarSpread',
  /** Put Calendar */
  PutCalendarSpread: 'PutCalendarSpread',
  /** Call Spread */
  CallSpread: 'CallSpread',
  /** Put Spread */
  PutSpread: 'PutSpread',
} as const;
export type SyntheticProductTypeEnum = (typeof SyntheticProductTypeEnum)[keyof typeof SyntheticProductTypeEnum];

export const TenorBucketEnum = {
  /** Outright */
  Outright: 'Outright',
  /** W1 */
  W1: 'W1',
  /** M1 */
  M1: 'M1',
  /** M3 */
  M3: 'M3',
  /** M6 */
  M6: 'M6',
  /** M9 */
  M9: 'M9',
  /** Y1 */
  Y1: 'Y1',
} as const;
export type TenorBucketEnum = (typeof TenorBucketEnum)[keyof typeof TenorBucketEnum];

export const ThresholdTypeEnum = {
  /** NewOrderCount */
  NewOrderCount: 'NewOrderCount',
  /** TotalActiveVolume */
  TotalActiveVolume: 'TotalActiveVolume',
  /** NewOrderVolume */
  NewOrderVolume: 'NewOrderVolume',
} as const;
export type ThresholdTypeEnum = (typeof ThresholdTypeEnum)[keyof typeof ThresholdTypeEnum];

export const TimeInForceEnum = {
  /** GoodTillCancel */
  GoodTillCancel: 'GoodTillCancel',
  /** Day */
  Day: 'Day',
  /** FillAndKill */
  FillAndKill: 'FillAndKill',
  /** FillOrKill */
  FillOrKill: 'FillOrKill',
  /** PostOnly */
  PostOnly: 'PostOnly',
} as const;
export type TimeInForceEnum = (typeof TimeInForceEnum)[keyof typeof TimeInForceEnum];

export const TopicStatusEnum = {
  /** Requesting */
  Requesting: 'Requesting',
  /** Streaming */
  Streaming: 'Streaming',
  /** NotAvailable */
  NotAvailable: 'NotAvailable',
} as const;
export type TopicStatusEnum = (typeof TopicStatusEnum)[keyof typeof TopicStatusEnum];

export const TradeActionEnum = {
  /** New */
  New: 'New',
  /** Confirmed */
  Confirmed: 'Confirmed',
  /** Updated */
  Updated: 'Updated',
  /** Canceled */
  Canceled: 'Canceled',
} as const;
export type TradeActionEnum = (typeof TradeActionEnum)[keyof typeof TradeActionEnum];

export const TradeRecoveryActionEnum = {
  /** start processing a trade recovery request */
  Process: 'Process',
  /** cancel processing a trade recovery request */
  Cancel: 'Cancel',
  /** report status of a trade recovery request */
  Status: 'Status',
} as const;
export type TradeRecoveryActionEnum = (typeof TradeRecoveryActionEnum)[keyof typeof TradeRecoveryActionEnum];

export const TradeRecoveryStatusEnum = {
  /** request has been accepted and awaiting processing */
  PendingProcessing: 'PendingProcessing',
  /** request is being processed */
  Processing: 'Processing',
  /** request has been requested to cancel */
  PendingCancel: 'PendingCancel',
  /** request has been cancelled */
  Cancelled: 'Cancelled',
  /** request has completed successfully */
  Completed: 'Completed',
  /** request has been rejected */
  Rejected: 'Rejected',
  /** request has failed due to an error */
  Failed: 'Failed',
} as const;
export type TradeRecoveryStatusEnum = (typeof TradeRecoveryStatusEnum)[keyof typeof TradeRecoveryStatusEnum];

export const TradeRefDataTypeEnum = {
  /** Delta of an option */
  Delta: 'Delta',
  /** Underlying price of an option */
  UnderlyingPrice: 'UnderlyingPrice',
  /** Conversion rate for unified liquidity trades */
  UnifiedLiquidityConversionRate: 'UnifiedLiquidityConversionRate',
  /** Leg fill price used to calculate basis points price */
  RefLegFillPrice: 'RefLegFillPrice',
} as const;
export type TradeRefDataTypeEnum = (typeof TradeRefDataTypeEnum)[keyof typeof TradeRefDataTypeEnum];

export const TradeSettleActionEnum = {
  /** Trade report is created */
  Created: 'Created',
  /** Trade report is settled */
  Settlement: 'Settlement',
  /** Trade was amended causing update of this trade settle report */
  TradeAmend: 'TradeAmend',
  /** Trade was canceled causing update of this trade settle report */
  TradeCancel: 'TradeCancel',
  /** Trade report is cancelled */
  Cancel: 'Cancel',
} as const;
export type TradeSettleActionEnum = (typeof TradeSettleActionEnum)[keyof typeof TradeSettleActionEnum];

export const TradeSettleSourceEnum = {
  /** Size was prefunded */
  Prefunded: 'Prefunded',
  /** Settled because of deposit */
  Deposit: 'Deposit',
  /** Settled because of settlement process */
  Settlement: 'Settlement',
} as const;
export type TradeSettleSourceEnum = (typeof TradeSettleSourceEnum)[keyof typeof TradeSettleSourceEnum];

export const TradeSettleStatusEnum = {
  /** Trade is settled */
  Settled: 'Settled',
  /** Trade is unsettled */
  Unsettled: 'Unsettled',
  /** Trade is canceled */
  Canceled: 'Canceled',
  /** Only the due portion of the trade has been settled */
  DueSettled: 'DueSettled',
  /** Only the proceeds portion of the trade has been settled */
  ProceedsSettled: 'ProceedsSettled',
} as const;
export type TradeSettleStatusEnum = (typeof TradeSettleStatusEnum)[keyof typeof TradeSettleStatusEnum];

export const TradeSourceEnum = {
  /** Market trade source */
  Market: 'Market',
  /** User trade source */
  User: 'User',
  /** Dealer trade source */
  Dealer: 'Dealer',
  /** Dealer trade manually added */
  DealerUser: 'DealerUser',
} as const;
export type TradeSourceEnum = (typeof TradeSourceEnum)[keyof typeof TradeSourceEnum];

export const TradeStatusEnum = {
  /** Trade capture has arrived, or no capture is expected */
  Confirmed: 'Confirmed',
  /** Trade capture will come later */
  Pending: 'Pending',
  /** Trade capture was canceled (didn't happen or added by mistake) */
  Canceled: 'Canceled',
} as const;
export type TradeStatusEnum = (typeof TradeStatusEnum)[keyof typeof TradeStatusEnum];

export const TradeTypeEnum = {
  /** RFQ */
  RFQ: 'RFQ',
  /** EXC */
  EXC: 'EXC',
} as const;
export type TradeTypeEnum = (typeof TradeTypeEnum)[keyof typeof TradeTypeEnum];

export const TradeUpdateRequestTypeEnum = {
  /** Update requested trade with specified param values */
  TradeUpdate: 'TradeUpdate',
  /** Cancel requested trade */
  TradeCancel: 'TradeCancel',
  /** Update requested order with specified param values */
  OrderUpdate: 'OrderUpdate',
  /** Update requested customer trade with specified param values */
  CustomerTradeUpdate: 'CustomerTradeUpdate',
  /** Cancel requested customertrade */
  CustomerTradeCancel: 'CustomerTradeCancel',
  /** Update requested dealer trade ledgers */
  DealerTradeUpdate: 'DealerTradeUpdate',
  /** Cancel requested dealer trade ledgers */
  DealerTradeCancel: 'DealerTradeCancel',
  /** Modify price and fixing details of done for day order, rfq and trade */
  OrderFixingPriceUpdate: 'OrderFixingPriceUpdate',
  /** Modify price and fixing details of done for day customer order, customer rfq and customer trade */
  CustomerOrderFixingPriceUpdate: 'CustomerOrderFixingPriceUpdate',
} as const;
export type TradeUpdateRequestTypeEnum = (typeof TradeUpdateRequestTypeEnum)[keyof typeof TradeUpdateRequestTypeEnum];

export const TransactionAutoProposalModeEnum = {
  /** No transfer details populated, directly into PendingTransfer status */
  None: 'None',
  /** Populate transfer proposal from links, move to PendingTransfer */
  ProposeAndAccept: 'ProposeAndAccept',
  /** Populate transfer proposal from links, automatically initiate a transfer if details are complete */
  ProposeAcceptAndInitiate: 'ProposeAcceptAndInitiate',
  /** Do not update information, but automatically initiate a transfer if details are sufficient */
  InitiateOnly: 'InitiateOnly',
} as const;
export type TransactionAutoProposalModeEnum =
  (typeof TransactionAutoProposalModeEnum)[keyof typeof TransactionAutoProposalModeEnum];

export const TransactionControlTypeEnum = {
  /** All transaction types. */
  All: 'All',
  /** All fees. */
  AllFees: 'AllFees',
  /** All transfer-related fees, e.g. transfer/withdrawal/deposit fees. */
  AllTransferFees: 'AllTransferFees',
  /** Recon adjustment. */
  ReconAdjustment: 'ReconAdjustment',
  /** Any transaction type not categorized otherwise. */
  Misc: 'Misc',
  /** Derivative funding event. */
  FundingPnL: 'FundingPnL',
  /** PnL realization event */
  RealizedPnL: 'RealizedPnL',
  /** Settlement fees. */
  SettlementFee: 'SettlementFee',
  /** Deposits. */
  Deposit: 'Deposit',
  /** Deposit fees. */
  DepositFee: 'DepositFee',
  /** Withdrawals. */
  Withdrawal: 'Withdrawal',
  /** Withdrawal fees. */
  WithdrawalFee: 'WithdrawalFee',
  /** Trades. */
  Trade: 'Trade',
  /** Trading fees. */
  TradingFee: 'TradingFee',
  /** Liquidation. */
  Liquidation: 'Liquidation',
  /** Liquidation fees. */
  LiquidationFee: 'LiquidationFee',
  /** Delivery of a deliverable contract. */
  Delivery: 'Delivery',
  /** Delivery fees. */
  DeliveryFee: 'DeliveryFee',
  /** Reward from staked assets */
  StakingReward: 'StakingReward',
  /** Fee for reward from staked assets */
  StakingRewardFee: 'StakingRewardFee',
  /** Fee paid on transfers. Ideally this shouldn't exist, and we should use only DepositFee or WithdrawalFee instead. This variant is intended as a temporary solution until gateways stop generating AssetTransactionType.TransferFee. */
  TransferFee: 'TransferFee',
  /** Settlement / credit reset */
  Settlement: 'Settlement',
  /** Preliminary amount for creating shares of a fund. */
  PreliminaryCreate: 'PreliminaryCreate',
  /** Final amount for creating shares of a fund. */
  FinalCreate: 'FinalCreate',
  /** Preliminary amount for redeeming shares of a fund. */
  PreliminaryRedeem: 'PreliminaryRedeem',
  /** Final amount for redeeming shares of a fund. */
  FinalRedeem: 'FinalRedeem',
  /** Management fee charged for managing a fund. */
  ManagementFee: 'ManagementFee',
  /** Interest paid or charged for cash held in a deposit savings account. */
  DepositInterest: 'DepositInterest',
  /** Miscellaneous fees. */
  MiscFee: 'MiscFee',
  /** Cash disbursement (lender side) or receipt (borrower side) at loan origination or drawdown. */
  LoanPrincipal: 'LoanPrincipal',
  /** Return of principal by the borrower. */
  LoanPrincipalRepayment: 'LoanPrincipalRepayment',
  /** Collateral transferred to secure the loan, from borrower to lender. */
  CollateralPost: 'CollateralPost',
  /** Full return of collateral to borrower at loan termination. */
  CollateralRelease: 'CollateralRelease',
  /** Return of the original collateral asset to the borrower / repo seller. */
  CollateralSubstitutionOut: 'CollateralSubstitutionOut',
  /** Receipt of the replacement collateral asset (swap of collateral). */
  CollateralSubstitutionIn: 'CollateralSubstitutionIn',
  /** Coupon / interest payment when it settles. */
  LoanInterest: 'LoanInterest',
  /** Penalty cash payment when an interest or principal payment is overdue. Configured as Late Fee % on the MLA. */
  LateFee: 'LateFee',
  /** Penalty for early repayment. */
  PrepaymentFee: 'PrepaymentFee',
  /** One-time fee charged at loan origination. */
  OriginationFee: 'OriginationFee',
  /** Cash settlement of a margin call on a repo (alternative to posting additional collateral). */
  CashMarginPayment: 'CashMarginPayment',
  /** Income earned on collateral during the life of a repo (e.g. staking rewards on ETH, coupon on a tokenised bond) passed through to the original owner. */
  ManufacturedPayment: 'ManufacturedPayment',
  /** Cash received from selling seized collateral after a default. For loans: output of the liquidation process. For repos: close-out netting settlement. Net amount may result in a payment to the defaulting party (excess) or a claim against them (shortfall). */
  LiquidationProceeds: 'LiquidationProceeds',
  /** An externally sourced reconciliation adjustment. */
  ExternalReconAdjustment: 'ExternalReconAdjustment',
  /** Creation of fund shares in exchange for a basket of constituent assets rather than cash. */
  InKindCreate: 'InKindCreate',
  /** Redemption of fund shares in exchange for a basket of constituent assets rather than cash. */
  InKindRedeem: 'InKindRedeem',
  /** PnL event for when marking derivative positions. */
  MarkToMarketPnL: 'MarkToMarketPnL',
} as const;
export type TransactionControlTypeEnum = (typeof TransactionControlTypeEnum)[keyof typeof TransactionControlTypeEnum];

export const TransactionExecTypeEnum = {
  /** Transaction was successfully created */
  Created: 'Created',
  /** Transaction is fully approved */
  Approved: 'Approved',
  /** Transfer has been initiated by transfer gateway */
  TransferInitiated: 'TransferInitiated',
  /** Transfer has been rejected by transfer gateway */
  TransferRejected: 'TransferRejected',
  /** Transfer has been completed */
  TransferCompleted: 'TransferCompleted',
  /** Transaction has been canceled by the user */
  Canceled: 'Canceled',
  /** Transaction has been rejected either by Talos user or external system */
  Rejected: 'Rejected',
  /** Transaction has been completed either by manual action or by transfer complete */
  Completed: 'Completed',
  /** Transaction got some update but didn't change its status */
  Restated: 'Restated',
  /** Update request was rejected */
  UpdateRejected: 'UpdateRejected',
  /** Transfer has been registered (request passed the validation and transfer request has been sent) */
  TransferRegistered: 'TransferRegistered',
  /** Transfer has been sent to blockchain and have txHash. Waiting for block confirmations */
  TransferPendingBlockchainConfirmation: 'TransferPendingBlockchainConfirmation',
  /** Child transaction update caused status change */
  GroupChildStatusUpdate: 'GroupChildStatusUpdate',
  /** Proposed transaction (e.g., with transfer details) has been accepted */
  ProposalAccepted: 'ProposalAccepted',
} as const;
export type TransactionExecTypeEnum = (typeof TransactionExecTypeEnum)[keyof typeof TransactionExecTypeEnum];

export const TransactionOptionsEnum = {
  /** Not available for automation */
  ManualOnly: 'ManualOnly',
  /** Deduct transaction fees from amount sent. */
  TreatAsGrossAmt: 'TreatAsGrossAmt',
} as const;
export type TransactionOptionsEnum = (typeof TransactionOptionsEnum)[keyof typeof TransactionOptionsEnum];

export const TransactionRejectReasonEnum = {
  /** Exceeds balances */
  ExceedsBalances: 'ExceedsBalances',
  /** Validation error */
  ValidationError: 'ValidationError',
  /** Transition is not possible with current transaction state */
  TransitionNotPossible: 'TransitionNotPossible',
  /** Internal error */
  InternalError: 'InternalError',
  /** Related transfer was rejected */
  TransferRejected: 'TransferRejected',
} as const;
export type TransactionRejectReasonEnum =
  (typeof TransactionRejectReasonEnum)[keyof typeof TransactionRejectReasonEnum];

export const TransactionStatusEnum = {
  /** Transaction has passed validation / is completed and needs to be approved by an authorized party */
  PendingApproval: 'PendingApproval',
  /** Rejected by the dealer or an external system */
  Rejected: 'Rejected',
  /** Transaction has been accepted and requires a transfer to be initiated */
  PendingTransfer: 'PendingTransfer',
  /** Completed */
  Completed: 'Completed',
  /** Canceled by the user */
  Canceled: 'Canceled',
  /** Transfer has been initiated (gateway accepted the transfer request) */
  TransferInitiated: 'TransferInitiated',
  /** Transfer has been registered (request passed the validation and transfer request has been sent) */
  TransferRegistered: 'TransferRegistered',
  /** Transfer has been sent to blockchain and have txHash. Waiting for block confirmation(s) */
  TransferPendingBlockchainConfirmation: 'TransferPendingBlockchainConfirmation',
  /** General / aggregate active status */
  InProgress: 'InProgress',
  /** Proposed transfer or settlement. Details have been populated and may be updated */
  Proposed: 'Proposed',
} as const;
export type TransactionStatusEnum = (typeof TransactionStatusEnum)[keyof typeof TransactionStatusEnum];

export const TransactionTypeEnum = {
  /** Customer initiated withdrawal */
  CustomerWithdrawal: 'CustomerWithdrawal',
  /** Customer initiated deposit */
  CustomerDeposit: 'CustomerDeposit',
  /** Settlement batch parent transaction */
  SettlementBatch: 'SettlementBatch',
  /** Outgoing settlement */
  SettlementOutgoing: 'SettlementOutgoing',
  /** Incoming settlement (expected) */
  SettlementIncoming: 'SettlementIncoming',
  /** A forced customer withdrawal that can take the amount into negative */
  CustomerForceWithdrawal: 'CustomerForceWithdrawal',
} as const;
export type TransactionTypeEnum = (typeof TransactionTypeEnum)[keyof typeof TransactionTypeEnum];

export const TransactionUpdateActionEnum = {
  /** User approves the transaction */
  Approve: 'Approve',
  /** User initiates the transfer */
  InitiateTransfer: 'InitiateTransfer',
  /** User cancels the transaction */
  Cancel: 'Cancel',
  /** User rejects the transaction */
  Reject: 'Reject',
  /** User completes the transaction. This means closing the transaction and creating ledger event */
  Complete: 'Complete',
  /** User updates transaction details, e.g., Source / Destination accounts */
  UpdateProposal: 'UpdateProposal',
  /** User accepts transaction details */
  AcceptProposal: 'AcceptProposal',
  /** User force-cancels the transaction */
  ForceCancel: 'ForceCancel',
  /** User force-rejects the transaction */
  ForceReject: 'ForceReject',
} as const;
export type TransactionUpdateActionEnum =
  (typeof TransactionUpdateActionEnum)[keyof typeof TransactionUpdateActionEnum];

export const TransferAutomationStatusEnum = {
  /** Enabled */
  Enabled: 'Enabled',
  /** Disabled */
  Disabled: 'Disabled',
} as const;
export type TransferAutomationStatusEnum =
  (typeof TransferAutomationStatusEnum)[keyof typeof TransferAutomationStatusEnum];

export const TransferOptionsEnum = {
  /** Deduct fees for transfer from amount sent. */
  TreatAsGrossAmt: 'TreatAsGrossAmt',
} as const;
export type TransferOptionsEnum = (typeof TransferOptionsEnum)[keyof typeof TransferOptionsEnum];

export const TransferRequestTypeEnum = {
  /** OMS */
  OMS: 'OMS',
  /** Gateway */
  Gateway: 'Gateway',
  /** Customer */
  Customer: 'Customer',
} as const;
export type TransferRequestTypeEnum = (typeof TransferRequestTypeEnum)[keyof typeof TransferRequestTypeEnum];

export const TransferStatusEnum = {
  /** Pending */
  Pending: 'Pending',
  /** Processing */
  Processing: 'Processing',
  /** Completed */
  Completed: 'Completed',
  /** Failed */
  Rejected: 'Rejected',
  /** WaitingForExternalAuth */
  WaitingForExternalAuth: 'WaitingForExternalAuth',
} as const;
export type TransferStatusEnum = (typeof TransferStatusEnum)[keyof typeof TransferStatusEnum];

export const TransferTypeEnum = {
  /** Default transfer type */
  Default: 'Default',
  /** Transfer initiates staking */
  StakeInitiate: 'StakeInitiate',
  /** Transfer indicates receiving staking rewards */
  StakeReward: 'StakeReward',
  /** Transfer indicates unstaking */
  StakeWithdraw: 'StakeWithdraw',
} as const;
export type TransferTypeEnum = (typeof TransferTypeEnum)[keyof typeof TransferTypeEnum];

export const TransferUpdateStatusEnum = {
  /** Update has been applied successfully */
  Updated: 'Updated',
  /** Failed to apply the update */
  Rejected: 'Rejected',
} as const;
export type TransferUpdateStatusEnum = (typeof TransferUpdateStatusEnum)[keyof typeof TransferUpdateStatusEnum];

export const TreasuryLinkDirectionEnum = {
  /** Outbound mapping, e.g., customer withdrawals or settlements to OTCs */
  Outbound: 'Outbound',
  /** Inbound mapping, e.g., customer deposits or settlements from OTCs */
  Inbound: 'Inbound',
} as const;
export type TreasuryLinkDirectionEnum = (typeof TreasuryLinkDirectionEnum)[keyof typeof TreasuryLinkDirectionEnum];

export const TreasuryLinkTypeEnum = {
  /** Treasury to whitelisted OTC settlement account */
  OTCSettlement: 'OTCSettlement',
  /** Treasury to/from exchange accounts */
  ExchangeRebalance: 'ExchangeRebalance',
  /** Treasury to/from customer user accounts facilitating customer deposits and withdrawals */
  CustomerTransfer: 'CustomerTransfer',
} as const;
export type TreasuryLinkTypeEnum = (typeof TreasuryLinkTypeEnum)[keyof typeof TreasuryLinkTypeEnum];

export const TriggerTypeEnum = {
  /** Cross */
  Cross: 'Cross',
  /** Stop */
  Stop: 'Stop',
  /** TakeProfit */
  TakeProfit: 'TakeProfit',
} as const;
export type TriggerTypeEnum = (typeof TriggerTypeEnum)[keyof typeof TriggerTypeEnum];

export const TypeEnum = {
  /** SubAccount */
  SubAccount: 'SubAccount',
  /** MarketAccount */
  MarketAccount: 'MarketAccount',
  /** Strategy */
  Strategy: 'Strategy',
  /** ABOR link from SubAccount to MarketAccount */
  ABORMarketAccount: 'ABORMarketAccount',
} as const;
export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];

export const UnconfirmedPositionStatusEnum = {
  /** Unconfirmed positions are up to date */
  Live: 'Live',
  /** Unconfirmed positions are stale */
  Stale: 'Stale',
} as const;
export type UnconfirmedPositionStatusEnum =
  (typeof UnconfirmedPositionStatusEnum)[keyof typeof UnconfirmedPositionStatusEnum];

export const UnifiedLiquidityEnum = {
  /** Enabled */
  Enabled: 'Enabled',
  /** Disabled */
  Disabled: 'Disabled',
  /** EnabledCrossInstrument */
  EnabledCrossInstrument: 'EnabledCrossInstrument',
} as const;
export type UnifiedLiquidityEnum = (typeof UnifiedLiquidityEnum)[keyof typeof UnifiedLiquidityEnum];

export const UpdateActionEnum = {
  /** Add or update the item with this key */
  Update: 'Update',
  /** Remove the item with this key */
  Remove: 'Remove',
  /** Set when this is the Initial Update sent */
  Initial: 'Initial',
  /** Reset */
  Reset: 'Reset',
} as const;
export type UpdateActionEnum = (typeof UpdateActionEnum)[keyof typeof UpdateActionEnum];

export const UserMarketDataLimitRequestStatusEnum = {
  /** MD request has been accepted and is active */
  Active: 'Active',
  /** MD request has been closed */
  Closed: 'Closed',
  /** MD request has been rejected */
  Rejected: 'Rejected',
} as const;
export type UserMarketDataLimitRequestStatusEnum =
  (typeof UserMarketDataLimitRequestStatusEnum)[keyof typeof UserMarketDataLimitRequestStatusEnum];

export const VenueClearingStatusEnum = {
  /** Report created locally, awaiting proposal submission (taker) or a matching proposal (maker) */
  Created: 'Created',
  /** Proposal submitted to venue */
  Proposed: 'Proposed',
  /** All counterparties accepted the proposal */
  Accepted: 'Accepted',
  /** Venue confirmed clearing */
  Cleared: 'Cleared',
  /** Counterparty explicitly rejected the proposal */
  Rejected: 'Rejected',
  /** Proposal canceled before acceptance */
  Canceled: 'Canceled',
  /** Proposal expired unaccepted */
  Expired: 'Expired',
  /** API failure during proposal submit or accept */
  Error: 'Error',
  /** Admin retry requested from Error; awaiting reconciliation against the venue's block trade proposals before resuming */
  Retrying: 'Retrying',
} as const;
export type VenueClearingStatusEnum = (typeof VenueClearingStatusEnum)[keyof typeof VenueClearingStatusEnum];

export const VenueClearingSubmissionTypeEnum = {
  /** Bilateral block trade submission */
  BlockTrade: 'BlockTrade',
  /** Post-trade drop copy submission */
  DropCopy: 'DropCopy',
} as const;
export type VenueClearingSubmissionTypeEnum =
  (typeof VenueClearingSubmissionTypeEnum)[keyof typeof VenueClearingSubmissionTypeEnum];

export const VenueClearingSubmittingPartyEnum = {
  /** This instance submitted/proposed the trade */
  Taker: 'Taker',
  /** This instance received/matched the proposal */
  Maker: 'Maker',
} as const;
export type VenueClearingSubmittingPartyEnum =
  (typeof VenueClearingSubmittingPartyEnum)[keyof typeof VenueClearingSubmittingPartyEnum];

export const ViewCancelTypeEnum = {
  /** Cancel a single request */
  Request: 'Request',
  /** Cancel all requests for client process */
  Client: 'Client',
  /** Cancel all requests for a session */
  Session: 'Session',
} as const;
export type ViewCancelTypeEnum = (typeof ViewCancelTypeEnum)[keyof typeof ViewCancelTypeEnum];

export const VoltraceHopStatusEnum = {
  /** The downstream node replied within the deadline */
  Responded: 'Responded',
  /** The downstream node did not reply within the deadline */
  TimedOut: 'TimedOut',
} as const;
export type VoltraceHopStatusEnum = (typeof VoltraceHopStatusEnum)[keyof typeof VoltraceHopStatusEnum];

export const VoltraceHopTypeEnum = {
  /** Logclient leaf — no further tracing available */
  LogClient: 'LogClient',
  /** Volatile stream hop — chainable to upstream compressor */
  VolStream: 'VolStream',
} as const;
export type VoltraceHopTypeEnum = (typeof VoltraceHopTypeEnum)[keyof typeof VoltraceHopTypeEnum];

export const VoltraceOptionsEnum = {
  /** Discover connectivity graph */
  TopologyDiscovery: 'TopologyDiscovery',
} as const;
export type VoltraceOptionsEnum = (typeof VoltraceOptionsEnum)[keyof typeof VoltraceOptionsEnum];

export const WorkingAmountAllocModeEnum = {
  /** AllAtTraded */
  AllAtTraded: 'AllAtTraded',
  /** OppAtFixing */
  OppAtFixing: 'OppAtFixing',
} as const;
export type WorkingAmountAllocModeEnum = (typeof WorkingAmountAllocModeEnum)[keyof typeof WorkingAmountAllocModeEnum];

export const WorkingOrderTypeEnum = {
  /** The response should be a live working order */
  Executable: 'Executable',
  /** The response should be a preview of the command results */
  Preview: 'Preview',
} as const;
export type WorkingOrderTypeEnum = (typeof WorkingOrderTypeEnum)[keyof typeof WorkingOrderTypeEnum];

/** Trading signal bin */
export interface ITradingSignalBin {
  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Start time of this trading signal bin in number of nanoseconds since Unix epoch */
  BinStartTime: JSON_UTCTimestamp;

  /** Date the bin belongs to in number of nanoseconds since Unix epoch */
  MarketDate: JSON_UTCTimestamp;

  /** Bin spread */
  Spread: JSON_Decimal;

  /** Bin spread in bps */
  SpreadBps: JSON_Decimal;

  /** Volatility in bps */
  VolatilityBps: JSON_Decimal;

  /** Bin volume */
  Volume: JSON_Decimal;

  /** Bin volume pct */
  VolumePct: JSON_Decimal;
}

/** Request for an order trajectory */
export interface IOrderTrajectoryRequest {
  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** OMS order OrderID */
  OrderID: string;

  /** Security ID */
  Symbol: JSON_Security;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** Overall start time of the full trajectory */
  StartTime: JSON_UTCTimestamp;

  /** Overall end time of the full trajectory */
  EndTime: JSON_UTCTimestamp;

  /** Overall quantity to be scheduled */
  Quantity: JSON_Decimal;

  /** Latest adjustment quantity */
  AdjustmentQty: JSON_Decimal;

  /** The index of the enum value chosen for BoundsControl. The allowed values are provided on the API. */
  BoundsControl: number;

  /** Base lower value to overwrite */
  BaseLower: JSON_Decimal;

  /** Base upper value to overwrite */
  BaseUpper: JSON_Decimal;

  /** Overall start time of the full trajectory */
  TrajectoryStartTime: JSON_UTCTimestamp;

  /** Overall duration of the full trajectory */
  TrajectoryDuration: JSON_DurationMillis;

  /** Currency ID */
  Currency: string;

  /** Volume cap to apply for the request */
  VolumeCap: JSON_Decimal;

  /** The index of the enum value chosen for Urgency. The allowed values are provided on the API. */
  Urgency: number;

  /** Whether arrival aware sniping is enabled */
  SnipingEnabled: boolean;

  /** Whether arrival aware sweeping is enabled */
  SweepingEnabled: boolean;

  /** Trajectory bins */
  Markets: IOrderTrajectoryRequest7201Markets[];
}

/** Trajectory bins */
export interface IOrderTrajectoryRequest7201Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;
}

/** Partial trajectory for an algo order */
export interface IOrderTrajectory {
  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** OMS order OrderID */
  OrderID: string;

  /** Status */
  Status: OrderTrajectoryResponseStatusEnum;

  /** Overall start time of the full trajectory */
  StartTime: JSON_UTCTimestamp;

  /** Overall end time of the full trajectory */
  EndTime: JSON_UTCTimestamp;

  /** Overall quantity to be scheduled */
  Quantity: JSON_Decimal;

  /** Latest adjustment quantity */
  AdjustmentQty: JSON_Decimal;

  /** Base lower value to overwrite */
  BaseLower: JSON_Decimal;

  /** Base upper value to overwrite */
  BaseUpper: JSON_Decimal;

  /** Volume cap to apply for the request */
  VolumeCap: JSON_Decimal;

  /** Algo type that was requested. */
  RequestedAlgoType: AlgoTypeEnum;

  /** Algo type that was provided (Allowed to deviate from requested in some situations). */
  ResponseAlgoType: AlgoTypeEnum;

  /** Optional arrival aware bound to take liquidity on price improvement */
  SnipeBound: JSON_Decimal;

  /** Optional arrival aware bound to take liquidity on price worsen */
  SweepBound: JSON_Decimal;

  /** Text */
  Text: string;

  /** Trajectory bins */
  Bins: IOrderTrajectory7202Bins[];

  /** Analytic properties */
  Analytics: IOrderTrajectory7202Analytics[];
}

/** Analytic properties */
export interface IOrderTrajectory7202Analytics {
  /** Property */
  Property: OMSOrderPropertyEnum;

  /** Value of property */
  Value: JSON_Decimal;
}

/** Trajectory bins */
export interface IOrderTrajectory7202Bins {
  /** Bin start time */
  StartTime: JSON_UTCTimestamp;

  /** Bin end time */
  EndTime: JSON_UTCTimestamp;

  /** Bin volume */
  Volume: JSON_Decimal;

  /** TargetQty at the start of the bin */
  StartTargetQty: JSON_Decimal;

  /** TargetQty at the end of the bin */
  EndTargetQty: JSON_Decimal;

  /** UpperBound at the start of the bin */
  StartUpperBound: JSON_Decimal;

  /** UpperBound at the end of the bin */
  EndUpperBound: JSON_Decimal;

  /** LowerBound at the start of the bin */
  StartLowerBound: JSON_Decimal;

  /** LowerBound at the end of the bin */
  EndLowerBound: JSON_Decimal;

  /** Bin qty based on the full bin quantity. It might differ from end-start qty in case of volume cap */
  BinQty: JSON_Decimal;
}

/** Request for a pre-trade trajectory analysis */
export interface IPreTradeRequest {
  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** Overall start time of the full trajectory */
  StartTime: JSON_UTCTimestamp;

  /** Overall end time of the full trajectory */
  EndTime: JSON_UTCTimestamp;

  /** Overall quantity to be scheduled */
  Quantity: JSON_Decimal;

  /** The index of the enum value chosen for BoundsControl. The allowed values are provided on the API. */
  BoundsControl: number;

  /** Currency ID */
  Currency: string;

  /** Volume cap to apply for the request */
  VolumeCap: JSON_Decimal;

  /** NewOrderSingle representation of pre trade request */
  NewOrderSingle: IOMSNewOrderSingle;

  /** Optional passthrough identifier for the pre trade session */
  SessionIdentifier: string;

  /** Trajectory bins */
  Markets: IPreTradeRequest7203Markets[];
}

/** Trajectory bins */
export interface IPreTradeRequest7203Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;
}

/** Snapshot for a HeartbeatModel */
export interface IHeartbeatModelSnapshot {
  /** The ID of this HeartbeatModel */
  SenderID: number;

  /** Timestamp of the last heartbeat published by this HeartbeatModel */
  LastPublishedHeartbeatTime: JSON_UTCTimestamp;

  /** The set of most recent heartbeats this HeartbeatModel has received by sender */
  LastReceivedHeartbeats: IHeartbeatModelSnapshot11300LastReceivedHeartbeats[];
}

/** The set of most recent heartbeats this HeartbeatModel has received by sender */
export interface IHeartbeatModelSnapshot11300LastReceivedHeartbeats {
  /** The ID of the Sender of this heartbeat */
  SenderID: number;

  /** Timestamp of the last heartbeat received from this sender */
  Timestamp: JSON_UTCTimestamp;
}

/** Pre-trade trajectory response for an algo order */
export interface IPreTradeResponse {
  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Internal time in number of nanoseconds since Unix epoch when request was submitted */
  RequestedTimestamp: JSON_UTCTimestamp;

  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** Overall start time of the full trajectory */
  StartTime: JSON_UTCTimestamp;

  /** Overall end time of the full trajectory */
  EndTime: JSON_UTCTimestamp;

  /** Overall quantity to be scheduled */
  Quantity: JSON_Decimal;

  /** Status */
  Status: OrderTrajectoryResponseStatusEnum;

  /** The index of the enum value chosen for BoundsControl. The allowed values are provided on the API. */
  BoundsControl: number;

  /** Volume cap to apply for the request */
  VolumeCap: JSON_Decimal;

  /** Algo type that was requested. */
  RequestedAlgoType: AlgoTypeEnum;

  /** Algo type that was provided (Allowed to deviate from requested in some situations). */
  ResponseAlgoType: AlgoTypeEnum;

  /** Currency ID */
  Currency: string;

  /** Optional arrival aware bound to take liquidity on price improvement, in bps */
  SnipeBound: JSON_Decimal;

  /** Optional arrival aware bound to take liquidity on price worsening, in bps */
  SweepBound: JSON_Decimal;

  /** Text */
  Text: string;

  /** NewOrderSingle representation of pre trade request */
  NewOrderSingle: IOMSNewOrderSingle;

  /** Optional passthrough identifier for the pre trade session */
  SessionIdentifier: string;

  /** Trajectory bins */
  Bins: IPreTradeResponse7204Bins[];

  /** Analytic properties */
  Analytics: IPreTradeResponse7204Analytics[];

  /** Fields used in calculations */
  NOSConsideredFields: IPreTradeResponse7204NOSConsideredFields[];

  /** Trajectory bins */
  Markets: IPreTradeResponse7204Markets[];
}

/** Analytic properties */
export interface IPreTradeResponse7204Analytics {
  /** Property */
  Property: OMSOrderPropertyEnum;

  /** Value of property */
  Value: JSON_Decimal;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;
}

/** Trajectory bins */
export interface IPreTradeResponse7204Bins {
  /** Bin start time */
  StartTime: JSON_UTCTimestamp;

  /** Bin end time */
  EndTime: JSON_UTCTimestamp;

  /** Bin volume */
  Volume: JSON_Decimal;

  /** TargetQty at the start of the bin */
  StartTargetQty: JSON_Decimal;

  /** TargetQty at the end of the bin */
  EndTargetQty: JSON_Decimal;

  /** UpperBound at the start of the bin */
  StartUpperBound: JSON_Decimal;

  /** UpperBound at the end of the bin */
  EndUpperBound: JSON_Decimal;

  /** LowerBound at the start of the bin */
  StartLowerBound: JSON_Decimal;

  /** LowerBound at the end of the bin */
  EndLowerBound: JSON_Decimal;

  /** Bin qty based on the full bin quantity. It might differ from end-start qty in case of volume cap */
  BinQty: JSON_Decimal;
}

/** Trajectory bins */
export interface IPreTradeResponse7204Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;
}

/** Fields used in calculations */
export interface IPreTradeResponse7204NOSConsideredFields {
  /** Fields used in calculations for pre-trade. */
  Name: string;
}

/** Order notification message */
export interface IOMSOrderNotification {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Order ID */
  OrderID: string;

  /** Notification type */
  Type: OrderNotificationTypeEnum;

  /** Text */
  Text: string;

  /** Markets related to the notification */
  Markets: IOMSOrderNotification7210Markets[];
}

/** Markets related to the notification */
export interface IOMSOrderNotification7210Markets {
  /** MarketID for requested Market */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Notification type */
  Command: OrderNotificationMarketCommandEnum;

  /** Text */
  Text: string;
}

/** MD Book Subscription Request */
export interface IMarketViewRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;

  /** Security ID for Subscription Request */
  Symbol: JSON_Security;

  /** User ID */
  User: JSON_User;

  /** Canonical price increment */
  PriceIncrement: JSON_Decimal;

  /** Requested Fee Mode */
  FeeMode: FeeModeEnum;

  /** Equivalent Currency ID */
  EquivalentCurrency: string;

  /** Requested Price Depth for Market View */
  Depth: number;

  /** Debug and additional flags */
  Debug: Record<AggregatorDebugFlagEnum, boolean>;

  /** Depth type */
  DepthType: DepthTypeEnum;

  /** Liquidity type */
  LiquidityType: LiquidityTypeEnum;

  /** Unique ID of the aggregation */
  Aggregation: JSON_Int64ID;

  /** Enabling/disabling uncrossing of multiple markets */
  UncrossMarkets: boolean;

  /** Enable or disable unified liquidity feature. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** Organization ID */
  OrgID: number;

  /** Requested Price Depth for Market View */
  SizeBuckets: IMarketViewRequest4146SizeBuckets[];

  /** Requested Price Depth for Market View */
  AmountBuckets: IMarketViewRequest4146AmountBuckets[];

  /** Requested Markets */
  Markets: IMarketViewRequest4146Markets[];
}

/** Requested Price Depth for Market View */
export interface IMarketViewRequest4146AmountBuckets {
  /** Amount Bucket */
  Bucket: JSON_Decimal;
}

/** Requested Markets */
export interface IMarketViewRequest4146Markets {
  /** MarketID for requested Market */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Optional specific security to sample on this market */
  Symbol: JSON_Security;
}

/** Requested Price Depth for Market View */
export interface IMarketViewRequest4146SizeBuckets {
  /** Size Bucket */
  Bucket: JSON_Decimal;
}

/** MD Book Subscription Response */
export interface IViewResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;

  /** ID of MarketView */
  ViewID: JSON_Int64ID;

  /** SenderID of view handler process */
  SenderID: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;
}

/** Request a connection to the sequencer and return details for the session */
export interface ISequencerConnectRequest {
  /** Client-generated request ID */
  RequestID: number;

  /** Unique identifier for the service */
  ServiceID: number;

  /** The service's partition ID */
  PartitionID: number;
}

/** Response to a sequencer connect request */
export interface ISequencerConnectResponse {
  /** The request ID that this status is in response to, if any. */
  RequestID: number;

  /** Last service sequence number the sequencer sequenced */
  LastServiceSequenceNumber: number;

  /** Last sequence position the service ACKed */
  LastServiceAckPosition: number;

  /** Stream ID the client should use to publish messages to the sequencer */
  IncomingDataStreamID: number;

  /** Stream ID the client should use to consume messages from the sequencer */
  OutgoingDataStreamID: number;

  /** The status of this connection */
  Status: SequencerConnectResponseStatusEnum;

  /** Stream ID the client should use to consume admin messages from the sequencer */
  OutgoingAdminStreamID: number;

  /** Current head position of the sequenced stream */
  CurrentPosition: number;

  /** Current global sequence number */
  CurrentGlobalSequenceNumber: number;

  /** Channel the client should publish messages to */
  IncomingDataEndpoint: string;

  /** Channel the client should subscribe to for messages from the sequencer */
  OutgoingDataEndpoint: string;

  /** Channel the client should subscribe to for admin messages from the sequencer */
  OutgoingAdminEndpoint: string;
}

/** Header for each message passed from the service to the sequencer */
export interface ISequencerServiceHeader {
  /** Time the service sent this message */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for the service */
  ServiceID: number;

  /** Sequence number of this message on the service */
  ServiceSequenceNo: number;

  /** The service's partition ID */
  PartitionID: number;

  /** Optional topic */
  Topic: number;
}

/** Header for each message produced by the sequencer */
export interface ISequencerHeader {
  /** Time the sequencer sequenced this message */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for the source service */
  SourceServiceID: number;

  /** Sequence number of this message on the source service */
  SourceSequenceNo: number;

  /** The source service's partition ID */
  SourcePartitionID: number;

  /** Global sequence number of this message */
  SequenceNumber: number;

  /** Optional topic */
  Topic: number;
}

/** Message to announce having finished processed a sequenced message */
export interface ISequencerACK {
  /** Position of the message being ACKed */
  Position: number;
}

/** Sequencer's current position */
export interface ISequencerPosition {
  /** Unique ID of this sequencer */
  SequencerID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Current position in this sequencer's recording */
  Position: number;

  /** Current global sequence number */
  SequenceNumber: number;
}

/** Sequencer's current state for a service */
export interface ISequencerServiceSnapshot {
  /** Unique ID of this sequencer */
  SequencerID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for a service */
  ServiceID: number;

  /** Last sequence number processed from the service */
  SequenceNumber: number;

  /** Last position ACKed by the service */
  AckPosition: number;

  /** The service's partition ID */
  PartitionID: number;
}

/** Snapshot for a SequencerClient */
export interface ISequencerClientSnapshot {
  /** Position in the sequenced stream */
  Position: number;

  /** Sequence number the SequencerClient has produced up to */
  SequenceNo: number;

  /** Timestamp of the heartbeat this service last received from itself */
  LastHeartbeatTimestamp: JSON_UTCTimestamp;

  /** Global sequence number the SequencerClient has received up to */
  GlobalSequenceNo: number;
}

/** TimerRegister entry snapshot */
export interface ITimerRegisterSnapshotEntry {
  /** Timestamp this timer should trigger at */
  TriggerTime: JSON_UTCTimestamp;

  /** Correlation ID for this timer */
  CorrelationID: number;
}

/** An in-flight message the sequencer client is waiting to get back from the sequencer */
export interface ISequencerClientInflightMessageSnapshot {
  /** Service sequence number of this message */
  SequenceNo: number;

  /** The time the message was last sent */
  LastSentTime: JSON_UTCTimestamp;

  /** The template ID of the message contents */
  TemplateID: number;

  /** Optional topic */
  Topic: number;

  /** The message contents in JSON */
  Message: unknown;
}

/** A message that the sequencer sends to itself to know when it has finished processing all pending messages */
export interface ISequencerConnectMarker {
  /** Unique identifier for the service */
  ServiceID: number;

  /** The service's partition ID */
  PartitionID: number;

  /** The client-generated request ID this marker refers to */
  RequestID: number;
}

/** An event message containing the maximum service sequence number that has been recorded for a service */
export interface ISequencerProgressEvent {
  /** Unique identifier for the service */
  ServiceID: number;

  /** The service's partition ID */
  PartitionID: number;

  /** Maximum service sequence number that has been recorded */
  SequenceNo: number;
}

/** Record that all messages from the given queue have been processed */
export interface IStreamPosition {
  /** StreamID that the incoming message came from */
  StreamID: number;

  /** The position processed as an offset of the given RecordingID */
  Position: number;

  /** The recordingID of the started recording */
  RecordingID: number;
}

/** Reset the log position for this streamID, sent following snapshot data to resume the stream */
export interface IStreamPositionReset {
  /** StreamID to reset message came from */
  StreamID: number;

  /** The log position to reset to */
  Position: number;

  /** RecordingID reset to */
  RecordingID: number;
}

/** Indicate the beginning of a stream, and is published as the first message on any recorded stream by publisher */
export interface IStreamStart {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** StreamID */
  StreamID: number;

  /** RecordingID */
  RecordingID: number;
}

/** A security traded */
export interface IStreamPositionCheckpoint {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for the service */
  ServiceID: number;

  /** The service's partition ID */
  PartitionID: number;

  /** StreamID that the incoming message came from */
  StreamID: number;

  /** The recordingID of the started recording */
  RecordingID: number;

  /** The position processed as an offset of the given RecordingID */
  Position: number;

  /** Channel of this stream recording position */
  Channel: string;
}

/** Realtime balance request */
export interface IRealtimeBalanceSnapshotRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Aeron ClientID of the requestor */
  ClientID: number;
}

/** Market balance request */
export interface IMarketBalanceSnapshotRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;
}

/** (TenantID:OrgID)(ResourceName:ReconMismatch ResourceTag:M DatabaseName:recon_mismatches Key:ID TimestampField:Timestamp PrimaryKey:id DBType:OrgDB)(ResourceName:ReconMismatchHistory ResourceTag:H DatabaseName:recon_mismatch_histories Key:ID,Revision TimestampField:Timestamp PrimaryKey:Generated DBType:OrgDB) */
export interface IReconMismatch {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID for this mismatch */
  ID: JSON_Int64ID;

  /** MarketAccount of this reconciliation */
  MarketAccount: JSON_MarketAccount;

  /** Asset of this reconciliation */
  Asset: string;

  /** Start time of the interval in which this missing delta occurred */
  StartTime: JSON_UTCTimestamp;

  /** End time of the interval in which this missing delta occurred */
  EndTime: JSON_UTCTimestamp;

  /** Revision of this mismatch */
  Revision: number;

  /** Delta between internal and externally calculated positions */
  MissingDelta: JSON_Decimal;

  /** External position amount at the end of this interval */
  ResultAmount: JSON_Decimal;

  /** Latest (workflow) state of this mismatch */
  State: ReconStateEnum;

  /** User ID for the last update to this mismatch */
  User: JSON_User;

  /** Resolution / reason for this mismatch */
  Resolution: ReconResolutionEnum;

  /** Organization ID */
  OrgID: number;

  /** External position amount at the start of this interval */
  StartAmount: JSON_Decimal;

  /** Sum of known ledger events for this interval */
  EventsDelta: JSON_Decimal;

  /** Additional information relating to this mismatch / resolution */
  Comments: string;
}

/** (TenantID:OrgID)(ResourceName:ReconStatus ResourceTag:S DatabaseName:recon_status Key:MarketAccountID,AssetID TimestampField:Timestamp PrimaryKey:Generated DBType:OrgDB) */
export interface IReconStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** MarketAccount of this reconciliation */
  MarketAccount: JSON_MarketAccount;

  /** Asset of this reconciliation */
  Asset: string;

  /** Revision of this mismatch */
  Revision: number;

  /** Delta between internal and externally calculated positions */
  TotalMismatch: JSON_Decimal;

  /** Last time of a reconciliation delta / mismatch */
  LastMismatchTime: JSON_UTCTimestamp;

  /** Status */
  Status: ReconStreamStatusEnum;

  /** Organization ID */
  OrgID: number;
}

/** Request sent by client to create a new care order */
export interface ICareNewOrderSingle {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the new order single request */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Unique identifier of this request, as assigned by client */
  ClOrdID: string;

  /** Counterparty ID */
  Counterparty: JSON_Counterparty;

  /** Side */
  Side: SideEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order entry time as provided by remote in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Order submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Instruction on how to interpret OrderQty */
  SizeMode: SizeModeEnum;

  /** Intended execution/settlement type of the order, from the perspective of the referenced Counterparty */
  CptySettlementType: CptySettlementTypeEnum;

  /** String assigned when the order is submitted, suitable for holding external order ids */
  Group: string;

  /** Additional string information relating to the care order */
  Comments: string;

  /** JSON dictionary of additional care order information */
  Annotations: unknown;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** A list of markets allowed for this order's children. Empty means all are allowed. */
  Markets: ICareNewOrderSingle5202Markets[];
}

/** A list of markets allowed for this order's children. Empty means all are allowed. */
export interface ICareNewOrderSingle5202Markets {
  /** Market ID */
  Market: JSON_Market;
}

/** Balance snapshot for capturing reconciliation state */
export interface IReconSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** MarketAccount of this reconciliation */
  MarketAccount: JSON_MarketAccount;

  /** Asset of this reconciliation */
  Asset: string;

  /** Amount of this snapshot */
  Amount: JSON_Decimal;

  /** Type of this external truth value */
  TruthType: ReconTruthTypeEnum;

  /** Organization ID */
  OrgID: number;
}

/** Care Execution Report is an individual update on the specified OrderID */
export interface ICareExecutionReport {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the order referred to in this ER */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** OrderID */
  OrderID: string;

  /** Unique identifier of this request, as assigned by client */
  ClOrdID: string;

  /** Revision of the order */
  Revision: number;

  /** Counterparty ID */
  Counterparty: JSON_Counterparty;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** ExecID */
  ExecID: string;

  /** Side */
  Side: SideEnum;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Average price */
  AvgPx: JSON_Decimal;

  /** OMSExecID */
  LastExecID: string;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last amount */
  LastAmt: JSON_Decimal;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Order submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** ID of user who issued the most recent modify/cancel order request */
  RequestUser: JSON_User;

  /** Maximum quantity available for new or amended children */
  AvailableQty: JSON_Decimal;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Last MarketID, 0 if not a fill message */
  LastMarket: JSON_Market;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Instruction on how to interpret OrderQty */
  SizeMode: SizeModeEnum;

  /** The optional ID of a working order this OrderID is currently active in.  Managed by the system. */
  WorkingOrderID: string;

  /** Intended execution/settlement type of the order, from the perspective of the referenced Counterparty */
  CptySettlementType: CptySettlementTypeEnum;

  /** String assigned when the order is submitted, suitable for holding external order ids */
  Group: string;

  /** Additional string information from the end users relating to the care order */
  Comments: string;

  /** JSON dictionary of additional care order information */
  Annotations: unknown;

  /** Error string after reject */
  Text: string;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** A list of markets allowed for this order's children. Empty means all are allowed. */
  Markets: ICareExecutionReport5203Markets[];

  /** For multileg orders, aggregates execution state per leg. */
  LegSummary: ICareExecutionReport5203LegSummary[];
}

/** For multileg orders, aggregates execution state per leg. */
export interface ICareExecutionReport5203LegSummary {
  /** Security ID */
  Symbol: JSON_Security;

  /** Currency for the dealt currency. */
  Currency: string;

  /** Currency in which amount is specified. */
  AmountCurrency: string;

  /** Side */
  Side: SideEnum;

  /** Total remaining qty to be traded on the leg */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity traded on the leg */
  CumQty: JSON_Decimal;

  /** Average price traded on the leg */
  AvgPx: JSON_Decimal;

  /** Cumulative amount traded on the leg */
  CumAmt: JSON_Decimal;

  /** Last price (may not be set) */
  LastPx: JSON_Decimal;

  /** Last qty (may not be set) */
  LastQty: JSON_Decimal;

  /** Last amount traded on the leg (may not be set) */
  LastAmt: JSON_Decimal;

  /** Order quantity */
  OrderQty: JSON_Decimal;
}

/** A list of markets allowed for this order's children. Empty means all are allowed. */
export interface ICareExecutionReport5203Markets {
  /** Market ID */
  Market: JSON_Market;
}

/** MD Book Subscription Cancel */
export interface IViewCancelRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Type of cancellation */
  ViewCancelType: ViewCancelTypeEnum;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;
}

/** Portfolio service admin commands */
export interface IPortfolioAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Type of this admin request */
  RequestType: PortfolioAdminRequestTypeEnum;

  /** Unique ID for the incoming request */
  ExternalID: string;

  /** ID of requested account (subaccount or marketaccount). Unset implies all */
  AccountID: number;

  /** Asset in scope for this request. Unset implies all */
  Asset: string;

  /** Organization ID */
  OrgID: number;
}

/** Request sent by client to change the parameters of an existing care order. */
export interface ICareOrderCancelReplaceRequest {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the replace request */
  User: JSON_User;

  /** Unique identifier of replacement order as assigned by client */
  ClOrdID: string;

  /** Initial ClOrdID of the order to be replaced. */
  OrigClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Counterparty ID */
  Counterparty: JSON_Counterparty;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Msg submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** String assigned when the order is submitted, suitable for holding external order ids */
  Group: string;

  /** Additional string information relating to the care order */
  Comments: string;

  /** JSON dictionary of additional care order information */
  Annotations: unknown;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** A list of markets allow for this order's children. Empty means all are allowed. */
  Markets: ICareOrderCancelReplaceRequest5204Markets[];
}

/** A list of markets allow for this order's children. Empty means all are allowed. */
export interface ICareOrderCancelReplaceRequest5204Markets {
  /** Market ID */
  Market: JSON_Market;
}

/** Portfolio asset details */
export interface IPortfolioAssetDetail {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** AssetID */
  Asset: string;

  /** Canonical symbol for this asset */
  Symbol: string;

  /** Product Type */
  ProductType: ProductTypeEnum;

  /** The notional multiplier for this asset */
  NotionalMultiplier: JSON_Decimal;

  /** Expiration */
  Expiration: JSON_UTCTimestamp;

  /** The type of calculation used to compute the settlement value of this asset */
  SettleValueType: SettleValueTypeEnum;

  /** Sub Product Type */
  SubProductType: SubProductTypeEnum;
}

/** Request sent by client to cancel all of the remaining quantity of an existing care order */
export interface ICareOrderCancelRequest {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the cancel request */
  User: JSON_User;

  /** Unique identifier of cancel order as assigned by client */
  ClOrdID: string;

  /** Initial ClOrdID of the order to be canceled */
  OrigClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Msg submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;
}

/** Message published to client upon receipt of a cancel request or cancel/replace request message which cannot be honored */
export interface ICareOrderCancelReject {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the cancel/replace request */
  User: JSON_User;

  /** OrderID */
  OrderID: string;

  /** Unique identifier of replacement order as assigned by client */
  ClOrdID: string;

  /** Initial ClOrdID of the order to be canceled or replaced */
  OrigClOrdID: string;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Identifies the type of request that a Cancel Reject is in response to */
  CxlRejResponseTo: CxlRejResponseToEnum;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Text */
  Text: string;
}

/** Admin action for CO service to control order */
export interface ICareOrderAdminRequest {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** User ID of the user submitting the request */
  User: JSON_User;

  /** The ID of the care order upon which to act */
  OrderID: string;

  /** Action type for CO service to carry out */
  Action: OrderAdminActionEnum;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;
}

/** An event which modifies a care order's available quantity */
export interface ICareAvailQtyEvent {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** User ID of the user originating the event */
  User: JSON_User;

  /** Unique identifier of RFQ/Order event which caused this event */
  ClientID: string;

  /** The ID of the Care Order for which the available quantity was modified */
  CareOrderID: string;
}

/** Request sent by client to manually fill a care order */
export interface ICareManualFillRequest {
  /** Organization ID */
  OrgID: number;

  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier of the request */
  RequestID: JSON_Int64ID;

  /** User ID of the user submitting the request */
  User: JSON_User;

  /** The ID of the care order upon which to act */
  OrderID: string;

  /** Execution type of the manual fill */
  ExecType: ExecTypeEnum;

  /** Price of the manual fill */
  FillPrice: JSON_Decimal;

  /** Quantity of the manual fill */
  FillQty: JSON_Decimal;

  /** Amount of the manual fill */
  FillAmount: JSON_Decimal;

  /** Per-leg fill details for compound care orders */
  LegSummary: ICareManualFillRequest5212LegSummary[];
}

/** Per-leg fill details for compound care orders */
export interface ICareManualFillRequest5212LegSummary {
  /** Security ID of the leg */
  Symbol: JSON_Security;

  /** Price on the leg */
  FillPrice: JSON_Decimal;

  /** Quantity on the leg */
  FillQty: JSON_Decimal;

  /** Amount on the leg */
  FillAmount: JSON_Decimal;
}

/** Response to a care manual fill request */
export interface ICareManualFillResponse {
  /** Unique identifier of the request */
  RequestID: JSON_Int64ID;

  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The ID of the care order upon which to act */
  OrderID: string;

  /** Error text if manual fill failed */
  ErrorText: string;

  /** The returned CareExecutionReport on success */
  CareER: ICareExecutionReport;
}

/** Heartbeat for monitoring publisher liveliness */
export interface IKeepalive {
  /** Internal send time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** SenderID of Heartbeating publisher process */
  SenderID: number;
}

/** A record of a fill economics from various sources to be delivered to a care order. */
export interface ICareFillSourceEvent {
  /** Internal time when last updated in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The ID of the care order that consumes this fill source */
  CareOrderID: string;

  /** The ID of the fill source whose allocation this record holds */
  SourceID: string;

  /** The kind of fill source this record was written from.  Indicates how to find the SourceID */
  SourceType: CareFillSourceTypeEnum;

  /** The amount allocated to the care order from this fill source */
  AllocatedAmount: JSON_Decimal;

  /** Per-leg allocated amounts for compound care orders */
  LegSummary: ICareFillSourceEvent5214LegSummary[];
}

/** Per-leg allocated amounts for compound care orders */
export interface ICareFillSourceEvent5214LegSummary {
  /** Security ID of the leg */
  Symbol: JSON_Security;

  /** The amount allocated to the leg from this fill source */
  AllocatedAmount: JSON_Decimal;
}

/** Message for delivery of websocket MarketDataSnapshots */
export interface IMarketDataSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Optional Market View ID */
  ViewID: JSON_Int64ID;

  /** Optional RequestID Indicates initial Snapshot on reused view */
  ViewRequestID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Depth type */
  DepthType: DepthTypeEnum;

  /** Liquidity type */
  LiquidityType: LiquidityTypeEnum;

  /** Latest exchange message timestamp from the markets used on this snapshot. Number of nanoseconds since the Unix epoch. */
  ExchangeTime: JSON_UTCTimestamp;

  /** Latest system message timestamp from the markets used on this snapshot. Number of nanoseconds since the Unix epoch. */
  SystemTime: JSON_UTCTimestamp;

  /** Enable or disable unified liquidity feature. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** Organization ID */
  OrgID: number;

  /** Bid Entries */
  Bids: IMarketDataSnapshot4195Bids[];

  /** Offer Entries */
  Offers: IMarketDataSnapshot4195Offers[];

  /** Market Statuses for this MarketView */
  Markets: IMarketDataSnapshot4195Markets[];
}

/** Bid Entries */
export interface IMarketDataSnapshot4195Bids {
  /** Bid Price */
  Price: JSON_Decimal;

  /** Bid VWAP Price */
  VWAP: JSON_Decimal;

  /** Bid Size */
  Size: JSON_Decimal;

  /** Bid Amount */
  Amount: JSON_Decimal;

  /** Bid Price Equivalent */
  Equivalent_Price: JSON_Decimal;

  /** Bid VWAP Price Equivalent */
  Equivalent_VWAP: JSON_Decimal;

  /** Equivalent Conversion Rate */
  Equivalent_ConversionRate: JSON_Decimal;

  /** Bid Amount Equivalent */
  Equivalent_Amount: JSON_Decimal;

  /** Bid basis points price for delta1 multileg */
  BPS: JSON_Decimal;
}

/** Market Statuses for this MarketView */
export interface IMarketDataSnapshot4195Markets {
  /** MarketID for requested Market */
  Market: JSON_Market;

  /** Status of conversion rate */
  Status: ConnectionStatusEnum;

  /** Time the exchange published the latest price in number of nanoseconds since the Unix epoch */
  ExchangeTime: JSON_UTCTimestamp;

  /** Time when the latest price update was received on this market, when constructing the snapshot, in number of nanoseconds since the Unix epoch */
  WebsocketTime: JSON_UTCTimestamp;

  /** Time the gateway published the latest price in number of nanoseconds since the Unix epoch */
  SystemTime: JSON_UTCTimestamp;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Security ID */
  Symbol: JSON_Security;

  /** Text */
  Text: string;
}

/** Offer Entries */
export interface IMarketDataSnapshot4195Offers {
  /** Offer Price */
  Price: JSON_Decimal;

  /** Offer VWAP Price */
  VWAP: JSON_Decimal;

  /** Offer Size */
  Size: JSON_Decimal;

  /** Offer Amount */
  Amount: JSON_Decimal;

  /** Offer Price Equivalent */
  Equivalent_Price: JSON_Decimal;

  /** Offer VWAP Price Equivalent */
  Equivalent_VWAP: JSON_Decimal;

  /** Equivalent Conversion Rate */
  Equivalent_ConversionRate: JSON_Decimal;

  /** Offer Amount Equivalent */
  Equivalent_Amount: JSON_Decimal;

  /** Offer basis points price for delta1 multileg */
  BPS: JSON_Decimal;
}

/** OMSNewOrderSingle */
export interface IOMSNewOrderSingle {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** ClOrdID */
  ClOrdID: string;

  /** Side */
  Side: SideEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Order entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Quote OMS ID */
  QuoteID: string;

  /** Quote request ID */
  RFQID: string;

  /** SessionID for this order */
  SessionID: JSON_Int64ID;

  /** SessionID for this order to be cancelled when the session resets */
  CancelSessionID: JSON_Int64ID;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** Expected average filled price */
  ExpectedFillPrice: JSON_Decimal;

  /** Expected filled quantity in units of Currency */
  ExpectedFillQty: JSON_Decimal;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** Parent Customer Order ID */
  ParentOrderID: string;

  /** Start time when order should be executed */
  StartTime: JSON_UTCTimestamp;

  /** End time when order should be completed */
  EndTime: JSON_UTCTimestamp;

  /** Slippage for limit orders where we decide the route */
  AllowedSlippage: JSON_Decimal;

  /** Initial decision status on an order */
  InitialDecisionStatus: DecisionStatusEnum;

  /** Internal time the message was sent in number of nanoseconds since Unix epoch */
  SubmitTime: JSON_UTCTimestamp;

  /** If present, Price is expressed in units determined by PricingMode, otherwise Price is in quote currency */
  PricingMode: PricingModeEnum;

  /** Organization ID */
  OrgID: number;

  /** Source of where the request is generated from */
  RequestSource: RequestSourceEnum;

  /** Parent Customer CounterpartyID */
  ParentCounterparty: JSON_Counterparty;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** The type of the order referenced by ParentOrderID */
  ParentOrderType: ParentOrderTypeEnum;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Algo parameters */
  Parameters: IStrategyParameters;

  /** optional allocation request */
  Allocation: IAllocationRequest;

  /** Additional information attached to the order */
  Comments: string;

  /** Algo leg parameters */
  MultilegParams: IMultilegParameters;

  /** PreTrade request identifier */
  PreTradeRequestID: string;

  /** PreTrade session identifier */
  PreTradeSessionID: string;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of markets to be used for this order */
  Markets: IOMSNewOrderSingle4200Markets[];

  /** Aggregations used for this order */
  Aggregations: IOMSNewOrderSingle4200Aggregations[];
}

/** Aggregations used for this order */
export interface IOMSNewOrderSingle4200Aggregations {
  /** Unique ID of the aggregation */
  Aggregation: JSON_Aggregation;

  /** Leg Index in Legs array */
  LegIndex: number;

  /** Security ID override for the leg (0 = use default routing) */
  Symbol: JSON_Security;

  /** Parent security ID for the synthetic leg market security */
  ParentSymbol: JSON_Security;
}

/** Number of markets to be used for this order */
export interface IOMSNewOrderSingle4200Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Index of synthetic leg if this leg is a child leg */
  LegIndex: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** Security ID of the parent security if this is the synthetic leg market security */
  ParentSymbol: JSON_Security;
}

/** OrderCancelReplaceRequest */
export interface IOMSOrderCancelReplaceRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Limit price */
  Price: JSON_Decimal;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** End time when order should be completed */
  EndTime: JSON_UTCTimestamp;

  /** Internal time the message was sent in number of nanoseconds since Unix epoch */
  SubmitTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Source of where the request is generated from */
  RequestSource: RequestSourceEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Algo parameters */
  Parameters: IStrategyParameters;

  /** Arbitrary string assigned to the order */
  Group: string;

  /** Optional allocation request */
  Allocation: IAllocationRequest;

  /** Additional information attached to the order */
  Comments: string;

  /** Algo leg parameters */
  MultilegParams: IMultilegParameters;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of markets to be used for this order */
  Markets: IOMSOrderCancelReplaceRequest4201Markets[];

  /** Aggregations used for this order */
  Aggregations: IOMSOrderCancelReplaceRequest4201Aggregations[];
}

/** Aggregations used for this order */
export interface IOMSOrderCancelReplaceRequest4201Aggregations {
  /** Unique ID of the aggregation */
  Aggregation: JSON_Aggregation;

  /** Leg Index in Legs array */
  LegIndex: number;

  /** Security ID override for the leg (0 = use default routing) */
  Symbol: JSON_Security;

  /** Parent security ID for the synthetic leg market security */
  ParentSymbol: JSON_Security;
}

/** Number of markets to be used for this order */
export interface IOMSOrderCancelReplaceRequest4201Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Index of synthetic leg if this leg is a child leg */
  LegIndex: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** Security ID of the parent security if this is the synthetic leg market security */
  ParentSymbol: JSON_Security;
}

/** Execution Report is an individual update on an order */
export interface IOMSExecutionReport {
  /** Internal time of update. */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID, required unless reject for unknown order */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Order Submission Time in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** ExecID */
  ExecID: string;

  /** Side, required unless reject for unknown order */
  Side: SideEnum;

  /** Timestamp of the update as provided by the liquidity provider. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecType, required in ExecutionReport but not sent for Order updates. */
  ExecType: ExecTypeEnum;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type, required unless reject for unknown order */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Average price */
  AvgPx: JSON_Decimal;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** Last MarketID, 0 if not a fill message */
  LastMarket: JSON_Market;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last amount */
  LastAmt: JSON_Decimal;

  /** Last fee */
  LastFee: JSON_Decimal;

  /** Currency ID for the last fee */
  LastFeeCurrency: string;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** Currency ID for the cumulative fee */
  FeeCurrency: string;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** MarketExecID */
  LastExecID: string;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Order routing status */
  DecisionStatus: DecisionStatusEnum;

  /** Quote OMS ID */
  QuoteID: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** SessionID for this order */
  SessionID: JSON_Int64ID;

  /** SessionID for this order to be cancelled when the session resets */
  CancelSessionID: JSON_Int64ID;

  /** Expected average filled price */
  ExpectedFillPrice: JSON_Decimal;

  /** Expected filled quantity in units of Currency */
  ExpectedFillQty: JSON_Decimal;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** StrategyID of the order strategy */
  Strategy: JSON_Strategy;

  /** Average price including fees */
  AvgPxAllIn: JSON_Decimal;

  /** Quote request ID */
  RFQID: string;

  /** Customer RFQ ID */
  ParentRFQID: string;

  /** Parent Customer Order ID */
  ParentOrderID: string;

  /** Start time when order should be executed */
  StartTime: JSON_UTCTimestamp | undefined;

  /** End time when order should be completed */
  EndTime: JSON_UTCTimestamp | undefined;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Slippage for limit orders where we decide the route */
  AllowedSlippage: JSON_Decimal;

  /** Bitmap of message characteristics */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Last Talos fee */
  LastTalosFee: JSON_Decimal;

  /** Cumulative Talos fee */
  CumTalosFee: JSON_Decimal;

  /** Currency ID for the Talos fee */
  TalosFeeCurrency: string;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** ID of user who did a change or send modify/cancel order request */
  RequestUser: JSON_User;

  /** Internal time the last request message for this order entered the system in number of nanoseconds since Unix epoch */
  LastRequestTimestamp: JSON_UTCTimestamp | undefined;

  /** Bitmap of risk status characteristics */
  RiskStatus: Record<OrdRiskStatusEnum, boolean>;

  /** Timestamp of the last trade as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  LastTradeTime: JSON_UTCTimestamp;

  /** Last MarketAccountID, 0 if not a fill message */
  LastMarketAccount: JSON_MarketAccount;

  /** If present determines the units of PricingReference. Price is always in quote currency */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** Revision of the order */
  Revision: number;

  /** Time when the order got triggered */
  TriggerTime: JSON_UTCTimestamp | undefined;

  /** Organization ID */
  OrgID: number;

  /** The service processing the parent order and producing the execution report */
  ProcessingService: JSON_ServiceIdentifier;

  /** Source of where the order is generated from */
  RequestSource: RequestSourceEnum;

  /** Source of where the most recent request is generated from */
  LastRequestSource: RequestSourceEnum;

  /** The market order ID for the most recent trade */
  LastMarketOrderID: string;

  /** Parent Customer CounterpartyID */
  ParentCounterparty: JSON_Counterparty;

  /** Timestamp to indicate when a staged order got activated in number of nanoseconds since Unix epoch */
  FirstActivationTime: JSON_UTCTimestamp;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Last SecurityID, 0 if not a fill message */
  LastSymbol: JSON_Security;

  /** The type of the order referenced by ParentOrderID */
  ParentOrderType: ParentOrderTypeEnum;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** MarketAccountID of the market account that is the clearing venue for the originating quote; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** Reason the order was most recently system-paused; cleared on resume */
  PauseReason: PauseReasonEnum;

  /** Text */
  Text: string;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Algo parameters */
  Parameters: IStrategyParameters;

  /** optional allocation */
  Allocation: IAllocation;

  /** Additional information attached to the order */
  Comments: string;

  /** Algo leg parameters */
  MultilegParams: IMultilegParameters;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** PreTrade request identifier */
  PreTradeRequestID: string;

  /** PreTrade session identifier */
  PreTradeSessionID: string;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of markets used for this order */
  Markets: IOMSExecutionReport4203Markets[];

  /** For multileg orders, leg execution details will be aggregated here */
  LegSummary: IOMSExecutionReport4203LegSummary[];

  /** Aggregations used for this order */
  Aggregations: IOMSExecutionReport4203Aggregations[];

  /** List of assets and amount received or paid when executing the order */
  TransactedAssets: IOMSExecutionReport4203TransactedAssets[];
}

/** Aggregations used for this order */
export interface IOMSExecutionReport4203Aggregations {
  /** Unique ID of the aggregation */
  Aggregation: JSON_Aggregation;

  /** Leg Index in LegSummary array */
  LegIndex: number;
}

/** For multileg orders, leg execution details will be aggregated here */
export interface IOMSExecutionReport4203LegSummary {
  /** Index of synthetic leg if this leg is a child leg */
  LegIndex: number;

  /** Total remaining qty to be traded on the leg */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity traded on the leg */
  CumQty: JSON_Decimal;

  /** Average price traded on the leg */
  AvgPx: JSON_Decimal;

  /** Cumulative quantity traded on the leg converted into the size units of the parent order */
  ParentCumQty: JSON_Decimal;

  /** Total amount not hedged after order is closed */
  UnhedgedAmt: JSON_Decimal;

  /** Currency of UnhedgedAmt */
  UnhedgedAmtCurrency: string;

  /** Cumulative amount traded on the leg */
  CumAmt: JSON_Decimal;

  /** Currency in which Amount is specified. */
  AmountCurrency: string;

  /** Side */
  Side: SideEnum;

  /** Currency in which qty is specified. */
  Currency: string;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** fee currency */
  FeeCurrency: string;

  /** Average price traded on the leg including fees */
  AvgPxAllIn: JSON_Decimal;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last MarketID, 0 if not a fill message */
  LastMarket: JSON_Market;

  /** Last MarketAccountID, 0 if not a fill message */
  LastMarketAccount: JSON_MarketAccount;

  /** Last fee */
  LastFee: JSON_Decimal;

  /** Last fee currency */
  LastFeeCurrency: string;

  /** Last amount traded on the leg */
  LastAmt: JSON_Decimal;

  /** Last stable price cached for this leg */
  LastSeenPrice: JSON_Decimal;

  /** Security ID */
  Symbol: JSON_Security;

  /** Security ID of the parent security if this is the synthetic leg summary */
  ParentSymbol: JSON_Security;

  /** Multileg reporting type */
  MultilegReportingType: MultilegReportingTypeEnum;

  /** Pricing reference in units of parent PricingMode (may not be set) */
  PricingReference: JSON_Decimal;

  /** Fixing details for spread to fixing */
  FixingDetails: number;
}

/** Number of markets used for this order */
export interface IOMSExecutionReport4203Markets {
  /** Market ID */
  Market: JSON_Market;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** Average price */
  AvgPx: JSON_Decimal;

  /** Last fee currency */
  FeeCurrency: string;

  /** MarketStatus */
  MarketStatus: OrderMarketStatusEnum;

  /** Security ID */
  Symbol: JSON_Security;

  /** Side */
  Side: SideEnum;

  /** [Deprecate]Index of synthetic leg if this leg is a child leg */
  LegIndex: number;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last amount */
  LastAmt: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Last fee */
  LastFee: JSON_Decimal;

  /** Currency ID for the last fee */
  LastFeeCurrency: string;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Average price including fees */
  AvgPxAllIn: JSON_Decimal;

  /** Leg Index in LegSummary array */
  LegSummaryIndex: number;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Text */
  Text: string;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;
}

/** List of assets and amount received or paid when executing the order */
export interface IOMSExecutionReport4203TransactedAssets {
  /** [Deprecate] Index of synthetic leg if this leg is a child leg */
  LegIndex: number;

  /** Transacted asset */
  Asset: string;

  /** Cumulative amount transacted for the currency. Positive for received amount, negative for paid amount */
  Amount: JSON_Decimal;

  /** Leg Index in LegSummary array */
  LegSummaryIndex: number;
}

/** UserCredential associates a user to a credential on a market */
export interface IUserCredential {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User ID */
  User: JSON_User;

  /** Market ID */
  Market: JSON_Market;

  /** Credential ID */
  CredentialID: number;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;

  /** Data linked to specific credential */
  Data: unknown;
}

/** Login details for a market */
export interface ICredential {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Market ID */
  Market: JSON_Market;

  /** Credential ID */
  CredentialID: number;

  /** The connection mode (Up / Down) */
  Mode: ConnectionModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision */
  Revision: number;

  /** The last time the secrets where modified in number of nanoseconds since Unix epoch */
  SecretsUpdatedAt: JSON_UTCTimestamp;

  /** The time until which the credential age alert is muted in number of nanoseconds since Unix epoch */
  AlertMutedUntil: JSON_UTCTimestamp;

  /** The user that muted the credential age alert */
  AlertMutedByUser: JSON_User;

  /** Credential name */
  Name: string;

  /** Credential label */
  Label: string;

  /** Type(s) of connections supported by this credential */
  ConnectionType: string;

  /** Credential secrets */
  Secrets: string;

  /** Credential attributes (non-secrets) */
  Attributes: unknown;

  /** JSON-encoded enclave secrets bundle containing KMS-encrypted secret values */
  EnclaveSecrets: string;
}

/** OrderCancelRequest */
export interface IOMSOrderCancelRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Internal time the message was sent in number of nanoseconds since Unix epoch */
  SubmitTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Source of where the request is generated from */
  RequestSource: RequestSourceEnum;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** OMSOrderCancelReject4208 */
export interface IOMSOrderCancelReject {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Cancel reject response to */
  CxlRejResponseTo: CxlRejResponseToEnum;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** OMSOrderRecord associates a ClOrdID to a generated OrderID */
export interface IOMSOrderRecord {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** OrderID of the OMS order */
  OrderID: string;

  /** User ID of the OMS order */
  User: JSON_User;

  /** ClOrdID of the OMS order */
  ClOrdID: string;
}

/** Admin action for OMS to control order */
export interface IOMSOrderAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID of the user submitting the request */
  User: JSON_User;

  /** The ID or the order upon which to act */
  OrderID: string;

  /** Action type for OMS to carry out */
  Action: OrderAdminActionEnum;

  /** Request entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** SessionID to cancel orders for */
  SessionID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Source of where the request is generated from */
  RequestSource: RequestSourceEnum;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** trade capture message in oms component */
export interface IOMSTradeCapture {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Credential ID */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ExecID */
  TradeID: string;

  /** Side */
  Side: SideEnum;

  /** Timestamp of the trade as provided by remote in number of nanoseconds since Unix epoch. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** Currency ID for the base currency */
  Currency: string;

  /** MarketID for this trade */
  Market: JSON_Market;

  /** Price */
  Price: JSON_Decimal;

  /** Quantity */
  Quantity: JSON_Decimal;

  /** Amount */
  Amount: JSON_Decimal;

  /** Fee */
  Fee: JSON_Decimal;

  /** Currency ID for the last fee */
  FeeCurrency: string;

  /** MarketTradeID */
  MarketTradeID: string;

  /** Trade capture info */
  TradeStatus: TradeStatusEnum;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Quote OMS ID */
  QuoteID: string;

  /** Currency ID for contra */
  AmountCurrency: string;

  /** Currency ID for dealt currency */
  DealtCurrency: string;

  /** Quote request ID */
  RFQID: string;

  /** Optional subaccountID */
  SubAccount: JSON_SubAccount;

  /** Customer Trade ID */
  ParentTradeID: string;

  /** ID of the counterparty for this trade. 0 means trading with liquidity provider */
  Counterparty: JSON_Counterparty;

  /** Talos fee */
  TalosFee: JSON_Decimal;

  /** Currency ID for the Talos fee */
  TalosFeeCurrency: string;

  /** Price with fees included */
  PriceAllIn: JSON_Decimal;

  /** Source of the trade information */
  TradeSource: TradeSourceEnum;

  /** Name of the action taken on the trade */
  TradeAction: TradeActionEnum;

  /** Revision of that trade */
  Revision: number;

  /** Specified when TradeSource=User or on user updates. */
  UpdateUser: JSON_User;

  /** optional allocation ID */
  AllocID: string;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount | undefined;

  /** Unique Trade ID provided by the dealer when booking trade manually */
  ClTradeID: string;

  /** Sales commission to take from the trade */
  SalesCommission: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** If present determines the units of PricingReference. */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** For an options trade, the offset delta exposure in the units of the underlying quote currency */
  OffsetDelta: JSON_Decimal;

  /** The market order id for this trade */
  MarketOrderID: string;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Defines the rebase multiplier for the underlying TokenizedAsset at the time of the trade */
  RebaseMultiplier: JSON_Decimal;

  /** Multileg reporting type. Set to Parent for the synthetic parent trade, Leg for child leg trades, NullValue for outright trades. */
  MultilegReportingType: MultilegReportingTypeEnum;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** MarketAccountID of the market account that is the clearing venue for the originating quote; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Additional information attached to trade */
  Comments: string;

  /** optional allocation */
  Allocation: IAllocation;

  /** Miscellaneous transaction attributes */
  Attributes: unknown;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Reference data for a trade */
  RefData: IOMSTradeCapture4211RefData[];
}

/** Reference data for a trade */
export interface IOMSTradeCapture4211RefData {
  /** Value of ref data */
  Value: JSON_Decimal;

  /** Type of ref data */
  Type: TradeRefDataTypeEnum;

  /** Security ID */
  Symbol: JSON_Security;

  /** Timestamp of ref data */
  Timestamp: number;
}

/** trade allocation */
export interface ITradeAllocation {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Credential ID */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ExecID */
  TradeID: string;

  /** Side */
  Side: SideEnum;

  /** Timestamp of the trade as provided by remote in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** Currency ID for the base currency */
  Currency: string;

  /** MarketID for this trade */
  Market: JSON_Market;

  /** Price */
  Price: JSON_Decimal;

  /** Quantity */
  Quantity: JSON_Decimal;

  /** Amount */
  Amount: JSON_Decimal;

  /** Fee */
  Fee: JSON_Decimal;

  /** Currency ID for the last fee */
  FeeCurrency: string;

  /** MarketTradeID */
  MarketTradeID: string;

  /** Trade capture info */
  TradeStatus: TradeStatusEnum;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Quote OMS ID */
  QuoteID: string;

  /** Currency ID for contra */
  AmountCurrency: string;

  /** Currency ID for dealt currency */
  DealtCurrency: string;

  /** Quote request ID */
  RFQID: string;

  /** Customer Trade ID */
  ParentTradeID: string;

  /** ID of the counterparty for this trade. 0 means trading with liquidity provider */
  Counterparty: JSON_Counterparty;

  /** Talos fee */
  TalosFee: JSON_Decimal;

  /** Currency ID for the Talos fee */
  TalosFeeCurrency: string;

  /** Price with fees included */
  PriceAllIn: JSON_Decimal;

  /** Source of the trade information */
  TradeSource: TradeSourceEnum;

  /** Name of the action taken on the trade */
  TradeAction: TradeActionEnum;

  /** Revision of that trade */
  Revision: number;

  /** Specified when TradeSource=User or on user updates. */
  UpdateUser: JSON_User;

  /** Allocation ID */
  AllocID: string;

  /** Allocation value type */
  ValueType: AllocationValueTypeEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** The market order id for this trade */
  MarketOrderID: string;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Additional information attached to trade */
  Comments: string;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Allocations set */
  Allocations: ITradeAllocation4212Allocations[];
}

/** Allocations set */
export interface ITradeAllocation4212Allocations {
  /** SubAccountID associated with given allocation value */
  SubAccount: JSON_SubAccount;

  /** Value for this allocation */
  Value: JSON_Decimal;

  /** Price */
  Price: JSON_Decimal;

  /** Quantity */
  Quantity: JSON_Decimal;

  /** Amount */
  Amount: JSON_Decimal;

  /** Allocated fee */
  Fee: JSON_Decimal;

  /** Allocation fee */
  TalosFee: JSON_Decimal;

  /** External reference */
  ExternalRef: string;
}

/** allocation */
export interface IAllocation {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** optional allocation ID */
  AllocID: string;

  /** Allocation status */
  Status: AllocationStatusEnum;

  /** Allocation value type */
  ValueType: AllocationValueTypeEnum;

  /** Currency ID allocation values (For Percentage allocation is 0). */
  Currency: string;

  /** Organization ID */
  OrgID: number;

  /** Allocations set */
  Allocations: IAllocation4213Allocations[];
}

/** Allocations set */
export interface IAllocation4213Allocations {
  /** SubAccountID associated with given allocation value */
  SubAccount: JSON_SubAccount;

  /** Value for this allocation */
  Value: JSON_Decimal;

  /** External reference */
  ExternalRef: string;
}

/** allocation request */
export interface IAllocationRequest {
  /** optional allocation ID */
  AllocID: string;

  /** Allocation request type */
  RequestType: AllocationRequestTypeEnum;

  /** Allocation value type */
  ValueType: AllocationValueTypeEnum;

  /** Currency ID allocation values (For Percentage allocation is 0). */
  Currency: string;

  /** Organization ID */
  OrgID: number;

  /** Allocations set */
  Allocations: IAllocationRequest4214Allocations[];
}

/** Allocations set */
export interface IAllocationRequest4214Allocations {
  /** SubAccountID associated with given allocation value */
  SubAccount: JSON_SubAccount;

  /** Value for this allocation */
  Value: JSON_Decimal;

  /** External reference */
  ExternalRef: string;
}

/** Snapshot of parent order state */
export interface IOMSOrderState {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The ID or the order upon which to act */
  OrderID: string;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** Cumulative pending fee */
  CumPendingFees: JSON_Decimal;

  /** Cumulative fee charged in order currency */
  CumFeeChargedInOrderCcy: JSON_Decimal;

  /** Precise cumulative amount */
  CumPxTimesQty: JSON_Dec128;

  /** Total confirmed trade quantity */
  TradeExposureQty: JSON_Decimal;

  /** Total confirmed trade amount */
  TradeExposureAmt: JSON_Decimal;

  /** Total quantity as traded as taker */
  CrossingFilledQty: JSON_Decimal;

  /** Latest scheduled quantity */
  ScheduleQty: JSON_Decimal;

  /** Latest adjustment quantity */
  AdjustmentQty: JSON_Decimal;

  /** Latest base lower bound value */
  BaseLowerBound: JSON_Decimal;

  /** Latest base upper bound value */
  BaseUpperBound: JSON_Decimal;

  /** Latest base upper bound value */
  VolumeInLimit: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Cumulative quantity with more precision */
  PreciseCumQty: JSON_Dec128;

  /** Cumulative amount with more precision */
  PreciseCumAmt: JSON_Dec128;

  /** Start time of the current clip for ClipBased orders */
  CurrentClipStartTime: JSON_UTCTimestamp;

  /** End time of the current clip for ClipBased orders */
  CurrentClipEndTime: JSON_UTCTimestamp;

  /** End time of the current clip without any end time adjustment */
  CurrentFullClipEndTime: JSON_UTCTimestamp;

  /** Total quantity as traded under IWould logic */
  IWouldFilledQty: JSON_Decimal;

  /** Volume-weighted total price of IWould trades */
  IWouldWeightedTotalPrice: JSON_Decimal;

  /** The best top-of-book all-in price across all exchanges when the last IWould trade was sumbitted */
  IWouldBestExchangeTOBAllInPrice: JSON_Decimal;

  /** Volume-weighted total price improvement of IWould trades */
  IWouldCummulativePriceImprovement: JSON_Decimal;

  /** Arrival price on order submission */
  ArrivalPrice: JSON_Decimal;

  /** Child-order outcome frozen when the order opens */
  TargetExpressedOutcome: ExpressedOutcomeEnum;

  /** OMSExecutionReport message from the current order state */
  OrderExecutionReport: IOMSExecutionReport;

  /** OMSExecutionReport message from the current order state */
  LatestOrderTrajectory: IOrderTrajectory;

  /** JSON representation of MultilegOrderDetailsSnapshot */
  MultilegOrderDetailsSnapshot: unknown;

  /** Markets used for this order */
  Markets: IOMSOrderState4215Markets[];

  /** Markets used for this order */
  ClOrdIDKeys: IOMSOrderState4215ClOrdIDKeys[];
}

/** Markets used for this order */
export interface IOMSOrderState4215ClOrdIDKeys {
  /** User ID of the user submitting the request */
  User: JSON_User;

  /** ClOrdID */
  ClOrdID: string;
}

/** Cum quantity by level for orders no longer working */
export interface IMarketsDoneCumQtyByLevel {
  /** Price associated with cum quantity */
  Price: JSON_Decimal;

  /** Cum quantity on an order that is no longer working */
  CumQty: JSON_Decimal;
}

/** Markets used for this order */
export interface IOMSOrderState4215Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Leg Index in Legs array */
  LegIndex: number;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** Last fee currency */
  FeeCurrency: string;

  /** Precise cumulative amount */
  CumPxTimesQty: JSON_Dec128;

  /** Last error time */
  LastErrTime: JSON_UTCTimestamp;

  /** Last error weight */
  LastErrWeight: number;

  /** Last error OID */
  LastErrOID: JSON_Int64ID;

  /** Last error reject reason */
  LastErrRejectReason: OrdRejReasonEnum;

  /** Error bucket wait interval */
  ErrorBucketCurrWait: JSON_DurationMillis;

  /** Security ID */
  Symbol: JSON_Security;

  /** Cumulative quantity with more precision */
  PreciseCumQty: JSON_Dec128;

  /** Conversion rate for unified liquidity symbols */
  UnifiedLiquidityConversionRate: JSON_Decimal;

  /** Average Daily Volume in the Base units of the parent order */
  AvgDailyVolume: JSON_Decimal;

  /** Last error message */
  LastErrMessage: string;

  /** Cum quantity by level for orders no longer working */
  DoneCumQtyByLevel: IMarketsDoneCumQtyByLevel[];

  /** Per market scaled order state */
  ScaledLevels: IMarketsScaledLevels[];
}

/** Per market scaled order state */
export interface IMarketsScaledLevels {
  /** Reason for excluding this level */
  RejReason: OrdRejReasonEnum;

  /** Price of the scaled level */
  Price: JSON_Decimal;
}

/** User action for OMS to control order */
export interface IOMSOrderControlRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID of the user submitting the request */
  User: JSON_User;

  /** The ID or the order upon which to act */
  OrderID: string;

  /** Action type for OMS to carry out */
  Action: OrderControlActionEnum;

  /** Request entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Organization ID */
  OrgID: number;

  /** Source of where the request is generated from */
  RequestSource: RequestSourceEnum;

  /** Source message for this update */
  MessageID: IMessageID;
}

/**  */
export interface ICustomerNewOrderSingle {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** ClOrdID */
  ClOrdID: string;

  /** Side */
  Side: SideEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Order entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Customer Quote ID */
  QuoteID: string;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** SessionID for this order */
  SessionID: JSON_Int64ID;

  /** SessionID for this order to be cancelled when the session resets */
  CancelSessionID: JSON_Int64ID;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** Expected average filled price */
  ExpectedFillPrice: JSON_Decimal;

  /** Expected filled quantity in units of Currency */
  ExpectedFillQty: JSON_Decimal;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** ID of the counterparty that is requesting */
  Counterparty: JSON_Counterparty;

  /** Slippage for limit orders where we decide the route */
  AllowedSlippage: JSON_Decimal;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Algo parameters */
  Parameters: IStrategyParameters;

  /** Additional information attached to the order */
  Comments: string;

  /** customer request parameters */
  PricingParameters: IQuoteParameters;

  /** Specification for how the hedge NewOrderSingle should be routed */
  RoutedNewOrderSingle: IOMSNewOrderSingle;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Summarizes updates for customer execution reports */
export interface ICustomerExecutionReport {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Order Submission Time in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** ExecID */
  ExecID: string;

  /** Side */
  Side: SideEnum;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Average price */
  AvgPx: JSON_Decimal;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last amount */
  LastAmt: JSON_Decimal;

  /** Last fee */
  LastFee: JSON_Decimal;

  /** Currency ID for the last fee */
  LastFeeCurrency: string;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** Currency ID for the cumulative fee */
  FeeCurrency: string;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Order routing status */
  DecisionStatus: DecisionStatusEnum;

  /** Quote OMS ID */
  QuoteID: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** SessionID for this order */
  SessionID: JSON_Int64ID;

  /** SessionID for this order to be cancelled when the session resets */
  CancelSessionID: JSON_Int64ID;

  /** Expected average filled price */
  ExpectedFillPrice: JSON_Decimal;

  /** Expected filled quantity in units of Currency */
  ExpectedFillQty: JSON_Decimal;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** StrategyID of the order strategy */
  Strategy: JSON_Strategy;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** ID of the counterparty that request is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** Slippage for limit orders where we decide the route */
  AllowedSlippage: JSON_Decimal;

  /** Internal Order reject reason */
  InternalOrdRejReason: OrdRejReasonEnum;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Selected MarketAccount */
  MarketAccount: JSON_CustomerMarketAccount | undefined;

  /** Manual dealer action on this order */
  DealerAction: OrderAdminActionEnum;

  /** Fill price set by dealer in force fill flow */
  AdminFillPrice: JSON_Decimal;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** Average fee-inclusive price */
  AvgPxAllIn: JSON_Decimal;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** Indication of whether order is executed with RisklessPrincipal or OrderAcceptance */
  ExecutionStrategy: CustomerExecutionStrategyEnum;

  /** Indication of whether the order quantity is post-trade fee aware, aka inclusive of the post-trade fees charged by the dealer */
  IsFeeAware: boolean;

  /** Defines the customer model price negotiation protocol for RFQs */
  RFQProtocol: RFQProtocolEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Organization ID */
  OrgID: number;

  /** RestatedExecID populated for ERs with exec type restated */
  RestatedExecID: string;

  /** MarketAccountID of the dealer-selected market account for the clearing venue; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** MarketID of the market that is the clearing venue for the originating customer quote; unset if unspecified */
  ClearingMarket: JSON_Market;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Text */
  Text: string;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Algo parameters */
  Parameters: IStrategyParameters;

  /** quote / pricing parameters */
  PricingParameters: IQuoteParameters;

  /** Internal reason for rejection */
  InternalText: string;

  /** Additional information attached to the order */
  Comments: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** customer security */
  CustomerSecurity: ICustomerSecurity;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** For multileg orders, aggregates execution state per leg. */
  LegSummary: ICustomerExecutionReport4224LegSummary[];
}

/** For multileg orders, aggregates execution state per leg. */
export interface ICustomerExecutionReport4224LegSummary {
  /** Security ID */
  Symbol: JSON_Security;

  /** Currency for the dealt currency. */
  Currency: string;

  /** Currency in which amount is specified. */
  AmountCurrency: string;

  /** Side */
  Side: SideEnum;

  /** Total remaining qty to be traded on the leg */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity traded on the leg */
  CumQty: JSON_Decimal;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Average price traded on the leg */
  AvgPx: JSON_Decimal;

  /** Cumulative amount traded on the leg */
  CumAmt: JSON_Decimal;

  /** Last price (may not be set) */
  LastPx: JSON_Decimal;

  /** Last qty (may not be set) */
  LastQty: JSON_Decimal;

  /** Last amount traded on the leg (may not be set) */
  LastAmt: JSON_Decimal;

  /** Trade ID for this leg */
  TradeID: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;
}

/** customer trade capture message */
export interface ICustomerTradeCapture {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Credential ID */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ExecID */
  TradeID: string;

  /** Side */
  Side: SideEnum;

  /** Timestamp of the trade as provided by the dealer */
  TransactTime: JSON_UTCTimestamp;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** Currency ID for the base currency */
  Currency: string;

  /** Price */
  Price: JSON_Decimal;

  /** Quantity */
  Quantity: JSON_Decimal;

  /** Amount */
  Amount: JSON_Decimal;

  /** Fee */
  Fee: JSON_Decimal;

  /** Currency ID for the last fee */
  FeeCurrency: string;

  /** Trade capture info */
  TradeStatus: TradeStatusEnum;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Quote OMS ID */
  QuoteID: string;

  /** Currency ID for contra */
  AmountCurrency: string;

  /** Currency ID for dealt currency */
  DealtCurrency: string;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** Optional subaccountID */
  SubAccount: JSON_SubAccount;

  /** ID of the counterparty that request is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Selected MarketAccount */
  MarketAccount: JSON_CustomerMarketAccount | undefined;

  /** Unique Trade ID provided by the dealer when booking trade manually */
  ClTradeID: string;

  /** Revision of that trade */
  Revision: number;

  /** Source of the trade information */
  TradeSource: TradeSourceEnum;

  /** Name of the action taken on the trade */
  TradeAction: TradeActionEnum;

  /** Specified when TradeSource=User or on user updates. */
  UpdateUser: JSON_User;

  /** PriceAllIn */
  PriceAllIn: JSON_Decimal;

  /** If present determines the units of PricingReference. */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** Sales commission to take from the trade */
  SalesCommission: JSON_Decimal;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Defines the rebase multiplier for the underlying TokenizedAsset at the time of the trade */
  RebaseMultiplier: JSON_Decimal;

  /** MarketAccountID of the dealer-selected market account for the clearing venue; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** MarketID of the market that is the clearing venue for the originating customer quote; unset if unspecified */
  ClearingMarket: JSON_Market;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Additional information attached to the order */
  Comments: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/**  */
export interface ICustomerOrderCancelRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ID of the counterparty that request is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/**  */
export interface ICustomerOrderCancelReplaceRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Limit price */
  Price: JSON_Decimal;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** End time when order should be completed */
  EndTime: JSON_UTCTimestamp;

  /** ID of the counterparty that request is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Algo parameters */
  Parameters: IStrategyParameters;

  /** Additional information attached to the order */
  Comments: string;

  /** customer request parameters */
  PricingParameters: IQuoteParameters;

  /** Specification for how the hedge OrderCancelReplaceRequest should be routed */
  RoutedOrderCancelReplaceRequest: IOMSOrderCancelReplaceRequest;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** User action for OMS to control order */
export interface ICustomerOrderControlRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID of the user submitting the request */
  User: JSON_User;

  /** The ID or the order upon which to act */
  OrderID: string;

  /** Action type for OMS to carry out */
  Action: OrderControlActionEnum;

  /** Request entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** ID of the counterparty that request is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Describe a partition of a split service where the partition can be changed dynamically */
export interface IDynamicPartition {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Business Identifier of the Partition */
  PartitionID: JSON_Int64ID;

  /** Group for the dynamic partition */
  PartitionGroup: DynamicPartitionGroupEnum;

  /** Name for the dynamic partition */
  PartitionName: string;

  /** Flag to enable or disable this partition */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision */
  Revision: number;

  /** Filters applied to the partition */
  Filters: unknown;
}

/** Admin action for managing Customer Orders */
export interface ICustomerOrderAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID of the user submitting the request */
  User: JSON_User;

  /** The ID or the order upon which to act */
  OrderID: string;

  /** Action type for OMS to carry out */
  Action: OrderAdminActionEnum;

  /** Request entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** SessionID to cancel orders for */
  SessionID: JSON_Int64ID;

  /** Optional fill price in force-fill customer flow */
  FillPrice: JSON_Decimal;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Admin action to cancel a stuck order */
export interface IOrderAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** ClOrdID for this request */
  ClOID: JSON_Int64ID;

  /** OID of the order to cancel */
  OID: JSON_Int64ID;

  /** Action type for OMS to carry out */
  Action: OrderAdminActionEnum;

  /** Request entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Indicates which side is the aggressor in the manual fill to book */
  AggressorSide: SideEnum;

  /** The ID of the order on which the manual fill is to be booked */
  OrderID: string;

  /** The execution ID of the manual fill to book */
  ExecID: string;

  /** Execution time in number of nanoseconds since Unix epoch of the manual fill to book */
  ExecTime: JSON_UTCTimestamp;

  /** Executed Price of the manual fill to book */
  ExecPrice: JSON_Decimal;

  /** Executed Quantity of the manual fill to book */
  ExecQty: JSON_Decimal;

  /** Executed Amount of the manual fill to book */
  ExecAmount: JSON_Decimal;

  /** Execution Fee of the manual fill to book */
  ExecFee: JSON_Decimal;

  /** Currency ID of the execution fee of the manual fill to book */
  ExecFeeCurrency: string;

  /** Currency ID for the dealt currency in the manual fill to book */
  Currency: string;

  /** Currency ID for amount in the manual fill to book */
  AmountCurrency: string;

  /** Source of where the request is generated from */
  RequestSource: RequestSourceEnum;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** instruction to book new customer trade capture */
export interface ICustomerTradeCaptureRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique Trade ID provided by the dealer */
  ClTradeID: string;

  /** OrderID */
  OrderID: string;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Side */
  Side: SideEnum;

  /** Timestamp of the trade as provided by remote in number of nanoseconds since Unix epoch. */
  TransactTime: JSON_UTCTimestamp;

  /** Currency ID for the base currency */
  Currency: string;

  /** Price */
  Price: JSON_Decimal;

  /** Quantity */
  Quantity: JSON_Decimal;

  /** Amount */
  Amount: JSON_Decimal;

  /** Currency ID for contra */
  AmountCurrency: string;

  /** Optional subaccountID */
  SubAccount: JSON_SubAccount;

  /** ID of the counterparty that request is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Optional subAccountID. If provided, it will be attached to dealer side of the trade as SubAccountID */
  RiskSubAccount: JSON_SubAccount;

  /** Sales commission to take from the trade */
  SalesCommission: JSON_Decimal;

  /** The amount of fee to charge for the trade */
  Fee: JSON_Decimal;

  /** Currency ID for the fee */
  FeeCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** Arbitrary string assigned when the trade is submitted */
  Group: string;

  /** Additional information attached to the order */
  Comments: string;
}

/** Snapshot for a conversionRateCache */
export interface IConversionRateCacheSnapshot {
  /** The view request ID the cache is interested in. */
  ViewRequestID: number;

  /** The view ID the cache is interested in. */
  ViewID: number;

  /** The sender ID the cache is interested in. */
  SenderID: number;
}

/**  */
export interface ICustomerOrderCancelReject {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Cancel reject response to */
  CxlRejResponseTo: CxlRejResponseToEnum;

  /** ID of the counterparty that request is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Analytics for an order execution */
export interface IOrderAnalytics {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** OrderID */
  OrderID: string;

  /** Time resolution of analytics */
  Resolution: ResolutionEnum;

  /** Start time of this interval in number of nanoseconds since Unix epoch */
  StartTime: JSON_UTCTimestamp;

  /** End time of this interval in number of nanoseconds since Unix epoch */
  EndTime: JSON_UTCTimestamp;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Limit price */
  Price: JSON_Decimal;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Average price */
  AvgPx: JSON_Decimal;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** Arrival price */
  ArrivalPx: JSON_Decimal;

  /** Cumulative market VWAP for the duration of the order's execution */
  CumulativeVWAP: JSON_Decimal;

  /** Total quantity as traded as taker */
  CrossingFilledQty: JSON_Decimal;

  /** Percentage traded of total market volume during this period */
  ParticipationRate: JSON_Decimal;

  /** Percentage fees paid in relation to total order quantity */
  EffectiveRate: JSON_Decimal;

  /** Lower bound, if this is a TWAP order */
  LowerBound: JSON_Decimal;

  /** Upper bound, if this is a TWAP order */
  UpperBound: JSON_Decimal;

  /** Average best mid price over all enabled markets */
  MarketMidPx: JSON_Decimal;

  /** Number of trades that occured during this interval */
  TradeCount: JSON_Decimal;

  /** Avg price traded at during this interval */
  TradedAvgPx: JSON_Decimal;

  /** Quantity traded during this interval */
  TradedQty: JSON_Decimal;

  /** Amount traded during this interval */
  TradedAmt: JSON_Decimal;

  /** DecisionStatus */
  DecisionStatus: DecisionStatusEnum;

  /** Reference price for this security */
  ReferencePx: JSON_Decimal;

  /** Percentage traded of global total market volume during this period */
  GlobalParticipationRate: JSON_Decimal;

  /** Security ID */
  Symbol: JSON_Security;

  /** Leg Index in Legs array */
  LegIndex: number;

  /** Multileg reporting type */
  MultilegReportingType: MultilegReportingTypeEnum;

  /** Expected fill price in the order markets */
  ExpectedPx: JSON_Decimal;

  /** Expected fill quantity in the order markets */
  ExpectedQty: JSON_Decimal;

  /** Expected fill price (up to the limit price) in the order markets */
  ExpectedPxLimit: JSON_Decimal;

  /** Expected fill quantity (up to the limit price) in the order markets */
  ExpectedQtyLimit: JSON_Decimal;

  /** Number of trades that occured during this interval */
  OrderRestingCount: JSON_Decimal;

  /** Number of trades that occured during this interval */
  OrderCrossingCount: JSON_Decimal;

  /** Number of trades that occured during this interval */
  OrderExchangeCount: JSON_Decimal;

  /** Number of trades that occured during this interval */
  OrderDealerCount: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Organization ID */
  OrgID: number;

  /** Total duration in milliseconds the parent order had open child order at a market */
  TimeInMarket: JSON_DurationMillis;

  /** Total market volume on Buy side in parent order size space */
  MarketParticipationCumSizeBuy: JSON_Decimal;

  /** Total market volume on Sell side in parent order size space */
  MarketParticipationCumSizeSell: JSON_Decimal;

  /** Total global market volume on Buy side in parent order size space */
  GlobalParticipationCumSizeBuy: JSON_Decimal;

  /** Total global market volume on Sell side in parent order size space */
  GlobalParticipationCumSizeSell: JSON_Decimal;

  /** Percentage of missed total market volume during order had no child order open at markets */
  MissedMarketParticipationRate: JSON_Decimal;

  /** Missed total market volume on buy side */
  MissedMarketParticipationCumSizeBuy: JSON_Decimal;

  /** Missed total market volume on sell side */
  MissedMarketParticipationCumSizeSell: JSON_Decimal;

  /** Start time of this clip in number of nanoseconds since Unix epoch */
  ClipStartTime: JSON_UTCTimestamp;

  /** End time of this clip in number of nanoseconds since Unix epoch */
  ClipEndTime: JSON_UTCTimestamp;

  /** Total quantity traded under IWould logic */
  IWouldFilledQty: JSON_Decimal;

  /** Volume-weighted average fill price of IWould fills */
  IWouldAvgPrice: JSON_Decimal;

  /** Volume-weighted average price improvement against exchange of IWould fills */
  IWouldPriceImprovementBps: JSON_Decimal;

  /** Cumulative market TWAP for the duration of the order's execution */
  CumulativeTWAP: JSON_Decimal;

  /** Snipe bound threshold price when arrival-aware crossing is enabled */
  SnipeBound: JSON_Decimal;

  /** Sweep bound threshold price when arrival-aware crossing is enabled */
  SweepBound: JSON_Decimal;

  /** Snipe bound in basis points */
  SnipeBoundBps: JSON_Decimal;

  /** Sweep bound in basis points */
  SweepBoundBps: JSON_Decimal;

  /** Volume-weighted signed bps across all quality-evaluated fills; positive means net better than intended, negative means net worse */
  FillHitMissVwBps: JSON_Decimal;

  /** Markets used for this order */
  Markets: unknown;

  /** Algo analytics properties */
  TradePredictions: IOrderAnalytics4240TradePredictions[];
}

/** Algo analytics properties */
export interface IOrderAnalytics4240TradePredictions {
  /** Property */
  Property: OMSOrderPropertyEnum;

  /** Value of property */
  Value: JSON_Decimal;
}

/** Trade settle report contains information about fundings and settlement for trade */
export interface ITradeSettleReport {
  /** Unique identifier of the report generated by Talos */
  ReportID: JSON_Int64ID;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of related trade */
  TradeID: string;

  /** Timestamp of the trade as provided by remote in number of nanoseconds since Unix epoch. */
  TradeTransactTime: JSON_UTCTimestamp;

  /** Trade side */
  TradeSide: SideEnum;

  /** Revision of this report */
  Revision: number;

  /** Status of this report */
  Status: TradeSettleStatusEnum;

  /** Asset which Due, CumSettledDue and LastSettledDue are expressed in */
  DueAsset: string;

  /** Total due asset for the report. Qty for sell, Amt for buy trade */
  Due: JSON_Decimal;

  /** Cumulative settled due asset for the report */
  CumSettledDue: JSON_Decimal;

  /** Asset which Proceeds, CumSettledProceeds and LastSettledProceeds are expressed in */
  ProceedsAsset: string;

  /** Total proceeds asset for the report. Amt for sell, Qty for buy trade */
  Proceeds: JSON_Decimal;

  /** Cumulative settled proceeds asset for the report */
  CumSettledProceeds: JSON_Decimal;

  /** Trade price */
  Price: JSON_Decimal;

  /** Last settled due asset for the report */
  LastSettledDue: JSON_Decimal;

  /** Last settled proceeds asset for the report */
  LastSettledProceeds: JSON_Decimal;

  /** Source for last settlement reported in LastSettledDue and LastSettledProceeds */
  LastSettledSource: TradeSettleSourceEnum;

  /** Source ID as OID or [36]byte */
  LastSourceID: string;

  /** Traded MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Optional subaccountID */
  SubAccount: JSON_SubAccount;

  /** Timestamp when report was created in number of nanoseconds since Unix epoch. */
  TransactTime: JSON_UTCTimestamp;

  /** Action that caused this Trade settle report */
  LastAction: TradeSettleActionEnum;

  /** Counterparty ID */
  Counterparty: JSON_Counterparty;

  /** End of the TradeDate on which this trade was executed. */
  TradeDateEOD: JSON_UTCTimestamp;

  /** Timestamp when the trade needs to be settled. */
  SettleDeadline: JSON_UTCTimestamp;

  /** Timestamp when the trade was fully settled. */
  SettleCompletion: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Initial fundings of proceeds */
  InitialProceeds: unknown;

  /** Optional allocation */
  Allocation: IAllocation;
}

/** A batch specifying the group of trades that needs to be settled */
export interface ISettlementBatch {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Optional ID of user who initiated this settlement batch request */
  InitiatorUser: JSON_User;

  /** Client defined request ID */
  ClReqID: string;

  /** Unique ID for this batch */
  SettlementID: JSON_Int64ID;

  /** Status for this trade settlement batch */
  Status: SettlementBatchStatusEnum;

  /** The service originating this settlement batch */
  SourceService: JSON_ServiceIdentifier;

  /** Revision of this settlement batch */
  Revision: number;

  /** Reason for why the batch is rejected */
  RejectReason: SettlementBatchRejectReasonEnum;

  /** RejectText */
  RejectText: string;

  /** Additional information relating to the settlement batch */
  Comments: string;
}

/** A trade belonging to a settlement batch */
export interface ISettlementBatchTrade {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID for the parent settlement batch */
  ParentSettlementID: JSON_Int64ID;

  /** ID of related trade */
  TradeID: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Bitmap field of indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;
}

/** Customer Trade settle report contains information about fundings and settlement for customer trade */
export interface ICustomerTradeSettleReport {
  /** Unique identifier of the report generated by Talos */
  ReportID: JSON_Int64ID;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of related trade */
  TradeID: string;

  /** Timestamp of the trade as provided by remote in number of nanoseconds since Unix epoch. */
  TradeTransactTime: JSON_UTCTimestamp;

  /** Trade side */
  TradeSide: SideEnum;

  /** Revision of this report */
  Revision: number;

  /** Status of this report */
  Status: TradeSettleStatusEnum;

  /** Asset which Due, CumSettledDue and LastSettledDue are expressed in */
  DueAsset: string;

  /** Total due asset for the report. Qty for sell, Amt for buy trade */
  Due: JSON_Decimal;

  /** Cumulative settled due asset for the report */
  CumSettledDue: JSON_Decimal;

  /** Asset which Proceeds, CumSettledProceeds and LastSettledProceeds are expressed in */
  ProceedsAsset: string;

  /** Total proceeds asset for the report. Amt for sell, Qty for buy trade */
  Proceeds: JSON_Decimal;

  /** Cumulative settled proceeds asset for the report */
  CumSettledProceeds: JSON_Decimal;

  /** Trade price */
  Price: JSON_Decimal;

  /** Last settled due asset for the report */
  LastSettledDue: JSON_Decimal;

  /** Last settled proceeds asset for the report */
  LastSettledProceeds: JSON_Decimal;

  /** Source for last settlement reported in LastSettledDue and LastSettledProceeds */
  LastSettledSource: TradeSettleSourceEnum;

  /** Source ID as OID or [36]byte */
  LastSourceID: string;

  /** Customer MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Customer counterparty ID */
  Counterparty: JSON_Counterparty;

  /** Timestamp when report was created in number of nanoseconds since Unix epoch. */
  TransactTime: JSON_UTCTimestamp;

  /** Action that caused this Trade settle report */
  LastAction: TradeSettleActionEnum;

  /** Organization ID */
  OrgID: number;

  /** Initial fundings of due */
  InitialDue: unknown;
}

/** View Request for ConversionRate feed */
export interface IConversionRateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;

  /** Tolerance of Conversion Changes, as a raw percentage (0.01 for 1%). */
  Tolerance: JSON_Decimal;

  /** Equivalent Currency ID */
  EquivalentCurrency: string;

  /** Debug and additional flags */
  Debug: Record<AggregatorDebugFlagEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** Source Currency/Security to Map to Equivalent Currency */
  AssetIDs: IConversionRateRequest4245AssetIDs[];
}

/** Source Currency/Security to Map to Equivalent Currency */
export interface IConversionRateRequest4245AssetIDs {
  /** AssetID */
  Asset: string;

  /** SourceUnit */
  SourceUnit: ConversionSourceUnitEnum;
}

/** Represents an update to an existing customer quote request */
export interface ICustomerQuoteUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Quote request ID for Update Request */
  QuoteReqID: string;

  /** Original Quote request ID */
  OrigQuoteReqID: string;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** Side */
  Side: SideEnum;

  /** Quantity */
  OrderQty: JSON_Decimal;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** ID of the counterparty that is requesting */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Organization ID */
  OrgID: number;

  /** Arbitrary string assigned when the customer request is submitted */
  Group: string;

  /** customer request parameters */
  Parameters: IQuoteParameters;

  /** Additional information attached to the quote */
  Comments: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Represents an parameters update request to an existing customer order */
export interface ICustomerOrderParamsUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** The ID or the order upon which to act */
  OrderID: string;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** customer request parameters */
  Parameters: IQuoteParameters;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Conversion Rate Delta for the View */
export interface IConversionRateDelta {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of MarketView */
  ViewID: JSON_Int64ID;

  /** Optional RequestID Indicates initial Snapshot on reused view */
  ViewRequestID: JSON_Int64ID;

  /** Equivalent Currency ID */
  EquivalentCurrency: string;

  /** Key for the conversion pair */
  PairKey: string;

  /** Asset of the delta */
  Asset: string;

  /** Conversion rate */
  Rate: JSON_Decimal;

  /** Status of conversion rate */
  Status: ConnectionStatusEnum;

  /** Implied asset price in Equivalent Currency */
  ImpliedPrice: JSON_Decimal;

  /** SourceUnit */
  SourceUnit: ConversionSourceUnitEnum;

  /** Paths to Calculate the Currency Rate */
  ConversionPath: string;
}

/** Settlement instruction belonging to a settlement batch */
export interface ISettlementInstruction {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier of the instruction generated by Talos */
  InstructionID: JSON_Int64ID;

  /** Unique ID for the parent settlement batch. Empty for preview */
  ParentSettlementID: JSON_Int64ID;

  /** Account affected by that instruction */
  OnBehalfOfAccountID: number;

  /** Direction of settlement instruction from the client perspective */
  Direction: SettlementInstructionDirectionEnum;

  /** Settlement instruction amount */
  Amount: JSON_Decimal;

  /** Settlement instruction asset */
  Asset: string;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Organization ID */
  OrgID: number;
}

/** Data for each possible market supporting the decision at the time the decision was made. */
export interface ITradeAnalytics {
  /** Timestamp of when the trade was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** OrderID of the parent order. */
  OrderID: string;

  /** SecurityID of Security that was traded. */
  Symbol: JSON_Security;

  /** Side of this trade */
  Side: SideEnum;

  /** TradeID of this trade. Generated by Talos. */
  TradeID: string;

  /** Timestamp of the trade as reported by the market. */
  TransactTime: JSON_UTCTimestamp;

  /** Market for this trade. */
  Market: JSON_Market;

  /** TradeID as reported by the market. */
  MarketTradeID: string;

  /** Price of the trade */
  Price: JSON_Decimal;

  /** Price of the trade with fees included. */
  PriceAllIn: JSON_Decimal;

  /** Quantity of the trade. */
  Quantity: JSON_Decimal;

  /** Currency of the Quantity of the trade. */
  Currency: string;

  /** Amount of the trade, i.e. Price times Quantity. */
  Amount: JSON_Decimal;

  /** Currency in which Amount is specified. */
  AmountCurrency: string;

  /** Currency in which Quantity was specified. */
  DealtCurrency: string;

  /** Fee on the trade as reported by the exchange. */
  Fee: JSON_Decimal;

  /** Fee currency, may be missing if no fees were paid. */
  FeeCurrency: string;

  /** Market for this analytics. If missing these analytics are aggregate values for a liquidity bucket instead of an individual market. */
  CandidateMarket: JSON_Market;

  /** The index of the Liquidity Bucket the market for these analytics belongs to. If CandidateMarketID is missing, then the index assigned to the liquidity bucket. */
  CandidateLiquidityBucketIdx: number;

  /** Expected fill price fee inclusive for this record. */
  CandidateExpectedFillPrice: JSON_Decimal;

  /** Expected fill quantity for this record. */
  CandidateExpectedFillQty: JSON_Decimal;

  /** Bps from best aggregate liquidity bucket price. */
  CandidateBpsFromBest: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Best bid on the candidate market */
  CandidateMarketBestBid: JSON_Decimal;

  /** Best offer on the candidate market */
  CandidateMarketBestOffer: JSON_Decimal;

  /** The market order id for this trade */
  MarketOrderID: string;
}

/** Snapshot message for a snowflake node */
export interface ISnowflakeNodeSnapshot {
  /** Timestamp node treats as the epoch */
  Epoch: JSON_UTCTimestamp;

  /** Last timestamp seen by this node */
  Time: number;

  /** Seed node number */
  Node: number;

  /** Current step this node is on */
  Step: number;

  /** Number of bits used for node number */
  NodeBits: number;

  /** Number of bits used for step */
  StepBits: number;
}

/** Message signaling the start of a DedupModel snapshot */
export interface IDedupModelSnapshotStartBlock {
  /** ID of the DedupModel, used to differentiate DedupModel snapshots */
  ID: number;

  /** Start time of the current lookback period */
  StartTime: JSON_UTCTimestamp;

  /** Duration of the lookback period */
  LookbackPeriod: JSON_DurationMillis;
}

/** DedupModel entry snapshot */
export interface IDedupModelSnapshotEntry {
  /** ID of the DedupModel this entry is a member of */
  DedupModelID: number;

  /** Bitmap field of eight Boolean type indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** A DedupModel entry */
  Entry: string;

  /** Type of this entry */
  EntryType: DedupModelEntryTypeEnum;
}

/** Snapshot message for a UuidV4Provider */
export interface IUuidV4ProviderSnapshot {
  /** The marshaled state of the RNG source */
  Source: string;
}

/** Snapshot of customer transaction data */
export interface ICustomerState {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The ID of the customer RFQ upon which to act */
  RFQID: string;

  /** The ID of the customer order upon which to act */
  OrderID: string;

  /** Effective Side of Executing RFQ */
  EffectiveSide: SideEnum;

  /** Order type - necessary for dispatching to the correct state in the model */
  OrdType: OrdTypeEnum;

  /** Pending Customer ClOrdID */
  PendingClOrdID: string;

  /** Pending Customer ClOrdID */
  PendingOMSClOrdID: string;

  /** Pending Quantity to Replace */
  PendingReplaceQty: JSON_Decimal;

  /** Pending Price to Replace */
  PendingReplacePrice: JSON_Decimal;

  /** Whether the leg is allowed to send crossing and/or resting orders, as requested by the order strategy */
  SplitHedges: boolean;

  /** Hedge Quote ID for bid quote */
  BidHedgeQuoteID: string;

  /** Hedge Quote ID for offer quote */
  OfferHedgeQuoteID: string;

  /** Strategy For Customer Order Execution */
  ExecutionStrategy: CustomerExecutionStrategyEnum;

  /** Flag to indicate whether a Back-to-Back Hedge is Complete */
  HedgeDone: boolean;

  /** Effective Pricing Parameters from the current customer transaction */
  EffectiveParameters: IQuoteParameters;

  /** Computed Pricing Parameters from the current customer transaction */
  PendingReplaceParameters: IQuoteParameters;

  /** Computed Pricing Parameters from the current customer transaction */
  PendingDirectParameters: IQuoteParameters;

  /** CustomerQuote message from the current rfq state */
  CustomerQuote: ICustomerQuote;

  /** CustomerExecutionReport message from the current order state */
  CustomerExecutionReport: ICustomerExecutionReport;

  /** omsLatestUpdate Quote in memory */
  OMSQuote: IOMSQuote;

  /** Security pinned to the order at creation, carried raw so SecurityWrapper reproduces its original fallback resolution */
  Security: ISecurity;

  /** CustomerSecurity pinned to the order at creation, carried raw and unmerged */
  CustomerSecurity: ICustomerSecurity;

  /** Existing Utilized OrderIDs, RFQIDs, ClOrdIDs, ClReqIDs */
  UtilizedOrderIDs: ICustomerState4255UtilizedOrderIDs[];

  /** Received Risk Responses */
  RiskApprovals: ICustomerState4255RiskApprovals[];

  /** The alignment of hedge quote ids */
  SplitHedgeStateByQuoteID: ICustomerState4255SplitHedgeStateByQuoteID[];

  /** Mapping of hedge quote to customer quote id */
  HedgeQuoteByCustomerQuoteID: ICustomerState4255HedgeQuoteByCustomerQuoteID[];
}

/** Mapping of hedge quote to customer quote id */
export interface ICustomerState4255HedgeQuoteByCustomerQuoteID {
  /** CustomerQuoteID for Hedge Quote */
  CustomerQuoteID: string;

  /** Hedge Quote ID */
  HedgeQuoteID: string;
}

/** Received Risk Responses */
export interface ICustomerState4255RiskApprovals {
  /** A Single Captured Risk Approval */
  Approval: ICustomerRiskResponse;
}

/** The alignment of hedge quote ids */
export interface ICustomerState4255SplitHedgeStateByQuoteID {
  /** Selected Hedge Quote ID for split hedges */
  UnifiedHedgeQuoteID: string;

  /** Hedge Quote ID for bid quote */
  BidHedgeQuoteID: string;

  /** Hedge Quote ID for offer quote */
  OfferHedgeQuoteID: string;
}

/** Existing Utilized OrderIDs, RFQIDs, ClOrdIDs, ClReqIDs */
export interface ICustomerState4255UtilizedOrderIDs {
  /** A utilized ID */
  OrderID: string;
}

/** Represents a reference data update request to an existing customer order */
export interface ICustomerOrderDataUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** The ID or the order upon which to act */
  OrderID: string;

  /** security */
  Security: ISecurity;

  /** customer security */
  CustomerSecurity: ICustomerSecurity;
}

/** Provide an enriched stream of pub/sub registrations for enriching monitoring/metrics with system details */
export interface IStreamRegistration {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** StreamID */
  StreamID: number;

  /** Stream Registration Id */
  RegistrationID: number;

  /** Name of Service registering pub/sub with stream */
  ServiceName: string;

  /** Hostname for Service registering pub/sub with stream */
  ServiceHost: string;

  /** Channel */
  Channel: string;
}

/** Runtime configuration */
export interface IConfiguration {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision of the most recent update */
  Revision: number;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Configuration key in the form a.b.c */
  Key: string;

  /** Configuration value as a string */
  Value: string;
}

/** Request to update an account ledger */
export interface ILedgerUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** A client-generated snowflake ID for this request */
  RequestID: JSON_Int64ID;

  /** The type of ledger update request */
  Type: LedgerUpdateTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset to be updated */
  Asset: string;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** Internal time in number of nanoseconds since Unix epoch representing the last time the balance changed in the system of record. */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Client-generated unique ID for incoming request if applicable */
  ExternalID: string;

  /** The ID of the OMS trade that generated this event, if applicable */
  TradeID: string;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** Indicates what is origin of ExternalID */
  ExternalType: ExternalTypeEnum;

  /** Optional units of Amount. If unset, then AssetID is assumed */
  AmountAsset: string;

  /** The optional intended / target type of the generated ledger event, if different than the request type */
  IntendedType: LedgerUpdateTypeEnum;

  /** Additional information relating to the update */
  Comments: string;
}

/** Response to updating an account ledger */
export interface ILedgerUpdateResponse {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** A client-generated snowflake ID for this request */
  RequestID: JSON_Int64ID;

  /** The type of ledger update request */
  Type: LedgerUpdateTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset to be updated */
  Asset: string;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** Status of the update request */
  Status: LedgerUpdateStatusEnum;

  /** Client-generated unique ID for incoming request if applicable */
  ExternalID: string;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** Indicates what is origin of ExternalID */
  ExternalType: ExternalTypeEnum;

  /** Timestamp representing when the balance changed in the system of record. */
  TransactTime: JSON_UTCTimestamp;

  /** Optional units of Amount. If unset, then AssetID is assumed */
  AmountAsset: string;

  /** The service originating this ledger */
  SourceService: JSON_ServiceIdentifier;

  /** Revision of the account that will be reflected on the LedgerAccountBalance if it is completed */
  Revision: number;

  /** The optional intended / target type of the generated ledger event, if different than the request type */
  IntendedType: LedgerUpdateTypeEnum;

  /** Text */
  Text: string;
}

/** An event on a ledger */
export interface ILedgerEvent {
  /** Internal time in number of nanoseconds since Unix epoch representing when the event was generated */
  TransactTime: JSON_UTCTimestamp;

  /** The ID of the ledger request that generated this event, if applicable */
  RequestID: JSON_Int64ID;

  /** The type of ledger update request */
  Type: LedgerUpdateTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset for this event */
  Asset: string;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Price of Amount, meaning depends on the Type */
  Price: JSON_Decimal;

  /** The Currency units of price */
  PriceCurrency: string;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** Status of the update request */
  Status: LedgerUpdateStatusEnum;

  /** Revision of the account that will be reflected on the LedgerAccountBalance if it is completed */
  Revision: number;

  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** The ID of the OMS trade that generated this event, if applicable */
  TradeID: string;

  /** Client-generated unique ID for incoming request if applicable */
  ExternalID: string;

  /** Current ledger amount after applying this ledger event */
  ResultingAmount: JSON_Decimal;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** Indicates what is origin of ExternalID */
  ExternalType: ExternalTypeEnum;

  /** The service originating this ledger */
  SourceService: JSON_ServiceIdentifier;

  /** Fee attributed to this event */
  Fee: JSON_Decimal;

  /** Currency ID for the fee */
  FeeCurrency: string;

  /** Optional units of Amount. If unset, then AssetID is assumed */
  AmountAsset: string;

  /** Organization ID */
  OrgID: number;

  /** Sequence number of this event affecting ResultingAmount, in transaction-time order */
  SequenceNumber: number;

  /** Additional information relating to the update */
  Comments: string;
}

/** The current state of an account */
export interface ILedgerAccountBalance {
  /** Internal time in number of nanoseconds since Unix epoch representing when the last event was applied */
  TransactTime: JSON_UTCTimestamp;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset of this balance */
  Asset: string;

  /** Resulting Balance / Position for the ledger */
  Amount: JSON_Decimal;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** Accumulated realized PnL for this balance / position */
  RealizedPnL: JSON_Decimal;

  /** The Currency units of average cost */
  CostCurrency: string;

  /** Revision of the account, which corresponds to the latest LedgerEvent that has been applied */
  Revision: number;

  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** The service originating this ledger balance */
  SourceService: JSON_ServiceIdentifier;

  /** Cumulative Fees attributed to this asset, in cost currency units */
  CumFees: JSON_Decimal;

  /** Resulting Unsettled Balance / Position for the ledger */
  UnsettledAmount: JSON_Decimal;

  /** Average cost of the UnsettledAmount, meaning depends on the Type */
  UnsettledAvgCost: JSON_Decimal;

  /** Cumulative FundingPnL attributed to this asset */
  FundingPnL: JSON_Decimal;

  /** The Currency units of FundingPnL */
  FundingPnLCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** The Currency units of RealizedPnL */
  RealizedPnLCurrency: string;

  /** The Currency units of CumFees */
  FeeCurrency: string;
}

/** Request to send out a snapshot of ledger details */
export interface ILedgerSnapshotRequest {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** A client-generated UUID for this request */
  RequestID: JSON_Int64ID;
}

/** Request to update a customer account ledger */
export interface ICustomerLedgerUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** A client-generated unique ID for this request */
  ExternalID: string;

  /** The type of ledger update request */
  Type: CustomerLedgerUpdateTypeEnum;

  /** ID of the counterparty for this user */
  Counterparty: JSON_Counterparty;

  /** The Currency to be updated, if non-zero */
  Currency: string;

  /** The Security to be updated, if non-zero */
  Symbol: JSON_Security;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Internal time in number of nanoseconds since Unix epoch representing the last time the balance changed in the system of record. */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Timestamp when the transaction or transfer occurred */
  TransactTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Additional information relating to the update */
  Comments: string;
}

/** Response to updating a customer account ledger */
export interface ICustomerLedgerUpdateResponse {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** A client-generated unique ID for this request */
  ExternalID: string;

  /** The type of ledger update request */
  Type: CustomerLedgerUpdateTypeEnum;

  /** ID of the counterparty for this user */
  Counterparty: JSON_Counterparty;

  /** The Currency to be updated, if non-zero */
  Currency: string;

  /** The Security to be updated, if non-zero */
  Symbol: JSON_Security;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Status of the update request */
  Status: LedgerUpdateStatusEnum;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;

  /** Additional information relating to the update */
  Comments: string;
}

/**  */
export interface ICustomerBalanceUpdate {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the counterparty for this user */
  Counterparty: JSON_Counterparty;

  /** Revision of the account, which corresponds to the latest LedgerEvent that has been applied */
  Revision: number;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of balance entries */
  Balances: ICustomerBalanceUpdate5307Balances[];
}

/** Number of balance entries */
export interface ICustomerBalanceUpdate5307Balances {
  /** Balance Entry Type */
  BalanceEntryType: BalanceEntryTypeEnum;

  /** The Currency to be updated, if non-zero */
  Currency: string;

  /** The Security to be updated, if non-zero */
  Symbol: JSON_Security;

  /** Balance Amount */
  Amount: JSON_Decimal;

  /** Available Amount not tied up in open orders */
  AvailableAmount: JSON_Decimal;

  /** Balance update time as given by the Exchange or zero if not given by the exchange */
  TransactTime: JSON_UTCTimestamp;

  /** Available Margin */
  AvailableMargin: JSON_Decimal;

  /** Amount that may get from open customer orders */
  OutstandingBuy: JSON_Decimal;

  /** Amount locked in open customer orders */
  OutstandingSell: JSON_Decimal;
}

/** An event on a ledger */
export interface ICustomerLedgerEvent {
  /** The ID of the ledger request that generated this event, if applicable */
  RequestID: JSON_Int64ID;

  /** The type of ledger update request */
  Type: CustomerLedgerUpdateTypeEnum;

  /** ID of the counterparty for this event */
  Counterparty: JSON_Counterparty;

  /** The Currency of this event, if non-zero */
  Currency: string;

  /** The Security of this event, if non-zero */
  Symbol: JSON_Security;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Status of the update request */
  Status: LedgerUpdateStatusEnum;

  /** Revision of the account that will be reflected on the LedgerAccountBalance if it is completed */
  Revision: number;

  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** The ID of the OMS trade that generated this event, if applicable */
  TradeID: string;

  /** Client-generated unique ID for incoming request if applicable */
  ExternalID: string;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Indicates what is origin of ExternalID */
  ExternalType: ExternalTypeEnum;

  /** Resulting amount of the ledger event */
  ResultingAmount: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Additional information relating to the update */
  Comments: string;
}

/** View Request for ReferenceRate feed */
export interface IReferenceRateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Tolerance of market moving average(s) from the median */
  Tolerance: JSON_Decimal;

  /** Frequency of reference rate updates */
  Throttle: JSON_DurationMillis;

  /** Debug and additional flags */
  Debug: Record<AggregatorDebugFlagEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** Requested Markets */
  Markets: IReferenceRateRequest5310Markets[];
}

/** Requested Markets */
export interface IReferenceRateRequest5310Markets {
  /** MarketID for requested Market */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** Message for delivery of websocket ReferenceRateSnapshots */
export interface IReferenceRateSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Optional Market View ID */
  ViewID: JSON_Int64ID;

  /** Optional RequestID Indicates initial Snapshot on reused view */
  ViewRequestID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Reference Rate */
  Rate: JSON_Decimal;

  /** Overall rate status */
  Status: ConnectionStatusEnum;

  /** Variance of underlying markets from the calculated reference rate */
  Variance: JSON_Decimal;

  /** A spread-like measure of underlying markets */
  SpreadMeasure: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Market Statuses for this MarketView */
  Markets: IReferenceRateSnapshot5311Markets[];
}

/** Market Statuses for this MarketView */
export interface IReferenceRateSnapshot5311Markets {
  /** MarketID for requested Market */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Status of this market in the reference rate */
  MarketStatus: OrderMarketStatusEnum;

  /** Price for this market */
  Price: JSON_Decimal;

  /** Type of this market's price if included in the ref-rate */
  PriceType: DepthTypeEnum;
}

/** Realtime balance specific to whitelabel customers, generated from RealtimeBalance5100 */
export interface ICustomerRealtimeBalance {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** ID of the customer counterparty */
  Counterparty: JSON_Counterparty;

  /** Number of balance entries */
  Balances: ICustomerRealtimeBalance5312Balances[];
}

/** Number of balance entries */
export interface ICustomerRealtimeBalance5312Balances {
  /** Latest time this balance was updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Message type indicating snapshot or update */
  BalanceEntryType: BalanceEntryTypeEnum;

  /** The Currency of the balance entry, if non-zero */
  Currency: string;

  /** Realtime amount including all trade executions */
  Amount: JSON_Decimal;

  /** Available amount not tied up in open orders */
  AvailableAmount: JSON_Decimal;

  /** Available margin */
  AvailableMargin: JSON_Decimal;

  /** Amount of open orders on the buy side */
  OutstandingBuy: JSON_Decimal;

  /** Amount of open orders on the sell side */
  OutstandingSell: JSON_Decimal;

  /** Account */
  Account: string;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Pending withdrawal amount */
  PendingWithdrawal: JSON_Decimal;

  /** Unsettled amount */
  UnsettledAmount: JSON_Decimal;

  /** Borrowed amount for margin trading (principal only) */
  BorrowAmount: JSON_Decimal;

  /** Equity */
  Equity: JSON_Decimal;
}

/** Snapshot request of all CustomerRealtimeBalance */
export interface ICustomerRealtimeBalanceSnapshotRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Aeron ClientID of the requestor */
  ClientID: number;
}

/** Represents the a snapshot of the position stats in the given resolution, for an asset of an account. */
export interface IPositionStat {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Time resolution of position stats */
  WindowResolution: ResolutionEnum;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** Account ID for this position stat */
  AccountID: number;

  /** Asset ID for this position stat */
  Asset: string;

  /** Highest position reached during time interval, in asset */
  HighPosition: JSON_Decimal;

  /** Lowest position reached during time interval, in asset */
  LowPosition: JSON_Decimal;

  /** Closing position of the time interval, in asset */
  ClosePosition: JSON_Decimal;

  /** Total quantity of asset bought (in absolute value) in the time interval */
  BuyVolume: JSON_Decimal;

  /** Quantity of asset bought for Life to date (LTD) (approx) */
  BuyVolumeToDate: JSON_Decimal;

  /** Total quantity of asset sold (in absolute value) in the time interval */
  SellVolume: JSON_Decimal;

  /** Quantity of asset sold for Life to date (LTD) (approx) */
  SellVolumeToDate: JSON_Decimal;

  /** Close Realized PnL for the interval (in CostCurrency) */
  CloseRealizedPnL: JSON_Decimal;

  /** Close Realized PnL for Life to date (in CostCurrency, approx) */
  CloseRealizedPnLToDate: JSON_Decimal;

  /** Close average cost (Life to date) */
  CloseAvgCost: JSON_Decimal;

  /** Cost currency ID (CostCurrency) */
  CostCurrency: string;

  /** Fees for the interval (in CostCurrency) */
  CloseFees: JSON_Decimal;

  /** Fees for Life to date (in CostCurrency, approx) */
  CloseFeesToDate: JSON_Decimal;

  /** FundingPnL for the interval (in CostCurrency) */
  CloseFundingPnL: JSON_Decimal;

  /** FundingPnL for Life to date (in CostCurrency, approx) */
  CloseFundingPnLToDate: JSON_Decimal;

  /** Revision of the ledger account balance */
  Revision: number;

  /** Last update time for offline stream in nanoseconds since Unix epoch, zero for live stream */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Position delta of the time interval, in asset */
  PositionDelta: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Close average cost of BuyVolume (Life to date, in CostCurrency) */
  BuyVolumeToDateAvgCost: JSON_Decimal;

  /** Close average cost of SellVolume (Life to date, in CostCurrency) */
  SellVolumeToDateAvgCost: JSON_Decimal;

  /** Currency units of RealizedPnL */
  RealizedPnLCurrency: string;

  /** Currency units of FundingPnL */
  FundingPnLCurrency: string;

  /** Currency units of Fees */
  FeeCurrency: string;

  /** Side of the position for this stat; defaults to Both */
  PositionSide: PositionSideTypeEnum;
}

/** Represents a conversion rate that will be used to calculate the USD value positions and PnL */
export interface IPriceMark {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** How the price mark was calculated */
  Source: PriceMarkSourceEnum;

  /** Asset ID for this price mark */
  Asset: string;

  /** Currency that the price mark is calculated with */
  EquivalentCurrency: string;

  /** Implied asset price in Equivalent Currency */
  Price: JSON_Decimal;

  /** Conversion rate */
  ConversionRate: JSON_Decimal;

  /** Status for the price mark */
  Status: MarketAccountStatusEnum;

  /** User who update that price mark */
  UpdateUser: JSON_User;

  /** Revision of this price mark */
  Revision: number;

  /** Organization ID */
  OrgID: number;

  /** External tags */
  Tags: Record<PriceMarkTagsEnum, boolean>;
}

/** Admin request for an orderbook */
export interface IOrderBookAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Security ID */
  Symbol: JSON_Security;

  /** Action type for orderbook to carry out */
  Action: OrderBookAdminActionEnum;

  /** OID of the order to cancel */
  OID: JSON_Int64ID;

  /** ClOrdID for this request */
  ClOID: JSON_Int64ID;

  /** The time from which we should recover trades from. Used when we use TimeBased checkpoints. */
  CheckpointTime: JSON_UTCTimestamp;

  /** All trades after this time should be kept in memory. This will always be set to a time before the CheckpointTime. Used when we use TimeBased checkpoints. */
  LookbackTime: JSON_UTCTimestamp;

  /** The last ExecID we've seen in a trade. Used when we use SequenceBased checkpoints. */
  LastTradeID: number;

  /** The start time for the request. */
  StartTime: JSON_UTCTimestamp;

  /** The end time for the request. */
  EndTime: JSON_UTCTimestamp;

  /** When supplied we update all checkpoints to last trade time and apply this leniency. */
  CheckpointLeniency: JSON_DurationMillis;

  /** When supplied request will only consider off-platform orders. */
  OffPlatform: boolean;

  /** Organization ID */
  OrgID: number;

  /** OrderID of the order */
  OrderID: string;

  /** ClOrdID of the order */
  ClOrdID: string;

  /** ExecID filter */
  ExecID: string;

  /** Zero-based offset for paginating GetOrders results */
  PageOffset: number;

  /** Maximum number of orders to return for GetOrders; 0 or absent means server default */
  PageLimit: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** OrdStatus filter values */
  OrdStatuses: IOrderBookAdminRequest4295OrdStatuses[];
}

/** OrdStatus filter values */
export interface IOrderBookAdminRequest4295OrdStatuses {
  /** OrdStatus value */
  OrdStatus: OrdStatusEnum;
}

/** Request to send out a data-snapshot of specific templates */
export interface IDataSnapshotRequest {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Generated request ID to be referenced in responses */
  RequestID: JSON_Int64ID;

  /** Template IDs requested */
  TemplateIDs: IDataSnapshotRequest5320TemplateIDs[];
}

/** Template IDs requested */
export interface IDataSnapshotRequest5320TemplateIDs {
  /** TemplateID */
  TemplateID: number;
}

/** Response to a data-snapshot request */
export interface IDataSnapshotResponse {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Request ID in response to */
  RequestID: JSON_Int64ID;

  /** Template ID in this response */
  TemplateID: number;

  /** Generated response ID to be referenced in the start / end block */
  ResponseID: JSON_Int64ID;

  /** EntryType */
  EntryType: SnapshotBlockEntryTypeEnum;
}

/** Admin request for gateway testing */
export interface IGatewayTestingAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Security ID */
  Symbol: JSON_Security;

  /** Gateway test type */
  GatewayTestType: GatewayTestTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** GatewayTestName */
  GatewayTestName: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** ClientFIXConnection configures a FIX session */
export interface IClientFIXConnection {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique ID of this connection */
  ConnectionID: number;

  /** Canonical name for this connection */
  Name: string;

  /** User ID */
  User: JSON_User;

  /** Type of functionality supported by this connection */
  ConnectionType: Record<ConnectionTypeEnum, boolean>;

  /** URL to connect or listen on, of the form fix://localhost:123 or fixs://:123 */
  URL: string;

  /** BeginString */
  BeginString: string;

  /** SenderCompID */
  SenderCompID: string;

  /** SenderSubID */
  SenderSubID: string;

  /** TargetCompID */
  TargetCompID: string;

  /** TargetSubID */
  TargetSubID: string;

  /** Time zone for this session; if specified, the session start and end will be converted from this zone to UTC */
  TimeZone: string;

  /** Time of day that this FIX session becomes activated in time in the format of HH:MM:SS */
  StartTime: string;

  /** Time of day that this FIX session becomes activated in time in the format of HH:MM:SS */
  EndTime: string;

  /** For week long sessions, the starting day of week for the session. Use in combination with StartTime. Full day of week in English, or 3 letter abbreviation (i.e. Monday and Mon are valid) */
  StartDay: string;

  /** For week long sessions, the ending day of week for the session. Use in combination with EndTime. Full day of week in English, or 3 letter abbreviation (i.e. Monday and Mon are valid) */
  EndDay: string;

  /** Bitmap to configure this session */
  Flags: Record<FIXFlagsEnum, boolean>;

  /** MarketAccountId bound to this session for DMA flow */
  MarketAccountID: number;

  /** MarketID bound to this session for DMA flow */
  MarketID: number;

  /** Revision */
  Revision: number;

  /** The service id responsible for the connection */
  ServiceID: number;

  /** Detailed functionality supported by this connection */
  ConnectionDetails: Record<ConnectionDetailsEnum, boolean>;

  /** ID of user who performed this update */
  UpdateUser: JSON_User;

  /** Whether this connection is enabled. Disabled connections are persisted and displayed in the UI but are not active. */
  Mode: ModeEnum;

  /** Organization ID */
  OrgID: number;
}

/** OMS Quote Response for negotiated RFQ protocol(TenantID:OrgID) */
export interface IOMSQuoteResponse {
  /** Organization ID */
  OrgID: number;

  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for Quote Response */
  QuoteRespID: string;

  /** Quote Response Type */
  QuoteRespType: QuoteRespTypeEnum;

  /** Quote request ID */
  RFQID: string;

  /** Transaction time as provided by remote */
  TransactTime: JSON_UTCTimestamp;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** FIXSession records the beginning of a FIX session */
export interface IFIXSession {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this connection */
  ConnectionID: number;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;
}

/** FIXSequence records sequence numbers */
export interface IFIXSequence {
  /** Direction */
  Direction: MessageDirectionEnum;

  /** Last sent message */
  MessageID: IMessageID;
}

/** WSSession records the beginning of a WS session */
export interface IWSSession {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** URL that the client connected to */
  LocalURL: string;

  /** URL that the client connected from */
  RemoteURL: string;
}

/** Request to update an account ledger */
export interface ILedgerUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** The timestamp (in nanoseconds since Unix epoch) when the external/original transaction took place. */
  TransactTime: JSON_UTCTimestamp;

  /** A client-generated snowflake ID for this request */
  RequestID: JSON_Int64ID;

  /** The type of ledger update request */
  Type: LedgerUpdateTypeEnum;

  /** The optional intended / target type of the generated ledger event, if different than the request type */
  IntendedType: LedgerUpdateTypeEnum;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset to be updated */
  Asset: string;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Optional units of Amount. If unset, then AssetID is assumed */
  AmountAsset: string;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** The ID of the trade / transaction that generated this event, if applicable */
  TradeID: string;

  /** Client-generated unique ID for incoming request if applicable */
  ExternalID: string;

  /** Indicates what is origin of ExternalID */
  ExternalType: ExternalTypeEnum;

  /** Whether this update is for amending a previously seen transaction. */
  ForLedgerAmendment: boolean;

  /** User who initiated this update, if user-initiated. */
  UpdateUser: JSON_User;

  /** Side of the position being updated; defaults to Both when omitted */
  PositionSide: PositionSideTypeEnum;

  /** Additional information relating to the update */
  Comments: string;
}

/** SessionReset records the end of a session */
export interface ISessionReset {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;
}

/** Response to updating an account ledger */
export interface ILedgerUpdateResponse {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Timestamp representing when the balance changed in the system of record. */
  TransactTime: JSON_UTCTimestamp;

  /** The service originating this ledger */
  SourceService: JSON_ServiceIdentifier;

  /** A client-generated snowflake ID for this request */
  RequestID: JSON_Int64ID;

  /** The type of ledger update request */
  Type: LedgerUpdateTypeEnum;

  /** The optional intended / target type of the generated ledger event, if different than the request type */
  IntendedType: LedgerUpdateTypeEnum;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset to be updated */
  Asset: string;

  /** Revision of the account that will be reflected on the LedgerAccountBalance if it is completed */
  Revision: number;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Optional units of Amount. If unset, then AssetID is assumed */
  AmountAsset: string;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** Status of the update request */
  Status: LedgerUpdateStatusEnum;

  /** The ID of the trade / transaction that generated this event, if applicable */
  TradeID: string;

  /** Client-generated unique ID for incoming request if applicable */
  ExternalID: string;

  /** Indicates what is origin of ExternalID */
  ExternalType: ExternalTypeEnum;

  /** Whether this update is for amending a previously seen transaction. */
  ForLedgerAmendment: boolean;

  /** User who initiated this update, if user-initiated. */
  UpdateUser: JSON_User;

  /** Side of the position being updated; defaults to Both when omitted */
  PositionSide: PositionSideTypeEnum;

  /** Text */
  Text: string;
}

/** CustomerFIXConnection configures a FIX session */
export interface ICustomerFIXConnection {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique ID of this connection */
  ConnectionID: number;

  /** Canonical name for this connection */
  Name: string;

  /** Customer User ID */
  CustomerUser: JSON_CustomerUser;

  /** Type of functionality supported by this connection */
  ConnectionType: Record<ConnectionTypeEnum, boolean>;

  /** URL to connect or listen on, of the form fix://localhost:123 or fixs://:123 */
  URL: string;

  /** BeginString */
  BeginString: string;

  /** SenderCompID */
  SenderCompID: string;

  /** SenderSubID */
  SenderSubID: string;

  /** TargetCompID */
  TargetCompID: string;

  /** TargetSubID */
  TargetSubID: string;

  /** Time zone for this session; if specified, the session start and end will be converted from this zone to UTC */
  TimeZone: string;

  /** Time of day that this FIX session becomes activated in time in the format of HH:MM:SS */
  StartTime: string;

  /** Time of day that this FIX session becomes activated in time in the format of HH:MM:SS */
  EndTime: string;

  /** For week long sessions, the starting day of week for the session. Use in combination with StartTime. Full day of week in English, or 3 letter abbreviation (i.e. Monday and Mon are valid) */
  StartDay: string;

  /** For week long sessions, the ending day of week for the session. Use in combination with EndTime. Full day of week in English, or 3 letter abbreviation (i.e. Monday and Mon are valid) */
  EndDay: string;

  /** Bitmap to configure this session */
  Flags: Record<FIXFlagsEnum, boolean>;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Revision */
  Revision: number;

  /** The service id responsible for the connection */
  ServiceID: number;

  /** ID of user who performed this update */
  UpdateUser: JSON_User;

  /** Whether this connection is enabled. Disabled connections are persisted and displayed in the UI but are not active. */
  Mode: ModeEnum;
}

/** An event on a ledger */
export interface ILedgerEvent {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Internal time in number of nanoseconds since Unix epoch representing when the event was generated */
  TransactTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The service originating this ledger */
  SourceService: JSON_ServiceIdentifier;

  /** The ID of the ledger request that generated this event, if applicable */
  RequestID: JSON_Int64ID;

  /** The type of ledger update request */
  Type: LedgerUpdateTypeEnum;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset for this event */
  Asset: string;

  /** Revision of the account that will be reflected on the LedgerAccountBalance if it is completed */
  Revision: number;

  /** Sequence number of this event affecting ResultingAmount, in transaction-time order */
  SequenceNumber: number;

  /** Amount of the ledger update, meaning depends on the Type */
  Amount: JSON_Decimal;

  /** Optional units of Amount. If unset, then AssetID is assumed */
  AmountAsset: string;

  /** Current ledger amount after applying this ledger event */
  ResultingAmount: JSON_Decimal;

  /** Price of Amount, meaning depends on the Type */
  Price: JSON_Decimal;

  /** The Currency units of price */
  PriceCurrency: string;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** Fee attributed to this event */
  Fee: JSON_Decimal;

  /** Currency ID for the fee */
  FeeCurrency: string;

  /** Status of the update request */
  Status: LedgerUpdateStatusEnum;

  /** The ID of the trade / transaction that generated this event, if applicable */
  TradeID: string;

  /** Client-generated unique ID for incoming request if applicable */
  ExternalID: string;

  /** Indicates what is origin of ExternalID */
  ExternalType: ExternalTypeEnum;

  /** User who initiated this update, if user-initiated. */
  UpdateUser: JSON_User;

  /** Side of the position being updated; defaults to Both when omitted */
  PositionSide: PositionSideTypeEnum;

  /** Additional information relating to the update */
  Comments: string;
}

/** Operator request to act on a live client FIX session */
export interface IClientFIXAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Correlation ID used to match the response */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** ID of the user who requested this action */
  User: JSON_User;

  /** Service ID recorded on the connection when the request was issued. Advisory only: the gateway routes on live session ownership because the connection API rewrites this field to the default service */
  ServiceID: number;

  /** Unique ID of the client FIX connection to act on */
  ConnectionID: number;

  /** Action to perform */
  Action: ClientFIXAdminActionEnum;
}

/** The current state of an account */
export interface ILedgerAccountBalance {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Internal time in number of nanoseconds since Unix epoch representing when the last event was applied */
  TransactTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The service originating this ledger balance */
  SourceService: JSON_ServiceIdentifier;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** The Asset of this balance */
  Asset: string;

  /** Revision of the account, which corresponds to the latest LedgerEvent that has been applied */
  Revision: number;

  /** Resulting Balance / Position for the ledger */
  Amount: JSON_Decimal;

  /** Average cost of the Amount, meaning depends on the Type */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  CostCurrency: string;

  /** Accumulated realized PnL for this balance / position */
  RealizedPnL: JSON_Decimal;

  /** The Currency units of RealizedPnL */
  RealizedPnLCurrency: string;

  /** Cumulative Fees attributed to this asset, in cost currency units */
  CumFees: JSON_Decimal;

  /** The Currency units of CumFees */
  FeeCurrency: string;

  /** Cumulative FundingPnL attributed to this asset */
  FundingPnL: JSON_Decimal;

  /** The Currency units of FundingPnL */
  FundingPnLCurrency: string;

  /** Resulting Unsettled Balance / Position for the ledger */
  UnsettledAmount: JSON_Decimal;

  /** Average cost of the UnsettledAmount, meaning depends on the Type */
  UnsettledAvgCost: JSON_Decimal;

  /** Type of the balance entry. Used only to differentiate between live and historical entries. (NonDatabaseField) */
  BalanceType: LedgerAccountBalanceTypeEnum;

  /** Side of the position for this balance; defaults to Both */
  PositionSide: PositionSideTypeEnum;
}

/** Result of a ClientFIXAdminRequest, published by the gateway that owns the session */
export interface IClientFIXAdminResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** RequestID of the request this responds to */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Service ID of the gateway instance that actually handled the request */
  ServiceID: number;

  /** Unique ID of the client FIX connection acted on */
  ConnectionID: number;

  /** Action that was requested */
  Action: ClientFIXAdminActionEnum;

  /** Outcome of the action */
  Status: ClientFIXAdminStatusEnum;

  /** FIX session ID in effect when the directive was armed, before it is applied at the next logon */
  SessionID: JSON_Int64ID;

  /** Next inbound sequence number in effect when the directive was armed */
  NextTargetMsgSeqNum: number;

  /** Next outbound sequence number in effect when the directive was armed */
  NextSenderMsgSeqNum: number;

  /** Reject or diagnostic detail */
  Text: string;
}

/** Represents the timestamp when the latest ledger account balance snapshot was created for the given account */
export interface ILedgerAccountBalanceCheckpoint {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Internal time in number of nanoseconds since Unix epoch representing when the last snapshot was created */
  TransactTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The service originating this ledger balance */
  SourceService: JSON_ServiceIdentifier;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the ledger account */
  AccountID: number;
}

/** Records sessions details */
export interface ISessionDetails {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** The source of the session, e.g. Websocket, REST, FIX. */
  Source: SessionSourceEnum;

  /** LocalAddress */
  LocalAddress: string;

  /** RemoteAddress */
  RemoteAddress: string;
}

/** Represents a request to recalculate ledger account balance for the specified account */
export interface ILedgerAccountBalanceRecalcRequest {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The service originating this ledger balance */
  SourceService: JSON_ServiceIdentifier;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** Internal time in number of nanoseconds since Unix epoch representing when the last snapshot was created */
  TransactTime: JSON_UTCTimestamp;
}

/** Quote Response for negotiated RFQ protocol */
export interface IQuoteResponse {
  /** Organization ID */
  OrgID: number;

  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for Quote Response */
  QuoteRespID: string;

  /** Quote Response Type */
  QuoteRespType: QuoteRespTypeEnum;

  /** Transaction time as provided by remote */
  TransactTime: JSON_UTCTimestamp;

  /** Credential ID */
  CredentialID: number;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Internal ID of request for quote */
  RID: JSON_Int64ID;

  /** Selected market ID */
  Market: JSON_Market;
}

/** Represents an asset related action which affects the ledger */
export interface ILedgerAssetAction {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The service originating this asset action */
  SourceService: JSON_ServiceIdentifier;

  /** Unique identifier for the hedge control */
  ActionID: JSON_Int64ID;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the ledger account */
  AccountID: number;

  /** Time of action this entity refers to (time that can be used for ordering) */
  TransactTime: JSON_UTCTimestamp;

  /** Source time of the event which generated the action (ie.: scheduled time) */
  ActionTime: JSON_UTCTimestamp;

  /** Type of the asset action */
  Type: LedgerAssetActionTypeEnum;

  /** The Asset this action refers to */
  Asset: string;

  /** Price tied to the asset action. Can be null if not applicable */
  Price: JSON_Decimal;

  /** Currency of the price tied to the asset action. Can be zero if not applicable */
  PriceCurrency: string;

  /** Additional information relating to the asset action */
  Comments: string;
}

/** Realtime derivative position specific to whitelabel customers */
export interface ICustomerPosition {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** ID of the customer counterparty */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** The Security of the balance entry, if non-zero */
  Symbol: JSON_Security;

  /** Type of position update message */
  UpdateType: PositionUpdateTypeEnum;

  /** Derivative position */
  Amount: JSON_Decimal;

  /** Average cost of the Amount */
  AvgCost: JSON_Decimal;

  /** Mark price of the instrument */
  MarkPrice: JSON_Decimal;

  /** UnrealizedPnL */
  UnrealizedPnL: JSON_Decimal;

  /** Margin amount locked by buy open orders */
  BuyLockedMargin: JSON_Decimal;

  /** Margin amount locked by sell open orders */
  SellLockedMargin: JSON_Decimal;

  /** Margin amount used by the position */
  UsedMargin: JSON_Decimal;

  /** Account collateral in the currency */
  Collateral: JSON_Decimal;

  /** The Currency units of the margin */
  MarginCurrency: string;

  /** Account leverage */
  Leverage: JSON_Decimal;

  /** Unique batch update belongs to */
  BatchID: JSON_Int64ID;

  /** Bitmap field of eight Boolean type indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Margin stress factor */
  StressFactor: JSON_Decimal;

  /** Unrealized PnL if the market moves down by the stress factor */
  NegativeStressPnL: JSON_Decimal;

  /** Unrealized PnL if the market moves up by the stress factor */
  PositiveStressPnL: JSON_Decimal;

  /** Last time the mark price has been updated */
  MarkPriceUpdateTime: JSON_UTCTimestamp;

  /** Threshold when reached margin call is going to happen */
  MarginCallThreshold: JSON_Decimal;

  /** Threshold when reached liquidation is going to happen */
  LiquidationThreshold: JSON_Decimal;

  /** RealizedPnL */
  RealizedPnL: JSON_Decimal;

  /** FundingPnL */
  FundingPnL: JSON_Decimal;

  /** The Currency units of the RealizedPnL */
  RealizedPnLCurrency: string;

  /** The Currency units of the UnrealizedPnL */
  UnrealizedPnLCurrency: string;

  /** The Currency units of the FundingPnL */
  FundingPnLCurrency: string;

  /** Maximum allowed exposure based on the configuration setting. Value is in the same currency as the equity */
  MaximumExposure: JSON_Decimal;

  /** Outstanding quantity based on locked buy open orders, in position units */
  OutstandingBuy: JSON_Decimal;

  /** Outstanding quantity based on locked sell open orders, in position units */
  OutstandingSell: JSON_Decimal;
}

/** Aggregate position figures based on realtime derivative position specific to whitelabel customers */
export interface ICustomerAggregatePosition {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Type of position update message */
  UpdateType: PositionUpdateTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** ID of the customer counterparty */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** The Currency units of the margin */
  MarginCurrency: string;

  /** Aggregate UnrealizedPnL for the market account */
  UnrealizedPnL: JSON_Decimal;

  /** Aggregate margin amount locked by buy open orders */
  BuyLockedMargin: JSON_Decimal;

  /** Aggregate margin amount locked by sell open orders */
  SellLockedMargin: JSON_Decimal;

  /** Aggregate margin amount used by the position */
  UsedMargin: JSON_Decimal;

  /** Aggregate realizedPnL */
  RealizedPnL: JSON_Decimal;

  /** Aggregate fundingPnL */
  FundingPnL: JSON_Decimal;

  /** Account collateral in the margin currency */
  Collateral: JSON_Decimal;

  /** Account leverage */
  Leverage: JSON_Decimal;

  /** Threshold when reached margin call is going to happen */
  MarginCallThreshold: JSON_Decimal;

  /** Threshold when reached liquidation is going to happen */
  LiquidationThreshold: JSON_Decimal;

  /** Maximum allowed exposure based on the configuration setting. Value is in the same currency as the equity */
  MaximumExposure: JSON_Decimal;

  /** Aggregate notional values of long positions. Always a positive number */
  LongNotional: JSON_Decimal;

  /** Aggregate notional values of short positions. Always a positive number */
  ShortNotional: JSON_Decimal;
}

/** Mark price for whitelabel customers to calculate margin positions */
export interface ICustomerMarkPrice {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** ID of the customer counterparty */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** The Asset to be updated */
  Asset: string;

  /** Hedge price bid side */
  BidHedgePrice: JSON_Decimal;

  /** Hedge price offer side */
  OfferHedgePrice: JSON_Decimal;

  /** Customer bid spread */
  BidSpread: JSON_Decimal;

  /** Customer offer spread */
  OfferSpread: JSON_Decimal;

  /** MarkPrice including the customer spread */
  BidPrice: JSON_Decimal;

  /** MarkPrice including the customer spread */
  OfferPrice: JSON_Decimal;
}

/** Settlement schedule controls for Counterparty / MarketAccount */
export interface IDEPRECATED_SettlementScheduleControl {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of this control */
  ControlID: JSON_Int64ID;

  /** Optional counterparty for this schedule. Either CounterpartyID or MarketAccountID must be set. */
  Counterparty: JSON_Counterparty;

  /** Optional MarketAccount for this schedule. Either CounterpartyID or MarketAccountID must be set. */
  MarketAccount: JSON_MarketAccount;

  /** Settlement offset from the trade-date */
  SettleCycle: JSON_ExtendedDuration;

  /** Settlement cutoff for trades on a particular date */
  SettleCutoff: JSON_TimeOnly;

  /** Holiday convention for business-day adjustment. Default is None */
  BusinessDayHolidayConvention: OTCHolidayBusinessDayConventionEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** ID of user who last updated */
  UpdateUser: JSON_User;

  /** Revision */
  Revision: number;

  /** Optional timezone for settlement cutoff. Default is UTC if not specified */
  SettleCutoffTimezone: string;

  /** Holiday calendars */
  HolidayCalendars: IDEPRECATED_SettlementScheduleControl4320HolidayCalendars[];
}

/** Holiday calendars */
export interface IDEPRECATED_SettlementScheduleControl4320HolidayCalendars {
  /** Calendar name */
  Name: string;
}

/** Customer account configurations */
export interface ICustomerAccountConfiguration {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Organization ID */
  OrgID: number;

  /** Unique ID generated by Talos for this configuration */
  ConfigID: JSON_Int64ID;

  /** ID of the customer counterparty */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Security the configuration applies to */
  Symbol: JSON_Security;

  /** Configuration key */
  Key: CustomerAccountConfigurationKeyEnum;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision of the most recent update */
  Revision: number;

  /** Configuration value as a string */
  Value: string;
}

/** Customer Quote Response for negotiated RFQ protocol */
export interface ICustomerQuoteResponse {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for Quote Response */
  QuoteRespID: string;

  /** Quote Response Type */
  QuoteRespType: QuoteRespTypeEnum;

  /** Quote request ID */
  RFQID: string;

  /** Quote ID */
  QuoteID: string;
}

/** Extra details for MarketAccounts */
export interface IMarketAccountDetails {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** MarketAccount for these details */
  MarketAccount: JSON_MarketAccount;

  /** Settlement offset from the trade-date */
  SettleCycle: JSON_ExtendedDuration;

  /** Settlement cutoff for trades on a particular date */
  SettleCutoff: JSON_TimeOnly;

  /** Holiday convention for business-day adjustment. Default is None */
  BusinessDayHolidayConvention: OTCHolidayBusinessDayConventionEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** ID of user who last updated */
  UpdateUser: JSON_User;

  /** Revision */
  Revision: number;

  /** Whether settlement is enabled for this MarketAccount */
  SettlementMode: ModeEnum;

  /** Type of the embedded agreement. */
  AgreementType: MarketAccountAgreementTypeEnum;

  /** Window for trades that settle in the same cycle */
  SettleTradingWindowDuration: JSON_ExtendedDuration;

  /** Fields that should be used in initial auto-batching of transactions for settlement */
  AutoBatchGroupFields: Record<LPSettlementAutoBatchGroupFieldsEnum, boolean>;

  /** Rounding increment for all asset settlements */
  SettleMinIncrement: JSON_Decimal;

  /** Optional timezone for settlement cutoff. Default is UTC if not specified */
  SettleCutoffTimezone: string;

  /** Embedded agreement, must match AgreementType */
  Agreement: unknown;

  /** Holiday calendars */
  HolidayCalendars: IMarketAccountDetails4322HolidayCalendars[];
}

/** Holiday calendars */
export interface IMarketAccountDetails4322HolidayCalendars {
  /** Calendar name */
  Name: string;
}

/** Rule for configuring the hedge behavior */
export interface IHedgeRule {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique Identifier Generated for HedgeRule */
  HedgeRuleID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision of Position Status */
  Revision: number;

  /** User who update that price mark */
  UpdateUser: JSON_User;

  /** Flag to enable or disable this rule */
  Mode: ModeEnum;

  /** Rule evaluation priority, lower value is higher priority */
  Priority: number;

  /** Account ID for the tracked hedge position */
  AccountID: number;

  /** Asset ID for the tracked hedge position */
  Asset: string;

  /** Asset for which the hedger compares the threshold positions */
  TargetAsset: string;

  /** Target Position to Maintain */
  TargetPosition: JSON_Decimal;

  /** Long Threshold to Begin Hedging Toward Target */
  LongPositionLimit: JSON_Decimal;

  /** Short Threshold to Begin Hedging Toward Target */
  ShortPositionLimit: JSON_Decimal;

  /** Hedge Order Target Account ID - Should close the position */
  TargetAccountID: number;

  /** Selected Execution Strategy for Hedge Order Execution */
  HedgeStrategy: JSON_Strategy;

  /** AggregationID to send on the Hedge Order for this Rule */
  HedgeAggregation: JSON_Aggregation;

  /** Hedge Security to override computed HedgeSecurity */
  HedgeSymbol: JSON_Security;

  /** CrossAssetRiskGroup monitored in Group mode; 0 in SingleAsset mode */
  CrossAssetRiskGroup: JSON_CrossAssetRiskGroup;
}

/** Tracks the current status of a hedge control */
export interface IHedgePositionStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Identifier for the Hedge Rule that created this Hedge Control */
  HedgeRuleID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Revision of Position Status */
  Revision: number;

  /** Account ID for the tracked hedge position */
  AccountID: number;

  /** Asset ID for the tracked hedge position */
  Asset: string;

  /** Asset for which the hedger compares the threshold positions */
  TargetAsset: string;

  /** Target Position to Maintain */
  TargetPosition: JSON_Decimal;

  /** Current Computed Asset Position (native asset) */
  CurrentAssetPosition: JSON_Decimal;

  /** Current Computed Position (converted asset) */
  CurrentPosition: JSON_Decimal;

  /** Long Threshold to Begin Hedging Toward Target */
  LongPositionLimit: JSON_Decimal;

  /** Last Long Asset Delta Since the Previous Status */
  LastLongAssetPositionDelta: JSON_Decimal;

  /** Last Long Position Delta (converted asset) Since the Previous Status */
  LastLongPositionDelta: JSON_Decimal;

  /** Reason for Last Long Position Delta */
  LongDeltaAttribution: HedgeDeltaAttributionEnum;

  /** Short Threshold to Begin Hedging Toward Target */
  ShortPositionLimit: JSON_Decimal;

  /** Last Short Asset Delta Since the Previous Status */
  LastShortAssetPositionDelta: JSON_Decimal;

  /** Last Short Position Delta (converted asset) Since the Previous Status */
  LastShortPositionDelta: JSON_Decimal;

  /** Reason for Last Short Position Delta */
  ShortDeltaAttribution: HedgeDeltaAttributionEnum;

  /** Status for this Hedge Control */
  HedgeControlStatus: HedgeControlStatusEnum;

  /** Last Decision Made for this Hedge Control */
  HedgeDecision: HedgeDecisionEnum;

  /** Last Action Taken by this Hedge Control */
  HedgeAction: HedgeActionEnum;

  /** Active Hedge Order ID if it Exists */
  HedgeOrderID: string;

  /** Hedge Security submitted on Hedge Order */
  HedgeSymbol: JSON_Security;

  /** Classification of HedgeControl associated with this report */
  HedgeControlType: HedgeControlTypeEnum;

  /** Unique identifier for the hedge control */
  HedgeControlID: JSON_Int64ID;

  /** Error Code for Hedge Control */
  HedgeControlErrorCode: HedgeControlErrorCodeEnum;

  /** Hedge Order Target Account ID - Copied from the Rule and used for Filtering in the sub */
  TargetAccountID: number;

  /** Status of the unconfirmed position monitor for this account and asset */
  UnconfirmedPositionStatus: UnconfirmedPositionStatusEnum;

  /** Timestamp of oldest unconfirmed position for this account and asset */
  UnconfirmedPositionTime: JSON_UTCTimestamp;

  /** CrossAssetRiskGroup for group controls; 0 for single-asset controls */
  CrossAssetRiskGroup: JSON_CrossAssetRiskGroup;

  /** JSON Data representation of Hedge Decision Data */
  HedgeDecisionData: unknown;

  /** HedgeControl Error Text */
  Text: string;
}

/** Snapshot state of a given Hedge Control */
export interface IHedgeControl {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Identifier for the Hedge Rule that created this Hedge Control */
  HedgeRuleID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Revision of Position Status */
  Revision: number;

  /** Account ID for the tracked hedge position */
  AccountID: number;

  /** Asset ID for the tracked hedge position */
  Asset: string;

  /** The Last Time a Hedge Decision was Applied to the Control */
  LastApplicationTime: JSON_UTCTimestamp;

  /** Unique identifier for the hedge control */
  HedgeControlID: JSON_Int64ID;

  /** OrderID of the initiating order to be hedged for order hedge controls */
  InitiatingOrderID: string;

  /** Classification of HedgeControl */
  HedgeControlType: HedgeControlTypeEnum;

  /** Current Computed Hedge Security on the Hedge Control */
  HedgeSymbol: JSON_Security;

  /** Boolean indicator whether the Hedge Security needs to be inverted */
  HedgeSecurityInverted: boolean;

  /** CrossAssetRiskGroup for group controls; 0 for single-asset controls */
  CrossAssetRiskGroup: JSON_CrossAssetRiskGroup;

  /** JSON representation of the current Hedge Rule State for this Control */
  HedgeRule: unknown;

  /** JSON representation of the Last Position Status published for this Control */
  LastPositionStatus: unknown;

  /** JSON representation of the Active Order Associated with this Control if one exists */
  ActiveOrder: unknown;

  /** JSON representation of the Active Order Associated with this Control if one exists */
  InitiatingOrder: unknown;

  /** JSON representation of the Last Order Status published for this Control when ControlType is Order */
  LastOrderStatus: unknown;

  /** JSON representation of OrderControlState */
  OrderControlState: unknown;
}

/** Snapshot message */
export interface ISnapshotMessage {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The snapshot ID this message belongs to */
  SnapshotID: number;

  /** The sequence number of this message within the snapshot */
  SequenceNumber: number;

  /** The service ID the snapshot belongs to */
  ServiceID: number;

  /** The partition ID the snapshot belongs to */
  PartitionID: number;

  /** The template ID of the message contents */
  TemplateID: number;

  /** The timestamp of the message */
  MessageTimestamp: JSON_UTCTimestamp;

  /** The message contents in JSON */
  Message: string;
}

/** Hedge status of an order */
export interface IHedgeOrderStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Revision of hedge order status */
  Revision: number;

  /** OrderID of the initiating order to be hedged */
  InitiatingOrderID: string;

  /** Status for this Hedge Control */
  HedgeControlStatus: HedgeControlStatusEnum;

  /** Last Decision Made for this Hedge Control */
  HedgeDecision: HedgeDecisionEnum;

  /** Security ID */
  HedgeSymbol: JSON_Security;

  /** Security ID */
  OrderSymbol: JSON_Security;

  /** Side */
  HedgeSide: SideEnum;

  /** Hedge strategy */
  HedgeStrategy: JSON_Strategy;

  /** OrderID of the current active hedge order */
  ActiveHedgeOrderID: string;

  /** Unhedged qty */
  UnhedgedQty: JSON_Decimal;

  /** Cum hedge qty */
  CumHedgeQty: JSON_Decimal;

  /** Cum hedge amt */
  CumHedgeAmt: JSON_Decimal;

  /** Average price paid to hedge */
  AvgHedgePx: JSON_Decimal;

  /** Average price paid to hedge fee inclusive */
  AvgHedgePxAllIn: JSON_Decimal;

  /** Total fees paid to hedge */
  CumHedgeFee: JSON_Decimal;

  /** Currency ID for fees */
  FeeCurrency: string;

  /** Currency ID for hedge quantity */
  Currency: string;

  /** Currency ID for hedge amount */
  AmountCurrency: string;

  /** Last delta we've received on a initiating trade */
  LastDelta: JSON_Decimal;

  /** Number of hedge orders sent */
  NumHedgeOrders: number;

  /** Hedging params */
  HedgeStrategyParams: IStrategyParameters;

  /** JSON Data representation of Hedge Decision Data */
  HedgeDecisionData: unknown;

  /** Provides additional info about the hedge order status e.g in case there is an error */
  Text: string;
}

/** Snapshot ID message */
export interface ISnapshotID {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The service ID the snapshot belongs to */
  ServiceID: number;

  /** The partition ID the snapshot belongs to */
  PartitionID: number;

  /** The snapshot ID */
  SnapshotID: number;

  /** The name of the process that wrote this snapshot. FOR READABILITY PURPOSES ONLY. DO NOT USE IN CODE. */
  Process: string;
}

/** Max snapshot ID */
export interface IMaxSnapshotID {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** DB table key. Always 0. */
  Key: number;

  /** The current maximum snapshot ID */
  MaxSnapshotID: number;
}

/** Hedger status */
export interface IHedgerStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** DEPRECATED because it was not deterministic */
  SessionID: JSON_Int64ID;

  /** Order hedging status */
  OrderHedgingStatus: HedgingStatusEnum;

  /** Position hedging status */
  PositionHedgingStatus: HedgingStatusEnum;
}

/** order annotations that complement OMSExecutionReport4203 */
export interface IOrderAnnotation {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Order ID */
  OrderID: string;

  /** Revision of order annotation */
  Revision: number;

  /** Most recent order execution report when annotation is modified */
  ExecutionReportRevision: number;

  /** Order status when it's completed */
  ArchivedStatus: ArchivedStatusEnum;

  /** User ID */
  User: JSON_User;
}

/** Request to send out a command subject to approval */
export interface ICommandApprovalRequest {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Generated request ID by requestor to be referenced in responses */
  RequestID: JSON_Int64ID;

  /** EntryType */
  EntryType: SnapshotBlockEntryTypeEnum;
}

/** Response to a command subject to aproval request */
export interface ICommandApprovalResponse {
  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Request ID in response to */
  RequestID: JSON_Int64ID;

  /** Decision for approval request */
  Decision: ApprovalDecisionEnum;

  /** Reason for denied approval decision */
  DeniedReason: ApprovalDecisionDeniedReasonEnum;

  /** Approval denied error string */
  Text: string;
}

/** Tracks the current status of a service within the org */
export interface IServiceStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique identifier for the service */
  ServiceID: number;

  /** Current Status of the service */
  ServiceStatus: ServiceStatusEnum;
}

/** User supplied command to take action at the hedger */
export interface IHedgeCommand {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Identifier for the Hedge Rule that created this Hedge Control */
  HedgeRuleID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Unique client supplied identifier for this hedge command */
  HedgeCommandID: string;

  /** Account ID for the tracked hedge position */
  AccountID: number;

  /** Asset ID for the tracked hedge position */
  Asset: string;

  /** Command to take action on at this scope */
  Command: HedgeCommandEnum;

  /** Classification of HedgeControl */
  HedgeControlType: HedgeControlTypeEnum;

  /** TradeID for UnconfirmedPosition commands */
  TradeID: string;

  /** Origin of the command */
  SourceService: JSON_ServiceIdentifier;

  /** User ID of the requester */
  User: JSON_User;

  /** CrossAssetRiskGroup targeted by this command; 0 for single-asset scope */
  CrossAssetRiskGroup: JSON_CrossAssetRiskGroup;
}

/** Response to Command for acknowledging the action taken */
export interface IHedgeCommandResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique client supplied identifier for this hedge command */
  HedgeCommandID: string;

  /** Command that this is in response to */
  Command: HedgeCommandEnum;

  /** Status of this command */
  Status: HedgeCommandStatusEnum;

  /** Optional Error Text to Report Back */
  Error: string;
}

/** Snapshot message for HedgerLedger aggregate state */
export interface IHedgerLedgerStatus {
  /** Current Status of HedgerLedger */
  HedgerLedgerStatus: HedgerLedgerStatusEnum;

  /** Identifier of in-progress Data Snapshot request */
  DataSnapshotRequestID: JSON_Int64ID;

  /** Timestamp of last recon timer */
  LastReconTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** JSON representation of an in progress Synchronization Command */
  SynchronizationRequest: unknown;

  /** List of outstanding Rollup IDs to Recalculate */
  RollupsToRecalc: IHedgerLedgerStatus5373RollupsToRecalc[];

  /** List of TradeIDs that were confirmed prior to their ExecutionReports */
  ConfirmedTradeIDs: IHedgerLedgerStatus5373ConfirmedTradeIDs[];

  /** List of in-progress Synchronization Commands */
  SynchronizationRequests: IHedgerLedgerStatus5373SynchronizationRequests[];

  /** List of SubAccountPositionUpdates accumulated during in-progress Synchronization */
  PendingSyncUpdates: IHedgerLedgerStatus5373PendingSyncUpdates[];
}

/** List of TradeIDs that were confirmed prior to their ExecutionReports */
export interface IHedgerLedgerStatus5373ConfirmedTradeIDs {
  /** TradeID for Confirmed Position without Unconfirmed Position */
  TradeID: string;
}

/** List of SubAccountPositionUpdates accumulated during in-progress Synchronization */
export interface IHedgerLedgerStatus5373PendingSyncUpdates {
  /** JSON representation of a pending SubAccountPositionUpdate */
  Update: unknown;
}

/** List of outstanding Rollup IDs to Recalculate */
export interface IHedgerLedgerStatus5373RollupsToRecalc {
  /** Rollup Account ID waiting to Recalc */
  RollupAccountID: number;
}

/** List of in-progress Synchronization Commands */
export interface IHedgerLedgerStatus5373SynchronizationRequests {
  /** JSON representation of a Synchronization Command */
  Request: unknown;
}

/** Snapshot message for HedgerLedger PositionDeltas */
export interface IHedgerLedgerPositionDelta {
  /** Account ID for the position delta */
  AccountID: number;

  /** Asset ID for the position delta */
  Asset: string;

  /** Current Short Position Delta */
  ShortPositionDelta: JSON_Decimal;

  /** Current Short Position Delta */
  LongPositionDelta: JSON_Decimal;

  /** Organization ID */
  OrgID: number;
}

/** Snapshot message for hydrating hedger ledger positionStatus and reconBreaks */
export interface IHedgerLedgerPositionStatus {
  /** Account ID hedge position status */
  AccountID: number;

  /** Asset ID hedge position status */
  Asset: string;

  /** Current Status of Position */
  Status: HedgerLedgerStatusEnum;

  /** Recon break delta if in status ReconBreak */
  ReconBreak: JSON_Decimal;

  /** Organization ID */
  OrgID: number;
}

/** Snapshot message for auto-issued commands by hedger services */
export interface IHedgerAutoCommandSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Service that created this snapshot */
  SourceService: JSON_ServiceIdentifier;

  /** Commands */
  Commands: IHedgerAutoCommandSnapshot5376Commands[];
}

/**  */
export interface IHedgerAutoCommandSnapshot5376Commands {
  /** The command ID that was issued */
  CommandID: string;

  /** Account ID from HedgeControlKey */
  AccountID: number;

  /** Asset ID from HedgeControlKey */
  Asset: string;

  /** CrossAssetRiskGroup from HedgeControlKey */
  CrossAssetRiskGroup: JSON_CrossAssetRiskGroup;
}

/** An empty message designed to ensure there are frequent-enough messages being sequenced */
export interface ITimerMessage {
  /** Interval in milliseconds timer messages are generated */
  IntervalMs: number;
}

/** Links a trading MarketAccount with a settlement MarketAccount */
export interface ITreasuryAccountLink {
  /** Internal time */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of the account this link is for. Either CounterpartyID or MarketAccountID must be set. */
  MarketAccount: JSON_MarketAccount;

  /** Currency supported by the link. */
  Currency: string;

  /** Unique ID of the transfer destination account */
  DestinationMarketAccount: JSON_MarketAccount;

  /** Unique ID of the transfer source account */
  SourceMarketAccount: JSON_MarketAccount;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Status of the account link */
  Status: MarketAccountStatusEnum;

  /** Type of the account link */
  Type: TreasuryLinkTypeEnum;

  /** Direction of the account link from the client perspective */
  Direction: TreasuryLinkDirectionEnum;

  /** ID of the counterparty for link. Either CounterpartyID or MarketAccountID must be set1. */
  Counterparty: JSON_Counterparty;

  /** Unique ID generated by Talos for this link */
  LinkID: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** ID of user who last updated this treasury account link */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Optional destination blockchain address */
  DestinationAddress: string;
}

/** Request sent by client to create a new working order */
export interface IWorkingNewOrderSingle {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the new order single request */
  User: JSON_User;

  /** Unique identifier of this request, as assigned by client */
  ClOrdID: string;

  /** Order entry time as provided by remote in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Indicates the desired nature of the response. See enum for details. */
  RequestType: WorkingOrderTypeEnum;

  /** Order submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Instruction on how to interpret OrderQty.  Member care orders may be converted to this SizeMode. */
  SizeMode: SizeModeEnum;

  /** String assigned when the order is submitted, suitable for holding external order ids */
  Group: string;

  /** Additional string information relating to the care order */
  Comments: string;

  /** JSON dictionary of additional working order information */
  Annotations: unknown;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** A list of care orders that should initially be members of this working order. */
  MemberCareOrders: IWorkingNewOrderSingle5402MemberCareOrders[];
}

/** A list of care orders that should initially be members of this working order. */
export interface IWorkingNewOrderSingle5402MemberCareOrders {
  /** Id of care order to assign to this working order. */
  OrderID: string;
}

/** Working Execution Report is an individual update on the specified OrderID */
export interface IWorkingExecutionReport {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the order referred to in this ER */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** OrderID */
  OrderID: string;

  /** Unique identifier of this request, as assigned by client */
  ClOrdID: string;

  /** Revision of the order */
  Revision: number;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** ExecID */
  ExecID: string;

  /** Side */
  Side: SideEnum;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Average price */
  AvgPx: JSON_Decimal;

  /** OMSExecID */
  LastExecID: string;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last amount */
  LastAmt: JSON_Decimal;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Order submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** ID of user who issued the most recent modify/cancel order request */
  RequestUser: JSON_User;

  /** Maximum quantity available for new or amended children */
  AvailableQty: JSON_Decimal;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Last MarketID, 0 if not a fill message */
  LastMarket: JSON_Market;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Instruction on how to interpret OrderQty */
  SizeMode: SizeModeEnum;

  /** Controls when fills are allocated to member care orders */
  FillMode: FillModeEnum;

  /** Working order decision status; substate of OrdStatus */
  DecisionStatus: DecisionStatusEnum;

  /** String assigned when the order is submitted, suitable for holding external order ids */
  Group: string;

  /** Additional string information from the end users relating to the care order */
  Comments: string;

  /** JSON dictionary of additional working order information */
  Annotations: unknown;

  /** Error string after reject */
  Text: string;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** A list of markets allowed for this order's children. Empty means all are allowed. */
  Markets: IWorkingExecutionReport5403Markets[];

  /** For multileg orders, aggregates execution state per leg. */
  LegSummary: IWorkingExecutionReport5403LegSummary[];

  /** A list of care orders that are currently members of this working order. */
  MemberCareOrders: IWorkingExecutionReport5403MemberCareOrders[];
}

/** For multileg orders, aggregates execution state per leg. */
export interface IWorkingExecutionReport5403LegSummary {
  /** Security ID */
  Symbol: JSON_Security;

  /** Currency for the dealt currency. */
  Currency: string;

  /** Currency in which amount is specified. */
  AmountCurrency: string;

  /** Side */
  Side: SideEnum;

  /** Total remaining qty to be traded on the leg */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity traded on the leg */
  CumQty: JSON_Decimal;

  /** Average price traded on the leg */
  AvgPx: JSON_Decimal;

  /** Cumulative amount traded on the leg */
  CumAmt: JSON_Decimal;

  /** Last price (may not be set) */
  LastPx: JSON_Decimal;

  /** Last qty (may not be set) */
  LastQty: JSON_Decimal;

  /** Last amount traded on the leg (may not be set) */
  LastAmt: JSON_Decimal;

  /** Order quantity */
  OrderQty: JSON_Decimal;
}

/** A list of markets allowed for this order's children. Empty means all are allowed. */
export interface IWorkingExecutionReport5403Markets {
  /** Market ID */
  Market: JSON_Market;
}

/** A list of care orders that are currently members of this working order. */
export interface IWorkingExecutionReport5403MemberCareOrders {
  /** ID of care order assigned to this working order. */
  OrderID: string;
}

/** Request sent by client to change the parameters of an existing working order. */
export interface IWorkingOrderCancelReplaceRequest {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the replace request */
  User: JSON_User;

  /** Unique identifier of this request and resulting response as assigned by client */
  ClOrdID: string;

  /** Initial ClOrdID of the order to be replaced. */
  OrigClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Msg submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** Indicates the desired nature of the response. See enum for details. */
  RequestType: WorkingOrderTypeEnum;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** String assigned when the order is submitted, suitable for holding external order ids */
  Group: string;

  /** Additional string information relating to the care order */
  Comments: string;

  /** JSON dictionary of additional working order information */
  Annotations: unknown;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** A list of care orders that should initially be members of this working order. */
  MemberCareOrders: IWorkingOrderCancelReplaceRequest5404MemberCareOrders[];
}

/** A list of care orders that should initially be members of this working order. */
export interface IWorkingOrderCancelReplaceRequest5404MemberCareOrders {
  /** Id of care order to assign to this working order. */
  OrderID: string;
}

/** Request sent by client to cancel all of the leaves quantity of an existing working order */
export interface IWorkingOrderCancelRequest {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the cancel request */
  User: JSON_User;

  /** Unique identifier of this cancel request as assigned by client */
  ClOrdID: string;

  /** Initial ClOrdID of the order to be canceled */
  OrigClOrdID: string;

  /** OrderID */
  OrderID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Msg submission time published internally on wire in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;
}

/** Message published to client upon receipt of a working cancel request or cancel/replace request message which cannot be honored */
export interface IWorkingOrderCancelReject {
  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Indicates the user that created the cancel/replace request */
  User: JSON_User;

  /** OrderID */
  OrderID: string;

  /** Unique identifier of replacement order as assigned by client */
  ClOrdID: string;

  /** Initial ClOrdID of the order to be canceled or replaced */
  OrigClOrdID: string;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Identifies the type of request that a Cancel Reject is in response to */
  CxlRejResponseTo: CxlRejResponseToEnum;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Text */
  Text: string;
}

/** Wrapper for a WorkingExecutionReport used in request-response flows (e.g., preview) */
export interface IWorkingExecutionReportWrapper {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Correlation key from the originating request */
  RequestID: string;

  /** The embedded WorkingExecutionReport */
  WorkingExecutionReport: IWorkingExecutionReport;
}

/** Request by a user to modify the state of an existing working order */
export interface IWorkingOrderControlRequest {
  /** Organization ID */
  OrgID: number;

  /** Internal time of message publication in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Correlation id echoed in the response */
  RequestID: JSON_Int64ID;

  /** User performing the control action */
  User: JSON_User;

  /** OrderID of the working order to control */
  OrderID: string;

  /** Expected revision of the working order; mismatch is rejected as a race */
  TargetRevision: number;

  /** Timestamp of the request in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Control action to perform */
  Action: OrderControlActionEnum;
}

/** Response to a working order control request */
export interface IWorkingOrderControlResponse {
  /** Organization ID */
  OrgID: number;

  /** Internal time when last published in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Correlation id from the originating request */
  RequestID: JSON_Int64ID;

  /** Error text if the request failed; empty on success */
  ErrorText: string;

  /** The updated WorkingExecutionReport on success */
  WorkingER: IWorkingExecutionReport;
}

/** Represents a user request against one or more LPs */
export interface IOMSQuoteRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Quote request ID specified by the client */
  QuoteReqID: string;

  /** Side */
  Side: SideEnum;

  /** Quantity */
  OrderQty: JSON_Decimal;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Parent Customer RFQ ID */
  ParentRFQID: string;

  /** Organization ID */
  OrgID: number;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** The trading protocol used for the RFQ. (optional) */
  RFQTradingProtocol: RFQTradingProtocolEnum;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Optional UUID grouping related sweep requests */
  SweepGroupID: string;

  /** The type of the parent referenced by ParentRFQID */
  ParentOrderType: ParentOrderTypeEnum;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** MarketAccountID of the market account that is the clearing venue, supplied with the quote request; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Arbitrary string assigned when the quote request is submitted */
  Group: string;

  /** quote request parameters */
  Parameters: IQuoteParameters;

  /** optional allocation request */
  Allocation: IAllocationRequest;

  /** Additional information attached to the order */
  Comments: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** negotiation parameters */
  NegotiationParameters: INegotiationParameters;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of markets to be used for this request for quote */
  Markets: IOMSQuoteRequest4400Markets[];

  /** Aggregations used for this quote */
  Aggregations: IOMSQuoteRequest4400Aggregations[];
}

/** Aggregations used for this quote */
export interface IOMSQuoteRequest4400Aggregations {
  /** Unique ID of the aggregation */
  Aggregation: JSON_Aggregation;

  /** Leg Index in Legs array */
  LegIndex: number;

  /** Security ID override for the leg (0 = use default routing) */
  Symbol: JSON_Security;

  /** Parent security ID for the synthetic leg market security */
  ParentSymbol: JSON_Security;
}

/** Number of markets to be used for this request for quote */
export interface IOMSQuoteRequest4400Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** Summarizes quotes for a single request across one or more LPs */
export interface IOMSQuote {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Quote request ID */
  RFQID: string;

  /** Quote request ID specified by the client */
  QuoteReqID: string;

  /** Quote status */
  QuoteStatus: QuoteStatusEnum;

  /** Quote OMS ID */
  QuoteID: string;

  /** Quote request reject reason */
  QuoteRequestRejectReason: OrdRejReasonEnum;

  /** Quote Request Submission Time in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** Quantity */
  OrderQty: JSON_Decimal;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  FirstTransactTime: JSON_UTCTimestamp;

  /** Internal timestamp at which the rfq will end - expressed in nanoseconds since Unix epoch. May be not set for RFQ with no end timestamp (infinitive) */
  EndTime: JSON_UTCTimestamp;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Quote request side */
  Side: SideEnum;

  /** Traded price */
  TradedPx: JSON_Decimal;

  /** Traded quantity */
  TradedQty: JSON_Decimal;

  /** Traded amount in opposite currency */
  TradedAmt: JSON_Decimal;

  /** Traded side */
  TradedSide: SideEnum;

  /** Parent Customer RFQ ID */
  ParentRFQID: string;

  /** External time, either client provided request time or latest dealer response time, in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Bitmap of message characteristics */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** Order routing status */
  DecisionStatus: DecisionStatusEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** The trading protocol used for the RFQ. (optional) */
  RFQTradingProtocol: RFQTradingProtocolEnum;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Defines the rebase multiplier for the underlying TokenizedAsset at the time of the quote submission */
  RebaseMultiplier: JSON_Decimal;

  /** Optional UUID grouping related sweep requests */
  SweepGroupID: string;

  /** The type of the parent referenced by ParentRFQID */
  ParentOrderType: ParentOrderTypeEnum;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** MarketAccountID of the market account that is the clearing venue, retained from the originating quote request; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** Text */
  Text: string;

  /** Arbitrary string assigned when the quote is submitted */
  Group: string;

  /** quote request parameters */
  Parameters: IQuoteParameters;

  /** optional allocation */
  Allocation: IAllocation;

  /** Additional information attached to the order */
  Comments: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** negotiation parameters */
  NegotiationParameters: INegotiationParameters;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of markets used for this quote */
  Markets: IOMSQuote4401Markets[];

  /** Number of pricing legs used in this quote */
  Legs: IOMSQuote4401Legs[];

  /** Aggregations used for this quote */
  Aggregations: IOMSQuote4401Aggregations[];
}

/** Aggregations used for this quote */
export interface IOMSQuote4401Aggregations {
  /** Unique ID of the aggregation */
  Aggregation: JSON_Aggregation;

  /** Leg Index in Legs array */
  LegIndex: number;
}

/** Used for derivatives related metrics */
export interface IMarketsDerivativeMetrics {
  /** Type of derivative metric */
  MetricType: DerivativeMetricTypeEnum;

  /** Value of derivative metric */
  Value: JSON_Decimal;

  /** Currency ID for the given derivative metric */
  Currency: string;
}

/** Number of pricing legs used for this quote */
export interface IMarketsLegIndexes {
  /** Leg Index in Legs array */
  LegIndex: number;
}

/** Number of pricing legs used in this quote */
export interface IOMSQuote4401Legs {
  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Leg Bid Quantity */
  BidQty: JSON_Decimal;

  /** Leg Offer Quantity */
  OfferQty: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Timestamp when quote will expire */
  ValidUntilTime: JSON_UTCTimestamp;

  /** Bid price of quote (may not be set) */
  BidPx: JSON_Decimal;

  /** Bid Amount in opposite currency */
  BidAmt: JSON_Decimal;

  /** Offer price of quote (may not be set) */
  OfferPx: JSON_Decimal;

  /** Quote status */
  QuoteStatus: QuoteStatusEnum;

  /** Offer Amount in opposite currency */
  OfferAmt: JSON_Decimal;

  /** Quote request side */
  Side: SideEnum;

  /** Quote request reject reason */
  QuoteRequestRejectReason: OrdRejReasonEnum;

  /** Quote type */
  QuoteType: QuoteTypeEnum;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  FirstTransactTime: JSON_UTCTimestamp;

  /** Traded price (may not be set) */
  TradedPx: JSON_Decimal;

  /** Traded quantity (may not be set) */
  TradedQty: JSON_Decimal;

  /** Traded amount in opposite currency (may not be set) */
  TradedAmt: JSON_Decimal;

  /** Traded side (may not be set) */
  TradedSide: SideEnum;

  /** Gateway internal ID of the quote */
  QID: JSON_Int64ID;

  /** Limit bid price of quote (set only when leg is using sampling to get prices) */
  LimitBidPx: JSON_Decimal;

  /** Limit offer price of quote (set only when leg is using sampling to get prices) */
  LimitOfferPx: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount | undefined;

  /** Last update time of gateway quote receipt in number of nanoseconds since Unix epoch */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Quote negotiation status per leg for negotiated rfq */
  NegotiationStatus: NegotiationStatusEnum | undefined;

  /** Direction this leg will trade compared to the parent side (Same, Opposite) */
  Direction: LegDirectionEnum;

  /** Pricing reference in units of parent PricingMode */
  PricingReference: JSON_Decimal;

  /** Original order quantity */
  OrderQty: JSON_Decimal;

  /** Text */
  Text: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;
}

/** Number of markets used for this quote */
export interface IOMSQuote4401Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Timestamp when quote will expire */
  ValidUntilTime: JSON_UTCTimestamp;

  /** Bid price of quote (may not be set) */
  BidPx: JSON_Decimal;

  /** Bid Amount in opposite currency */
  BidAmt: JSON_Decimal;

  /** Offer price of quote (may not be set) */
  OfferPx: JSON_Decimal;

  /** Quote status */
  QuoteStatus: QuoteStatusEnum;

  /** Offer Amount in opposite currency */
  OfferAmt: JSON_Decimal;

  /** Quote request reject reason */
  QuoteRequestRejectReason: OrdRejReasonEnum;

  /** Quote type */
  QuoteType: QuoteTypeEnum;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  FirstTransactTime: JSON_UTCTimestamp;

  /** Traded price (may not be set) */
  TradedPx: JSON_Decimal;

  /** Traded quantity (may not be set) */
  TradedQty: JSON_Decimal;

  /** Traded amount in opposite currency (may not be set) */
  TradedAmt: JSON_Decimal;

  /** Traded side (may not be set) */
  TradedSide: SideEnum;

  /** Gateway internal ID of the quote */
  QID: JSON_Int64ID;

  /** Limit bid price of quote (set only when market is using sampling to get prices) */
  LimitBidPx: JSON_Decimal;

  /** Limit offer price of quote (set only when market is using sampling to get prices) */
  LimitOfferPx: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount | undefined;

  /** Last update time of gateway quote receipt in number of nanoseconds since Unix epoch */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Quote negotiation status per market for negotiated rfq */
  NegotiationStatus: NegotiationStatusEnum | undefined;

  /** Internal ID for the market request */
  RID: JSON_Int64ID;

  /** Bid quantity (set when size countering is active) */
  BidQty: JSON_Decimal;

  /** Offer quantity (set when size countering is active) */
  OfferQty: JSON_Decimal;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Text */
  Text: string;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Number of pricing legs used for this quote */
  LegIndexes: IMarketsLegIndexes[];

  /** Used for derivatives related metrics */
  DerivativeMetrics: IMarketsDerivativeMetrics[];
}

/** Represents a user request to cancel an open RFQ against one or more LPs */
export interface IOMSQuoteCancel {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** This field is deprecated and no longer used */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Quote request ID specified by the client */
  RFQID: string;

  /** Quote request ID specified by the client */
  QuoteReqID: string;

  /** Quote status */
  QuoteStatus: QuoteStatusEnum;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Contain parameters for quote request */
export interface IQuoteParameters {
  /** Spread applied both to bid and ask price like 0.01 */
  Spread: JSON_Decimal;

  /** Time to live for individual quote in millisecond */
  QuoteTTL: JSON_DurationMillis;

  /** Time to live for entire RFQ in millisecond */
  RFQTTL: JSON_DurationMillis;

  /** If price improvement happens this param indicates how much price improvement benefit goes to counterparty */
  PriceImprovementRatio: JSON_Decimal;

  /** Maximum time in millisecond for first price update. 0 means no waiting for getting all market prices */
  PricesTimeout: JSON_DurationMillis;

  /** Price leniency when deciding whether to accept a previously quoted price as a ratio of the customer price. This specifies the maximum amount of slippage that the dealer is willing to take. */
  AcceptPriceLeniency: JSON_Decimal;

  /** Time leniency to apply on top of the QuoteTTL as a duration string */
  AcceptTimeLeniency: JSON_DurationMillis;

  /** Enabling/disabling synthetic counter currency support */
  EnableSyntheticCounterCurrency: boolean;

  /** Minimum supported MarketData throttle */
  MinMarketDataThrottle: JSON_DurationMillis | undefined;

  /** Order version of PriceImprovementRatio - regular is for RFQ */
  OrderPriceImprovementRatio: JSON_Decimal;

  /** Switch to publish expected hedge prices */
  PublishExpectedHedgePrice: boolean;

  /** Flag to indicate the expected pricing mode */
  FixedPricingMode: FixedPricingModeEnum;

  /** Fixed customer bid price */
  CustomerBidPrice: JSON_Decimal;

  /** Fixed customer offer price */
  CustomerOfferPrice: JSON_Decimal;

  /** Assymetric bid spread */
  BidSpread: JSON_Decimal;

  /** Assymetric offer spread */
  OfferSpread: JSON_Decimal;

  /** Aggregation id containing list of underlying markets to use for pricing. */
  PricingAggregation: JSON_Aggregation;

  /** Ensure profits are taken in the quote currency */
  TakeProfitInQuoteCurrency: boolean;

  /** Optional hedge subaccount sets on hedge executions */
  HedgeSubAccount: JSON_SubAccount;

  /** Optional trade subaccount sets on dealer-side trades */
  TradeSubAccount: JSON_SubAccount;

  /** Controls whether customer and dealer trades are booked fill-by-fill, or only for terminal order state */
  BookSingleTrade: boolean;

  /** Sales commission to take from the trade */
  SalesCommission: JSON_Decimal;

  /** Post-trade fee to take on top of the trade */
  Fee: JSON_Decimal;

  /** How the fee will be charged from the customer */
  FeeMode: MarketFeeModeEnum;

  /** The currency the fee will be charged in */
  FeeCurrency: string;

  /** When enabled, customer fill prices exclude exchange fees from hedge orders */
  ExcludeExchangeFees: boolean;

  /** Organization ID */
  OrgID: number;

  /** Number of AllowedCrossCurrencies */
  AllowedCrossCurrencies: IQuoteParameters4403AllowedCrossCurrencies[];

  /** Number of AllowedCrossMarkets */
  AllowedCrossMarkets: IQuoteParameters4403AllowedCrossMarkets[];

  /** Explicit markets set by the Customer process to be used for this request */
  PricingMarkets: IQuoteParameters4403PricingMarkets[];
}

/** Number of AllowedCrossCurrencies */
export interface IQuoteParameters4403AllowedCrossCurrencies {
  /** Currency ID for amount */
  Currency: string;
}

/** Number of AllowedCrossMarkets */
export interface IQuoteParameters4403AllowedCrossMarkets {
  /** Market ID */
  Market: JSON_Market;
}

/** Explicit markets set by the Customer process to be used for this request */
export interface IQuoteParameters4403PricingMarkets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** Rules to define unified liquidity tokens */
export interface IUnifiedLiquidityRules {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of the rule */
  RuleID: JSON_Int64ID;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Input currency or security for the rule */
  SourceAsset: string;

  /** Market ID */
  SourceMarket: JSON_Market;

  /** Unified currency or security */
  UnifiedAsset: string;

  /** Revision */
  Revision: number;

  /** Product type */
  ProductType: ProductTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** Enable or disable this rule */
  Mode: ModeEnum;

  /** ID of user who last updated this rule */
  UpdateUser: JSON_User;

  /** Cross-instrument product type this rule should unify with */
  UnifiedProductType: ProductTypeEnum;
}

/** Matches given counterpartyID with quote parameters */
export interface IPricingRule {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Counterparty ID */
  Counterparty: JSON_Counterparty;

  /** Security ID */
  Symbol: JSON_Security;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Spread applied both to bid and ask price like 0.01 (applied if no BidSpread and OfferSpread is provided) */
  Spread: JSON_Decimal;

  /** Time to live for individual quote in millisecond */
  QuoteTTL: JSON_DurationMillis | undefined;

  /** Time to live for entire RFQ in millisecond */
  RFQTTL: JSON_DurationMillis | undefined;

  /** If price improvement happens this param indicates how much price improvement benefit goes to counterparty */
  PriceImprovementRatio: JSON_Decimal;

  /** Maximum time in millisecond for first price update. 0 means no waiting for getting all market prices */
  PricesTimeout: JSON_DurationMillis | undefined;

  /** Price leniency when deciding whether to accept a previously quoted price as a ratio of the customer price. This specifies the maximum amount of slippage that the dealer is willing to take. */
  AcceptPriceLeniency: JSON_Decimal;

  /** Time leniency to apply on top of the QuoteTTL as a duration string */
  AcceptTimeLeniency: JSON_DurationMillis | undefined;

  /** Enabling/disabling synthetic counter currency support */
  EnableSyntheticCounterCurrency: boolean;

  /** Controls if trading and market data is enabled */
  Mode: ModeEnum;

  /** Minimum supported MarketData throttle */
  MinMarketDataThrottle: JSON_DurationMillis | undefined;

  /** Order version of PriceImprovementRatio - regular is for RFQ */
  OrderPriceImprovementRatio: JSON_Decimal;

  /** Spread applied to bid price like 0.01 */
  BidSpread: JSON_Decimal;

  /** Spread applied to offer price like 0.01 */
  OfferSpread: JSON_Decimal;

  /** Aggregation id containing list of underlying markets to use for pricing. */
  PricingAggregation: JSON_Aggregation;

  /** Ensure profits are taken in the quote currency */
  TakeProfitInQuoteCurrency: boolean;

  /** User who update that revision */
  UpdateUser: JSON_User;

  /** Optional hedge subaccount sets on hedge executions */
  HedgeSubAccount: JSON_SubAccount;

  /** Optional trade subaccount sets on dealer-side trades */
  TradeSubAccount: JSON_SubAccount;

  /** Sales commission to take from the trade */
  SalesCommission: JSON_Decimal;

  /** Post-trade fee to take on top of the trade */
  Fee: JSON_Decimal;

  /** How the fee will be charged from the customer */
  FeeMode: MarketFeeModeEnum;

  /** The currency the fee will be charged in */
  FeeCurrency: string;

  /** Pricing rule type */
  Type: PricingRuleTypeEnum;

  /** Optional ID of the tier */
  Tier: JSON_PricingTier;

  /** Controls if this rule should be excluded in evaluation of effective pricing parameters. Empty means not ignore */
  Excluded: boolean;

  /** When enabled, customer fill prices exclude exchange fees from hedge orders */
  ExcludeExchangeFees: boolean;

  /** Revision of that pricing rule */
  Revision: number;

  /** Organization ID */
  OrgID: number;

  /** Number of AllowedCrossCurrencies */
  AllowedCrossCurrencies: IPricingRule4404AllowedCrossCurrencies[];

  /** Number of AllowedCrossMarkets */
  AllowedCrossMarkets: IPricingRule4404AllowedCrossMarkets[];
}

/** Number of AllowedCrossCurrencies */
export interface IPricingRule4404AllowedCrossCurrencies {
  /** Currency ID for amount */
  Currency: string;
}

/** Number of AllowedCrossMarkets */
export interface IPricingRule4404AllowedCrossMarkets {
  /** Market ID */
  Market: JSON_Market;
}

/** Unified Liquidity token */
export interface IUnifiedLiquidityToken {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Base security for unified liquidity tokens */
  Symbol: JSON_Security;

  /** List of unified liquidity tokens */
  Tokens: IUnifiedLiquidityToken8501Tokens[];
}

/** List of unified liquidity tokens */
export interface IUnifiedLiquidityToken8501Tokens {
  /** Market ID */
  Market: JSON_Market;

  /** Unified security */
  Symbol: JSON_Security;
}

/** Rules for determining how customer Orders are Executed */
export interface ICustomerOrderExecutionRule {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique Identifier Generated for CustomerOrderExecutionRule */
  RuleID: JSON_Int64ID;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Rule evaluation priority, lower value is higher priority */
  Priority: number;

  /** Counterparty Associated with Order */
  Counterparty: JSON_Counterparty;

  /** Security Associated with Order */
  Symbol: JSON_Security;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** Order Type */
  OrdType: OrdTypeEnum;

  /** Time in Force Associated with Order */
  TimeInForce: TimeInForceEnum;

  /** StrategyID Associated with Order */
  Strategy: JSON_Strategy;

  /** Lower Limit of Quantity Threshold */
  MinQuantityThreshold: JSON_Decimal;

  /** Upper Limit of Quantity Threshold */
  MaxQuantityThreshold: JSON_Decimal;

  /** Lower Limit of Notional Amount */
  MinNotionalThreshold: JSON_Decimal;

  /** Upper Limit of Notional Amount */
  MaxNotionalThreshold: JSON_Decimal;

  /** Output of Rule - Strategy to Utilize for Customer Order Execution */
  ExecutionStrategy: CustomerExecutionStrategyEnum;

  /** Revision of the Execution Rule */
  Revision: number;

  /** User who updates latest revision of Execution Rule */
  UpdateUser: JSON_User;

  /** Rule to apply when prior execution rule fails to execute */
  OnFallback: boolean;

  /** Mode of this execution rule */
  Mode: ModeEnum;

  /** Rule type defining this execution rule */
  RuleType: CustomerOrderExecutionRuleTypeEnum;

  /** Currency ID for amount */
  NotionalCurrency: string;

  /** Output of Rule - Strategy to Utilize for Customer RFQ Execution */
  RFQProtocol: RFQProtocolEnum;

  /** Product type */
  ProductType: ProductTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** UTC Start time for rule application - format HH24:MM:SS.zzzzzz */
  StartTime: string;

  /** UTC End time for rule application - format HH24:MM:SS.zzzzzz - must be present include rule that has StartTime */
  EndTime: string;
}

/** PricingTier represents tier that has name, display name and type. */
export interface IPricingTier {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of the tier */
  Tier: JSON_Int64ID;

  /** Unique name of the tier */
  Name: string;

  /** Display name for tier */
  DisplayName: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User who made an update */
  UpdateUser: JSON_User;

  /** Type of tier */
  Type: PricingRuleTypeEnum;

  /** Mode of this pricing tier */
  Mode: ModeEnum;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;
}

/** Matches given counterparty or tier with currency withdrawal fees */
export interface ICustomerCurrencyRule {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique Identifier Generated for CustomerCurrencyRule */
  RuleID: JSON_Int64ID;

  /** Rule type defining which dimension this currency rule applies to */
  RuleType: PricingRuleTypeEnum;

  /** Counterparty ID */
  Counterparty: JSON_Counterparty;

  /** Optional ID of the tier */
  Tier: JSON_PricingTier;

  /** Currency ID this rule applies to */
  Currency: string;

  /** Withdrawal fee rate as a decimal fraction */
  Fee: JSON_Decimal;

  /** Minimum withdrawal fee in the rule currency */
  MinimumFee: JSON_Decimal;

  /** Maximum withdrawal fee in the rule currency */
  MaximumFee: JSON_Decimal;

  /** Controls if this currency rule is enabled */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User who made an update */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Revision of that currency rule */
  Revision: number;
}

/** CustomerConfiguration represents various configuration for customer. */
export interface ICustomerConfiguration {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the counterparty that this configuration applies for */
  Counterparty: JSON_Counterparty;

  /** ID of the tier that resolves spread, commission and aggregation */
  AllInTier: JSON_PricingTier;

  /** ID of the tier that resolves post-trade fee parameters */
  FeeTier: JSON_PricingTier;

  /** ID of the tier that group of available customer securities */
  SymbolGroup: JSON_PricingTier;

  /** Mode of this configuration */
  Mode: ModeEnum;

  /** User who made an update */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;

  /** ID of the tier that resolves customer withdrawal fees */
  WithdrawalFeeTier: JSON_PricingTier;
}

/** Represents a QuoteRequest to a particular gateway / LP */
export interface IQuoteRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Credential ID */
  CredentialID: number;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Internal ID for this request */
  RID: JSON_Int64ID;

  /** Side */
  Side: SideEnum;

  /** Quantity */
  OrderQty: JSON_Decimal;

  /** OMS Quote request ID */
  ParentRFQID: string;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** MarketAccountID of the market account that is the clearing venue, forwarded from the originating quote request; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** negotiation parameters */
  NegotiationParameters: INegotiationParameters;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Represents a Quote from an LP */
export interface IQuote {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Credential ID */
  CredentialID: number;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Internal ID of request for quote */
  RID: JSON_Int64ID;

  /** Internal ID of the quote */
  QID: JSON_Int64ID;

  /** Quote request ID generated by the gateway to the LP */
  QuoteReqID: string;

  /** Quote type */
  QuoteType: QuoteTypeEnum;

  /** Side */
  Side: SideEnum;

  /** Quantity */
  OrderQty: JSON_Decimal;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Timestamp when quote will expire */
  ValidUntilTime: JSON_UTCTimestamp;

  /** Bid price of quote (may be not set) */
  BidPx: JSON_Decimal;

  /** Bid Amount in opposite currency */
  BidAmt: JSON_Decimal;

  /** Offer price of quote (may be not set) */
  OfferPx: JSON_Decimal;

  /** Offer Amount in opposite currency */
  OfferAmt: JSON_Decimal;

  /** Quote status */
  QuoteStatus: QuoteStatusEnum;

  /** Quote request reject reason */
  QuoteRequestRejectReason: OrdRejReasonEnum;

  /** OMS Quote request ID */
  ParentRFQID: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Quote Request Submission Time in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp | undefined;

  /** Traded side */
  TradedSide: SideEnum;

  /** Traded price */
  TradedPx: JSON_Decimal;

  /** Traded quantity */
  TradedQty: JSON_Decimal;

  /** Traded amount in opposite currency */
  TradedAmt: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Bid quantity (set when size countering is active) */
  BidQty: JSON_Decimal;

  /** Offer quantity (set when size countering is active) */
  OfferQty: JSON_Decimal;

  /** MarketAccountID of the market account that is the clearing venue, echoed from the originating quote request; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Buy QuoteID given by the venue */
  BuyQuoteID: string;

  /** Sell QuoteID given by the venue */
  SellQuoteID: string;

  /** Text */
  Text: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** negotiation parameters */
  NegotiationParameters: INegotiationParameters;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Per-leg details for multileg quotes. */
  LegSummary: IQuote4411LegSummary[];

  /** Used for derivatives related metrics */
  DerivativeMetrics: IQuote4411DerivativeMetrics[];
}

/** Used for derivatives related metrics */
export interface IQuote4411DerivativeMetrics {
  /** Type of derivative metric */
  MetricType: DerivativeMetricTypeEnum;

  /** Value of derivative metric */
  Value: JSON_Decimal;

  /** Currency ID for the given derivative metric */
  Currency: string;
}

/** Per-leg details for multileg quotes. */
export interface IQuote4411LegSummary {
  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Bid price of quote (may not be set) */
  BidPx: JSON_Decimal;

  /** Offer price of quote (may not be set) */
  OfferPx: JSON_Decimal;

  /** Leg Bid Quantity */
  BidQty: JSON_Decimal;

  /** Leg Offer Quantity */
  OfferQty: JSON_Decimal;

  /** Leg bid amount in amount currency */
  BidAmt: JSON_Decimal;

  /** Leg offer amount in amount currency */
  OfferAmt: JSON_Decimal;

  /** Direction this leg will trade compared to the parent order side (Same, Opposite) */
  Direction: LegDirectionEnum;

  /** Traded price (may not be set) */
  TradedPx: JSON_Decimal;

  /** Traded quantity (may not be set) */
  TradedQty: JSON_Decimal;

  /** Traded amount in amount currency (may not be set) */
  TradedAmt: JSON_Decimal;

  /** Traded side (may not be set) */
  TradedSide: SideEnum;

  /** Pricing reference in units of parent PricingMode (may not be set) */
  PricingReference: JSON_Decimal;

  /** Original order quantity */
  OrderQty: JSON_Decimal;

  /** Fixing details for spread to fixing */
  FixingDetails: number;
}

/** Represents a quote cancel request to particular LP */
export interface IQuoteCancel {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Credential ID */
  CredentialID: number;

  /** Internal ID of request for quote */
  RID: JSON_Int64ID;

  /** Cancel quote request entry time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** OMS Quote request ID */
  ParentRFQID: string;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Represents a Quote with multiple buckets for internally by the simulator */
export interface ISimQuote {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Quote request ID generated by the gateway to the LP */
  QuoteReqID: string;

  /** Quote type */
  QuoteType: QuoteTypeEnum;

  /** Timestamp when quote will expire */
  ValidUntilTime: JSON_UTCTimestamp;

  /** Depth type */
  DepthType: DepthTypeEnum;

  /** Number of entries in SimQuote message */
  Entries: ISimQuote4413Entries[];
}

/** Number of entries in SimQuote message */
export interface ISimQuote4413Entries {
  /** Order price */
  MDEntryPx: JSON_Decimal;

  /** Market Data entry size */
  MDEntrySize: JSON_Decimal;

  /** Market Data entry type */
  MDEntryType: MDEntryTypeEnum;

  /** Legs */
  Legs: IEntriesLegs[];
}

/**  */
export interface IEntriesLegs {
  /** Order price */
  MDEntryPx: JSON_Decimal;

  /** Market Data entry size */
  MDEntrySize: JSON_Decimal;

  /** Market Data entry type */
  MDEntryType: MDEntryTypeEnum;
}

/** Represents a cancel of a streaming quote request */
export interface IStreamingQuoteCancel {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Security ID */
  Symbol: JSON_Security;

  /** The Quote request ID we would like to cancel */
  QuoteReqID: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Represents a customer request to the dealer */
export interface ICustomerQuoteRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Quote request ID specified by the client */
  QuoteReqID: string;

  /** Side */
  Side: SideEnum;

  /** Quantity */
  OrderQty: JSON_Decimal;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** ID of the counterparty that is requesting */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Defines the customer requested incoming RFQProtocol */
  RequestedRFQProtocol: RFQProtocolEnum;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** Minimum size increment for order size countering */
  MinSizeIncrement: JSON_Decimal;

  /** MarketID of the market that is the clearing venue, supplied with the customer quote request; unset if unspecified */
  ClearingMarket: JSON_Market;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** MarketAccountID of the dealer-selected market account for the clearing venue, supplied with the customer quote request; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** Arbitrary string assigned when the customer request is submitted */
  Group: string;

  /** customer request parameters */
  Parameters: IQuoteParameters;

  /** Additional information attached to the quote */
  Comments: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** negotiation parameters */
  NegotiationParameters: INegotiationParameters;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Individual leg specifications for multileg quote requests.(Type:JSONB) */
  LegSummary: ICustomerQuoteRequest4420LegSummary[];
}

/** Individual leg specifications for multileg quote requests.(Type:JSONB) */
export interface ICustomerQuoteRequest4420LegSummary {
  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Leg Bid Quantity */
  BidQty: JSON_Decimal;

  /** Leg Offer Quantity */
  OfferQty: JSON_Decimal;

  /** Direction this leg will trade compared to the parent order side (Same, Opposite) */
  Direction: LegDirectionEnum;

  /** Original order quantity */
  OrderQty: JSON_Decimal;

  /** Leg's share of top-level OrderQty */
  SizeRatio: JSON_Decimal;
}

/** Summarizes quote updates for customer quote request */
export interface ICustomerQuote {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** Quote request ID specified by the client */
  QuoteReqID: string;

  /** Quote status */
  QuoteStatus: QuoteStatusEnum;

  /** Customer Quote ID */
  QuoteID: string;

  /** Quote request reject reason */
  QuoteRequestRejectReason: OrdRejReasonEnum;

  /** Quote Request Submission Time */
  SubmitTime: JSON_UTCTimestamp;

  /** Quantity */
  OrderQty: JSON_Decimal;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Internal timestamp at which the rfq will end, may be not set for RFQ with no end timestamp */
  EndTime: JSON_UTCTimestamp;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Quote request side */
  Side: SideEnum;

  /** Traded price */
  TradedPx: JSON_Decimal;

  /** Traded quantity */
  TradedQty: JSON_Decimal;

  /** Traded amount in opposite currency */
  TradedAmt: JSON_Decimal;

  /** Traded side */
  TradedSide: SideEnum;

  /** ID of the counterparty that request is made for */
  Counterparty: JSON_Counterparty;

  /** Bid price of quote (may not be set) */
  BidPx: JSON_Decimal;

  /** Bid amount in opposite currency */
  BidAmt: JSON_Decimal;

  /** Offer price of quote (may not be set) */
  OfferPx: JSON_Decimal;

  /** Offer amount in opposite currency */
  OfferAmt: JSON_Decimal;

  /** Timestamp till quote is valid */
  ValidUntilTime: JSON_UTCTimestamp;

  /** ReferenceQuoteID matches QuoteID from underlying OMSQuote4401 */
  ReferenceQuoteID: string;

  /** Internal Quote request reject reason */
  InternalQuoteRequestRejectReason: OrdRejReasonEnum;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Selected MarketAccount */
  MarketAccount: JSON_CustomerMarketAccount | undefined;

  /** Expected Bid Price for Hedge Order */
  ExpectedHedgeBidPx: JSON_Decimal;

  /** Expected Offer Price for Hedge Order */
  ExpectedHedgeOfferPx: JSON_Decimal;

  /** Effective Spread for Bid Side */
  EffectiveBidSpread: JSON_Decimal;

  /** Effective Spread for Offer Side */
  EffectiveOfferSpread: JSON_Decimal;

  /** Original Quote request ID */
  OrigQuoteReqID: string;

  /** Bitmap of message characteristics */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** Buy side risk approval status */
  BuySideApprovalStatus: CustomerRiskApprovalStatusEnum;

  /** Sell side risk approval status */
  SellSideApprovalStatus: CustomerRiskApprovalStatusEnum;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** Defines the customer model price negotiation protocol */
  RFQProtocol: RFQProtocolEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** An optional value that can be used to indicate to external parties a relationship between multiple messages. */
  ExternalGroup: string;

  /** Quote negotiation status for manually negotatied customer rfq */
  NegotiationStatus: NegotiationStatusEnum | undefined;

  /** Organization ID */
  OrgID: number;

  /** Defines the rebase multiplier for the underlying TokenizedAsset at the time of the quote submission */
  RebaseMultiplier: JSON_Decimal;

  /** Minimum size increment for order size countering */
  MinSizeIncrement: JSON_Decimal;

  /** Bid quantity (set when size countering is active) */
  BidQty: JSON_Decimal;

  /** Offer quantity (set when size countering is active) */
  OfferQty: JSON_Decimal;

  /** MarketAccountID of the dealer-selected market account for the clearing venue; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** MarketID of the market that is the clearing venue, retained from the originating customer quote request; unset if unspecified */
  ClearingMarket: JSON_Market;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** Quote routing status */
  DecisionStatus: DecisionStatusEnum;

  /** ExecutionStrategy for the full trade negotiation if computed on the QuoteRequest */
  ExecutionStrategy: CustomerExecutionStrategyEnum;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Text */
  Text: string;

  /** Arbitrary string assigned when the quote is submitted */
  Group: string;

  /** quote parameters */
  Parameters: IQuoteParameters;

  /** Internal reason for rejection */
  InternalText: string;

  /** Additional information attached to the quote */
  Comments: string;

  /** Market Level Errors For Internal Analytics */
  InternalMarketErrors: string;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** Additional comments supplied by or on behalf of the user and sent externally to the market. */
  ExternalComments: string;

  /** negotiation parameters */
  NegotiationParameters: INegotiationParameters;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Per-leg details for multileg quotes. */
  LegSummary: ICustomerQuote4421LegSummary[];
}

/** Per-leg details for multileg quotes. */
export interface ICustomerQuote4421LegSummary {
  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Bid price of quote (may not be set) */
  BidPx: JSON_Decimal;

  /** Offer price of quote (may not be set) */
  OfferPx: JSON_Decimal;

  /** Leg Bid Quantity */
  BidQty: JSON_Decimal;

  /** Leg Offer Quantity */
  OfferQty: JSON_Decimal;

  /** Leg bid amount in amount currency */
  BidAmt: JSON_Decimal;

  /** Leg offer amount in amount currency */
  OfferAmt: JSON_Decimal;

  /** Direction this leg will trade compared to the parent order side (Same, Opposite) */
  Direction: LegDirectionEnum;

  /** Traded price (may not be set) */
  TradedPx: JSON_Decimal;

  /** Traded quantity (may not be set) */
  TradedQty: JSON_Decimal;

  /** Traded amount in amount currency (may not be set) */
  TradedAmt: JSON_Decimal;

  /** Traded side (may not be set) */
  TradedSide: SideEnum;

  /** Pricing reference in units of parent PricingMode (may not be set) */
  PricingReference: JSON_Decimal;

  /** Leg's share of top-level OrderQty */
  SizeRatio: JSON_Decimal;

  /** Original order quantity */
  OrderQty: JSON_Decimal;

  /** Fixing details for spread to fixing */
  FixingDetails: number;
}

/** Represents a customer request to cancel an open Customer RFQ */
export interface ICustomerQuoteCancel {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** Quote request ID specified by the client */
  QuoteReqID: string;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ID of the counterparty that request is made for */
  Counterparty: JSON_Counterparty;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Workflow Associated with Order */
  Workflow: CustomerWorkflowEnum;

  /** If present determines the units of PricingReference */
  PricingMode: PricingModeEnum;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Provides pricing for a manual customer quote - supports top-level or leg-level pricing */
export interface ICustomerQuotePricingRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User pricing the RFQ */
  User: JSON_User;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** Current unique internal ID for the customer quote */
  QuoteID: string;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Bid price for customer quote with single security */
  BidPx: JSON_Decimal;

  /** Offer price for customer quote with single security */
  OfferPx: JSON_Decimal;

  /** Unique ID for this pricing request for correlation with response */
  RequestID: JSON_Int64ID;

  /** Action to perform - Submit (default) or Preview */
  Action: CustomerQuotePricingActionEnum;

  /** Bid quantity for customer quote for countering */
  BidQty: JSON_Decimal;

  /** Offer quantity for customer quote for countering */
  OfferQty: JSON_Decimal;

  /** MarketAccountID of the dealer-selected market account for the clearing venue; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Individual leg prices for customer quote with leg summary */
  LegPrices: ICustomerQuotePricingRequest4423LegPrices[];
}

/** Individual leg prices for customer quote with leg summary */
export interface ICustomerQuotePricingRequest4423LegPrices {
  /** Security ID for this leg */
  Symbol: JSON_Security;

  /** Bid price for this leg */
  BidPx: JSON_Decimal;

  /** Offer price for this leg */
  OfferPx: JSON_Decimal;
}

/** Response to a customer quote pricing request containing the resulting quote */
export interface ICustomerQuotePricingResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID correlating to the pricing request */
  RequestID: JSON_Int64ID;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** The resulting CustomerQuote */
  CustomerQuote: ICustomerQuote;

  /** Error text if pricing failed */
  ErrorText: string;
}

/** Cancel a specific customer view */
export interface ICancelCustomerView {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Type of cancellation */
  CustomerViewCancelType: CustomerViewCancelTypeEnum;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** ID of the counterparty that is requesting */
  Counterparty: JSON_Counterparty;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;
}

/** instruction to close open position with settlement price */
export interface IPositionCloseRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique settlement requestID */
  RequestID: string;

  /** User ID */
  User: JSON_User;

  /** AssetID */
  Asset: string;

  /** Price */
  ClosingPrice: JSON_Decimal;

  /** PriceType */
  PriceType: ClosePriceTypeEnum;

  /** Unique ID of the customer account */
  MarketAccount: JSON_MarketAccount;
}

/** A request from the Customer API for steaming markets */
export interface ICustomerMarketViewRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;

  /** Security ID for Subscription Request */
  Symbol: JSON_Security;

  /** ID of the counterparty that is requesting */
  Counterparty: JSON_Counterparty;

  /** Canonical price increment */
  PriceIncrement: JSON_Decimal;

  /** Requested Price Depth for Market View */
  Depth: number;

  /** Frequency of market data snapshot updates */
  Throttle: JSON_DurationMillis;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** User ID of Principal User */
  User: JSON_User;

  /** Enable or disable unified liquidity feature. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** Organization ID */
  OrgID: number;

  /** customer request parameters */
  PricingParameters: IQuoteParameters;

  /** Requested Price Depth for Market View */
  SizeBuckets: ICustomerMarketViewRequest4426SizeBuckets[];

  /** Requested Price Depth for Market View - Amounts */
  AmountBuckets: ICustomerMarketViewRequest4426AmountBuckets[];
}

/** Requested Price Depth for Market View - Amounts */
export interface ICustomerMarketViewRequest4426AmountBuckets {
  /** Amount Bucket */
  Bucket: JSON_Decimal;
}

/** Requested Price Depth for Market View */
export interface ICustomerMarketViewRequest4426SizeBuckets {
  /** Size Bucket */
  Bucket: JSON_Decimal;
}

/** response to position close request */
export interface IPositionCloseResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique settlement requestID */
  RequestID: string;

  /** AssetID */
  Asset: string;

  /** Status */
  Status: PositionCloseResponseStatusEnum;

  /** RealizedPnL generated by closing the position */
  RealizedPnL: JSON_Decimal;

  /** The Currency units of the RealizedPnL */
  RealizedPnLCurrency: string;

  /** Position that was closed */
  ClosedPosition: JSON_Decimal;

  /** Text */
  Text: string;
}

/** Message for delivery of Customer API MarketDataSnapshots */
export interface ICustomerMarketDataSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Optional RequestID Indicates initial Snapshot on reused view */
  ViewRequestID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** ID of the counterparty that is requesting */
  Counterparty: JSON_Counterparty;

  /** Status of customer connection to dealer liquidity */
  Status: ConnectionStatusEnum;

  /** Spread applied both to bid and ask price like 0.01 */
  Spread: JSON_Decimal;

  /** Time to live for individual quote in millisecond */
  QuoteTTL: JSON_DurationMillis | undefined;

  /** If price improvement happens this param indicates how much price improvement benefit goes to counterparty */
  PriceImprovementRatio: JSON_Decimal;

  /** Price leniency when deciding whether to accept a previously quoted price as a ratio of the customer price. This specifies the maximum amount of slippage that the dealer is willing to take. */
  AcceptPriceLeniency: JSON_Decimal;

  /** Minimum supported MarketData throttle */
  MinMarketDataThrottle: JSON_DurationMillis | undefined;

  /** Order version of PriceImprovementRatio - regular is for RFQ */
  OrderPriceImprovementRatio: JSON_Decimal;

  /** Spread applied to bid price like 0.01 */
  BidSpread: JSON_Decimal;

  /** Spread applied to offer price like 0.01 */
  OfferSpread: JSON_Decimal;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** View ID */
  ViewID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** Requested Price Depth for Market View */
  SizeBuckets: ICustomerMarketDataSnapshot4427SizeBuckets[];

  /** Bid Entries */
  Bids: ICustomerMarketDataSnapshot4427Bids[];

  /** Offer Entries */
  Offers: ICustomerMarketDataSnapshot4427Offers[];

  /** Requested Price Depth for Market View - Amounts */
  AmountBuckets: ICustomerMarketDataSnapshot4427AmountBuckets[];
}

/** Requested Price Depth for Market View - Amounts */
export interface ICustomerMarketDataSnapshot4427AmountBuckets {
  /** Amount Bucket */
  Bucket: JSON_Decimal;
}

/** Bid Entries */
export interface ICustomerMarketDataSnapshot4427Bids {
  /** Bid Price */
  Price: JSON_Decimal;

  /** Bid Size */
  Size: JSON_Decimal;

  /** Bid Amount */
  Amount: JSON_Decimal;
}

/** Offer Entries */
export interface ICustomerMarketDataSnapshot4427Offers {
  /** Offer Price */
  Price: JSON_Decimal;

  /** Offer Size */
  Size: JSON_Decimal;

  /** Offer Amount */
  Amount: JSON_Decimal;
}

/** Requested Price Depth for Market View */
export interface ICustomerMarketDataSnapshot4427SizeBuckets {
  /** Size Bucket */
  Bucket: JSON_Decimal;
}

/**  */
export interface ICustomerOrderHedgePreviewRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Unique ID for this preview request */
  RequestID: JSON_Int64ID;

  /** An enum denoting what type of preview is requested */
  PreviewType: CustomerOrderPreviewTypeEnum;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Hedge execution reports */
  HedgeExecutions: ICustomerOrderHedgePreviewRequest4428HedgeExecutions[];
}

/** Hedge execution reports */
export interface ICustomerOrderHedgePreviewRequest4428HedgeExecutions {
  /** Hedge execution reports */
  ExecutionReport: IOMSExecutionReport;
}

/**  */
export interface ICustomerOrderHedgePreview {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Unique ID for this preview request */
  RequestID: JSON_Int64ID;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** internal order reject reason */
  InternalOrdRejReason: OrdRejReasonEnum;

  /** Text */
  Text: string;

  /** Internal reason for rejection */
  InternalText: string;

  /** quote / pricing parameters */
  PricingParameters: IQuoteParameters;

  /** A preview of the hedge new order request */
  RoutedNewOrderSingle: IOMSNewOrderSingle;

  /** A preview of the hedge new order cancel replace request */
  RoutedOrderCancelReplaceRequest: IOMSOrderCancelReplaceRequest;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Customer execution reports */
  CustomerExecutions: ICustomerOrderHedgePreview4429CustomerExecutions[];
}

/** Customer execution reports */
export interface ICustomerOrderHedgePreview4429CustomerExecutions {
  /** Customer execution reports */
  ExecutionReport: ICustomerExecutionReport;
}

/** Aggregation definition */
export interface IAggregation {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique ID of the aggregation */
  Aggregation: JSON_Int64ID;

  /** Unique name of the aggregation */
  Name: string;

  /** Display name for the aggregation */
  DisplayName: string;

  /** Type of aggregation */
  AggregationType: AggregationTypeEnum;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;
}

/** Market available for an aggregation */
export interface IAggregationMarket {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique ID of the aggregation */
  Aggregation: JSON_Aggregation;

  /** Market ID */
  Market: JSON_Market;

  /** Aggregation market state */
  Mode: ModeEnum;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;
}

/** An summary containing PnL details regarding a customer order's execution */
export interface ICustomerOrderSummary {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Revision of this customer order summary */
  Revision: number;

  /** ID of the associate customer order */
  OrderID: string;

  /** ID of the associate customer RFQ */
  RFQID: string;

  /** ID of the associate customer execution report */
  ExecID: string;

  /** Side of the associated order */
  Side: SideEnum;

  /** Last action that updated the order summary */
  LastAction: CustomerOrderSummaryActionEnum;

  /** Manual dealer action on this order */
  DealerAction: OrderAdminActionEnum;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the base currency */
  Currency: string;

  /** Currency ID for the quote currency */
  AmountCurrency: string;

  /** ID of the customer's market account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** ID of the counterparty that the order is made for. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** Status of the associated order */
  OrdStatus: OrdStatusEnum;

  /** Target spread for the order */
  TargetSpread: JSON_Decimal;

  /** Order quantity requested by the customer, expressed in the base currency */
  Quantity: JSON_Decimal;

  /** Order amount requested by the customer, expressed in the quote currency */
  Amount: JSON_Decimal;

  /** Average dealer price for the order */
  AvgDealerPx: JSON_Decimal;

  /** Average dealer all-in price for the order */
  AvgDealerPxAllIn: JSON_Decimal;

  /** Cumulative dealer quantity */
  CumDealerQty: JSON_Decimal;

  /** Cumulative dealer amount */
  CumDealerAmt: JSON_Decimal;

  /** Cumulative dealer fee */
  CumDealerFee: JSON_Decimal;

  /** Currency ID for the dealer fee */
  DealerFeeCurrency: string;

  /** Average hedge price for the order */
  AvgHedgePx: JSON_Decimal;

  /** Average hedge all-in price for the order */
  AvgHedgePxAllIn: JSON_Decimal;

  /** Cumulative hedge quantity */
  CumHedgeQty: JSON_Decimal;

  /** Cumulative hedge amount */
  CumHedgeAmt: JSON_Decimal;

  /** Cumulative hedge fee */
  CumHedgeFee: JSON_Decimal;

  /** Currency ID for the hedge fee */
  HedgeFeeCurrency: string;

  /** Actual spread for the order */
  ActualSpread: JSON_Decimal;

  /** Sales commission for the order */
  SalesCommission: JSON_Decimal;

  /** Order Submission Time in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** Dealer leniency expressed in ratio */
  DealerLeniency: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Execution strategy for the order */
  ExecutionStrategy: CustomerExecutionStrategyEnum;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** Per-currency PnL details */
  PerCurrencyPnL: ICustomerOrderSummary4432PerCurrencyPnL[];

  /** Per-currency fee details */
  PerCurrencyFees: ICustomerOrderSummary4432PerCurrencyFees[];
}

/** Per-currency fee details */
export interface ICustomerOrderSummary4432PerCurrencyFees {
  /** Currency ID */
  Currency: string;

  /** Fee amount for the currency */
  Amount: JSON_Decimal;
}

/** Per-currency PnL details */
export interface ICustomerOrderSummary4432PerCurrencyPnL {
  /** Currency ID */
  Currency: string;

  /** PnL amount for the currency */
  Amount: JSON_Decimal;
}

/** Request to regenerate customer order summary */
export interface ICustomerOrderSummaryRegenRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** ID of the associate customer order */
  OrderID: string;

  /** ID of the associated customer RFQ */
  RFQID: string;

  /** ExecID */
  DealerTradeID: string;

  /** Revision of the trade */
  DealerTradeRevision: number;
}

/**  */
export interface ICustomerOrderPayPreviewRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the counterparty requesting preview */
  Counterparty: JSON_Counterparty;

  /** Customer user requesting preview */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Selected customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Unique ID for this preview request */
  RequestID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Currency ID */
  Currency: string;

  /** Side */
  Side: SideEnum;

  /** Optional equivalent currency ID */
  EquivalentCurrency: string;

  /** Strategy ID of the order strategy used */
  Strategy: JSON_Strategy;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;
}

/**  */
export interface ICustomerOrderPayPreview {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the counterparty requesting preview */
  Counterparty: JSON_Counterparty;

  /** Customer user requesting preview */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Selected customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Unique ID for this preview request */
  RequestID: JSON_Int64ID;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Currency ID */
  Currency: string;

  /** Amount */
  Amount: JSON_Decimal;

  /** Amount currency ID */
  AmountCurrency: string;

  /** Estimated fee */
  Fee: JSON_Decimal;

  /** Fee currency ID */
  FeeCurrency: string;

  /** Estimated total expressed in equivalent currency */
  EstimatedTotal: JSON_Decimal;

  /** Optional equivalent currency ID */
  EquivalentCurrency: string;

  /** Security ID */
  Symbol: JSON_Security;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Side */
  Side: SideEnum;

  /** Returns true if order is likely to be rejected wrt balances */
  BalanceExceeding: boolean;

  /** Status of the pay preview */
  Status: CustomerOrderPayPreviewStatusEnum;

  /** Indication of whether the order quantity is post-trade fee aware, aka inclusive of the post-trade fees charged by the dealer */
  IsFeeAware: boolean;

  /** Type of exposure required to the trade the selected symbol */
  RequiredExposureType: ExposureTypeEnum;

  /** Required exposure to trade */
  RequiredExposure: JSON_Decimal;

  /** Required exposure currency ID */
  RequiredExposureCurrency: string;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;
}

/** Heartbeat message to be used in accordance with the sequencer */
export interface IHeartbeatMessage {
  /** Unique identifier for a service */
  ServiceID: number;

  /** The service's partition ID */
  PartitionID: number;
}

/** Details of settlement for an event, e.g., trade */
export interface ILPSettlementReport {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** Timestamp when report was created */
  TransactTime: JSON_UTCTimestamp;

  /** Type of event for settlement */
  EventType: LPSettlementEventTypeEnum;

  /** ID of related event */
  EventID: string;

  /** Event (i.e., trade) side */
  EventSide: SideEnum;

  /** Event (i.e., trade) price */
  EventPrice: JSON_Decimal;

  /** TransactTime of the event to be settled */
  EventTransactTime: JSON_UTCTimestamp;

  /** Assigned SettlementBatch of this report */
  SettleBatchID: JSON_Int64ID;

  /** Status of this report */
  SettleStatus: TradeSettleStatusEnum;

  /** Revision of this report */
  Revision: number;

  /** Expected due amount (i.e., outgoing) */
  Due: JSON_Decimal;

  /** Cumulative settled due amount */
  CumSettledDue: JSON_Decimal;

  /** Asset in which Due is expressed */
  DueAsset: string;

  /** Expected proceeds amount (e.g., incoming) */
  Proceeds: JSON_Decimal;

  /** Cumulative settled proceeds amount */
  CumSettledProceeds: JSON_Decimal;

  /** Asset which Proceeds is expressed */
  ProceedsAsset: string;

  /** Action for this revision */
  LastAction: TradeSettleActionEnum;

  /** Last due amount settled */
  LastSettledDue: JSON_Decimal;

  /** Last proceeds amount settled */
  LastSettledProceeds: JSON_Decimal;

  /** Source for last settled amount */
  LastSettledSource: TradeSettleSourceEnum;

  /** Source ID as OID or [36]byte */
  LastSourceID: string;

  /** End of the TradeDate on which this event was executed */
  TradeDateEOD: JSON_UTCTimestamp;

  /** Timestamp when the event needs to be settled. */
  SettleDeadline: JSON_UTCTimestamp;

  /** Timestamp when the event was fully settled. */
  SettleCompletion: JSON_UTCTimestamp;

  /** Counterparty from the Event */
  Counterparty: JSON_Counterparty;

  /** MarketAccount from the Event */
  MarketAccount: JSON_MarketAccount;

  /** Optional SubaccountID */
  SubAccount: JSON_SubAccount;

  /** ID of the last updating user */
  UpdateUser: JSON_User;

  /** External event ID, e.g., MarketTradeID */
  EventExternalID: string;

  /** Granular transaction type for this settlement event */
  TransactionType: TransactionControlTypeEnum;

  /** ID of the order/care order/deal that gave rise to this event */
  ParentEventID: string;

  /** Type of the entity referenced by ParentEventID */
  ParentEventType: SettlementParentEventTypeEnum;

  /** Type of the MarketAccount at the time this report was generated */
  MarketAccountType: MarketAccountTypeEnum;

  /** Type of the Counterparty at the time this report was generated */
  CounterpartyType: CounterpartyTypeEnum;

  /** Optional Allocation */
  Allocation: IAllocation;

  /** Initial fundings of due / proceeds (for event) */
  InitialProceeds: unknown;
}

/** A batch of events that need to be settled */
export interface ILPSettlementBatch {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** Unique ID for this batch */
  BatchID: JSON_Int64ID;

  /** Initial source of this settlement batch */
  CreationSource: LPSettlementBatchSourceEnum;

  /** ID of user who initiated this batch */
  CreationUser: JSON_User;

  /** Timestamp when report was created */
  TransactTime: JSON_UTCTimestamp;

  /** Status for this batch */
  Status: LPSettlementBatchStatusEnum;

  /** Revision of this batch */
  Revision: number;

  /** Timestamp when the batch must be settled. */
  SettleDeadline: JSON_UTCTimestamp;

  /** Timestamp when the batch was fully settled. */
  SettleCompletion: JSON_UTCTimestamp;

  /** Counterparty for settlement */
  Counterparty: JSON_Counterparty;

  /** MarketAccount for settlement */
  MarketAccount: JSON_MarketAccount;

  /** Number of reports in this batch */
  ReportCount: number;

  /** Number of settlement instructions for this batch */
  InstructionCount: number;

  /** ID of user who last updated this batch */
  UpdateUser: JSON_User;

  /** Number of completed settlement instructions for this batch */
  CompletedInstructionCount: number;

  /** List of SubAccounts in this batch */
  SettlementSubAccounts: ILPSettlementBatch5501SettlementSubAccounts[];

  /** List of comments */
  Comments: ILPSettlementBatch5501Comments[];
}

/** List of comments */
export interface ILPSettlementBatch5501Comments {
  /** Comments */
  Comments: string;
}

/** List of SubAccounts in this batch */
export interface ILPSettlementBatch5501SettlementSubAccounts {
  /** SubAccountID */
  SubAccount: JSON_SubAccount;
}

/** Request to preview, create, update, etc, an lp-settlement-batch */
export interface ILPSettlementBatchRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** A unique external ID of this request, used to avoid duplicate requests */
  ClientReqID: string;

  /** System generated unique ID for this request / reponse */
  InternalReqID: JSON_Int64ID;

  /** The type of request */
  RequestType: LPSettlementBatchRequestTypeEnum;

  /** ID of user who made this request. 0 for system generateed requests */
  RequestUser: JSON_User;

  /** Currency for equivalent amounts */
  EquivalentCurrency: string;

  /** Bitmap field of eight Boolean type indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** ID of the settlement batch for updates */
  SettleBatchID: JSON_Int64ID;

  /** Target revision of the batch for updates */
  SettleBatchRevision: number;

  /** User comments for the update */
  Comments: string;

  /** List of event details for preview, create, update, etc. */
  SettleBatchRequestEvents: ILPSettlementBatchRequest5502SettleBatchRequestEvents[];
}

/** List of event details for preview, create, update, etc. */
export interface ILPSettlementBatchRequest5502SettleBatchRequestEvents {
  /** Type of the event (e.g., Trade) */
  EventType: LPSettlementEventTypeEnum;

  /** ID of the event (e.g., TradeID) */
  EventID: string;

  /** Revision of the target event */
  Revision: number;
}

/** Response to an lp-settlement-request */
export interface ILPSettlementBatchResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The unique external ID of this request, if provided */
  ClientReqID: string;

  /** The InternalReqID this is a reponse to */
  InternalReqID: JSON_Int64ID;

  /** The type of request */
  RequestType: LPSettlementBatchRequestTypeEnum;

  /** Status of the request */
  RequestStatus: LPSettlementBatchRequestStatusEnum;

  /** Bitmap field of eight Boolean type indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** The resulting settlement batch / details */
  SettleBatch: ILPSettlementBatch;

  /** Error or Reject reason */
  Text: string;

  /** List of (updated) instructions for preview, create, update requests */
  SettleBatchInstructions: ILPSettlementBatchResponse5503SettleBatchInstructions[];
}

/** List of (updated) instructions for preview, create, update requests */
export interface ILPSettlementBatchResponse5503SettleBatchInstructions {
  /** Unique identifier of the instruction */
  InstructionID: JSON_Int64ID;

  /** Direction of the instruction */
  Direction: SettlementInstructionDirectionEnum;

  /** Instruction amount, always positive */
  Amount: JSON_Decimal;

  /** Instruction asset */
  Asset: string;

  /** Instruction amount, always positive */
  EquivalentAmount: JSON_Decimal;

  /** Currency for equivalent amount */
  EquivalentCurrency: string;
}

/** LP settlement instruction */
export interface ILPSettlementInstruction {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** Unique identifier of the instruction */
  InstructionID: JSON_Int64ID;

  /** Revision of this instruction */
  Revision: number;

  /** Timestamp when report was created */
  TransactTime: JSON_UTCTimestamp;

  /** ID of the parent settlement batch */
  SettleBatchID: JSON_Int64ID;

  /** Account affected by the instruction */
  MarketAccount: JSON_MarketAccount;

  /** Counterparty affected by the instruction */
  Counterparty: JSON_Counterparty;

  /** Timestamp when the batch must be settled. */
  SettleDeadline: JSON_UTCTimestamp;

  /** Direction of settlement instruction from the client perspective */
  Direction: SettlementInstructionDirectionEnum;

  /** Settlement instruction amount */
  Amount: JSON_Decimal;

  /** Settlement instruction asset */
  Asset: string;

  /** ID of user who last updated this instruction */
  UpdateUser: JSON_User;

  /** Status of the instruction and related transactions */
  Status: LPSettlementInstructionStatusEnum;

  /** Number of reports that relate to this instruction */
  ReportCount: number;

  /** ID of the (latest) transfer associated with this instruction */
  TransferID: JSON_Int64ID;

  /** Status of the (latest) transfer associated with this instruction */
  TransferStatus: TransferStatusEnum;

  /** Timestamp when the instruction was completed. */
  CompletionTime: JSON_UTCTimestamp;

  /** Source of the completion of this instruction */
  CompletionSource: LPSettlementBatchSourceEnum;

  /** Type of the MarketAccount at the time this instruction was created */
  MarketAccountType: MarketAccountTypeEnum;

  /** Type of the Counterparty at the time this instruction was created */
  CounterpartyType: CounterpartyTypeEnum;

  /** Unrounded amount of the instruction */
  UnroundedAmount: JSON_Decimal;

  /** MarketTransferStatus of the (latest) transfer associated with this instruction */
  MarketTransferStatus: string;

  /** Error text of the (latest) transfer associated with this instruction */
  ErrorText: string;

  /** Latest transfer details */
  LatestTransferDetails: ITransfer;

  /** List of transaction hashes */
  TxHashes: ILPSettlementInstruction5504TxHashes[];

  /** List of comments */
  Comments: ILPSettlementInstruction5504Comments[];
}

/** List of comments */
export interface ILPSettlementInstruction5504Comments {
  /** Comments */
  Comments: string;
}

/** List of transaction hashes */
export interface ILPSettlementInstruction5504TxHashes {
  /** Blockchain transaction hash */
  TxHash: string;
}

/** Request change to an lp-settlement-instruction */
export interface ILPSettlementInstructionRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** A unique external ID of this request, used to avoid duplicate requests */
  ClientReqID: string;

  /** System generated unique ID for this request / reponse */
  InternalReqID: JSON_Int64ID;

  /** The type of request */
  RequestType: LPSettlementInstructionRequestTypeEnum;

  /** Unique identifier of the target batch, when referring to multiple instructions */
  SettleBatchID: JSON_Int64ID;

  /** Unique identifier of the target instruction */
  SettleInstructionID: JSON_Int64ID;

  /** ID of user who made this request. 0 for system generateed requests */
  RequestUser: JSON_User;

  /** Source market account for the requested transfer */
  TransferFromMarketAccount: JSON_MarketAccount;

  /** Destination market account for the requested transfer */
  TransferToMarketAccount: JSON_MarketAccount;

  /** Optional transfer currency override */
  TransferCurrency: string;

  /** Options for requested transfer */
  TransferOptions: Record<TransferOptionsEnum, boolean>;

  /** Transfer amount override */
  TransferAmount: JSON_Decimal;

  /** External transaction hash / ID */
  TxHash: string;

  /** User comments for the update */
  Comments: string;
}

/** Response to an lp-settlement-instruction request */
export interface ILPSettlementInstructionResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** The unique external ID of this request, if provided */
  ClientReqID: string;

  /** System generated unique ID for this request / reponse */
  InternalReqID: JSON_Int64ID;

  /** Status of the request */
  RequestStatus: LPSettlementInstructionRequestStatusEnum;

  /** Error or Reject reason */
  Text: string;
}

/** Post-trade clearing/settlement lifecycle of a Talos trade at an external clearing venue, e.g. a Kalshi block trade */
export interface IVenueClearingReport {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** MarketAccount whose credential this report was submitted under */
  MarketAccount: JSON_MarketAccount;

  /** Talos-internal unique ID for this clearing report */
  ClearingReportID: string;

  /** FK to OMSTradeCapture.TradeID, the Talos trade this report covers */
  TradeID: string;

  /** Denormalized from the trade; supports lookups without joining through OMSTradeCapture */
  RFQID: string;

  /** OMSTradeCapture4211.MarketID of the trade being cleared - identifies the external clearing venue */
  ClearingVenueMarket: JSON_Market;

  /** BlockTrade or DropCopy */
  SubmissionType: VenueClearingSubmissionTypeEnum;

  /** Clearing lifecycle state */
  Status: VenueClearingStatusEnum;

  /** Proposal/submission ID assigned by the venue, e.g. Kalshi's block_trade_proposal_id */
  VenueSubmissionID: string;

  /** Venue fill/trade ID assigned on clearing confirmation */
  VenueFillID: string;

  /** Which side this instance played for the submission */
  SubmittingParty: VenueClearingSubmittingPartyEnum;

  /** Venue user ID of the buyer */
  VenueBuyerID: string;

  /** Venue user ID of the seller */
  VenueSellerID: string;

  /** Price in the venue's native units, e.g. Kalshi price_centi_cents */
  VenuePrice: number;

  /** Quantity in the venue's native units, e.g. Kalshi centicount */
  VenueQuantity: number;

  /** Timestamp when the proposal was submitted to the venue */
  CreatedAt: JSON_UTCTimestamp;

  /** Timestamp when venue confirmed clearing; zero until Status=Cleared */
  ClearedAt: JSON_UTCTimestamp;

  /** Venue error code if Status=Error or Rejected */
  ErrorCode: string;

  /** Revision of this report */
  Revision: number;

  /** Our own side's order_id from the accepted block trade proposal (buyer_order_id or seller_order_id, whichever matches our own kalshi_user_id) - used to filter GET /portfolio/fills for fill detection */
  VenueOrderID: string;

  /** Security ID of the trade being cleared */
  Symbol: JSON_Security;

  /** Side of the trade being cleared, from Talos's perspective */
  Side: SideEnum;

  /** OMSTradeCapture4211.TransactTime of the trade being cleared - used by the maker flow to reject a matched venue proposal created before our own trade happened */
  TradeTransactTime: JSON_UTCTimestamp;

  /** OMSTradeCapture4211.MarketAccountID of the trade being cleared - the counterparty's own MarketAccount, used to look up its venue-specific credential fields; unset if the trade has none */
  CounterpartyMarketAccount: JSON_MarketAccount;

  /** Raw JSON payload from the venue's fill/confirmation API */
  VenueFillPayload: unknown;

  /** Human-readable error detail for ops/alerting */
  ErrorMessage: string;
}

/** Admin request to retry a VenueClearingReport5507 stuck in Error status, moving it to Retrying so the gateway reconciles it against the venue before resuming. Carried over the same orderbook RPC request/response channel as OrderBookAdminRequest4295, dispatched by concrete message type rather than an Action field */
export interface IVenueClearingAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** MarketAccount to retry Error reports for */
  MarketAccount: JSON_MarketAccount;

  /** Retry only the report for this TradeID */
  TradeID: string;

  /** Retry only the report with this ClearingReportID */
  ClearingReportID: string;
}

/** An Account that contains some balances on a given Market */
export interface IMarketAccount {
  /** Unique ID of the account */
  MarketAccountID: number;

  /** Unique ID that market assigns to this account. Unique only within the market */
  SourceAccountID: string;

  /** ID of the market this account belongs to. */
  Market: JSON_Market;

  /** Credential associated with this account. 0 if this is an external account */
  CredentialID: number;

  /** ID of the counterparty that owns this account. For client owned accounts this is 0 */
  Counterparty: JSON_Counterparty;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Type of ownership defined for the market account */
  Ownership: MarketAccountOwnershipEnum;

  /** Status of the market account */
  Status: MarketAccountStatusEnum;

  /** Type of the market account */
  Type: MarketAccountTypeEnum;

  /** Exposure mode to use for the market account */
  ExposureMode: ExposureModeEnum;

  /** Capabilities */
  Capabilities: Record<MarketAccountCapabilitiesEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;

  /** ID of user who last updated the market account */
  UpdateUser: JSON_User;

  /** Reference data used with external accounts for various purposes */
  ReferenceData: string;

  /** Description of the account */
  Description: string;

  /** Display name for the account */
  DisplayName: string;

  /** Miscellaneous market account data */
  SourceData: string;

  /** Description of the account type */
  TypeDescription: string;

  /** Arbitrary string to group accounts */
  Group: string;

  /** Unique name of the market account */
  Name: string;
}

/** A transfer between two accounts */
export interface ITransfer {
  /** Unique ID of the transfer */
  TransferID: JSON_Int64ID;

  /** ID of the market the transfer took place on */
  Market: JSON_Market;

  /** Account ID of the owner of the transfer */
  OwnerAccountID: number;

  /** Transfer amount */
  Amount: JSON_Decimal;

  /** Currency ID for amount */
  Currency: string;

  /** Transfer status */
  Status: TransferStatusEnum;

  /** Internal timestamp */
  Timestamp: JSON_UTCTimestamp;

  /** Time at which transfer happened */
  TransactTime: JSON_UTCTimestamp;

  /** Credential associated with this transfer. */
  CredentialID: number;

  /** ClientID */
  ClientID: string;

  /** User ID */
  User: JSON_User;

  /** The time the transfer was submitted. Set by gateway if its talos transfer otherwise set to */
  SubmitTime: JSON_UTCTimestamp;

  /** Sender of transfer's MarketAccountID */
  FromMarketAccount: JSON_MarketAccount;

  /** Receiver of transfer's MarketAccountID */
  ToMarketAccount: JSON_MarketAccount;

  /** Provider published Effective Date of Transfer */
  EffectiveDate: JSON_UTCTimestamp;

  /** Optional symbol for identifying blockchain to use for transfer */
  ChainCurrencySymbol: string;

  /** Transfer fee amount */
  FeeAmount: JSON_Decimal;

  /** Currency ID for FeeAmount */
  FeeCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** Optional ID of related transaction object */
  ParentTransactionID: JSON_Int64ID;

  /** Type of transfer */
  TransferType: TransferTypeEnum;

  /** Options for transfer */
  TransferOptions: Record<TransferOptionsEnum, boolean>;

  /** Provider published transfer status */
  MarketTransferStatus: string;

  /** Unique ID assigned to transfer by the market */
  MarketTransferID: string;

  /** Owner's SourceAccountID used to identify direction of transfer */
  OwnerSourceAccountID: string;

  /** Sender of transfer's SourceAccountID */
  FromSourceAccountID: string;

  /** Receiver of transfer's SourceAccountID */
  ToSourceAccountID: string;

  /** Description of the transfer */
  Description: string;

  /** Text associated with status of transfer */
  Text: string;

  /** Reference data used with external accounts for various purposes */
  ReferenceData: string;

  /** Market provided description of the transaction */
  MarketDescription: string;

  /** Miscellaneous transaction data */
  SourceData: unknown;

  /** ExternalID of the InitiatingUser. */
  ExternalInitiatingUserInfo: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Represents a one-sided transaction, possibly connected to an existing position */
export interface IAssetTransaction {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Type */
  Type: AssetTransactionTypeEnum;

  /** Assigned OID of this transaction */
  TID: JSON_Int64ID;

  /** MarketID */
  Market: JSON_Market;

  /** CredentialID */
  CredentialID: number;

  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;

  /** AssetID */
  Asset: string;

  /** Amount */
  Amount: JSON_Decimal;

  /** A rate associated with this transaction */
  Rate: JSON_Decimal;

  /** Optional asset this transaction is associated with */
  PositionAsset: string;

  /** ID of this transaction at the market */
  TransactionID: string;

  /** Timestamp of this transaction at the market */
  TransactTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Settlement status. Encodes how this transaciton update should affect ledgers */
  SettleStatus: AssetTransactionSettlementStatusEnum;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision */
  Revision: number;

  /** Optional subAccountID */
  SubAccount: JSON_SubAccount;

  /** Status of allocation on this transaction */
  AllocationStatus: AssetTransactionAllocationStatusEnum;

  /** Source of the transaction */
  SourceType: AssetTransactionSourceTypeEnum;

  /** Optional. Price of the asset being transacted, used to calculate average cost and cost basis. Only has effect if PriceCurrencyID is also set. If at least one of them is missing then the default conversion rate to the home currency or the position asset's PnL currency will be used instead. */
  Price: JSON_Decimal;

  /** Optional. Currency of the price. Only has effect if PriceCurrencyID is also set. If at least one of them is missing then the default conversion rate to the home currency or the position asset's PnL currency will be used instead. */
  PriceCurrency: string;

  /** Source of the price */
  PriceSource: AssetTransactionPriceSourceEnum;

  /** Last action happened to the asset transaction */
  TransactionAction: AssetTransactionActionEnum;

  /** Timestamp of when this transaction was processed by the SubAccount ledger */
  AllocationTransactTime: JSON_UTCTimestamp;

  /** optional allocation */
  Allocation: IAllocation;

  /** Optional user-authored comment */
  Comment: string;

  /** Optional transaction details */
  TransactionDetails: unknown;
}

/** Contains information about the time from which we should start recovering transactions from */
export interface IAssetTransactionCheckpoint {
  /** Time of last update */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Credential associated with this transaction. */
  CredentialID: number;

  /** Optional asset ID. If not provided, we checkpoint based on credential ID */
  Asset: string;

  /** The time of the last transaction we received. */
  LastTransactionTime: JSON_UTCTimestamp;

  /** The time from which we should recover transactions from. */
  CheckpointTime: JSON_UTCTimestamp;

  /** All transactions after this time should be kept in memory. This will always be set to a time before the CheckpointTime. */
  LookbackTime: JSON_UTCTimestamp;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Optional name to be assigned to the checkpoint, defaults to empty string */
  CheckpointName: string;
}

/** AssetTransactionsSnapshot indicates the start or end of an asset transactions snapshot */
export interface IAssetTransactionsSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** EntryType */
  EntryType: SnapshotBlockEntryTypeEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;
}

/** DEPRECATED, use AssetTransactionPatchRequest4528 instead */
export interface IDEPRECATED_AssetTransactionUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The system-generated request ID used to correlate with a response. */
  RequestID: JSON_Int64ID;

  /** The client-provided request ID, used together with OrgID to deduplicate requests. */
  ClReqID: string;

  /** Organization ID, used together with ClReqID to deduplicate requests. */
  OrgID: number;

  /** Assigned OID of this transaction */
  TID: JSON_Int64ID;

  /** Revision of the transaction to update. Used to verify that the update is for the latest revision. */
  Revision: number;

  /** Optional. Sub account to allocate the transaction to. Mutually exclusive with field Allocation. If neither are provided then the transaction will be unallocated. */
  SubAccount: JSON_SubAccount;

  /** User that requests the update. */
  UpdateUser: JSON_User;

  /** Optional. If provided, set the type of the transaction. Changing the type is subject to some constraints, notably which types can be changed from, and what new types can be assigned. The implementation is the source of truth for what those constraints are. */
  Type: AssetTransactionTypeEnum;

  /** Optional. Custom allocation of this transaction. Mutually exclusive with field SubAccount ID. If neither are provided then the transaction will be unallocated. */
  Allocation: IAllocation;
}

/** Trade update request */
export interface ITradeUpdateRequest {
  /** Type of this trade update request */
  RequestType: TradeUpdateRequestTypeEnum;

  /** Client defined request ID */
  ClReqID: string;

  /** OrderID */
  OrderID: string;

  /** ExecID */
  TradeID: string;

  /** Revision of the trade or order to be updated */
  Revision: number;

  /** Revision of the customer trade to be updated */
  CustomerTradeRevision: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** Side */
  Side: SideEnum;

  /** Timestamp of the trade as provided by remote in number of nanoseconds since Unix epoch. */
  TransactTime: JSON_UTCTimestamp;

  /** Currency ID for the base currency */
  Currency: string;

  /** MarketID for this trade */
  Market: JSON_Market;

  /** Price */
  Price: JSON_Decimal;

  /** Quantity */
  Quantity: JSON_Decimal;

  /** Amount */
  Amount: JSON_Decimal;

  /** Fee */
  Fee: JSON_Decimal;

  /** Currency ID for the last fee */
  FeeCurrency: string;

  /** MarketTradeID */
  MarketTradeID: string;

  /** Currency ID for contra */
  AmountCurrency: string;

  /** Currency ID for dealt currency */
  DealtCurrency: string;

  /** Optional subaccountID */
  SubAccount: JSON_SubAccount;

  /** Talos fee */
  TalosFee: JSON_Decimal;

  /** Currency ID for the Talos fee */
  TalosFeeCurrency: string;

  /** User requesting the trade update */
  UpdateUser: JSON_User;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount | undefined;

  /** Sales commission to take from the trade */
  SalesCommission: JSON_Decimal;

  /** ID of the counterparty for this trade. 0 means trading with liquidity provider */
  Counterparty: JSON_Counterparty;

  /** Parent Customer Order ID */
  ParentOrderID: string;

  /** User ID */
  CustomerUser: JSON_CustomerUser | undefined;

  /** Optional subAccountID. If provided, it will be attached to dealer side of the trade as SubAccountID */
  RiskSubAccount: JSON_SubAccount;

  /** Organization ID */
  OrgID: number;

  /** The market order id for this trade */
  MarketOrderID: string;

  /** Arbitrary string assigned when the order is submitted */
  Group: string;

  /** Additional information attached to trade */
  Comments: string;

  /** optional allocation */
  Allocation: IAllocation;

  /** Fixing details for spread to fixing order modifications */
  FixingDetails: number;
}

/** Message for delivery of websocket MarketDataStatistics */
export interface IMarketDataStatistics {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Security for this statistic */
  Symbol: JSON_Security;

  /** Market for this statistic */
  Market: JSON_Market;

  /** Margin Funding Rate */
  FundingRate: JSON_Decimal;

  /** Margin Funding Time */
  FundingTime: JSON_UTCTimestamp;

  /** Predicted Next Funding Rate */
  PredictedNextFundingRate: JSON_Decimal;

  /** Next Funding Time */
  NextFundingTime: JSON_UTCTimestamp;

  /** Volume24h */
  Volume24h: JSON_Decimal;

  /** Turnover24h */
  Turnover24h: JSON_Decimal;

  /** Open Interest */
  OpenInterest: JSON_Decimal;

  /** Mark Price */
  MarkPrice: JSON_Decimal;

  /** Open Value */
  OpenValue: JSON_Decimal;

  /** Delta */
  Delta: JSON_Decimal;

  /** Gamma */
  Gamma: JSON_Decimal;

  /** Vega */
  Vega: JSON_Decimal;

  /** Theta */
  Theta: JSON_Decimal;

  /** Rho */
  Rho: JSON_Decimal;

  /** Mark Price IV */
  MarkPriceIV: JSON_Decimal;

  /** Best Bid IV */
  BestBidIV: JSON_Decimal;

  /** Best Bid IV */
  BestOfferIV: JSON_Decimal;

  /** Underlying Price */
  UnderlyingPrice: JSON_Decimal;

  /** Index Price */
  IndexPrice: JSON_Decimal;

  /** Last Price */
  LastPrice: JSON_Decimal;

  /** Minimum Order Price */
  MinOrderPrice: JSON_Decimal;

  /** Maximum Order Price */
  MaxOrderPrice: JSON_Decimal;

  /** Funding Rate for Long Positions */
  FundingRateLong: JSON_Decimal;

  /** Funding Rate for Short Positions */
  FundingRateShort: JSON_Decimal;

  /** Capture id */
  Capture: string;
}

/** Response message for a previous request to update an asset transaction. */
export interface IAssetTransactionUpdateResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The system-generated request ID this is a response for. */
  RequestID: JSON_Int64ID;

  /** The status code of this request. */
  Status: AssetTransactionUpdateStatusEnum;

  /** On failed requests (i.e. where Status is not OK) this field contains a user-facing error message. */
  Message: string;

  /** On successful requests this is the updated AssetTransaction. */
  AssetTransaction: IAssetTransaction;
}

/** Request message to patch (partially update) an asset transaction */
export interface IAssetTransactionPatchRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The system-generated request ID used to correlate with a response. */
  RequestID: JSON_Int64ID;

  /** The client-provided request ID, used together with OrgID to deduplicate requests. */
  ClReqID: string;

  /** Organization ID, used together with ClReqID to deduplicate requests. */
  OrgID: number;

  /** User that requests the update. */
  UpdateUser: JSON_User;

  /** TID of the transaction to update. */
  TID: JSON_Int64ID;

  /** Revision of the transaction to update. Used to verify that the update is for the latest revision */
  Revision: number;

  /** Update or Remove */
  UpdateType: UpdateActionEnum;

  /** Patch (of an AssetTransaction4521 message) describing how to update the transaction. This is the raw request body submitted to the PATCH endpoint by the client and needs to be unmarshalled using a semantic marshaller that can resolve all fields on an AssetTransaction4521. */
  Patch: unknown;
}

/** Available currency for the given market account */
export interface IMarketAccountCurrency {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the account */
  MarketAccountID: number;

  /** Currency ID for amount */
  Currency: string;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;

  /** Symbol used by this market */
  MarketSymbol: string;

  /** Symbols for this currency's supported chain currencies */
  ChainCurrencySymbols: unknown;
}

/** Schedules for funding events, etc. */
export interface ISchedule {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Organization ID */
  OrgID: number;

  /** Unique ID generated by Talos for this schedule */
  ScheduleID: JSON_Int64ID;

  /** Start time for the schedule */
  StartTime: JSON_TimeOnly;

  /** Time zone for the start time of the schedule */
  TimeZone: string;

  /** Interval between scheduled events */
  Interval: JSON_ExtendedDuration;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision of the most recent update */
  Revision: number;

  /** Name of the schedule */
  Name: string;
}

/** Funding rate configurations */
export interface IFundingRateConfiguration {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Organization ID */
  OrgID: number;

  /** Unique ID generated by Talos for this configuration */
  ConfigID: JSON_Int64ID;

  /** ID of the customer counterparty */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Security the configuration applies to */
  Symbol: JSON_Security;

  /** Funding rate for long positions */
  LongPositionFundingRate: JSON_Decimal;

  /** Funding rate for short positions */
  ShortPositionFundingRate: JSON_Decimal;

  /** Calculation mode */
  CalculationMode: FundingRateConfigurationCalculationModeEnum;

  /** Duration for the funding rate */
  RateDuration: JSON_ExtendedDuration;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision of the most recent update */
  Revision: number;
}

/** Represents a funding event */
export interface IFundingEvent {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Assigned OID of this funding event */
  EventID: JSON_Int64ID;

  /** MarketID */
  Market: JSON_Market;

  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;

  /** PositionAssetID */
  PositionAsset: string;

  /** PositionAmount */
  PositionAmount: JSON_Decimal;

  /** AvgCost of the position at the time of the funding event */
  AvgCost: JSON_Decimal;

  /** MarkPrice of the position symbol at the time of the funding event */
  MarkPrice: JSON_Decimal;

  /** UsedMargin of the position at the time of the funding event */
  UsedMargin: JSON_Decimal;

  /** Funding rate from funding configuration */
  FundingRate: JSON_Decimal;

  /** ID of the FundingRateConfiguration used to calculate the payment */
  FundingRateConfigID: JSON_Int64ID;

  /** Funding payment */
  Payment: JSON_Decimal;

  /** AssetID of the funding payment */
  PaymentAsset: string;

  /** Timestamp of the funding event based on the schedule */
  TransactTime: JSON_UTCTimestamp;

  /** ID of the funding schedule at the time of the funding event */
  ScheduleID: JSON_Int64ID;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** Organization ID */
  OrgID: number;

  /** Leverage of the position at the time of the funding event */
  Leverage: JSON_Decimal;

  /** Effective funding rate */
  EffectiveFundingRate: JSON_Decimal;
}

/** Transaction is a state for transaction state machine which is responsible for managing initiating transfers and getting approvals */
export interface ITransaction {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** External defined request ID */
  ClReqID: string;

  /** Unique ID generated by Talos for transaction */
  TransactionID: JSON_Int64ID;

  /** Optional group transaction ID indicating that this particular transaction is part of transaction group */
  GroupTransactionID: JSON_Int64ID;

  /** Revision of this transaction */
  Revision: number;

  /** An increasing sequence number for this TransactionID and revision. A new value for the same Revision indicates updated information is available without state changing. Commonly used to report errors on commands received since the last state change. Generated by Talos. */
  AmendmentCount: number;

  /** Type of transaction */
  TransactionType: TransactionTypeEnum;

  /** Sender of transfer's MarketAccountID */
  FromMarketAccount: JSON_MarketAccount;

  /** Receiver of transfer's MarketAccountID */
  ToMarketAccount: JSON_MarketAccount;

  /** On behalf account */
  OnBehalfOfAccountID: number;

  /** Transaction quantity after deducting any applicable transaction fee */
  Quantity: JSON_Decimal;

  /** Transaction currency */
  Currency: string;

  /** The ID of the user initiating the transaction. */
  InitiatorUser: JSON_User;

  /** Status of this transaction */
  Status: TransactionStatusEnum;

  /** Exec type of this transaction */
  ExecType: TransactionExecTypeEnum;

  /** Optional ID of user who performed update (state transition) for transaction */
  UpdateUser: JSON_User;

  /** Transaction reject reason */
  RejectReason: TransactionRejectReasonEnum;

  /** optional transfer ID */
  TransferID: JSON_Int64ID;

  /** ClientID of the attached transfer */
  TransferClientID: string;

  /** ID to related address record */
  AddressID: JSON_Int64ID;

  /** Optional ExternalID to use while creating ledger event */
  ExternalID: string;

  /** External defined request ID for transaction update request. Used to notify response for update request. Cleared on status change */
  UpdateClReqID: string;

  /** The service originating this transaction */
  SourceService: JSON_ServiceIdentifier;

  /** Optional ID of user who approved transaction */
  ApproveUser: JSON_User;

  /** Settlement class */
  SettlementClass: SettlementClassEnum;

  /** Optional ID of user who accepted the transaction proposal */
  AcceptUser: JSON_User;

  /** Timestamp when the transaction or transfer occurred */
  TransactTime: JSON_UTCTimestamp;

  /** Transfer currency. If set, should be an alias related to CurrencyID */
  TransferCurrency: string;

  /** Options for the transaction */
  TransactionOptions: Record<TransactionOptionsEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** Requested transaction quantity before deducting any applicable fee */
  RequestedQuantity: JSON_Decimal;

  /** RejectText */
  RejectText: string;

  /** Additional information relating to the transaction */
  Comments: string;

  /** Deprecated. Optional transaction hash provided by the custody or manually by the user */
  TxHash: string;

  /** additional routing information provided like WalletAddress, BankAddress etc. Printed if routing info provided alongside TransactionRequest is not recognized(TemplateID:4813) */
  RoutingInfo: ICustomerRoutingInfo;

  /** Additional comments supplied by external users */
  ExternalComments: string;

  /** Transaction subject contains authentication information about the entity that requested the transaction */
  Subject: ITransactionSubject;

  /** Optional list of transaction hashes */
  TxHashes: ITransaction4550TxHashes[];
}

/** Optional list of transaction hashes */
export interface ITransaction4550TxHashes {
  /** Blockchain transaction hash provided to track moving funds */
  TxHash: string;
}

/** (TenantID:Subject.OrgID) Transaction request command */
export interface ITransactionRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Customer defined request ID */
  ClReqID: string;

  /** Type of transaction */
  TransactionType: TransactionTypeEnum;

  /** Sender of transfer's MarketAccountID */
  FromMarketAccount: JSON_MarketAccount;

  /** Receiver of transfer's MarketAccountID */
  ToMarketAccount: JSON_MarketAccount;

  /** On behalf account */
  OnBehalfOfAccountID: number;

  /** Transaction quantity */
  Quantity: JSON_Decimal;

  /** Transaction currency */
  Currency: string;

  /** The ID of the user initiating the transaction. */
  User: JSON_User;

  /** Optional ExternalID to use while creating ledger event */
  ExternalID: string;

  /** optional transfer ID */
  TransferID: JSON_Int64ID;

  /** Optional ID of the transfer credential when transfer ID is provided */
  TransferCredentialID: number;

  /** Optional ID of the transfer market when transfer ID is provided */
  TransferMarket: JSON_Market;

  /** Optional group transaction ID indicating that this particular transaction shoult be part of transaction group */
  GroupTransactionID: JSON_Int64ID;

  /** Unique batch this transaction request belongs to */
  BatchID: JSON_Int64ID;

  /** Bitmap field of indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** ID to related address record */
  AddressID: JSON_Int64ID;

  /** Settlement class */
  SettlementClass: SettlementClassEnum;

  /** Timestamp when the transaction or transfer occurred */
  TransactTime: JSON_UTCTimestamp;

  /** Transfer currency. If set, should be an alias related to CurrencyID */
  TransferCurrency: string;

  /** Options for the transaction */
  TransactionOptions: Record<TransactionOptionsEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** additional routing information provided like WalletAddress, BankAddress etc. */
  RoutingInfo: ICustomerRoutingInfo;

  /** Additional information relating to the transaction */
  Comments: string;

  /** Additional comments supplied by the external user */
  ExternalComments: string;

  /** Transaction subject */
  Subject: ITransactionSubject;

  /** Optional list of transaction hashes */
  TxHashes: ITransactionRequest4551TxHashes[];
}

/** Optional list of transaction hashes */
export interface ITransactionRequest4551TxHashes {
  /** Blockchain transaction hash provided to track moving funds */
  TxHash: string;
}

/** Reference data poll time */
export interface IReferenceDataPollTime {
  /** Unique ID of this service */
  ServiceID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The database type: OrgDB=1, AvaDB=2, LoanDB=3 */
  DBType: number;

  /** (OBSOLETE) Time this database type was last polled */
  OBSOLETE_LastPollTime: JSON_UTCTimestamp;

  /** The service's partition ID */
  PartitionID: number;

  /** The tables that were polled for this database, comma-delimited */
  TableNames: string;

  /** Times each table registered in this database type was last polled */
  LastPollTimes: unknown;
}

/** (TenantID:Subject.OrgID) Transaction update request command */
export interface ITransactionUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Customer defined request ID */
  ClReqID: string;

  /** Unique ID generated by Talos for transaction */
  TransactionID: JSON_Int64ID;

  /** Type of update action */
  Action: TransactionUpdateActionEnum;

  /** The ID of the user performing that request. */
  User: JSON_User;

  /** optional transfer ID */
  TransferID: JSON_Int64ID;

  /** Sender's MarketAccountID */
  FromMarketAccount: JSON_MarketAccount;

  /** Receiver's MarketAccountID */
  ToMarketAccount: JSON_MarketAccount;

  /** Transaction quantity */
  Quantity: JSON_Decimal;

  /** Transfer currency */
  TransferCurrency: string;

  /** Options for the transaction */
  TransactionOptions: Record<TransactionOptionsEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** Transaction update subject */
  Subject: ITransactionSubject;

  /** Optional list of transaction hashes */
  TxHashes: ITransactionUpdateRequest4552TxHashes[];
}

/** Optional list of transaction hashes */
export interface ITransactionUpdateRequest4552TxHashes {
  /** Blockchain transaction hash provided to track moving funds */
  TxHash: string;
}

/** A request to initiate a transfer for a transaction */
export interface ITransactionTransferRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Customer defined request ID */
  ClReqID: string;

  /** Client-specified ID for transfer request based on this command */
  ClientID: string;

  /** ID of transaction to link generated transfer */
  TransactionID: JSON_Int64ID;

  /** Market ID */
  Market: JSON_Market;

  /** User ID */
  User: JSON_User;

  /** Credential associated with this transfer. */
  CredentialID: number;

  /** Sender of transfer's market account */
  FromMarketAccount: JSON_MarketAccount;

  /** Receiver of transfer's market account */
  ToMarketAccount: JSON_MarketAccount;

  /** Optional symbol for identifying blockchain to use for transfer */
  ChainCurrencySymbol: string;

  /** Organization ID */
  OrgID: number;

  /** Optional transfer currency override */
  TransferCurrency: string;

  /** Reference data used with external accounts for various purposes */
  ReferenceData: string;

  /** Description of the transfer */
  Description: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** A request to initiate a transfer */
export interface ITransferRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Request type */
  RequestType: TransferRequestTypeEnum;

  /** ClOrdID */
  ClientID: string;

  /** Currency ID for amount */
  Currency: string;

  /** Transfer amount */
  Amount: JSON_Decimal;

  /** Market ID */
  Market: JSON_Market;

  /** User ID */
  User: JSON_User;

  /** Credential associated with this transfer. */
  CredentialID: number;

  /** Account ID of the owner of the transfer */
  OwnerAccountID: number;

  /** Sender of transfer's MarketAccountID */
  FromMarketAccountID: number;

  /** Receiver of transfer's MarketAccountID */
  ToMarketAccountID: number;

  /** Optional symbol for identifying blockchain to use for transfer */
  ChainCurrencySymbol: string;

  /** Organization ID */
  OrgID: number;

  /** Optional ID of related transaction object */
  ParentTransactionID: JSON_Int64ID;

  /** Options for transfer */
  TransferOptions: Record<TransferOptionsEnum, boolean>;

  /** Reference data used with external accounts for various purposes */
  ReferenceData: string;

  /** Description of the transfer */
  Description: string;

  /** ExternalID of the InitiatingUser. */
  ExternalInitiatingUserInfo: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** A request to update done of live transfer */
export interface ITransferUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of the transfer update request */
  RequestID: JSON_Int64ID;

  /** ID of the transfer to update */
  TransferID: JSON_Int64ID;

  /** ID of the market the transfer took place on */
  Market: JSON_Market;

  /** Credential associated with this transfer update request. */
  CredentialID: number;

  /** List of fields to update */
  Fields: ITransferUpdateRequest4581Fields[];
}

/** List of fields to update */
export interface ITransferUpdateRequest4581Fields {
  /** Key name */
  Key: string;

  /** New value */
  Value: string;
}

/** A response for transfer update request */
export interface ITransferUpdateResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of the transfer update request */
  RequestID: JSON_Int64ID;

  /** ID of the transfer to update */
  TransferID: JSON_Int64ID;

  /** Status of the transfer update */
  UpdateStatus: TransferUpdateStatusEnum;
}

/** Customer security definition */
export interface ICustomerSecurity {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Security ID */
  Symbol: JSON_Security;

  /** Canonical size increment */
  MinSizeIncrement: JSON_Decimal;

  /** Canonical price increment */
  MinPriceIncrement: JSON_Decimal;

  /** Market size increment */
  MaximumSize: JSON_Decimal;

  /** Customer security status */
  Mode: ModeEnum;

  /** Market size increment */
  MinimumSize: JSON_Decimal;

  /** Default pricing rule more for this security */
  DefaultPricingRuleMode: ModeEnum;

  /** When enabled, price this symbol via the synthetic cross */
  PriceViaSyntheticCross: ModeEnum;

  /** Revision of that customer user update */
  Revision: number;

  /** User who performed an update of that entity */
  UpdateUser: JSON_User;

  /** Multileg security to map this 'native' pair to */
  UnderlyingCrossSymbol: JSON_Security;

  /** Canonical amount increment */
  MinAmtIncrement: JSON_Decimal;

  /** Enable or disable unified liquidity feature. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** Optional minimum amount */
  MinimumAmount: JSON_Decimal;

  /** Optional size increment to book the customer fills at */
  MinSizeFillIncrement: JSON_Decimal;

  /** Optional amount increment to book the customer fills at */
  MinAmtFillIncrement: JSON_Decimal;

  /** When enabled, route RFQ hedges to the UnderlyingCrossSecurityID */
  UseUnderlyingSecurityForRFQ: ModeEnum;

  /** Counterparty-level override key. 0 (null) means this row is the symbol-level default; any other value is a per-counterparty override of the symbol-level default. */
  Counterparty: JSON_Counterparty;

  /** DisplaySymbol field (Display Field) */
  DisplaySymbol: string;

  /** Description of the customer security */
  Description: string;

  /** Default list of size buckets (Display Field) */
  SizeBuckets: ICustomerSecurity4600SizeBuckets[];
}

/** Default list of size buckets (Display Field) */
export interface ICustomerSecurity4600SizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** Contains information about transfer state upon startup */
export interface ITransferCheckpoint {
  /** The last time for which we've queries for historical transfers */
  LastHistoricalTransferTime: JSON_UTCTimestamp;

  /** Credential associated with this transfer. */
  CredentialID: number;

  /** Organization ID */
  OrgID: number;
}

/** Contains information about the point time or execID from which we should start recovering trades from */
export interface ITradeCheckpoint {
  /** Time of last update */
  Timestamp: JSON_UTCTimestamp;

  /** Checkpoint Type */
  CheckpointType: CheckpointTypeEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Credential associated with this trade. */
  CredentialID: number;

  /** Optional Security ID. If not provided, we checkpoint based on credential ID */
  Symbol: JSON_Security;

  /** The time of the last trade we. Used when we use TimeBased checkpoints. */
  LastTradeTime: JSON_UTCTimestamp;

  /** The time from which we should recover trades from. Used when we use TimeBased checkpoints. */
  CheckpointTime: JSON_UTCTimestamp;

  /** All trades after this time should be kept in memory. This will always be set to a time before the CheckpointTime. Used when we use TimeBased checkpoints. */
  LookbackTime: JSON_UTCTimestamp;

  /** The last ExecID we've seen in a trade. Used when we use SequenceBased checkpoints. */
  LastTradeID: number;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;
}

/** Message for publishing market data to internal gateway */
export interface IUpdateMarketData {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Price origination timestamp */
  TransactTime: JSON_UTCTimestamp;

  /** Timestamp until the provided prices are invalid */
  ValidUntilTime: JSON_UTCTimestamp;

  /** SessionID for data action */
  SessionID: JSON_Int64ID;

  /** SessionID for market data to be reset when the session resets */
  CancelSessionID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Market for this market data update - not publicly exposed, just used for internal routing */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Credential ID */
  CredentialID: number;

  /** Organization ID */
  OrgID: number;

  /** Bid Entries */
  Bids: IUpdateMarketData6700Bids[];

  /** Offer Entries */
  Offers: IUpdateMarketData6700Offers[];
}

/** Bid Entries */
export interface IUpdateMarketData6700Bids {
  /** Bid Price */
  Price: JSON_Decimal;

  /** Bid Size */
  Size: JSON_Decimal;
}

/** Offer Entries */
export interface IUpdateMarketData6700Offers {
  /** Offer Price */
  Price: JSON_Decimal;

  /** Offer Size */
  Size: JSON_Decimal;
}

/** Messgae for publishing customer balance updates to the customer process */
export interface IUpdateCustomerBalance {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** ID of the counterparty these balances belong to */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** The Currency of the balance entry, if non-zero */
  Currency: string;

  /** Price origination timestamp */
  TransactTime: JSON_UTCTimestamp;

  /** Realtime amount including all trade executions */
  Amount: JSON_Decimal;

  /** Available amount not tied up in open orders */
  AvailableAmount: JSON_Decimal;

  /** Amount of open orders on the buy side */
  OutstandingBuy: JSON_Decimal;

  /** Amount of open orders on the sell side */
  OutstandingSell: JSON_Decimal;

  /** Pending withdrawal amount */
  PendingWithdrawal: JSON_Decimal;
}

/** A benchmark index for underlying security or basket of securities */
export interface IIndex {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Specified when source=User or on user updates. */
  UpdateUser: JSON_User;

  /** This Index's OID style ID */
  Index: JSON_Int64ID;

  /** Canonical symbol for this index */
  Name: string;

  /** Canonical symbol for this index */
  DisplayName: string;

  /** Default price increment (Display Field) */
  DefaultSpreadIncrement: JSON_Decimal;

  /** Canonical min increment for expressing the underlying price as a spread to the index */
  MinSpreadIncrement: JSON_Decimal;

  /** Display spec for spread (Display Field) */
  SpreadDisplaySpec: string;

  /** Index fixing time */
  ValidNominalIndexTime: number;

  /** Timezone definition that captures daylight savings on a given date. */
  NominalIndexTimeZone: string;

  /** The asset that the index tracks */
  Asset: string;

  /** The currency units of the index. */
  QuoteCurrency: string;

  /** The increment IndexMarks for this Index must satisfy to be applied as a fixing. */
  MinFixingIncrement: JSON_Decimal;

  /** Description of the index */
  Description: string;
}

/** Maps Indexes to the Markets that support them */
export interface IMarketIndex {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Specified when source=User or on user updates. */
  UpdateUser: JSON_User;

  /** Revision */
  Revision: number;

  /** The ID of this record's market */
  Market: JSON_Market;

  /** The ID of this record's index */
  Index: JSON_Index;

  /** Symbol used by this market */
  MarketSymbol: string;

  /** Date it was delisted */
  EndTime: JSON_UTCTimestamp;
}

/** A individual observation for an index */
export interface IIndexMark {
  /** Unique identifier of this mark entity. An IndexMarkID may have multiple revisions. */
  ID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Time of most recent update in number of nanoseconds since Unix epoch. */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Specified when updates are submitted by a user, as opposed to the system. */
  UpdateUser: JSON_User;

  /** This Index's OID style ID */
  Index: JSON_Index;

  /** The time this observation is nominally as-of in number of nanoseconds since Unix epoch. */
  NominalTime: JSON_UTCTimestamp;

  /** The index level for this observation. */
  Mark: JSON_Decimal;

  /** Where this observation was sourced from. */
  Source: IndexMarkSourceEnum;
}

/** (TenantID:OrgID)(ResourceName:PositionUpdate ResourceTag:P Key:UpdateSource,MarketAccountID,AssetID,PositionSide PrimaryKey:Generated ExtraIndexes:UpdateSource;UpdateSource,MarketAccountID;UpdateSource,AssetID,PositionSide;UpdateSource,CredentialID GoTableExtras:LastUpdateTime:time.Time) */
export interface IPositionUpdate {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Source of this position update message */
  UpdateSource: PositionUpdateSourceEnum;

  /** Type of position update message */
  UpdateType: PositionUpdateTypeEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** The asset of the position */
  Asset: string;

  /** Side of the Position */
  PositionSide: PositionSideTypeEnum;

  /** Position Amount */
  Amount: JSON_Decimal;

  /** Position average (entry) price */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** Position (forced) liquidation price */
  LiquidationPrice: JSON_Decimal;

  /** Accumulated Realized PnL (pre-fee) */
  RealizedPnL: JSON_Decimal;

  /** Unrealized PnL */
  UnrealizedPnL: JSON_Decimal;

  /** The Currency unit of PnL properties */
  PnLCurrency: string;

  /** Position update time as given by the Exchange or zero if not given by the exchange */
  TransactTime: JSON_UTCTimestamp;

  /** Unique batch update belongs to */
  BatchID: JSON_Int64ID;

  /** Bitmap field of eight Boolean type indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** First derivative of asset value with respect to underlying index price */
  Delta: JSON_Decimal;

  /** Second derivative of asset value with respect to underlying index price */
  Gamma: JSON_Decimal;

  /** First derivative of asset value with respect to underlying volatility */
  Vega: JSON_Decimal;

  /** First derivative of asset value with respect to time */
  Theta: JSON_Decimal;

  /** First derivative of asset value with respect to risk free interest rate */
  Rho: JSON_Decimal;

  /** Mark price of the instrument (derivatives only) */
  MarkPrice: JSON_Decimal;

  /** Index price of the underlying instrument (options only) */
  UnderlyingPrice: JSON_Decimal;

  /** The quote currency of the underlying instrument (options only) */
  UnderlyingQuoteCurrency: string;

  /** Expiration date/time of the security (options and futures) */
  Expiration: JSON_UTCTimestamp;

  /** Currency of the delta */
  DeltaCurrency: string;

  /** Cumulative Fees attributed to this asset */
  CumFees: JSON_Decimal;

  /** Currency of CumFees */
  FeeCurrency: string;

  /** Cumulative FundingPnL attributed to this asset */
  FundingPnL: JSON_Decimal;

  /** The Currency units of FundingPnL */
  FundingPnLCurrency: string;

  /** Unsettled amount for this position */
  UnsettledAmount: JSON_Decimal;

  /** Average cost of the UnsettledAmount */
  UnsettledAvgCost: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Maximum risk limit value for the position. Used to determine if new orders can be opened by comparing positionValue + new order value against this limit. */
  RiskLimit: JSON_Decimal;

  /** Currency of the RiskLimit value */
  RiskLimitCurrency: string;

  /** ADL (auto deleveraging) risk level for this position; indicates how likely this position is to be (fully or partially) liquidated when the ADL mechanism of the exchange is triggered */
  AutoDeleverageRiskLevel: PositionAdlRiskTypeEnum;

  /** User-configured leverage for this position (exchange-reported) */
  Leverage: JSON_Decimal;

  /** Exchange Reported Margin Mode (CrossWallet CrossAccount or Isolated) */
  MarginMode: MarginAllocationTypeEnum;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID)(ResourceName:SubAccountPositionUpdate ResourceTag:S Key:UpdateSource,SubAccountID,AssetID,PositionSide PrimaryKey:Generated ExtraIndexes:UpdateSource;UpdateSource,SubAccountID GoTableExtras:LastUpdateTime:time.Time) */
export interface ISubAccountPositionUpdate {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Source of this position update message */
  UpdateSource: PositionUpdateSourceEnum;

  /** Type of position update message */
  UpdateType: PositionUpdateTypeEnum;

  /** Unique ID of the account */
  SubAccount: JSON_SubAccount;

  /** The asset of the position */
  Asset: string;

  /** Side of the Position */
  PositionSide: PositionSideTypeEnum;

  /** Position Amount */
  Amount: JSON_Decimal;

  /** Position average (entry) price */
  AvgCost: JSON_Decimal;

  /** The Currency units of average cost */
  AvgCostCurrency: string;

  /** Accumulated Realized PnL (pre-fee) */
  RealizedPnL: JSON_Decimal;

  /** Unrealized PnL */
  UnrealizedPnL: JSON_Decimal;

  /** The Currency unit of PnL properties */
  PnLCurrency: string;

  /** Position update time as given by the Exchange or zero if not given by the exchange */
  TransactTime: JSON_UTCTimestamp;

  /** Unique batch update belongs to */
  BatchID: JSON_Int64ID;

  /** Bitmap field of eight Boolean type indicators signaling if there are more entries to follow. Only the ContinuationFlag is used. */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Amount of open orders on the buy side */
  OutstandingBuy: JSON_Decimal;

  /** Amount of open orders on the sell side */
  OutstandingSell: JSON_Decimal;

  /** Cumulative Fees attributed to this asset, in pnl-currency units */
  CumFees: JSON_Decimal;

  /** Cumulative FundingPnL attributed to this asset */
  FundingPnL: JSON_Decimal;

  /** The Currency units of FundingPnL */
  FundingPnLCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** Inflows for this subaccount + asset */
  Inflows: JSON_Decimal;

  /** Average cost of inflows */
  InflowAvgCost: JSON_Decimal;

  /** Outflows for this subaccount + asset */
  Outflows: JSON_Decimal;

  /** Average cost of outflows */
  OutflowAvgCost: JSON_Decimal;

  /** The Currency units of CumFees */
  FeeCurrency: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (ResourceName:AssetRiskValuation ResourceTag:V Key:SourceService,AssetID,RiskSide PrimaryKey:id PrimaryKeyType:int64) */
export interface IAssetRiskValuation {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this valuation / keys. Assigned by the SourceService */
  ID: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** AssetID for this vaulation */
  Asset: string;

  /** Side to which this valuation applies */
  RiskSide: PositionSideTypeEnum;

  /** Currency for unit Net/Gross values */
  UnitCurrency: string;

  /** Tenor bucket for the asset */
  Tenor: TenorBucketEnum;

  /** Current Moneyness bucket for the asset */
  Moneyness: MoneynessBucketEnum;

  /** Unitless Delta */
  Delta: JSON_Decimal;

  /** Unitless Gamma */
  Gamma: JSON_Decimal;

  /** Unitless Vega */
  Vega: JSON_Decimal;

  /** Unitless Rho */
  Rho: JSON_Decimal;

  /** Unitless Theta */
  Theta: JSON_Decimal;

  /** Unitless Vanna */
  Vanna: JSON_Decimal;

  /** Unitless Volga */
  Volga: JSON_Decimal;

  /** Home Currency Delta Net */
  UnitCurrencyDelta_Net: JSON_Decimal;

  /** Home Currency Delta Gross */
  UnitCurrencyDelta_Gross: JSON_Decimal;

  /** Home Currency Gamma Net */
  UnitCurrencyGamma_Net: JSON_Decimal;

  /** Home Currency Gamma Gross */
  UnitCurrencyGamma_Gross: JSON_Decimal;

  /** Home Currency Vega Net */
  UnitCurrencyVega_Net: JSON_Decimal;

  /** Home Currency Vega Gross */
  UnitCurrencyVega_Gross: JSON_Decimal;

  /** Home Currency Rho Net */
  UnitCurrencyRho_Net: JSON_Decimal;

  /** Home Currency Rho Gross */
  UnitCurrencyRho_Gross: JSON_Decimal;

  /** Home Currency Theta Net */
  UnitCurrencyTheta_Net: JSON_Decimal;

  /** Home Currency Theta Gross */
  UnitCurrencyTheta_Gross: JSON_Decimal;

  /** Home Currency Vanna Net */
  UnitCurrencyVanna_Net: JSON_Decimal;

  /** Home Currency Vanna Gross */
  UnitCurrencyVanna_Gross: JSON_Decimal;

  /** Home Currency Volga Net */
  UnitCurrencyVolga_Net: JSON_Decimal;

  /** Home Currency Volga Gross */
  UnitCurrencyVolga_Gross: JSON_Decimal;

  /** Computation time from the underlying data source */
  TransactTime: JSON_UTCTimestamp;

  /** Batch this valuation belongs to */
  BatchID: JSON_Int64ID;

  /** EventIndicator */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Home Currency Delta Exposure Net */
  UnitCurrencyDeltaExposure_Net: JSON_Decimal;

  /** Home Currency Delta Exposure Gross */
  UnitCurrencyDeltaExposure_Gross: JSON_Decimal;

  /** Present Value */
  PV: JSON_Decimal;

  /** Implied Volatility */
  IV: JSON_Decimal;

  /** Quoted Price */
  Price: JSON_Decimal;

  /** Home Currency Dollar Value of 01 Net */
  UnitCurrencyDV01_Net: JSON_Decimal;

  /** Home Currency Dollar Value of 01 Gross */
  UnitCurrencyDV01_Gross: JSON_Decimal;

  /** Home Currency Future Value of 01 Net */
  UnitCurrencyFV01_Net: JSON_Decimal;

  /** Home Currency Future Value of 01 Gross */
  UnitCurrencyFV01_Gross: JSON_Decimal;

  /** Dirty price (price including accrued interest) */
  DirtyPrice: JSON_Decimal;

  /** Clean price (price excluding accrued interest) */
  CleanPrice: JSON_Decimal;

  /** Accrued interest per unit */
  AccruedInterest: JSON_Decimal;

  /** Spread duration per unit */
  SpreadDuration: JSON_Decimal;

  /** Home Currency Gamma Exposure Net */
  UnitCurrencyGammaExposure_Net: JSON_Decimal;

  /** Home Currency Gamma Exposure Gross */
  UnitCurrencyGammaExposure_Gross: JSON_Decimal;

  /** Error message text */
  ErrorMessage: string;
}

/** (ResourceName:MarginPositionMetric ResourceTag:M Key:SourceService,AccountType,AccountID,AssetID,EquivalentCurrencyID PrimaryKey:id PrimaryKeyType:int64 ExtraIndexes:SourceService,AccountType) */
export interface IMarginPositionMetric {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this metric / keys. Assigned by the SourceService */
  ID: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** ID of the account. */
  AccountID: number;

  /** AssetID for this metric. Unset if it is cross-asset. */
  Asset: string;

  /** EquivalentCurrencyID */
  EquivalentCurrency: string;

  /** NetLiquidationValue */
  NetLiquidationValue: JSON_Decimal;

  /** DistanceToLiquidation */
  DistanceToLiquidation: JSON_Decimal;

  /** DistanceToLiquidationCurrencyID */
  DistanceToLiquidationCurrency: string;

  /** DistanceToLiquidationPct */
  DistanceToLiquidationPct: JSON_Decimal;

  /** LeverageRatio */
  LeverageRatio: JSON_Decimal;

  /** EquityContribution_Equity */
  EquityContribution_Equity: JSON_Decimal;

  /** EquityContribution_Equity_CurrencyID */
  EquityContribution_Equity_Currency: string;

  /** EquityContribution_Equity_Equivalent */
  EquityContribution_Equity_Equivalent: JSON_Decimal;

  /** EquityContribution_Balance */
  EquityContribution_Balance: JSON_Decimal;

  /** EquityContribution_Balance_CurrencyID */
  EquityContribution_Balance_Currency: string;

  /** EquityContribution_Balance_Equivalent */
  EquityContribution_Balance_Equivalent: JSON_Decimal;

  /** EquityContribution_Pnl */
  EquityContribution_Pnl: JSON_Decimal;

  /** EquityContribution_Pnl_CurrencyID */
  EquityContribution_Pnl_Currency: string;

  /** EquityContribution_Pnl_Equivalent */
  EquityContribution_Pnl_Equivalent: JSON_Decimal;

  /** Computation time from the underlying data source */
  TransactTime: JSON_UTCTimestamp;

  /** Batch this valuation belongs to */
  BatchID: JSON_Int64ID;

  /** EventIndicator */
  EventIndicator: Record<EventIndicatorEnum, boolean>;
}

/** (ResourceName:MarginPortfolioMetric ResourceTag:F Key:SourceService,AccountType,AccountID,EquivalentCurrencyID PrimaryKey:id PrimaryKeyType:int64 ExtraIndexes:SourceService,AccountType) */
export interface IMarginPortfolioMetric {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this metric / keys. Assigned by the SourceService */
  ID: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** The originating service */
  SourceService: JSON_ServiceIdentifier;

  /** The type of account that AccountID references */
  AccountType: MarginPortfolioTypeEnum;

  /** ID of the account. */
  AccountID: number;

  /** EquivalentCurrencyID */
  EquivalentCurrency: string;

  /** InitialMargin */
  InitialMargin: JSON_Decimal;

  /** NetLiquidationValue */
  NetLiquidationValue: JSON_Decimal;

  /** NetDeltaExposure */
  NetDeltaExposure: JSON_Decimal;

  /** GrossDeltaExposure */
  GrossDeltaExposure: JSON_Decimal;

  /** EquityMarginRatio */
  EquityMarginRatio: JSON_Decimal;

  /** NetLeverageRatio */
  NetLeverageRatio: JSON_Decimal;

  /** GrossLeverageRatio */
  GrossLeverageRatio: JSON_Decimal;

  /** PositionsAtRisk */
  PositionsAtRisk: number;

  /** PositionValueAtRisk */
  PositionValueAtRisk: JSON_Decimal;

  /** RiskScore */
  RiskScore: JSON_Decimal;

  /** EquityContribution_Equity */
  EquityContribution_Equity: JSON_Decimal;

  /** EquityContribution_Equity_CurrencyID */
  EquityContribution_Equity_Currency: string;

  /** EquityContribution_Equity_Equivalent */
  EquityContribution_Equity_Equivalent: JSON_Decimal;

  /** EquityContribution_Balance */
  EquityContribution_Balance: JSON_Decimal;

  /** EquityContribution_Balance_CurrencyID */
  EquityContribution_Balance_Currency: string;

  /** EquityContribution_Balance_Equivalent */
  EquityContribution_Balance_Equivalent: JSON_Decimal;

  /** EquityContribution_Pnl */
  EquityContribution_Pnl: JSON_Decimal;

  /** EquityContribution_Pnl_CurrencyID */
  EquityContribution_Pnl_Currency: string;

  /** EquityContribution_Pnl_Equivalent */
  EquityContribution_Pnl_Equivalent: JSON_Decimal;

  /** Computation time from the underlying data source */
  TransactTime: JSON_UTCTimestamp;

  /** Batch this valuation belongs to */
  BatchID: JSON_Int64ID;

  /** EventIndicator */
  EventIndicator: Record<EventIndicatorEnum, boolean>;
}

/** UI configuration settings for users */
export interface IUiConfiguration {
  /** Organization ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID generated by Talos for this configuration */
  ConfigID: JSON_Int64ID;

  /** User who owns this configuration */
  User: JSON_User;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision of the most recent update */
  Revision: number;

  /** Whether this configuration is public (accessible to all users in the organization) */
  IsPublic: number;

  /** Type of UI configuration */
  Type: string;

  /** Configuration data as JSONB */
  Config: unknown;

  /** Sharing information for this configuration (user, group, or role) */
  Shares: IUiConfiguration19000Shares[];
}

/** Sharing information for this configuration (user, group, or role) */
export interface IUiConfiguration19000Shares {
  /** Organization ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of the configuration being shared */
  ConfigID: JSON_Int64ID;

  /** User ID of the user the configuration is shared with (for user shares) */
  User: JSON_User | undefined;

  /** Group ID of the group the configuration is shared with (for group shares) */
  GroupID: JSON_Int64ID | undefined;

  /** User ID who shared the configuration */
  SharedBy: number;

  /** User who performed the most recent update */
  UpdateUser: JSON_User;

  /** Revision of the most recent update */
  Revision: number;

  /** Role name the configuration is shared with (for role shares) */
  Role: string;
}

/** Status of a sub-account position recalculation/backfill process */
export interface ISubAccountRecalcState {
  /** Internal time of this update */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Time the recalculation process was requested */
  RequestTimestamp: JSON_UTCTimestamp;

  /** Start of the recalculation time range */
  StartTransactTime: JSON_UTCTimestamp;

  /** End of the recalculation time range, usually the truncated current time */
  EndTransactTime: JSON_UTCTimestamp;

  /** The timestamp of the last transaction or PositionStat-window processed */
  EventProcessedTransactTime: JSON_UTCTimestamp;

  /** Number of events processed so far */
  EventProcessedCount: number;

  /** Recalculation progress as a percentage from 0 to 100 */
  TimestampProgressPct: JSON_Decimal;

  /** Number of timestamps with changes / updates */
  TimestampUpdateCount: number;

  /** Whether or not changes will be committed */
  CommitChanges: boolean;

  /** Current status of the recalculation process */
  Status: SubAccountRecalcStatusEnum;

  /** Trigger contexts */
  TriggerContexts: string;

  /** Error message text */
  Text: string;

  /** Sub-account IDs being recalculated. Empty means all sub-accounts. */
  SubAccounts: ISubAccountRecalcState4665SubAccounts[];
}

/** Sub-account IDs being recalculated. Empty means all sub-accounts. */
export interface ISubAccountRecalcState4665SubAccounts {
  /** SubAccountID */
  SubAccount: JSON_SubAccount;
}

/** Describes a request relating to trade recovery */
export interface ITradeRecoveryRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Credential ID associated with the account to this market */
  CredentialID: number;

  /** Unique ID of the market account (required when gateway has multiple market accounts) */
  MarketAccount: JSON_MarketAccount;

  /** User ID that made this request */
  User: JSON_User;

  /** A unique correlation ID for this request that responses will use */
  RequestID: JSON_Int64ID;

  /** Unique ID of this request (when action is Process) or of the request being targeted (when action is not Process) */
  TargetRequestID: JSON_Int64ID;

  /** Indicates what action to be performed on this request */
  Action: TradeRecoveryActionEnum;

  /** Trade recovery start time in number of nanoseconds since Unix epoch (required only when action is Process) */
  StartTime: JSON_UTCTimestamp;

  /** Trade recovery end time in number of nanoseconds since Unix epoch (required only when action is Process) */
  EndTime: JSON_UTCTimestamp;

  /** Security ID for trade recovery request (optional and used only when action is Process; recovers all securities when missing) */
  Symbol: JSON_Security;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Describes the response to a trade recovery request */
export interface ITradeRecoveryResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Credential ID associated with the account to this market */
  CredentialID: number;

  /** Unique ID of the market account (required when gateway has multiple market accounts) */
  MarketAccount: JSON_MarketAccount;

  /** Correlation ID of the request that this response relates to */
  RequestID: JSON_Int64ID;

  /** Unique ID of the request being targeted or the requested target id is a duplicate of (required only when action is not Process) */
  TargetRequestID: JSON_Int64ID;

  /** Status of trade recovery request that this response relates to */
  Status: TradeRecoveryStatusEnum;

  /** Measure of completion (in range [0.0, 1.0]) of the underlying request, as a percentage of the total date range to be recovered */
  ProgressPct: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Additional information when the relevant request has an unsuccessful status */
  Text: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Request information about margin cost for a particular order */
export interface IMarginCostRequest {
  /** Unique identifier of this request */
  RequestID: JSON_Int64ID;

  /** ID of the traded security (must be a derivative) */
  Symbol: JSON_Security;

  /** Market ID */
  Market: JSON_Market;

  /** Credential ID associated with the account to this market */
  CredentialID: number;

  /** Unique ID of the market account */
  MarketAccount: JSON_MarketAccount;

  /** Order side */
  Side: SideEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Currency of the order quantity (optional) */
  Currency: string;

  /** Execution Price */
  Price: JSON_Decimal;

  /** Organization ID */
  OrgID: number;
}

/** Information about margin cost */
export interface IMarginCost {
  /** Unique identifier of the request */
  RequestID: JSON_Int64ID;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The status of the margin cost request */
  Status: MarginCostStatusEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Credential ID associated with the account to this market */
  CredentialID: number;

  /** Unique ID of the market account */
  MarketAccount: JSON_MarketAccount;

  /** The margin account type */
  MarginAccountType: MarginAccountTypeEnum;

  /** The margin allocation type */
  MarginAllocationType: MarginAllocationTypeEnum;

  /** Currency of the initial margin */
  InitialMarginCurrency: string;

  /** The total IM required after placing this order */
  InitialMargin: JSON_Decimal;

  /** The total PM required after placing this order (optional) */
  PortfolioMargin: JSON_Decimal;

  /** The maximum order qty that can be placed (optional) */
  MaxOrderQty: JSON_Decimal;

  /** Currency of the portfolio margin */
  PortfolioMarginCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** Additional information in case the request was not successful */
  Text: string;

  /** What the exchange calls the margin account type */
  MarketMarginAccountType: string;
}

/** Window constraint for limiting subaccount orders */
export interface ISubAccountWindowLimit {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this Limit */
  LimitID: JSON_Int64ID;

  /** Threshold type of the window limit */
  ThresholdType: ThresholdTypeEnum;

  /** The asset of the threshold definition (optional) */
  ThresholdAsset: string;

  /** Threshold to breach window limit */
  ThresholdValue: JSON_Decimal;

  /** The duration of the window limit */
  WindowDuration: JSON_DurationMillis;

  /** Side of the window limit */
  Direction: PositionSideTypeEnum;

  /** SubaccountID (book or rollup) of this window limit */
  SubAccount: JSON_SubAccount;

  /** Asset for which this limit applies */
  MatchAsset: string;

  /** ID of user for which this limit applies */
  MatchUser: JSON_User;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision of this subaccount window limit */
  Revision: number;

  /** ID of user who last updated this subaccount window limit */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Description of this limit */
  Description: string;
}

/** Window data snapshot for capturing window limit state */
export interface ISubAccountWindowLimitSnapshot {
  /** Unique ID of this Limit */
  LimitID: JSON_Int64ID;

  /** SubaccountID (book or rollup) of this window limit */
  SubAccount: JSON_SubAccount;

  /** Asset for which this limit applies */
  MatchAsset: string;

  /** Internal time in number of nanoseconds since Unix epoch */
  StartTimestamp: JSON_UTCTimestamp;

  /** Window bucket startoffset */
  StartOffset: number;

  /** Number of buckets */
  Size: number;

  /** Total count */
  TotalNewOrderCount: JSON_Decimal;

  /** Total fill volume */
  TotalFillVolume: JSON_Decimal;

  /** Total new order volume */
  TotalNewOrderVolume: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Window data buckets */
  SizeBuckets: ISubAccountWindowLimitSnapshot4681SizeBuckets[];

  /** In-window order-quantity increases */
  WindowOrderSizeIncreases: ISubAccountWindowLimitSnapshot4681WindowOrderSizeIncreases[];
}

/** Window data buckets */
export interface ISubAccountWindowLimitSnapshot4681SizeBuckets {
  /** Bucket new order count */
  NewOrderCount: JSON_Decimal;

  /** Bucket fill volume */
  FillVolume: JSON_Decimal;

  /** Bucket new order volume */
  NewOrderVolume: JSON_Decimal;
}

/** In-window order-quantity increases */
export interface ISubAccountWindowLimitSnapshot4681WindowOrderSizeIncreases {
  /** Time in nanoseconds that the increase occurred */
  Timestamp: JSON_UTCTimestamp;

  /** The ID of the order */
  OrderID: string;

  /** Increase at the timestamp */
  Increase: JSON_Decimal;
}

/** (TenantID:OrgID)(ResourceName:SubAccountWindowLimitStatus ResourceTag:S Key:LimitID,SubAccountID,MatchAssetID PrimaryKey:Generated GoTableExtras:LastUpdateTime:time.Time) */
export interface ISubAccountWindowLimitStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this Limit */
  LimitID: JSON_Int64ID;

  /** SubaccountID (book or rollup) of this window limit */
  SubAccount: JSON_SubAccount;

  /** Asset for which this limit applies */
  MatchAsset: string;

  /** Current limit Status */
  Status: LimitStatusEnum;

  /** Lastest value of window limit */
  LatestValue: JSON_Decimal;

  /** Organization ID */
  OrgID: number;
}

/** Attributes and metadata of a basket definition for multi-token ETFs (primarily). Does not contain the constituents, see the BasketConstituent18001 message for that. */
export interface IBasketDefinition {
  /** ID generated by Talos for this basket definition. */
  ID: JSON_Int64ID;

  /** Revision. Attributes, metadata, and constituents are immutable at a given revision. */
  Revision: number;

  /** When this revision was created. Internal time in number of nanoseconds since Unix epoch. */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID for multi tenancy. */
  OrgID: number;

  /** Update action for this revision. */
  UpdateAction: UpdateActionEnum;

  /** User who last created this revision. */
  UpdateUser: JSON_User;

  /** Symbol that represents this basket. Unique within the organization. Cannot be changed after creation. */
  Symbol: string;

  /** How many constituents this basket definition has. Can be 0. */
  ConstituentCount: number;

  /** How to interpret this basket's constituent's numerical values. Cannot be changed after a basket definition has been created. */
  ConstituentType: BasketConstituentTypeEnum;

  /** Display symbol. Display field only. */
  DisplaySymbol: string;
}

/** A single constituent (asset-value pair) belonging to a basket definition. */
export interface IBasketConstituent {
  /** The basket definition that this constituent belongs to. Forms a stable key together with Revision and AssetID. */
  BasketDefinitionID: JSON_Int64ID;

  /** The revision of the basket definition that this constituent belongs to. Forms a stable key together with BasketDefinitionID and AssetID. Note that this is not the revision of the constituent itself as it cannot be independently updated. */
  Revision: number;

  /** When this revision was created. Internal time in number of nanoseconds since Unix epoch. */
  Timestamp: JSON_UTCTimestamp;

  /** Update action for this revision. */
  UpdateAction: UpdateActionEnum;

  /** User who last created this revision. */
  UpdateUser: JSON_User;

  /** The asset of this constituent. Forms a stable key together with BasketDefinitionID and Revision. */
  Asset: string;

  /** Value for this constituent. The interpretation of this number is determined by the basket's definition ConstituentType. */
  Value: JSON_Decimal;
}

/** (TenantID:OrgID)(ResourceName:SubAccountReconCheckpoint ResourceTag:C DatabaseName:sub_account_recon_checkpoints Key:EndTime,AssetID,AccountsKey TimestampField:Timestamp PrimaryKey:id PrimaryKeyType:int64 DBType:OrgDB)(ResourceName:SubAccountReconCheckpointHistory ResourceTag:H DatabaseName:sub_account_recon_checkpoint_histories Key:EndTime,AssetID,AccountsKey,Revision TimestampField:Timestamp PrimaryKey:Generated DBType:OrgDB) */
export interface ISubAccountReconCheckpoint {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of this checkpoint */
  ID: JSON_Int64ID;

  /** AssetID for this checkpoint */
  Asset: string;

  /** StartTime (inclusive) for this checkpoint */
  StartTime: JSON_UTCTimestamp;

  /** EndTime (exclusive) for this checkpoint */
  EndTime: JSON_UTCTimestamp;

  /** Timestamp when this checkpoint was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Status */
  Status: SubAccountReconCheckpointStatusEnum;

  /** EvalStatus */
  EvalStatus: SubAccountReconCheckpointEvalStatusEnum;

  /** Composite key from SubAccounts */
  AccountsKey: string;

  /** List of SubAccount recon summaries */
  ReconSubAccounts: ISubAccountReconCheckpoint4690ReconSubAccounts[];

  /** List of MarketAccount recon summaries */
  ReconMarketAccounts: ISubAccountReconCheckpoint4690ReconMarketAccounts[];
}

/** List of MarketAccount recon summaries */
export interface ISubAccountReconCheckpoint4690ReconMarketAccounts {
  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;

  /** Amount */
  Amount: JSON_Decimal;

  /** Count of unmatched events */
  Unmatched_Count: number;

  /** Total unmatched value */
  Unmatched_Amount: JSON_Decimal;

  /** Status */
  Status: SubAccountReconCheckpointStatusEnum;
}

/** List of SubAccount recon summaries */
export interface ISubAccountReconCheckpoint4690ReconSubAccounts {
  /** SubAccountID */
  SubAccount: JSON_SubAccount;

  /** Amount */
  Amount: JSON_Decimal;

  /** Count of unmatched events */
  Unmatched_Count: number;

  /** Total unmatched value */
  Unmatched_Amount: JSON_Decimal;

  /** Status */
  Status: SubAccountReconCheckpointStatusEnum;
}

/** A composite message that holds a basket definition and all its constituents in one big message. This is _only_ intended as a transport message for the API/UI, and should _never_ be used for anything else. In particular, this message should _never_ be written to an Aeron stream. */
export interface IFullBasketDefinition {
  /** The basket definition. */
  Definition: IBasketDefinition;

  /** The full set of constituents, in an unspecified order. */
  Constituents: IFullBasketDefinition18002Constituents[];
}

/** The full set of constituents, in an unspecified order. */
export interface IFullBasketDefinition18002Constituents {
  /** The basket constituent. */
  Constituent: IBasketConstituent;
}

/** (TenantID:OrgID)(ResourceName:SubAccountReconMatch ResourceTag:M DatabaseName:sub_account_recon_matches Key:CheckpointID,AssetID,TransactTime,EventType,TradeID,ExternalID TimestampField:Timestamp PrimaryKey:id PrimaryKeyType:int64 DBType:OrgDB)(ResourceName:SubAccountReconMatchHistory ResourceTag:H DatabaseName:sub_account_recon_match_histories Key:CheckpointID,AssetID,TransactTime,EventType,TradeID,ExternalID,Revision TimestampField:Timestamp PrimaryKey:Generated DBType:OrgDB) */
export interface ISubAccountReconMatch {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of this checkpoint */
  ID: JSON_Int64ID;

  /** Parent checkpoint ID */
  CheckpointID: JSON_Int64ID;

  /** AssetID for this vaulation */
  Asset: string;

  /** Timestamp of the underlying event(s) */
  TransactTime: JSON_UTCTimestamp;

  /** EventType */
  EventType: LedgerUpdateTypeEnum;

  /** The underlying ID of the event that generated the ledger-event */
  TradeID: string;

  /** Underlying external-id if applicable */
  ExternalID: string;

  /** Timestamp when this checkpoint was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** User to last update this Match */
  UpdateUser: JSON_User;

  /** Status */
  Status: SubAccountReconMatchStatusEnum;

  /** Composite key from SubAccounts */
  AccountsKey: string;

  /** List of SubAccount event summaries */
  ReconSubAccountEvents: ISubAccountReconMatch4691ReconSubAccountEvents[];

  /** List of MarketAccount event summaries */
  ReconMarketAccountEvents: ISubAccountReconMatch4691ReconMarketAccountEvents[];

  /** List of comments */
  ReconMatchComments: ISubAccountReconMatch4691ReconMatchComments[];
}

/** List of MarketAccount event summaries */
export interface ISubAccountReconMatch4691ReconMarketAccountEvents {
  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;

  /** The event amount */
  Amount: JSON_Decimal;

  /** AvgCost of the event */
  AvgCost: JSON_Decimal;

  /** Units of AvgCost */
  AvgCostCurrency: string;

  /** Comments */
  Comments: string;
}

/** List of comments */
export interface ISubAccountReconMatch4691ReconMatchComments {
  /** Comments */
  Comments: string;
}

/** List of SubAccount event summaries */
export interface ISubAccountReconMatch4691ReconSubAccountEvents {
  /** SubAccountID */
  SubAccount: JSON_SubAccount;

  /** The event amount */
  Amount: JSON_Decimal;

  /** AvgCost of the event */
  AvgCost: JSON_Decimal;

  /** Units of AvgCost */
  AvgCostCurrency: string;

  /** Comments */
  Comments: string;
}

/** (TenantID:OrgID)(ResourceName:ABORReconCheckpoint ResourceTag:C DatabaseName:abor_recon_checkpoints Key:EndTime,AssetID,AccountsKey TimestampField:Timestamp PrimaryKey:id PrimaryKeyType:int64 DBType:OrgDB)(ResourceName:ABORReconCheckpointHistory ResourceTag:H DatabaseName:abor_recon_checkpoint_histories Key:EndTime,AssetID,AccountsKey,Revision TimestampField:Timestamp PrimaryKey:Generated DBType:OrgDB) */
export interface IABORReconCheckpoint {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of this checkpoint */
  ID: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** AssetID for this checkpoint */
  Asset: string;

  /** StartTime (inclusive) for this checkpoint */
  StartTime: JSON_UTCTimestamp;

  /** EndTime (exclusive) for this checkpoint */
  EndTime: JSON_UTCTimestamp;

  /** Timestamp when this checkpoint was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Status */
  Status: SubAccountReconCheckpointStatusEnum;

  /** Total IBOR value */
  ReconSubAccountsAmount: JSON_Decimal;

  /** Total IBOR value in equivalent currency */
  EquivalentReconSubAccountsAmount: JSON_Decimal;

  /** Total ABOR value */
  ReconMarketAccountsAmount: JSON_Decimal;

  /** Total ABOR value in equivalent currency */
  EquivalentReconMarketAccountsAmount: JSON_Decimal;

  /** Total unmatched value (IBOR - ABOR) */
  UnmatchedAmount: JSON_Decimal;

  /** Total unmatched value in equivalent currency */
  EquivalentUnmatchedAmount: JSON_Decimal;

  /** Conversion rate from asset to equivalent currency */
  ConversionRate: JSON_Decimal;

  /** Mark price of the asset in equivalent currency */
  MarkPrice: JSON_Decimal;

  /** Equivalent currency ID */
  EquivalentCurrency: string;

  /** User to last update this checkpoint */
  UpdateUser: JSON_User;

  /** ABOR EndTime for this checkpoint */
  ABOREndTime: JSON_UTCTimestamp;

  /** Composite key from SubAccounts */
  AccountsKey: string;

  /** List of SubAccount recon summaries */
  ReconSubAccounts: IABORReconCheckpoint4692ReconSubAccounts[];

  /** List of MarketAccount recon summaries */
  ReconMarketAccounts: IABORReconCheckpoint4692ReconMarketAccounts[];

  /** List of comments */
  Comments: IABORReconCheckpoint4692Comments[];
}

/** List of comments */
export interface IABORReconCheckpoint4692Comments {
  /** Comments */
  Comments: string;
}

/** List of MarketAccount recon summaries */
export interface IABORReconCheckpoint4692ReconMarketAccounts {
  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;

  /** MarketAccountType */
  MarketAccountType: MarketAccountTypeEnum;

  /** MarketID */
  Market: JSON_Market;

  /** MarketType */
  MarketType: MarketTypeEnum;

  /** ABOR value */
  Amount: JSON_Decimal;

  /** Amount in equivalent currency */
  EquivalentAmount: JSON_Decimal;

  /** Equivalent currency ID */
  EquivalentCurrency: string;

  /** Conversion rate from asset to equivalent currency */
  ConversionRate: JSON_Decimal;

  /** Mark price of the asset in equivalent currency */
  MarkPrice: JSON_Decimal;
}

/** List of SubAccount recon summaries */
export interface IABORReconCheckpoint4692ReconSubAccounts {
  /** SubAccountID */
  SubAccount: JSON_SubAccount;

  /** IBOR value */
  Amount: JSON_Decimal;

  /** Amount in equivalent currency */
  EquivalentAmount: JSON_Decimal;

  /** Equivalent currency ID */
  EquivalentCurrency: string;
}

/** Customer user session event */
export interface ICustomerSessionEvent {
  /** Assigned counterparty */
  CounterpartyID: number;

  /** Connect/Disconnect event type */
  SessionEventType: SessionEventTypeEnum;
}

/** Rule for allocating transactions to subaccounts. */
export interface ISubAccountAllocationControl {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID for multi tenancy */
  OrgID: number;

  /** Unique ID generated by Talos for this rule */
  RuleID: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** Match transactions from this market. Optional: omitting this means that any market is matched. */
  MatchMarket: JSON_Market;

  /** Match transactions for this market account. Optional: omitting this means that any market account is matched. */
  MatchMarketAccount: JSON_MarketAccount;

  /** Match transactions for this asset. Optional: omitting this means that any asset is matched. */
  MatchAsset: string;

  /** Match transactions for this transaction type. */
  MatchTransactionType: TransactionControlTypeEnum;

  /** Define how matching transactions should be allocated. For SpecificSubAccount exactly one of SubAccountID and Allocation must be populated. */
  AllocationMode: SubAccountTradeRoutingModeEnum;

  /** If AllocationMode==SpecificSubAccount, allocate all matching transactions to this sub account. Cannot be set together with Allocation. */
  SubAccount: JSON_SubAccount;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User to last update this rule */
  UpdateUser: JSON_User;

  /** Whether this rule is enabled. Disabled rules are persisted and displayed in the UI but are not applied to any transactions. */
  Mode: ModeEnum;

  /** If AllocationMode==SpecificSubAccount, allocate all matching transactions accordingly. Cannot be set together with SubAccountID. */
  Allocation: IAllocation;
}

/** customer user entity */
export interface ICustomerUser {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  CustomerUser: JSON_Int64ID;

  /** External Identifier For User */
  ExternalID: string;

  /** (DEPRECATED please use 256 length DisplayName). Friendly user name for display */
  DeprecatedDisplayName: string;

  /** ID of the counterparty for this user */
  Counterparty: JSON_Counterparty;

  /** Enable/disable customer user */
  Mode: ModeEnum;

  /** Revision of that customer user update */
  Revision: number;

  /** User who performed an update of that entity */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Friendly user name for display */
  DisplayName: string;

  /** Organization ID */
  OrgID: number;

  /** User email - unique identifier */
  Email: string;
}

/** Contains information about transfer state upon startup */
export interface ICounterparty {
  /** Time of last update */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the counterparty */
  CounterpartyID: number;

  /** String64 */
  Name: string;

  /** String64. Deprecated, please use the 256 length DisplayName instead/ */
  DeprecatedDisplayName: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Type of counterparty */
  Type: CounterpartyTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;

  /** String256 */
  DisplayName: string;

  /** Jurisdiction of the CSA */
  Jurisdiction: string;

  /** Default settlement cycle */
  DefaultSettleCycle: JSON_ExtendedDuration;

  /** Holiday convention for business-day adjustment */
  DefaultBusinessDayHolidayConvention: OTCHolidayBusinessDayConventionEnum;

  /** Default settlement cutoff for trades on a particular date */
  DefaultSettleCutoff: JSON_TimeOnly;

  /** Counterparty properties */
  Properties: unknown;

  /** Legal name for the CSA */
  LegalEntityName: string;

  /** Legal ID for the CSA */
  LegalEntityID: string;

  /** Optional default timezone for settlement cutoff. UTC if not specified */
  DefaultSettleCutoffTimezone: string;

  /** A map of system-name to external-identifier */
  ExternalIDs: unknown;

  /** Holiday calendars */
  DefaultHolidayCalendars: ICounterparty4720DefaultHolidayCalendars[];

  /** Contact details */
  ContactDetails: ICounterparty4720ContactDetails[];
}

/** Contact details */
export interface ICounterparty4720ContactDetails {
  /** Contact method */
  ContactMethod: ContactMethodEnum;

  /** Purpose of contact */
  Purpose: ContactPurposeEnum;

  /** Contact value, such as email or phone number */
  Value: string;
}

/** Holiday calendars */
export interface ICounterparty4720DefaultHolidayCalendars {
  /** Business center name */
  Name: string;
}

/** config setting for customer users */
export interface ICustomerUserConfig {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  CustomerUser: JSON_Int64ID;

  /** Config Status */
  Mode: ModeEnum;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Key in Key-Value Customer User Config Pairs */
  Key: string;

  /** Value in Key-Value Customer User Config Pairs */
  Value: string;
}

/** role mappings for customer users */
export interface ICustomerUserRole {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  CustomerUser: JSON_Int64ID;

  /** Customer User Role */
  RoleID: number;

  /** Role Status */
  Mode: ModeEnum;

  /** Revision of that customer user role update */
  Revision: number;

  /** User who performed an update of that entity */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;
}

/** api key for customer users */
export interface ICustomerUserApiKey {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique Identifier for Customer User ApiKey */
  CustomerUserApiKeyID: JSON_Int64ID;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User ID */
  CustomerUser: JSON_Int64ID;

  /** Customer User ApiKey */
  ApiKey: string;

  /** Customer User ApiSecret */
  ApiSecret: string;

  /** Revision */
  Revision: number;

  /** Concatenated list of Whitelisted IPs for Customer ApiKey Authentication */
  WhitelistedIps: string;

  /** Label of the Customer User ApiKey */
  Label: string;
}

/** permission for customer functions */
export interface ICustomerPermission {
  /** Internal time representing creation time */
  Timestamp: JSON_UTCTimestamp;

  /** Unique Identifier for Permission */
  PermissionID: number;

  /** Action of permission */
  Action: CustomerPermissionActionEnum;

  /** Object Group of Permissions */
  ObjectGroup: string;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;
}

/** mapping of customer permissions to roles */
export interface ICustomerRolePermission {
  /** Internal time representing creation time */
  Timestamp: JSON_UTCTimestamp;

  /** Customer User Role */
  RoleID: number;

  /** Unique Identifier for Permission */
  PermissionID: number;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;
}

/** roles configured for a customer */
export interface ICustomerRole {
  /** Internal time representing creation time */
  Timestamp: JSON_UTCTimestamp;

  /** Internal system id for role */
  RoleID: number;

  /** Name of role to use for reference */
  Name: string;

  /** DisplayName of role for display purposes */
  DisplayName: string;

  /** Role Status - Can be used to filter out roles from use */
  Mode: ModeEnum;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;
}

/** customer user api key permission */
export interface ICustomerUserApiKeyPermission {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique Identifier for Customer User ApiKey */
  CustomerUserApiKeyID: JSON_Int64ID;

  /** Unique Identifier for Permission */
  PermissionID: number;

  /** Filter specification */
  Filter: JSON_ApiPermissionFilterSpec;

  /** Revision */
  Revision: number;
}

/** mapping of customer resources to permissions */
export interface ICustomerResourcePermission {
  /** Internal time representing creation time */
  Timestamp: JSON_UTCTimestamp;

  /** Customer Resource */
  Resource: CustomerResourceEnum;

  /** Unique Identifier for Permission */
  PermissionID: number;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;
}

/** Configurations for message processing rate limits based on various parameters */
export interface IMessageProcessingRateLimit {
  /** Unique identifier for this rate limit */
  RateLimitID: JSON_Int64ID;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Definition for the metric that this rate limit is controlling */
  RateLimitDefinition: MessageProcessingRateLimitDefinitionTypeEnum;

  /** The duration, within which the rate limit should be evaluated */
  Window: JSON_DurationMillis;

  /** The maximum amount allowed within the specified window */
  Threshold: JSON_Decimal;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** ID of the counterparty this scope filters for */
  Counterparty: JSON_Counterparty;

  /** ID of the customer user this scope filters for */
  CustomerUser: JSON_CustomerUser;

  /** ID of the market account this scope filters for */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Revision of the rate limit */
  Revision: number;

  /** User who performed an update of the rate limit */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** A string describing the purpose of this rate limit */
  Description: string;

  /** The scopes that the messages are aggregated based on */
  Scopes: IMessageProcessingRateLimit6777Scopes[];
}

/** The scopes that the messages are aggregated based on */
export interface IMessageProcessingRateLimit6777Scopes {
  /** The scope to group the messages based on */
  GroupByScope: RateLimitGroupByScopeEnum;
}

/** Market specific counterparty mapping */
export interface IMarketCounterparty {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** CounterpartyID */
  Counterparty: JSON_Counterparty;

  /** Symbol used by this market */
  MarketSymbol: string;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;
}

/** customer user permission */
export interface ICustomerUserPermission {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique Identifier for Customer User */
  CustomerUser: JSON_Int64ID;

  /** Unique Identifier for Permission */
  PermissionID: number;

  /** Filter specification */
  Filter: JSON_ApiPermissionFilterSpec;

  /** Revision */
  Revision: number;
}

/** persistent version of customer user object filters that should overlay on top of roles to build available permissions */
export interface ICustomerUserObjectFilter {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique Identifier for Customer User */
  CustomerUser: JSON_Int64ID;

  /** Action of permission */
  Action: CustomerPermissionActionEnum;

  /** Filter specification */
  Filter: JSON_ApiPermissionFilterSpec;

  /** Revision */
  Revision: number;
}

/** Lookup or create a CSA */
export interface IDEPRECATED_CreditSupportAnnexRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique identifier for the Credit Support Annex (CSA) agreement that defines the collateral terms between parties */
  CsaID: JSON_Int64ID;

  /** CSA details for create / update */
  CsaInfo: ICreditSupportAnnex;
}

/** The response of a CreditSupportAnnexRequest */
export interface IDEPRECATED_CreditSupportAnnexResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Unique identifier for the Credit Support Annex (CSA) agreement that defines the collateral terms between parties */
  CsaID: JSON_Int64ID;

  /** Status of the request */
  Status: CsaRequestStatusEnum;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Error description */
  Text: string;
}

/** Collateral agreement to reduce counterparty risk in derivatives trading. */
export interface ICreditSupportAnnex {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** External Unique identifier set by the client */
  ExternalID: string;

  /** Custodian holding collateral */
  Custodian: string;

  /** Party arrangement type, Bilateral or Triparty */
  CustodialArrangement: CsaCustodialArrangementEnum;

  /** Time window to post additional collateral */
  MarginCurePeriod: JSON_ExtendedDuration;

  /** Percent of notional that needs to be posted as margin to open a position */
  InitialMarginPct: JSON_Decimal;

  /** Percent of notional that needs to be maintained to avoid a margin call */
  MaintenanceMarginPct: JSON_Decimal;

  /** For OTC derivatives, % of notional that needs to be maintained to avoid auto-liquidation */
  LiquidationMarginPct: JSON_Decimal;

  /** Time window for access to collateral */
  CollateralAccessPeriod: JSON_ExtendedDuration;

  /** Whether or not collateral pooling is enabled */
  CollateralPoolingMode: ModeEnum;

  /** Margin model for the agreement */
  MarginModel: MarginAccountTypeEnum;

  /** The minimum transfer amount */
  MinTransferAmount: JSON_Decimal;

  /** Margin management policy */
  MarginManagementPolicy: OTCMarginManagementPolicyEnum;

  /** Percent of notional to be paid as a late fee */
  LateFeePct: JSON_Decimal;

  /** Percent of notional that needs to be released after a margin call */
  MarginReleasePct: JSON_Decimal;

  /** Margin percent threshold after which a margin call is triggered */
  MarginCallPct: JSON_Decimal;

  /** Label of this CSA */
  Label: string;

  /** Description of this CSA */
  Description: string;

  /** Accepted collateral */
  AcceptedCollateral: ICreditSupportAnnex16002AcceptedCollateral[];
}

/** Accepted collateral */
export interface ICreditSupportAnnex16002AcceptedCollateral {
  /** Collateral Asset */
  Asset: string;

  /** Haircut percentage */
  HaircutPct: JSON_Decimal;

  /** Price source */
  PriceSource: string;

  /** Additional collateral description */
  Description: string;
}

/** Collateral agreement for loans. For embedding only, no OrgID needed. */
export interface IMasterLoanAgreement {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** External Unique identifier set by the client */
  ExternalID: string;

  /** Party arrangement type, Bilateral or Triparty */
  CustodialArrangement: CsaCustodialArrangementEnum;

  /** Time window for access to collateral */
  CollateralAccessPeriod: JSON_ExtendedDuration;

  /** Whether or not collateral pooling is enabled */
  CollateralPoolingMode: ModeEnum;

  /** Margin model for the agreement */
  MarginModel: MarginAccountTypeEnum;

  /** Custodian holding collateral */
  Custodian: string;

  /** The minimum transfer amount */
  MinTransferAmount: JSON_Decimal;

  /** The minimum threshold required to maintain a healthy deal */
  Thresholds_Minimum: JSON_Decimal;

  /** Threshold at which a margin call is triggered */
  Thresholds_MarginCall: JSON_Decimal;

  /** Threshold at which the deal will be liquidated */
  Thresholds_Liquidation: JSON_Decimal;

  /** Threshold at which the collateral can be released */
  Thresholds_CollateralRelease: JSON_Decimal;

  /** Percent of notional that needs to be posted as margin to open a position */
  EarlyTerminationFeePct: JSON_Decimal;

  /** Time window to post additional collateral */
  MarginCurePeriod: JSON_ExtendedDuration;

  /** Percent of notional that needs to be paid as a late fee */
  LateFeePct: JSON_Decimal;

  /** Events that can trigger the acceleration of the loan */
  AccelerationTriggerEvents: Record<OTCTriggerEventsEnum, boolean>;

  /** Margin management policy */
  MarginManagementPolicy: OTCMarginManagementPolicyEnum;

  /** Collateralization interpretation of thresholds. */
  CollateralizationMode: OTCCollateralizationModeEnum;

  /** Allowed time to fulfill a recall (call) or redelivery (collateral return) for loans with pre-payment terms or allowances for excess collateral return */
  RecallSettleCycle: JSON_ExtendedDuration;

  /** Label of this Agreement */
  Label: string;

  /** Description of this Agreement */
  Description: string;

  /** Accepted collateral */
  AcceptedCollateral: IMasterLoanAgreement16003AcceptedCollateral[];
}

/** Accepted collateral */
export interface IMasterLoanAgreement16003AcceptedCollateral {
  /** Collateral Asset */
  Asset: string;

  /** Haircut percentage */
  HaircutPct: JSON_Decimal;

  /** Price source */
  PriceSource: string;

  /** Additional collateral description */
  Description: string;
}

/** Pegged Algo */
export interface IPeggedStrategy {
  /** Price offset from the reference price, positive offsets are more passive prices */
  PriceOffset: JSON_Decimal;

  /** Size to show on the market when resting */
  ShowQty: JSON_Decimal;
}

/** Global master repurchase agreement for repo trades. */
export interface IGlobalMasterRepurchaseAgreement {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** External Unique identifier set by the client */
  ExternalID: string;

  /** Party arrangement type, Bilateral or Triparty */
  CustodialArrangement: CsaCustodialArrangementEnum;

  /** Custodian holding collateral */
  Custodian: string;

  /** Time window for access to collateral */
  CollateralAccessPeriod: JSON_ExtendedDuration;

  /** Whether or not substitution rights are permitted. */
  SubstitutionRightsPermitted: ModeEnum;

  /** Substitution notice period. */
  SubstitutionNoticePeriod: JSON_ExtendedDuration;

  /** Percent of notional that needs to be released after a margin call */
  ReleaseBufferPct: JSON_Decimal;

  /** Percent of notional that needs to be maintained to avoid a margin call */
  MaintenanceBufferPct: JSON_Decimal;

  /** Margin percent threshold after which a margin call is triggered */
  MarginCallBufferPct: JSON_Decimal;

  /** % of notional that needs to be maintained to avoid auto-liquidation */
  CloseOutBufferPct: JSON_Decimal;

  /** Time window to post additional collateral */
  MarginCurePeriod: JSON_ExtendedDuration;

  /** The minimum transfer amount */
  MinTransferAmount: JSON_Decimal;

  /** Default settlement convention (DVP/FOP) */
  DefaultSettlementConvention: OTCDefaultSettlementConventionEnum;

  /** Whether or not manufactured payments is enabled. */
  ManufacturedPayments: OTCManufacturedPaymentsEnum;

  /** Whether or not auto rollover is enabled */
  AutoRollover: ModeEnum;

  /** Net exposure method (gross/net) */
  NetExposureMethod: OTCNetExposureMethodEnum;

  /** Label of this Agreement */
  Label: string;

  /** Description of this Agreement */
  Description: string;

  /** Accepted collateral */
  AcceptedCollateral: IGlobalMasterRepurchaseAgreement16004AcceptedCollateral[];
}

/** Accepted collateral */
export interface IGlobalMasterRepurchaseAgreement16004AcceptedCollateral {
  /** Collateral Asset */
  Asset: string;

  /** Haircut percentage */
  HaircutPct: JSON_Decimal;

  /** Price source */
  PriceSource: string;

  /** Additional collateral description */
  Description: string;
}

/** Permission filters */
export interface IApiPermissionFilter {
  /** Internal time representing creation time */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique Identifier for filter */
  FilterID: JSON_Int64ID;

  /** Filter subject */
  Subject: JSON_ApiPermissionSubject;

  /** Action of permission */
  Action: ApiPermissionActionEnum;

  /** Filter specification */
  Filter: JSON_ApiPermissionFilterSpec;

  /** Revision of the filter */
  Revision: number;

  /** User who performed an update */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** A message describing the reason for the change */
  Comments: string;
}

/** VerificationCredentials */
export interface IVerificationCredentials {
  /** Internal time representing creation time */
  Timestamp: JSON_UTCTimestamp;

  /** Revision of MFA code verification */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Verification status of MFA */
  VerificationStatus: boolean;

  /** Internal time representing expiration time */
  ExpiryTime: JSON_UTCTimestamp;

  /** Hash of api + user_id + MFA session + user IP */
  Credentials: string;

  /** Hash of api + user_id + MFA session + user IP + MFA code */
  VerificationCode: string;
}

/** Lookup or create a deal */
export interface IDealRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Unique identifier for the deal, used to track and manage the transaction throughout its lifecycle */
  DealID: JSON_Int64ID;

  /** Identifier linking to previous deal that has been rolled, if this record represents an amendment or is part of a related deal series */
  LinkedDealID: JSON_Int64ID;

  /** Underlying security or product associated with the deal, representing the financial instrument involved */
  Symbol: JSON_Security;

  /** Unique identifier for the counterparty involved in the CSA, used to manage counterparty credit risk */
  Counterparty: JSON_Counterparty;

  /** External Unique identifier set by the client */
  ExternalID: string;

  /** Identifier for the market account associated with the deal */
  MarketAccount: JSON_MarketAccount;

  /** Identifier for the sub-account associated with the deal */
  SubAccount: JSON_SubAccount;

  /** Requested action to take on the deal */
  DealAction: DealActionEnum;

  /** Template for the underlying security or product associated with the deal. Will be instantiated for the specific deal. */
  TemplateSymbol: JSON_Security;

  /** Identifier for the sub-account associated with the collateral */
  CollateralSubAccount: JSON_SubAccount;

  /** Identifier for the sub-account associated with the payment */
  PaymentSubAccount: JSON_SubAccount;

  /** Additional deal-specific information, such as contractual terms, conditions, or other metadata */
  DealInfo: unknown;

  /** optional allocation request */
  Allocation: IAllocationRequest;

  /** JIT Instrument creation */
  FinancialInstrument: ICustomInstrumentRequest;

  /** Details of the request based on the request-type */
  RequestDetails: unknown;

  /** Additional information attached to the deal */
  Comments: string;
}

/** The response of a DealRequest */
export interface IDealResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Unique identifier for the deal */
  DealID: JSON_Int64ID;

  /** Status of the request */
  Status: DealRequestStatusEnum;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Display symbol */
  DisplaySymbol: string;

  /** Error reason */
  Text: string;

  /** Details of the request based on the request-type */
  ResponseDetails: unknown;
}

/** Either an OTC derivatives contract or a lending agreement. */
export interface IDeal {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Unique identifier for the deal */
  ID: JSON_Int64ID;

  /** Used for version control and update tracking */
  Revision: number;

  /** Identifier of the user who last modified the entity */
  UpdateUser: JSON_User;

  /** Identifier linking to previous deal that has been rolled, if this record represents an amendment or is part of a related deal series */
  LinkedDealID: JSON_Int64ID;

  /** Underlying security or product associated with the deal, representing the financial instrument involved */
  Symbol: JSON_Security;

  /** Unique identifier for the counterparty participating in the deal */
  Counterparty: JSON_Counterparty;

  /** Enumerated value representing the role of the counterparty in the deal */
  CounterpartyRole: CounterpartyRoleEnum;

  /** Pending, Rejected, Booked, etc */
  Status: DealStatusEnum;

  /** Identifier for the market account associated with the deal */
  MarketAccount: JSON_MarketAccount;

  /** Identifier for the sub-account associated with the deal */
  SubAccount: JSON_SubAccount;

  /** External Unique identifier set by the client */
  ExternalID: string;

  /** Timestamp of the when deal is booked */
  TradeTime: JSON_UTCTimestamp;

  /** Timestamp when the deal becomes active, i.e., TransactTime */
  EffectiveTime: JSON_UTCTimestamp;

  /** Timestamp of deal expiry / maturity */
  ExpireTime: JSON_UTCTimestamp;

  /** Side / direction of the Deal */
  DealSide: SideEnum;

  /** Deal quantity */
  Quantity: JSON_Decimal;

  /** Asset units for quantity. Defaults to the deal Security */
  QuantityAsset: string;

  /** Deal price or rate */
  Price: JSON_Decimal;

  /** Product Type */
  ProductType: ProductTypeEnum;

  /** Sub Product Type */
  SubProductType: SubProductTypeEnum;

  /** Template for the underlying security or product associated with the deal. Will be instantiated for the specific deal. */
  TemplateSymbol: JSON_Security;

  /** Timestamp of deal settlement */
  SettleTime: JSON_UTCTimestamp;

  /** System Timestamp of the when deal is submitted */
  SubmitTime: JSON_UTCTimestamp;

  /** Identifier of the user who created the deal */
  CreateUser: JSON_User;

  /** Identifier for the sub-account associated with the collateral */
  CollateralSubAccount: JSON_SubAccount;

  /** Identifier for the sub-account associated with the payment */
  PaymentSubAccount: JSON_SubAccount;

  /** Additional deal-specific information, such as contractual terms, conditions, or other metadata */
  DealInfo: unknown;

  /** optional allocation */
  Allocation: IAllocation;

  /** Additional information attached to the deal */
  Comments: string;
}

/** Represents lifecycle event occurring within an OTC derivatives contract or lending agreement. */
export interface IDealEvent {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Unique identifier for the deal */
  ID: JSON_Int64ID;

  /** Used for version control and update tracking */
  Revision: number;

  /** Identifier of the user who last modified the entity */
  UpdateUser: JSON_User;

  /** Identifier linking to the deal */
  DealID: JSON_Int64ID;

  /** New, Unwind, Cancel, Expiration, Exercise, Fixing, CollateralUpdate, MarginCall */
  DealEventType: DealEventTypeEnum;

  /** JSON-encoded details specific to the event type. For example, a Settlement event might include details like settlement amount, currency, payment date, and settlement status */
  EventDetails: string;
}

/** Represents cashflow data associated with a deal. */
export interface IDEPRECATED_DealCashflow {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Used for version control and update tracking */
  Revision: number;

  /** Identifier of the user who last modified the entity */
  UpdateUser: JSON_User;

  /** Identifier linking to the deal */
  DealID: JSON_Int64ID;

  /** Identifier linking to the deal security */
  DealSymbol: JSON_Security;

  /** The market account associated with the deal */
  MarketAccount: JSON_MarketAccount;

  /** The sub-account associated with the deal */
  SubAccount: JSON_SubAccount;

  /** Cashflow identifier for the deal */
  ExternalID: string;

  /** Type of cashflow */
  CashflowType: DEPRECATED_OTCCashflowTypeEnum;

  /** Amount of the cashflow */
  Amount: JSON_Decimal;

  /** Accrued amount of the cashflow */
  AccruedAmount: JSON_Decimal;

  /** Currency of the cashflow */
  Currency: string;

  /** Timestamp of the payment */
  PaymentTime: JSON_UTCTimestamp;

  /** Stable sequence number of the cashflow to identify it across time */
  SequenceNumber: number;

  /** Pending, Completed, etc */
  Status: DEPRECATED_OTCCashflowStatusEnum;

  /** optional allocation */
  Allocation: IAllocation;
}

/** Collateral health status for an OTC loan or repo deal, computed periodically by the portfoliodata process. */
export interface IDealCollateralStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Identifier of the deal */
  DealID: JSON_Int64ID;

  /** Asset of the deal */
  DealAsset: string;

  /** ID of the customer counterparty */
  Counterparty: JSON_Counterparty;

  /** Market account associated with the deal */
  MarketAccount: JSON_MarketAccount;

  /** Collateralization interpretation of ratio fields in PriceResults */
  CollateralizationMode: OTCCollateralizationModeEnum;

  /** Currency of CollateralValue entries in PriceResults */
  CollateralValueCurrency: string;

  /** Collateral asset */
  CollateralAsset: string;

  /** Currency of Shortfall entries in PriceResults */
  ShortfallCurrency: string;

  /** Minimum transfer amount from the MLA */
  MinTransferAmount: JSON_Decimal;

  /** Currency of MinTransferAmount */
  MinTransferAmountCurrency: string;

  /** Quantity of collateral pledged; populated for loans, null for repos (see RepoAmount) */
  PledgedCollateral: JSON_Decimal;

  /** Quantity of collateral asset pledged; populated for repos, null for loans (see PledgedCollateral) */
  RepoAmount: JSON_Decimal;

  /** Collateral health result per named price; one entry per NamedPrice in the request */
  PriceResults: IDealCollateralStatus16015PriceResults[];
}

/** Collateral health result per named price; one entry per NamedPrice in the request */
export interface IDealCollateralStatus16015PriceResults {
  /** Matches the NamedPrice label from the request (e.g. spot or the fixing index name) */
  PriceLabel: string;

  /** Collateral health state at this price */
  HealthStatus: CollateralHealthStatusEnum;

  /** LTV or coverage ratio depending on CollateralizationMode; null when HealthStatus is Unsecured */
  Ratio: JSON_Decimal;

  /** Post-haircut collateral value; null when HealthStatus is Unsecured */
  CollateralValue: JSON_Decimal;

  /** Shortfall vs the maintenance threshold; null when HealthStatus is Unsecured or Healthy */
  Shortfall: JSON_Decimal;

  /** Shortfall expressed in collateral asset units; null when Shortfall is null */
  ShortfallCollateral: JSON_Decimal;

  /** Shortfall as a percentage of MinTransferAmount; null when Shortfall is null */
  ShortfallPctMTA: JSON_Decimal;
}

/** Collateral health status for a sub-account OTC loan or repo pool, computed periodically by the portfoliodata process. */
export interface ISubAccountCollateralStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Collateral sub-account of the member deals (CollateralSubAccountID); deals without a collateral sub-account are not pooled */
  SubAccount: JSON_SubAccount;

  /** Collateral asset for the pool */
  CollateralAsset: string;

  /** Principal or cash currency of the pool */
  PrincipalAsset: string;

  /** Loan vs repo product family for this pool */
  CollateralProduct: OTCCollateralProductEnum;

  /** Collateralization interpretation of ratio fields in PriceResults; null for repos */
  CollateralizationMode: OTCCollateralizationModeEnum;

  /** Currency of CollateralValue entries in PriceResults */
  CollateralValueCurrency: string;

  /** Currency of Shortfall entries in PriceResults */
  ShortfallCurrency: string;

  /** Minimum transfer amount shared by the pool (must match across member deals) */
  MinTransferAmount: JSON_Decimal;

  /** Currency of MinTransferAmount */
  MinTransferAmountCurrency: string;

  /** Collateral quantity for loans; null for repos (see RepoAmount) */
  PledgedCollateral: JSON_Decimal;

  /** Summed repo collateral quantity; null for loans (see PledgedCollateral) */
  RepoAmount: JSON_Decimal;

  /** Summed loan principal; null for repos (see PurchasePrice) */
  LoanAmount: JSON_Decimal;

  /** Summed repo purchase price / cash leg; null for loans (see LoanAmount) */
  PurchasePrice: JSON_Decimal;

  /** Update or remove this collateral pool */
  UpdateAction: UpdateActionEnum;

  /** Collateral health result per named price; one entry per NamedPrice in the request */
  PriceResults: ISubAccountCollateralStatus16016PriceResults[];

  /** Live deals included in this collateral pool */
  MemberDeals: ISubAccountCollateralStatus16016MemberDeals[];
}

/** Live deals included in this collateral pool */
export interface ISubAccountCollateralStatus16016MemberDeals {
  /** Identifier of a member deal */
  DealID: JSON_Int64ID;

  /** Security asset of the member deal */
  DealAsset: string;
}

/** Collateral health result per named price; one entry per NamedPrice in the request */
export interface ISubAccountCollateralStatus16016PriceResults {
  /** Matches the NamedPrice label from the request (e.g. spot or the fixing index name) */
  PriceLabel: string;

  /** Collateral health state at this price */
  HealthStatus: CollateralHealthStatusEnum;

  /** LTV or coverage ratio depending on CollateralizationMode; null when HealthStatus is Unsecured */
  Ratio: JSON_Decimal;

  /** Post-haircut collateral value; null when HealthStatus is Unsecured */
  CollateralValue: JSON_Decimal;

  /** Shortfall vs the maintenance threshold; null when HealthStatus is Unsecured or Healthy */
  Shortfall: JSON_Decimal;

  /** Shortfall expressed in collateral asset units; null when Shortfall is null */
  ShortfallCollateral: JSON_Decimal;

  /** Shortfall as a percentage of MinTransferAmount; null when Shortfall is null */
  ShortfallPctMTA: JSON_Decimal;
}

/** Notification */
export interface INotification {
  /** Unique ID of this Notification */
  NotificationID: JSON_Int64ID;

  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Severity */
  Severity: NotificationSeverityEnum;

  /** Notification type */
  Type: NotificationTypeEnum;

  /** Notification subtype */
  Subtype: NotificationSubtypeEnum;

  /** ID of the rule that triggered this notification. */
  RuleID: JSON_Int64ID;

  /** State for a specific target. Empty until combined with NotificationTarget6801. */
  State: NotificationStateEnum;

  /** Whether sound is enabled for a specific target. Empty until combined with NotificationTarget6801. */
  SoundMode: ModeEnum;

  /** Template ID of the payload message. */
  PayloadTemplateID: number;

  /** Recipient of the notification. Empty until combined with NotificationTarget6801. (NonDatabaseField) */
  User: JSON_User;

  /** Notification delivery type. Empty until combined with NotificationTarget6801. (NonDatabaseField) */
  DeliveryType: NotificationDeliveryTypeEnum;

  /** Payload message */
  Payload: number;

  /** Name of the notification sound for a specific target. Empty until combined with NotificationTarget6801. */
  SoundSelection: string;

  /** The destination contents, dependent on DeliveryType. Empty until combined with NotificationTarget6801. (NonDatabaseField) */
  Destination: unknown;

  /** Error message if state is Error. Empty until combined with NotificationTarget6801. (NonDatabaseField) */
  ErrorMessage: string;
}

/** A single row in the coupon payment schedule for an OTC loan deal, computed periodically by portfoliodata. */
export interface IDealCouponSchedule {
  /** Internal time in ns since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Used for version control and update tracking */
  Revision: number;

  /** Identifier linking to the deal */
  DealID: JSON_Int64ID;

  /** Identifier linking to the deal security */
  DealSymbol: JSON_Security;

  /** The market account associated with the deal */
  MarketAccount: JSON_MarketAccount;

  /** Stable row identifier unique with OrgID, DealID, and SubperiodIndex: coupon_number for External rows; lifecycle IDs for Internal rows */
  InternalID: number;

  /** Type of schedule row: gRPC-sourced (InterestPayment, PrincipalReturn, AccountingAccrual) or lifecycle-generated (CollateralPosting, PrincipalTransfer, CollateralReturn, PrincipalReturn) */
  RowType: OTCCouponTypeEnum;

  /** Settled amount; NaN if unset */
  AmountPaid: JSON_Decimal;

  /** Amount due; NaN if unset */
  AmountDue: JSON_Decimal;

  /** Present value; NaN if unset */
  PV: JSON_Decimal;

  /** Currency of the payment; from payment_asset_id on External rows */
  Currency: string;

  /** Unadjusted coupon period start in ns since Unix epoch; 0 if unset */
  PeriodStartDatetime: JSON_UTCTimestamp;

  /** Unadjusted coupon period end or maturity in ns since Unix epoch; 0 if unset */
  PeriodEndDatetime: JSON_UTCTimestamp;

  /** Datetime at which the payment is or will be made, in ns since Unix epoch; 0 if unset */
  PaymentDatetime: JSON_UTCTimestamp;

  /** Past, Due, Current, or Future relative to the valuation datetime; null on accounting-accrual rows */
  CashflowStatus: OTCCouponPeriodStatusEnum;

  /** Product type of the underlying deal security */
  ProductType: ProductTypeEnum;

  /** Sub-product type of the underlying deal security */
  SubProductType: SubProductTypeEnum;

  /** Whether the row was sourced from gRPC (External) or generated by Ava (Internal) */
  RowSource: OTCCouponRowSourceEnum;

  /** Accrued interest for the cashflow period; NaN if unset */
  Accrual: JSON_Decimal;

  /** Full coupon amount of the period; NaN if unset */
  ScheduledPaidAmount: JSON_Decimal;

  /** Whether ScheduledPaidAmount is determined or estimated; null if unspecified */
  ScheduledPaidAmountType: OTCCouponScheduledPaidAmountTypeEnum;

  /** Zero-based accounting-accrual subperiod within the coupon; -1 on coupon rows and lifecycle rows */
  SubperiodIndex: number;

  /** Accrual for this subperiod; NaN if unset */
  SubperiodAccrual: JSON_Decimal;
}

/** NotificationTarget */
export interface INotificationTarget {
  /** Notification ID */
  NotificationID: JSON_Int64ID;

  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Notification delivery type */
  DeliveryType: NotificationDeliveryTypeEnum;

  /** State for this notification/type/destination */
  State: NotificationStateEnum;

  /** Whether sound is enabled for this target. Only used for InApp notifications. */
  SoundMode: ModeEnum;

  /** Recipient of the notification. */
  User: JSON_User;

  /** The destination contents, dependent on DeliveryType. Empty for InApp. */
  Destination: unknown;

  /** Error message if state is Error. */
  ErrorMessage: string;

  /** Name of the notification sound. Only used for InApp notifications. */
  SoundSelection: string;
}

/** Per-deal watermark tracking coupon payment processing progress. */
export interface IDealCouponState {
  /** Internal time in ns since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Identifier of the deal */
  DealID: JSON_Int64ID;

  /** Max InternalID for which an AssetTransaction was generated; MinInt64 if none processed yet */
  LastProcessedInternalID: number;

  /** Revision of the DealCouponSchedule batch to which this state corresponds */
  Revision: number;
}

/** Notification update state request for a single notification */
export interface INotificationUpdateStateRequest {
  /** Unique ID of this Notification */
  NotificationID: JSON_Int64ID;

  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Notification delivery type */
  DeliveryType: NotificationDeliveryTypeEnum;

  /** Target state for this notification/type/destination */
  TargetState: NotificationStateEnum;

  /** Recipient of the notification. */
  User: JSON_User;

  /** The destination contents, dependent on DeliveryType. Empty for InApp. */
  Destination: unknown;

  /** Error message if state is Error. */
  ErrorMessage: string;
}

/** Notification configuration for a single user */
export interface INotificationUserConfiguration {
  /** Org ID */
  OrgID: number;

  /** User ID */
  User: JSON_User;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Timestamp when this rule was created */
  CreateTime: JSON_UTCTimestamp;

  /** User who created this rule */
  CreateUser: JSON_User;

  /** Timestamp when this rule was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** User to last update this rule */
  UpdateUser: JSON_User;

  /** Default targets for this user */
  NotificationTargets: INotificationUserConfiguration6803NotificationTargets[];
}

/** Default targets for this user */
export interface INotificationUserConfiguration6803NotificationTargets {
  /** Enabled or Disabled */
  Mode: ModeEnum;

  /** Severity that this target applies to */
  Severity: NotificationSeverityEnum;

  /** Notification delivery type */
  DeliveryType: NotificationDeliveryTypeEnum;

  /** The destination contents, dependent on DeliveryType. Empty for InApp. */
  Destination: unknown;
}

/** Order status notification rule */
export interface IOrderStatusNotificationRule {
  /** Rule ID */
  RuleID: JSON_Int64ID;

  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Timestamp when this rule was created */
  CreateTime: JSON_UTCTimestamp;

  /** User who created this rule */
  CreateUser: JSON_User;

  /** Timestamp when this rule was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** User to last update this rule */
  UpdateUser: JSON_User;

  /** Enabled or Disabled */
  Mode: ModeEnum;

  /** Order status to notify on */
  OrderStatus: OrderStatusNotificationTriggerEnum;

  /** If the order is updated by a system or user */
  ActionSource: OrderActionSourceEnum;

  /** Severity of generated notifications */
  Severity: NotificationSeverityEnum;

  /** Specifies whether individual users can suppress notifications from this rule. */
  UserSuppressPolicy: SuppressPolicyEnum;

  /** Who is monitored by this rule */
  MonitorScope: MonitorScopeEnum;

  /** Overrides at the user level. Empty until combined with NotificationRuleUserOverride6805. */
  UserOverrides: INotificationRuleUserOverride;

  /** Users whose orders are monitored by this rule. */
  MonitoredUsers: IOrderStatusNotificationRule6804MonitoredUsers[];

  /** Market account IDs to notify on. Empty for all. */
  MarketAccounts: IOrderStatusNotificationRule6804MarketAccounts[];

  /** Subaccount IDs to notify on. Empty for all. */
  SubAccounts: IOrderStatusNotificationRule6804SubAccounts[];

  /** Order strategies to notify on. Empty for all. */
  Strategies: IOrderStatusNotificationRule6804Strategies[];

  /** Targets to notify. */
  RouteTargets: IOrderStatusNotificationRule6804RouteTargets[];
}

/** Market account IDs to notify on. Empty for all. */
export interface IOrderStatusNotificationRule6804MarketAccounts {
  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;
}

/** Users whose orders are monitored by this rule. */
export interface IOrderStatusNotificationRule6804MonitoredUsers {
  /** User ID */
  User: JSON_User;
}

/** Targets to notify. */
export interface IOrderStatusNotificationRule6804RouteTargets {
  /** Route target */
  RouteTarget: JSON_RouteTarget;
}

/** Order strategies to notify on. Empty for all. */
export interface IOrderStatusNotificationRule6804Strategies {
  /** Order strategy */
  Strategy: JSON_Strategy;
}

/** Subaccount IDs to notify on. Empty for all. */
export interface IOrderStatusNotificationRule6804SubAccounts {
  /** SubaccountID */
  SubAccount: JSON_SubAccount;
}

/** Limits net purchases of non-specified crypto assets over rolling window duration */
export interface ICustomerNetAcquisitionLimit {
  /** Organization ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this limit */
  LimitID: JSON_Int64ID;

  /** Unique name of the limit */
  Name: string;

  /** Net acquisition threshold to prevent further orders */
  RejectThreshold: JSON_Decimal;

  /** The asset the threshold definition is defined in */
  ThresholdAsset: string;

  /** How far in the past to count trades towards the net acquisition threshold */
  WindowDuration: JSON_ExtendedDuration;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Update action last taken on this limit */
  UpdateAction: UpdateActionEnum;

  /** Revision of this limit */
  Revision: number;

  /** ID of user who last updated this limit */
  UpdateUser: JSON_User;

  /** Description of this limit */
  Description: string;
}

/** User override for a notification rule */
export interface INotificationRuleUserOverride {
  /** The rule ID this override applies to. Used with user_id to represent a user override for a specific rule. */
  RuleID: JSON_Int64ID;

  /** The user ID this override applies to. Used with rule_id to represent a user override for a specific rule. */
  User: JSON_User;

  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Timestamp when this override was created */
  CreateTime: JSON_UTCTimestamp;

  /** User who created this override */
  CreateUser: JSON_User;

  /** Timestamp when this override was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** User to last update this override */
  UpdateUser: JSON_User;

  /** The type of the rule this override applies to */
  RuleType: NotificationTypeEnum;

  /** Whether notifications from this rule to this user are enabled */
  Mode: ModeEnum;

  /** Whether sound is enabled for notifications generated by this rule for this user. */
  SoundMode: ModeEnum;

  /** Name of the notification sound. */
  SoundSelection: string;

  /** Override targets for this user + rule. If empty, falls back to defaults. */
  OverrideTargets: INotificationRuleUserOverride6805OverrideTargets[];
}

/** Override targets for this user + rule. If empty, falls back to defaults. */
export interface INotificationRuleUserOverride6805OverrideTargets {
  /** Enabled or Disabled */
  Mode: ModeEnum;

  /** Notification delivery type */
  DeliveryType: NotificationDeliveryTypeEnum;

  /** The destination contents, dependent on DeliveryType. Empty for InApp. */
  Destination: unknown;
}

/** Many-to-one mapping between a market account and a net acquisition limit */
export interface ICustomerNetAcquisitionLimitMembership {
  /** Organization ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The ID of the limit which applies to the market account */
  AcquisitionLimit: JSON_AcquisitionLimit;

  /** The ID of the market account */
  MarketAccount: JSON_MarketAccount;

  /** Update action last taken on this limit membership */
  UpdateAction: UpdateActionEnum;

  /** Revision of this limit membership */
  Revision: number;

  /** ID of user who last updated this limit membership */
  UpdateUser: JSON_User;
}

/** Snapshot message for an active order status notification */
export interface IOrderStatusActiveNotification {
  /** Org ID */
  OrgID: number;

  /** Order ID */
  OrderID: string;

  /** Notification ID */
  NotificationID: JSON_Int64ID;

  /** Rule ID */
  RuleID: JSON_Int64ID;

  /** Order status that was notified on */
  TriggerStatus: OrderStatusNotificationTriggerEnum;
}

/** A customer's acquisition amount against a limit */
export interface ICustomerNetAcquisitionAmount {
  /** Organization ID */
  OrgID: number;

  /** The ID of the limit which this record applies to */
  AcquisitionLimit: JSON_AcquisitionLimit;

  /** The ID of the market accountt which this record applies to */
  MarketAccount: JSON_MarketAccount;

  /** Internal time when record created in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The amount cached */
  Amount: JSON_Decimal;
}

/** Message template for a notification type/subtype */
export interface INotificationTemplate {
  /** Org ID */
  OrgID: number;

  /** Notification type */
  Type: NotificationTypeEnum;

  /** Notification subtype */
  Subtype: NotificationSubtypeEnum;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Timestamp when this override was created */
  CreateTime: JSON_UTCTimestamp;

  /** User who created this override */
  CreateUser: JSON_User;

  /** Timestamp when this override was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** User to last update this override */
  UpdateUser: JSON_User;

  /** Message template for subject */
  SubjectMessageTemplate: string;

  /** Message template for body */
  BodyMessageTemplate: string;

  /** Message template for HTML body */
  HtmlBodyMessageTemplate: string;
}

/** (TenantID:OrgID) */
export interface IBalanceUpdate {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** Market ID */
  Market: JSON_Market;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of balance entries */
  Balances: IBalanceUpdate4760Balances[];
}

/** Number of balance entries */
export interface IBalanceUpdate4760Balances {
  /** Balance Entry Type */
  BalanceEntryType: BalanceEntryTypeEnum;

  /** Account */
  Account: string;

  /** The Currency updated, if non-zero */
  Currency: string;

  /** Balance Amount */
  Amount: JSON_Decimal;

  /** Available Amount not tied up in open orders */
  AvailableAmount: JSON_Decimal;

  /** Balance update time as given by the Exchange or zero if not given by the exchange */
  TransactTime: JSON_UTCTimestamp;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Available Margin */
  AvailableMargin: JSON_Decimal;

  /** Initial Margin */
  InitialMargin: JSON_Decimal;

  /** Maintenance Margin */
  MaintenanceMargin: JSON_Decimal;

  /** Equity */
  Equity: JSON_Decimal;

  /** The total delta accross all options positions in this currency */
  OptionsDelta: JSON_Decimal;

  /** The total delta accross all positions in this currency */
  TotalDelta: JSON_Decimal;

  /** MarginReportingType */
  MarginReportingType: MarginReportingTypeEnum;

  /** The blockchain chain id on which this currency's balance exists */
  ChainID: number;

  /** Unavailable Amount tied up in some yielding position */
  YieldingAmount: JSON_Decimal;

  /** Borrowed amount for margin trading (principal only) */
  BorrowAmount: JSON_Decimal;
}

/** Snapshot message for an active customer quote notification */
export interface ICustomerQuoteStatusActiveNotification {
  /** Customer RFQ ID */
  RFQID: string;

  /** Notification ID */
  NotificationID: JSON_Int64ID;
}

/** Provides fixing for request for customer rfq */
export interface ICustomerApplyFixingRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Internal unique ID for customer quote */
  RFQID: string;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Fixing price for the top level RFQ. optional */
  FixingPrice: JSON_Decimal;

  /** Canonical name for this index */
  IndexName: string;

  /** Unique ID for this fixing request for correlation with response */
  RequestID: JSON_Int64ID;

  /** Individual leg fixing (if provided, takes precedence over top-level fixing) */
  LegFixingPrices: ICustomerApplyFixingRequest6809LegFixingPrices[];
}

/** Individual leg fixing (if provided, takes precedence over top-level fixing) */
export interface ICustomerApplyFixingRequest6809LegFixingPrices {
  /** Security ID for this leg */
  Symbol: JSON_Security;

  /** Fixing price for this leg */
  FixingPrice: JSON_Decimal;
}

/** Snapshot message for an active customer margin notification */
export interface ICustomerMarginActiveNotification {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;

  /** SecurityID the notification belongs to */
  Symbol: JSON_Security;

  /** Notification ID */
  NotificationID: JSON_Int64ID;

  /** Rule ID */
  RuleID: JSON_Int64ID;

  /** Notification type that was notified on */
  NotificationType: NotificationSubtypeEnum;

  /** CurrencyID the notification belongs to */
  Currency: string;
}

/** Customer margin notification rule */
export interface ICustomerMarginNotificationRule {
  /** Rule ID */
  RuleID: JSON_Int64ID;

  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Timestamp when this rule was created */
  CreateTime: JSON_UTCTimestamp;

  /** User who created this rule */
  CreateUser: JSON_User;

  /** Timestamp when this rule was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** User to last update this rule */
  UpdateUser: JSON_User;

  /** Enabled or Disabled */
  Mode: ModeEnum;

  /** Type of event on customer margins to notify on */
  Type: CustomerMarginNotificationTypeEnum;

  /** Severity of generated notifications */
  Severity: NotificationSeverityEnum;

  /** Specifies whether individual users can suppress notifications from this rule. */
  UserSuppressPolicy: SuppressPolicyEnum;

  /** Overrides at the user level. Empty until combined with NotificationRuleUserOverride6805. */
  UserOverrides: INotificationRuleUserOverride;

  /** Market account IDs to notify on. Empty for all. */
  MarketAccounts: ICustomerMarginNotificationRule6811MarketAccounts[];

  /** Counterparty IDs to notify on. Empty for all. */
  Counterparties: ICustomerMarginNotificationRule6811Counterparties[];

  /** Targets to notify. */
  RouteTargets: ICustomerMarginNotificationRule6811RouteTargets[];
}

/** Counterparty IDs to notify on. Empty for all. */
export interface ICustomerMarginNotificationRule6811Counterparties {
  /** Counterparty */
  Counterparty: JSON_Counterparty;
}

/** Market account IDs to notify on. Empty for all. */
export interface ICustomerMarginNotificationRule6811MarketAccounts {
  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;
}

/** Targets to notify. */
export interface ICustomerMarginNotificationRule6811RouteTargets {
  /** Route target */
  RouteTarget: JSON_RouteTarget;
}

/** Response to a customer apply fixing request */
export interface ICustomerApplyFixingResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID correlating to the fixing request */
  RequestID: JSON_Int64ID;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** The resulting CustomerQuote */
  CustomerQuote: ICustomerQuote;

  /** Error text if fixing failed */
  ErrorText: string;
}

/** Entity management request command envelope */
export interface IEntityManagementRequest {
  /** Time of most recent update in number of nanoseconds since Unix epoch. */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** ID of user making the request */
  User: JSON_User;

  /** Request identifier generated by the system. */
  RequestID: JSON_Int64ID;

  /** Action propsed on the target payload. */
  Action: EntityMaintenanceActionEnum;

  /** Template ID of the payload message. */
  PayloadTemplateID: number;

  /** Payload message */
  Payload: number;
}

/** Entity management response command envelope */
export interface IEntityManagementResponse {
  /** Time of most recent update in number of nanoseconds since Unix epoch. */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID correlating to that of the request */
  RequestID: JSON_Int64ID;

  /** Result for the request. */
  Result: EntityManagementResultEnum;

  /** Template ID of the payload message. */
  PayloadTemplateID: number;

  /** Payload message when request succeeds. */
  Payload: number;

  /** User suitable message for request result. */
  Text: string;

  /** Internal message for logging and diagnostics. */
  InternalText: string;
}

/** External notification destination */
export interface INotificationDestination {
  /** Timestamp when this destination was last updated */
  Timestamp: JSON_UTCTimestamp;

  /** Org ID */
  OrgID: number;

  /** Talos-generated ID */
  ID: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** ID of user who last updated this destination */
  UpdateUser: JSON_User;

  /** Timestamp when this destination was created */
  CreateTime: JSON_UTCTimestamp;

  /** User who created this destination */
  CreateUser: JSON_User;

  /** User-specified name of this destination */
  DisplayName: string;

  /** Notification destination type */
  DeliveryType: NotificationDeliveryTypeEnum;

  /** The destination contents, dependent on DeliveryType. */
  DestinationDetails: unknown;
}

/** Audit log notification rule */
export interface IAuditLogNotificationRule {
  /** Rule ID */
  RuleID: JSON_Int64ID;

  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Timestamp when this rule was created */
  CreateTime: JSON_UTCTimestamp;

  /** User who created this rule */
  CreateUser: JSON_User;

  /** Timestamp when this rule was last updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** User to last update this rule */
  UpdateUser: JSON_User;

  /** Enabled or Disabled */
  Mode: ModeEnum;

  /** Audit event type this rule fires on */
  EventType: AuditLogEventTypeEnum;

  /** Severity of generated notifications */
  Severity: NotificationSeverityEnum;

  /** Specifies whether individual users can suppress notifications from this rule. */
  UserSuppressPolicy: SuppressPolicyEnum;

  /** Overrides at the user level. Empty until combined with NotificationRuleUserOverride6805. */
  UserOverrides: INotificationRuleUserOverride;

  /** Targets to notify. */
  RouteTargets: IAuditLogNotificationRule6816RouteTargets[];
}

/** Targets to notify. */
export interface IAuditLogNotificationRule6816RouteTargets {
  /** Route target */
  RouteTarget: JSON_RouteTarget;
}

/** Request for volatile data stream info */
export interface IVolatileJoinRequest {
  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;
}

/** Response to an Volatile Join request with the update/snapshot streams */
export interface IVolatileJoinResponse {
  /** The request ID that this response is for. */
  RequestID: number;

  /** Last time the sequence numbers were reset */
  LastResetTime: number;

  /** Stream ID the client should use to consume update messages */
  UpdateStreamID: number;

  /** Stream ID the client should use to consume snapshot messages */
  SnapshotStreamID: number;

  /** Channel the client should subscribe to receive updates(deltas) */
  UpdateChannel: string;

  /** Channel the client should subscribe to receive snapshots */
  SnapshotChannel: string;
}

/** Available Customer Alert Codes */
export interface ICustomerAlertCode {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Code to resolve the alert details */
  Code: number;

  /** Name of code */
  Name: string;

  /** Description of error code */
  Description: string;
}

/** Acknowledges receipt of a Volatile request */
export interface IVolatileRequestAck {
  /** The request ID that this response is for. */
  RequestID: number;

  /** Was this request successfully queued */
  Failure: boolean;

  /** Reason for failure */
  FailureReason: string;
}

/** Alert raised from anomalous behavior within the customer stack */
export interface ICustomerAlert {
  /** Org ID */
  OrgID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Business Identifier of the CustomerAlert */
  CustomerAlertID: JSON_Int64ID;

  /** Security Associated with the Alert if Relevant */
  Symbol: JSON_Security;

  /** Code to simplify customer alert reason */
  AlertCode: number;

  /** Scope on which the customer alert is firing */
  AlertScope: CustomerAlertScopeEnum;

  /** Counterparty Associated with the Alert */
  Counterparty: JSON_Counterparty;

  /** OrderID for this alert */
  OrderID: string;

  /** RFQID for this alert */
  RFQID: string;

  /** AccountID for this alert */
  AccountID: number;

  /** The type of account that AccountID references */
  AccountType: LedgerAccountTypeEnum;

  /** AssetID for this alert */
  Asset: string;

  /** Message describing the alert reason */
  Message: string;
}

/** Header for Volatile message passed in response to a request */
export interface IVolatileSnapshotHeader {
  /** Service that generated this message */
  ServiceID: JSON_Int64ID;

  /** Correlation ID to associate Volatile request/response */
  RequestID: JSON_Int64ID;

  /** ID of item to snapshot */
  TopicID: JSON_Int64ID;

  /** The sequence number of this message in the Topic stream */
  SequenceNumber: number;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;
}

/** Header for Volatile message sent on updates */
export interface IVolatileUpdateHeader {
  /** ID of item to snapshot */
  TopicID: JSON_Int64ID;

  /** The sequence number of this message in the Topic stream */
  SequenceNumber: number;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;
}

/** Reset a stream */
export interface IVolatileReset {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of item to snapshot */
  TopicID: JSON_Int64ID;
}

/** Signal market data is still alive */
export interface IVolatileKeepAlive {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of item to snapshot */
  TopicID: JSON_Int64ID;
}

/** Signals the end of the snapshot messages for a snapshot request */
export interface IVolatileSnapshotEnd {
  /** The ID of the snapshot request */
  RequestID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Number of snapshot messages sent for this request */
  SnapshotsSent: number;
}

/** TradeSummary */
export interface ITradeSummary {
  /** Internal processing time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** ExecID */
  TradeID: string;

  /** Trade price */
  Price: JSON_Decimal;

  /** Trade quantity */
  Size: JSON_Decimal;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;
}

/** ConversionRate */
export interface IConversionRate {
  /** Internal processing time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Currency ID */
  Currency: string;

  /** Equivalent Currency ID */
  EquivalentCurrency: string;

  /** Conversion rate */
  Rate: JSON_Decimal;

  /** Status of conversion rate */
  Status: ConnectionStatusEnum;
}

/** Notifies VolatileClient of a topic for its request */
export interface IVolatileTopicAnnouncement {
  /** ID of item to snapshot */
  TopicID: JSON_Int64ID;

  /** The current status for the topic */
  TopicStatus: TopicStatusEnum;

  /** Data */
  Data: string;

  /** Number of requests */
  Requests: IVolatileTopicAnnouncement14009Requests[];
}

/** Number of requests */
export interface IVolatileTopicAnnouncement14009Requests {
  /** A requestID that would be interested in this announcement */
  RequestID: JSON_Int64ID;
}

/** Ohlcv */
export interface IOhlcv {
  /** Resolution Timestamp */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Open */
  Open: JSON_Decimal;

  /** High */
  High: JSON_Decimal;

  /** Low */
  Low: JSON_Decimal;

  /** Close */
  Close: JSON_Decimal;

  /** Volume */
  Volume: JSON_Decimal;

  /** Ticks */
  Ticks: number;

  /** Volume in USD */
  VolumeInUsd: JSON_Decimal;

  /** Volume in Quote Currency */
  QuoteVolume: JSON_Decimal;
}

/** Requests a snapshot for a set of topics */
export interface ITopicSnapshotRequest {
  /** Number of topics to subscribe to */
  Topics: ITopicSnapshotRequest14010Topics[];
}

/** Number of topics to subscribe to */
export interface ITopicSnapshotRequest14010Topics {
  /** TopicID ID */
  TopicID: number;

  /** RequestID for this topic */
  RequestID: number;
}

/** Sparkline */
export interface ISparkline {
  /** Security ID */
  Symbol: JSON_Security;

  /** Volume */
  Volume: JSON_Decimal;

  /** Open */
  Open: JSON_Decimal;

  /** Close */
  Close: JSON_Decimal;

  /** Values */
  Values: number[];
}

/** Risk constraint for limiting the size of orders */
export interface IMaxOrderSizeLimit {
  /** Max Order Size Limit ID */
  TradingLimitID: JSON_Int64ID;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Emit a warning when breaching this threshold */
  WarnThreshold: JSON_Decimal;

  /** Prevent submitting the order when breaching this threshold */
  RejectThreshold: JSON_Decimal;

  /** Currency for which this limit applies */
  ThresholdCurrency: string;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User for which this limit applies */
  User: JSON_User;

  /** User group for which this limit applies */
  UserGroupID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID */
  Currency: string;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;

  /** A name to distinguish this limit from others */
  Description: string;
}

/** Governs system handling of short-form confirm fields */
export interface IConfirmConfigEntry {
  /** Path within the first message with a ResourceName to the field this config applies to */
  FieldPath: string;

  /** Which participants may set the associated field */
  Authority: ConfirmFieldAuthorityEnum;

  /** Which participants may set the associated field */
  Negotiability: ConfirmFieldNegotiabilityEnum;
}

/** A group of users */
export interface IUserGroup {
  /** ID of this group */
  GroupID: JSON_Int64ID;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;

  /** DisplayName */
  DisplayName: string;
}

/** Entity management request command envelope */
export interface IRepoConfirm {
  /** The currency of the cash leg of this transaction. */
  CashCurrency: string;

  /** The underlying of the collateral leg of this transaction. */
  CollateralAsset: string;

  /** The haircut ratio for collateral on this transaction.  100% is 1.0. */
  HaircutRatio: JSON_Decimal;

  /** The reference price for this transaction. */
  ReferencePrice: JSON_Decimal;

  /** The start time for this transaction in nanoseconds since Unix epoch. */
  StartTime: JSON_UTCTimestamp;

  /** The end time for this transaction in nanoseconds since Unix epoch. */
  EndTime: JSON_UTCTimestamp;

  /** Cumulative quantity on the cash leg */
  CumCashQty: JSON_Decimal;

  /** Cumulative quantity on the collateral leg */
  CumCollateralQty: JSON_Decimal;

  /** Cash amount at the start of the repo, after haircut. System-computed. */
  StartCash: JSON_Decimal;

  /** Cash amount at the end of the repo, including repo interest. System-computed. */
  EndCash: JSON_Decimal;

  /** Repo interest included in EndCash. System-computed. */
  RepoInterest: JSON_Decimal;

  /** (optional) Configuration that applies to this confirms' fields */
  ConfigEntries: IRepoConfirm6851ConfigEntries[];
}

/** (optional) Configuration that applies to this confirms' fields */
export interface IRepoConfirm6851ConfigEntries {
  /** A config entry for a field in this repo confirm */
  ConfigEntry: IConfirmConfigEntry;
}

/** Many-to-many mapping between a user group and a user */
export interface IUserGroupMembership {
  /** ID of the user group */
  GroupID: JSON_Int64ID;

  /** ID of the user */
  User: JSON_User;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;
}

/** Usage limits for market data for users */
export interface IUserMarketDataLimit {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this Limit */
  LimitID: JSON_Int64ID;

  /** Market data subs limit */
  ViewLimit: number;

  /** ID of the user */
  User: JSON_User;

  /** Market ID */
  Market: JSON_Market;

  /** Whether this limit is for API usage */
  IsApi: boolean;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** ID of user who last updated this MD position limit */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Description */
  Description: string;
}

/** Usage limit audit logs for market data for users */
export interface IUserMarketDataAccessAudit {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of the user */
  User: JSON_User;

  /** Market ID */
  Market: JSON_Market;

  /** Whether this audit is for the API */
  IsApi: boolean;

  /** Market data session current count */
  MaxCount: number;

  /** Status of user MD request */
  Status: UserMarketDataLimitRequestStatusEnum;

  /** Organization ID */
  OrgID: number;
}

/** Equity margin ratio limit for market accounts */
export interface IEquityMarginRatioLimit {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of this Limit */
  LimitID: JSON_Int64ID;

  /** Market account which the limit applies to */
  MarketAccount: JSON_MarketAccount;

  /** Equity margin ratio limit */
  Ratio: JSON_Decimal;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** ID of user who last updated this limit */
  UpdateUser: JSON_User;

  /** Revision */
  Revision: number;
}

/** Request for reference data snapshot */
export interface IReferenceDataSnapshotRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the request */
  RequestID: JSON_Int64ID;

  /** Tables */
  Tables: IReferenceDataSnapshotRequest13000Tables[];
}

/**  */
export interface IReferenceDataSnapshotRequest13000Tables {
  /** The database type: OrgDB=1, AvaDB=2, LoanDB=3 */
  DBType: number;

  /** Name of the requested table */
  TableName: string;
}

/** Rejection of request for reference data snapshot */
export interface IReferenceDataSnapshotReject {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the request */
  RequestID: JSON_Int64ID;

  /** Reason for rejection */
  Reason: string;
}

/** Customer balance transaction holds information about customer initiated deposit or withdrawal state */
export interface ICustomerBalanceTransaction {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Customer defined request ID */
  ClReqID: string;

  /** Unique ID generated by Talos for customer transaction */
  TransactionID: JSON_Int64ID;

  /** Revision of this customer transaction */
  Revision: number;

  /** Type of balance transaction */
  TransactionType: CustomerBalanceTransactionTypeEnum;

  /** User ID */
  CustomerUser: JSON_CustomerUser;

  /** ID of the counterparty for this customer user */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Customer-requested transaction quantity, inclusive of any transfer fee */
  Quantity: JSON_Decimal;

  /** Transaction currency */
  Currency: string;

  /** ID to related customer address record */
  CustomerAddressID: JSON_Int64ID;

  /** Status of this customer balance transaction */
  Status: CustomerBalanceTransactionStatusEnum;

  /** Optional ID of user with dealer permission who touched this customer transaction */
  DealerUser: JSON_User;

  /** Optional ID of user with treasury permission who touched this customer transaction */
  TreasuryUser: JSON_User;

  /** Customer transaction reject reason */
  RejectReason: CustomerTransactionRejectReasonEnum;

  /** optional transfer ID */
  TransferID: JSON_Int64ID;

  /** Balance transaction initiator */
  Initiator: BalanceTransactionInitiatorEnum;

  /** Internal time in number of nanoseconds since Unix epoch representing the last time the balance changed in the system of record. */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Optional ID of user with dealer permission who initiated this customer transaction */
  InitiatorUser: JSON_User;

  /** Internal time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Sender of transfer's MarketAccountID */
  FromMarketAccount: JSON_MarketAccount;

  /** Receiver of transfer's MarketAccountID */
  ToMarketAccount: JSON_MarketAccount;

  /** Transfer currency. If set, should be an alias related to CurrencyID */
  TransferCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** Fee deducted from Quantity before transfer */
  TransferFee: JSON_Decimal;

  /** Net quantity transferred after deducting TransferFee */
  TransferQuantity: JSON_Decimal;

  /** RejectText */
  RejectText: string;

  /** Additional information relating to the transaction */
  Comments: string;

  /** Optional transaction hash provided by the dealer to track transfer */
  TxHash: string;

  /** additional routing information provided like WalletAddress, BankAddress etc. Printed if routing info provided alongside CustomerBalanceTransactionRequest is not recognized(TemplateID:4813) */
  RoutingInfo: ICustomerRoutingInfo;

  /** Additional comments supplied by the external user */
  ExternalComments: string;

  /** Optional list of transaction hashes */
  TxHashes: ICustomerBalanceTransaction4810TxHashes[];
}

/** Optional list of transaction hashes */
export interface ICustomerBalanceTransaction4810TxHashes {
  /** Blockchain transaction hash provided to track moving funds */
  TxHash: string;
}

/** Marks the start of a reference data snapshot */
export interface IReferenceDataSnapshotStart {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the request */
  RequestID: JSON_Int64ID;
}

/** Customer balance transaction request holds information about customer initiated deposit or withdrawal */
export interface ICustomerBalanceTransactionRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Customer defined request ID */
  ClReqID: string;

  /** User ID */
  CustomerUser: JSON_CustomerUser;

  /** ID of the counterparty for this customer user */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Type of balance transaction */
  TransactionType: CustomerBalanceTransactionTypeEnum;

  /** Transaction quantity */
  Quantity: JSON_Decimal;

  /** Transaction currency */
  Currency: string;

  /** Balance transaction initiator */
  Initiator: BalanceTransactionInitiatorEnum;

  /** Internal time in number of nanoseconds since Unix epoch representing the last time the balance changed in the system of record. */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Optional ID of user with dealer permission who initiated this customer transaction */
  InitiatorUser: JSON_User;

  /** ID to related address record */
  AddressID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** routing information provided by customer like WalletAddress, BankAddress etc. */
  RoutingInfo: ICustomerRoutingInfo;

  /** Additional information relating to the transaction */
  Comments: string;

  /** Additional comments supplied by the external user */
  ExternalComments: string;

  /** Optional list of transaction hashes */
  TxHashes: ICustomerBalanceTransactionRequest4811TxHashes[];
}

/** Optional list of transaction hashes */
export interface ICustomerBalanceTransactionRequest4811TxHashes {
  /** Blockchain transaction hash provided to track moving funds */
  TxHash: string;
}

/** Marks the end of a reference data snapshot */
export interface IReferenceDataSnapshotEnd {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the request */
  RequestID: JSON_Int64ID;
}

/** Risk constraint for limiting the size of customer orders */
export interface ICustomerMaxOrderSizeLimit {
  /** Max Order Size Limit ID */
  TradingLimitID: JSON_Int64ID;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Emit a warning when breaching this threshold */
  WarnThreshold: JSON_Decimal;

  /** Prevent submitting the order when breaching this threshold */
  RejectThreshold: JSON_Decimal;

  /** Currency for which this limit applies */
  ThresholdCurrency: string;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** User ID */
  CustomerUser: JSON_CustomerUser;

  /** ID of the counterparty that trading limit is referring to */
  Counterparty: JSON_Counterparty;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID */
  Currency: string;

  /** Revision of that customer trading limit */
  Revision: number;

  /** User who performed an update of that entity */
  UpdateUser: JSON_User;

  /** ID of the customer's market account that trading limit is referring to */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Organization ID */
  OrgID: number;

  /** A name to distinguish this limit from others */
  Description: string;
}

/** Marks the position of a reference data snapshot within the sequenced stream */
export interface IReferenceDataSnapshotPosition {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the request */
  RequestID: JSON_Int64ID;
}

/** CustomerRoutingInfo holds information about provided crypto or fiat routing details */
export interface ICustomerRoutingInfo {
  /** crypto wallet address */
  WalletAddress: string;

  /** Optional memo attached to wallet address */
  Memo: string;

  /** Optional destination tag attached to wallet address */
  DestinationTag: string;

  /** The transaction URL as specified by the client custody provider. Customer should use this URL to initiate the transaction */
  ExternalTxnURL: string;
}

/** Reference data client snapshot, contains whether it has received or is still waiting for a ReferenceDataSnapshotPosition13004 */
export interface IReferenceDataClientSnapshot {
  /** True if a ReferenceDataSnapshotPosition13004 has been received */
  ReceivedSnapshot: boolean;

  /** ID of the request */
  RequestID: JSON_Int64ID;
}

/** CustomerAddress holds information about active customer addresses for deposit and withdrawal */
export interface ICustomerAddress {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID generated by Talos for customer address */
  CustomerAddressID: JSON_Int64ID;

  /** User ID */
  CustomerUser: JSON_CustomerUser;

  /** ID of the counterparty for this customer user */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Customer address currency */
  Currency: string;

  /** Type of customer address. Either Deposit or Withdrawal */
  AddressType: CustomerAddressTypeEnum;

  /** Type of routing address. Either Fiat or Crypto */
  AddressRoutingType: AddressRoutingTypeEnum;

  /** Config Status */
  Mode: ModeEnum;

  /** Optional ID of user who last touched customer address record */
  UpdateUser: JSON_User;

  /** Status of customer address */
  Status: CustomerAddressStatusEnum;

  /** Revision */
  Revision: number;

  /** String64 */
  Name: string;

  /** Organization ID */
  OrgID: number;

  /** routing information provided by customer like WalletAddress, BankAddress etc. */
  RoutingInfo: ICustomerRoutingInfo;
}

/** EncryptedCustomerAddress holds encrypted customer address information */
export interface IEncryptedCustomerAddress {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID generated by Talos for customer address */
  CustomerAddressID: JSON_Int64ID;

  /** User ID */
  CustomerUser: JSON_CustomerUser;

  /** ID of the counterparty for this customer user */
  Counterparty: JSON_Counterparty;

  /** Unique ID of the customer account */
  MarketAccount: JSON_MarketAccount;

  /** Customer address currency */
  Currency: string;

  /** Type of customer address. Either Deposit or Withdrawal */
  AddressType: CustomerAddressTypeEnum;

  /** Type of routing address. Either Fiat or Crypto */
  AddressRoutingType: AddressRoutingTypeEnum;

  /** Config Status */
  Mode: ModeEnum;

  /** Optional ID of user who last touched customer address record */
  UpdateUser: JSON_User;

  /** Status of customer address */
  Status: CustomerAddressStatusEnum;

  /** Revision */
  Revision: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** String64 */
  Name: string;

  /** Organization ID */
  OrgID: number;

  /** Encrypting key ID */
  EncryptingKeyID: string;

  /** Encrypted content */
  Content: string;

  /** Routing info hash. Used for comparison identity of routing address without decrypting */
  RoutingInfoHash: string;
}

/** Lookup or create a custom instrument */
export interface ICustomInstrumentRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Request type */
  RequestType: CustomInstrumentRequestTypeEnum;

  /** Canonical symbol (only for multileg instruments) */
  Symbol: string;

  /** Product (only for the multileg instruments) */
  ProductType: ProductTypeEnum;

  /** Synthetic Product Type if ProductType is Synthetic */
  SyntheticProductType: SyntheticProductTypeEnum;

  /** Requested fee mode for output market data (only for multileg instruments) */
  FeeMode: FeeModeEnum;

  /** Display symbol (only for multileg instruments) */
  DisplaySymbol: string;

  /** Requested price increment (only for multileg instruments) */
  MinPriceIncrement: JSON_Decimal;

  /** requested size increment (only for multileg instruments) */
  MinSizeIncrement: JSON_Decimal;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Market ID (only for options) */
  Market: JSON_Market;

  /** Base currency ID (only for options) */
  BaseCurrency: string;

  /** Quote currency ID (only for options) */
  QuoteCurrency: string;

  /** Expiration (only for options) */
  Expiration: JSON_UTCTimestamp;

  /** Strike price (only for options) */
  StrikePrice: JSON_Decimal;

  /** Option type (only for options) */
  OptionType: OptionTypeEnum;

  /** Contract size (only for options) */
  ContractSize: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Max number of market data levels to process for the symbol */
  MaxMarketDataDepth: number;

  /** Sub Product type (OTC Forward, Vanilla Option, etc) */
  SubProductType: SubProductTypeEnum;

  /** When enabled, expand each leg using outright unified-liquidity rules for pricing. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** parent parameters */
  Parameters: IMultilegParameters;

  /** Description of the security (only for multileg instruments) */
  Description: string;

  /** Custom Instrument attributes based on the template provided */
  ProductDetails: unknown;

  /** The legs to use on the multileg instrument */
  ReqLegs: ICustomInstrumentRequest12000ReqLegs[];
}

/** Markets to be used for this leg */
export interface IReqLegsMarkets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Optional token on this market. 0 = use the leg SecurityID (and UL expansion if enabled). */
  Symbol: JSON_Security;
}

/** The legs to use on the multileg instrument */
export interface ICustomInstrumentRequest12000ReqLegs {
  /** Security/Instrument ID */
  Symbol: JSON_Security;

  /** Direction this leg will trade compared to the parent order side (Same, Opposite) */
  Direction: LegDirectionEnum;

  /** Leg category */
  Category: string;

  /** The amount of this leg in one unit of a composite asset */
  SizeRatio: JSON_Decimal;

  /** Markets to be used for this leg */
  Markets: IReqLegsMarkets[];
}

/** Contain parameters for a synthetic multileg instrument */
export interface IMultilegParameters {
  /** The legs to use on the multileg instrument */
  LegParams: IMultilegParameters12001LegParams[];
}

/** The legs to use on the multileg instrument */
export interface IMultilegParameters12001LegParams {
  /** Cap on the number of levels to rest on a leg */
  MaxRestingLevels: number;

  /** Whether the leg is allowed to send crossing orders */
  CrossingAllowed: boolean;

  /** Whether the leg is allowed to send crossing and/or resting orders, as requested by the order strategy */
  Initiating: boolean;

  /** A percentage discount to apply to the legs sizes in market data when decision-making. Example: a value of 0.25 reduces the sizes by 25% */
  HaircutRatio: JSON_Decimal;
}

/** The response of a CustomInstrumentRequest */
export interface ICustomInstrumentRequestResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Status of the request */
  Status: CustomInstrumentRequestStatusEnum;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;

  /** Display symbol */
  DisplaySymbol: string;

  /** Error reason */
  Text: string;
}

/** Custom Securities snapshot request */
export interface IDeprecatedCustomInstrumentSnapshotRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;
}

/** Custom Securities snapshot */
export interface IDeprecatedCustomInstrumentSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Status of the CustomInstrumentSnapshot */
  Status: DeprecatedCustomInstrumentSnapshotRequestStatusEnum;

  /** The error message that occurred */
  Text: string;
}

/** Request to delete a multileg synthetic instrument */
export interface ICustomInstrumentDeleteRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security/Instrument ID */
  SecurityID: number;

  /** Type of deletion */
  DeleteOperation: DeleteOperationEnum;

  /** Organization ID */
  OrgID: number;

  /** OID for this request */
  RequestID: JSON_Int64ID;
}

/** Response to a request to delete a multileg synthetic security */
export interface ICustomInstrumentDeleteRequestResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** Security ID */
  Symbol: JSON_Security;

  /** Status of the request */
  Status: CustomInstrumentDeleteRequestStatusEnum;

  /** Organization ID */
  OrgID: number;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Error reason */
  Text: string;
}

/** Request to change a multileg synthetic instrument */
export interface ICustomInstrumentUpdateRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Security/Instrument ID */
  SecurityID: number;

  /** Canonical symbol (only for multileg instruments or options) */
  Symbol: string;

  /** Requested fee mode for output market data (only for multileg instruments) */
  FeeMode: FeeModeEnum;

  /** Requested price increment (only for multileg instruments or options) */
  MinPriceIncrement: JSON_Decimal;

  /** requested size increment (only for multileg instruments or options) */
  MinSizeIncrement: JSON_Decimal;

  /** Canonical size increment (only for options) */
  MinimumSize: JSON_Decimal;

  /** Canonical size increment (only for options) */
  MaximumSize: JSON_Decimal;

  /** Default price increment (Display Field) (only for options) */
  DefaultPriceIncrement: JSON_Decimal;

  /** Default size increment (Display Field) (only for options) */
  DefaultSizeIncrement: JSON_Decimal;

  /** Display spec for prices (Display Field) (only for options) */
  PriceDisplaySpec: string;

  /** Display spec for sizes (Display Field) (only for options) */
  SizeDisplaySpec: string;

  /** Normal size for display (Display Field) (only for options) */
  NormalSize: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Max number of market data levels to process for the symbol */
  MaxMarketDataDepth: number;

  /** When enabled, expand each leg using outright unified-liquidity rules for pricing. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** parent parameters */
  Parameters: IMultilegParameters;

  /** Description of the security (only for multileg instruments or options) */
  Description: string;

  /** Display symbol (only for multileg instruments or options) */
  DisplaySymbol: string;

  /** Custom Instrument attributes based on the template provided */
  ProductDetails: unknown;

  /** The legs to use on the multileg instrument */
  UpdateReqLegs: ICustomInstrumentUpdateRequest12007UpdateReqLegs[];

  /** Default list of size buckets (Display Field) */
  SizeBuckets: ICustomInstrumentUpdateRequest12007SizeBuckets[];
}

/** Markets to be used for this leg */
export interface IUpdateReqLegsMarkets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Optional token on this market. 0 = use the leg SecurityID (and UL expansion if enabled). */
  Symbol: JSON_Security;
}

/** Default list of size buckets (Display Field) */
export interface ICustomInstrumentUpdateRequest12007SizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** The legs to use on the multileg instrument */
export interface ICustomInstrumentUpdateRequest12007UpdateReqLegs {
  /** Security/Instrument ID, cannot differ from the existing security for this leg index */
  Symbol: JSON_Security;

  /** Leg category */
  Category: string;

  /** Direction this leg will trade compared to the parent order side (Same, Opposite) */
  Direction: LegDirectionEnum;

  /** The amount of this leg in one unit of a composite asset */
  SizeRatio: JSON_Decimal;

  /** Markets to be used for this leg */
  Markets: IUpdateReqLegsMarkets[];
}

/** Response to a request to update a multileg synthetic security */
export interface ICustomInstrumentUpdateResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  User: JSON_User;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Security/Instrument ID */
  Symbol: JSON_Security;

  /** Status of the request */
  Status: CustomInstrumentRequestStatusEnum;

  /** Organization ID */
  OrgID: number;

  /** Error reason */
  Text: string;
}

/** Contain parameters for child markets */
export interface IMarketParameters {
  /** List of market parameters */
  MarketParams: IMarketParameters12009MarketParams[];
}

/** List of market parameters */
export interface IMarketParameters12009MarketParams {
  /** Property */
  Property: MarketParameterPropertyEnum;

  /** Property value as a string */
  Value: string;
}

/** Request to create an instance of a template */
export interface ICustomInstrumentInstanceRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** User ID */
  User: JSON_User;

  /** OID for this request */
  RequestID: JSON_Int64ID;

  /** Template Security/Instrument ID */
  TemplateSecurityID: number;

  /** Optional display-symbol for the instance */
  InstanceDisplaySymbol: string;

  /** Instance-specific attributes */
  InstanceInfo: unknown;
}

/** Contain negotiation parameters for quote chain messages */
export interface INegotiationParameters {
  /** SizeCountering */
  SizeCountering: SizeCounteringEnum;

  /** PartialFill */
  PartialFill: PartialFillEnum;
}

/** Order metadata used by the NEAR Intents gateway */
export interface INearIntentsMetadata {
  /** Deposit address the swap must be funded to; used for polling 1Click swap status */
  DepositAddress: string;

  /** Optional memo/tag to include with the deposit; required for polling swap status on certain chains */
  Memo: string;
}

/** Order metadata used by the Polymarket gateway */
export interface IPolymarketMetadata {
  /** Full Polymarket order ID (0x-prefixed order hash); ExecutionReport OrderID holds only its first 36 bytes */
  OrderID: string;
}

/** Common trade sizes seen for a particular security */
export interface ITradeSize {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Security ID */
  Symbol: JSON_Security;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Trade sizes and their weights for securities */
  Sizes: ITradeSize4850Sizes[];
}

/** Trade sizes and their weights for securities */
export interface ITradeSize4850Sizes {
  /** Trade size */
  Size: JSON_Decimal;

  /** Weight of trade size */
  Weight: JSON_Decimal;
}

/** Heartbeat from DBS containing the position on the sequenced stream it has persisted up to */
export interface IDBSHeartbeat {
  /** Position on the sequenced stream that all resources have been persisted up to */
  Position: number;

  /** Subset of positions per resource */
  ResourcePositions: IDBSHeartbeat6900ResourcePositions[];
}

/** Subset of positions per resource */
export interface IDBSHeartbeat6900ResourcePositions {
  /** Position for this resource */
  Position: number;

  /** ResourceKey identifying the resource */
  ResourceKey: IResourceKey;
}

/** MarketSecurityOrg is information sourced by the gateways for a market/marketaccount and can be used by the rest of the system */
export interface IMarketSecurityOrg {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Market Account ID */
  MarketAccountID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** Whether this security is enabled */
  Enabled: boolean;

  /** Type of functionality supported by this market security */
  Capabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** Min market price increment */
  MinPriceIncrement: JSON_Decimal;

  /** Min market size increment */
  MinSizeIncrement: JSON_Decimal;

  /** Min market size */
  MinimumSize: JSON_Decimal;

  /** Max market size */
  MaximumSize: JSON_Decimal;

  /** Minimum amount required to place an order */
  MinimumAmount: JSON_Decimal;

  /** Min amount increment */
  MinAmountIncrement: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Default list of size buckets (Display Field) */
  SizeBuckets: IMarketSecurityOrg11000SizeBuckets[];
}

/** Default list of size buckets (Display Field) */
export interface IMarketSecurityOrg11000SizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** MarketSecurityStatus records if a security is enabled for this market/marketaccountid */
export interface IMarketSecurityStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Market Account ID */
  MarketAccount: JSON_MarketAccount;

  /** Security ID */
  Symbol: JSON_Security;

  /** Type of functionality supported by this connection */
  ConnectionType: Record<ConnectionTypeEnum, boolean>;

  /** Overall status */
  Status: ConnectionStatusEnum;

  /** Min price increment */
  MinPriceIncrement: JSON_Decimal;

  /** Min size increment */
  MinSizeIncrement: JSON_Decimal;

  /** Minimum size */
  MinimumSize: JSON_Decimal;

  /** Maximum size */
  MaximumSize: JSON_Decimal;

  /** Type of functionality supported by this market security */
  Capabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** Minimum amount required to place an order */
  MinimumAmount: JSON_Decimal;

  /** Whether this security is enabled according to the market */
  MarketEnabled: ConnectionModeEnum;

  /** Market min price increment */
  MarketMinPriceIncrement: JSON_Decimal;

  /** Market min size increment */
  MarketMinSizeIncrement: JSON_Decimal;

  /** Market minimum size */
  MarketMinimumSize: JSON_Decimal;

  /** Market maximum size */
  MarketMaximumSize: JSON_Decimal;

  /** Market Minimum amount required to place an order */
  MarketMinimumAmount: JSON_Decimal;

  /** Type of functionality supported by this market security */
  MarketCapabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** The requested connection mode (Up / Down) */
  RequestedEnabled: ConnectionModeEnum;

  /** Requested min price increment */
  RequestedMinPriceIncrement: JSON_Decimal;

  /** Requested max size increment */
  RequestedMinSizeIncrement: JSON_Decimal;

  /** Requested minimum size */
  RequestedMinimumSize: JSON_Decimal;

  /** Requested maximum size */
  RequestedMaximumSize: JSON_Decimal;

  /** Requested Minimum amount required to place an order */
  RequestedMinimumAmount: JSON_Decimal;

  /** Type of functionality supported by this market security */
  RequestedCapabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** Whether this security is enabled as a result of market or user overrides */
  Enabled: ConnectionModeEnum;

  /** Min amount increment */
  MinAmountIncrement: JSON_Decimal;

  /** Market min amount increment */
  MarketMinAmountIncrement: JSON_Decimal;

  /** Requested min amount increment */
  RequestedMinAmountIncrement: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Active list of size buckets (Display Field) */
  SizeBuckets: IMarketSecurityStatus11001SizeBuckets[];

  /** Active list of size buckets (Display Field) */
  MarketSizeBuckets: IMarketSecurityStatus11001MarketSizeBuckets[];

  /** Active list of size buckets (Display Field) */
  RequestedSizeBuckets: IMarketSecurityStatus11001RequestedSizeBuckets[];
}

/** Active list of size buckets (Display Field) */
export interface IMarketSecurityStatus11001MarketSizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** Active list of size buckets (Display Field) */
export interface IMarketSecurityStatus11001RequestedSizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** Active list of size buckets (Display Field) */
export interface IMarketSecurityStatus11001SizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** MarketSecurityOrgRequest is sent by receivers to request gateway-sourced MarketSecurityOrg snapshots */
export interface IMarketSecurityOrgRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Subscribe, Unsubscribe, Snapshot, etc. */
  SubscriptionRequestType: SubscriptionRequestTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** Optional list of securities to filter by; empty means all */
  Symbols: IMarketSecurityOrgRequest11002Symbols[];

  /** Optional list of markets to filter by; empty means all */
  Markets: IMarketSecurityOrgRequest11002Markets[];
}

/** Optional list of markets to filter by; empty means all */
export interface IMarketSecurityOrgRequest11002Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** Optional list of securities to filter by; empty means all */
export interface IMarketSecurityOrgRequest11002Symbols {
  /** Security ID */
  Symbol: JSON_Security;
}

/** Order strategy */
export interface IStrategy {
  /** ID of the strategy */
  Strategy: JSON_Strategy;

  /** Strategy name */
  Name: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Strategy group */
  Group: string;

  /** Strategy type */
  AlgoType: AlgoTypeEnum;

  /** Indicates what securities a strategy supports */
  InstrumentScope: string;

  /** Revision */
  Revision: number;

  /** Scope in which this strategy can be used */
  StrategyScope: StrategyScopeEnum;

  /** Strategy description */
  Description: string;

  /** Strategy display name */
  DisplayName: string;

  /** Strategy metadata */
  Metadata: string;

  /** Parameters of the strategy */
  Parameters: IStrategy4860Parameters[];
}

/** When Type=Enum, this list will contain the allowed values */
export interface IParametersEnumValues {
  /** The index of the value within the set, which can be used both for sorting and an identifier */
  Index: number;

  /** Short name for this enum value */
  Name: string;

  /** Parameter description */
  Description: string;
}

/** Parameters of the strategy */
export interface IStrategy4860Parameters {
  /** ID of the strategy parameter */
  ParameterID: number;

  /** Parameter name */
  Name: string;

  /** Parameter type */
  Type: string;

  /** Whether param is optional, required etc */
  Presence: PresenceEnum;

  /** Parameter description */
  Description: string;

  /** Parameter display name */
  DisplayName: string;

  /** Parameter default value */
  DefaultValue: string;

  /** Parameter metadata */
  Metadata: string;

  /** When Type=Enum, this list will contain the allowed values */
  EnumValues: IParametersEnumValues[];
}

/** Command generated by publisher for esign service to prepare and send document to all recipients. */
export interface IESignCreateAndSend {
  /** ID of the esign gateway service where the document should be sent from. */
  ESignGateway: JSON_ESignGateway;

  /** ID, generated by publisher, to be assigned to the document being created/sent. */
  DocumentID: JSON_Int64ID;

  /** Esign platform identifier of the document template (e.g. DocuSign template ID). */
  ESignTemplateID: string;

  /** User friendly name for the document. */
  DocumentDisplayName: string;

  /** Recipients of the document. */
  Recipients: IESignCreateAndSend11010Recipients[];

  /** All the tab labels required for this document. */
  Tabs: IESignCreateAndSend11010Tabs[];
}

/** Recipients of the document. */
export interface IESignCreateAndSend11010Recipients {
  /** Name of recipient to be used at the esign venue. Not necessarily an individual. */
  LegalName: string;

  /** Delivery identifier used by esign platforms for the recipient (e.g. email address). */
  DeliveryID: string;

  /** ESign platform role name associated with the recipient. */
  Role: string;
}

/** All the tab labels required for this document. */
export interface IESignCreateAndSend11010Tabs {
  /** Tab label name. */
  Label: string;

  /** Tab label value. */
  Value: string;
}

/** ESign gateway update events for a document. */
export interface IESignGatewayEvent {
  /** Timestamp of when this event was generated by the document gateway service. */
  Timestamp: JSON_UTCTimestamp;

  /** Timestamp of when the event was generate at esign platform. */
  RemoteTimestamp: JSON_UTCTimestamp;

  /** Unique identifier of the document assigned during creation. */
  DocumentID: JSON_Int64ID;

  /** Events published by esign gateway (e.g. created, signed, completed). */
  EventType: ESignGatewayEventTypeEnum;

  /** Delivery identifier used by esign platforms for the recipient (e.g. email address). */
  RecipientDeliveryID: string;

  /** Additional details for the event (e.g. cancellation reason). */
  Text: string;

  /** Identifier generated by eSign platform to uniquely identify this document. */
  RemoteDocumentID: string;
}

/** Cumulative status update for a document.(ResourceName:ESignStatus ResourceTag:S DatabaseName:esign_statuses Key:DocumentID TimestampField:Timestamp AeronCols:true ConstantGroupLength:true PrimaryKey:Generated DBType:LoanDB)(ResourceName:ESignStatusHistory ResourceTag:H DatabaseName:esign_status_history Key:DocumentID,Revision TimestampField:Timestamp AeronCols:true ConstantGroupLength:true PrimaryKey:Generated DBType:LoanDB) */
export interface IESignStatus {
  /** Timestamp of when this event was generated by the document service. */
  Timestamp: JSON_UTCTimestamp;

  /** An increasing sequence number for this DocumentID. A new value indicates state has changed. Generated by Talos. */
  Revision: number;

  /** Unique identifier of the document assigned during creation. */
  DocumentID: JSON_Int64ID;

  /** Esign platform identifier of template (e.g. DocuSign template ID) used to generate document. */
  ESignTemplateID: string;

  /** Latest state of the document (e.g. created, signed, completed) for this recipient. */
  DocumentStatus: ESignStatusEnum;

  /** Additional details for the event (e.g. cancellation reason). */
  Text: string;

  /** User friendly name for the document. */
  DocumentDisplayName: string;

  /** Identifier generated by eSign platform to uniquely identify this document. */
  RemoteDocumentID: string;

  /** States of all the recipients of this document. */
  Recipients: IESignStatus11012Recipients[];

  /** All the tab labels used to create this document. */
  RequestedTabs: IESignStatus11012RequestedTabs[];
}

/** States of all the recipients of this document. */
export interface IESignStatus11012Recipients {
  /** Remote timestamp, from ESign platform, when this entry was last updated. */
  Timestamp: JSON_UTCTimestamp;

  /** Latest recipient status (e.g. PendingSignature, Signed, Rejected). */
  Status: ESignRecipientStatusEnum;

  /** Name of recipient to be used at the esign venue. Not necessarily an individual. */
  LegalName: string;

  /** Delivery identifier used by esign platforms for the recipient (e.g. email address). */
  DeliveryID: string;

  /** ESign platform role name associated with the recipient. */
  Role: string;
}

/** All the tab labels used to create this document. */
export interface IESignStatus11012RequestedTabs {
  /** Tab label name. */
  Label: string;

  /** Tab label value. */
  Value: string;
}

/** Command generated by esign service for esign gateway to prepare and send document to all recipients. */
export interface IESignGatewayCreateAndSend {
  /** ID of the esign gateway service where this message should be processed. */
  ESignGateway: JSON_ESignGateway;

  /** ID, generated by publisher, to be assigned to the document being created/sent. */
  DocumentID: JSON_Int64ID;

  /** ESign platform identifier of the document template (e.g. DocuSign template ID). */
  ESignTemplateID: string;

  /** User friendly name for the document. */
  DocumentDisplayName: string;

  /** Recipients of the document. */
  Recipients: IESignGatewayCreateAndSend11013Recipients[];

  /** All the tab labels required for this document. */
  Tabs: IESignGatewayCreateAndSend11013Tabs[];
}

/** Recipients of the document. */
export interface IESignGatewayCreateAndSend11013Recipients {
  /** Name of recipient to be used at the esign venue. Not necessarily an individual. */
  LegalName: string;

  /** Delivery identifier used by esign platforms for the recipient (e.g. email address). */
  DeliveryID: string;

  /** ESign platform role name associated with the recipient. */
  Role: string;
}

/** All the tab labels required for this document. */
export interface IESignGatewayCreateAndSend11013Tabs {
  /** Tab label name. */
  Label: string;

  /** Tab label value. */
  Value: string;
}

/** The configuration of enum values for strategy parameters, which can optionally change internal settings */
export interface IStrategyParameterEnum {
  /** ID of the strategy parameter */
  ParameterID: number;

  /** The index of the value within the set, which can be used both for sorting and an identifier. Zero is the null value of Enums inside Strategy Parameters, so these should start at 1. */
  Index: number;

  /** Short name for this enum value */
  Name: string;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Parameter description */
  Description: string;

  /** Internal algo settings modified by selecting this enum value, if any */
  Settings: IStrategyParameterEnum4870Settings[];
}

/** Internal algo settings modified by selecting this enum value, if any */
export interface IStrategyParameterEnum4870Settings {
  /** An internal setting to be set for this effect */
  Setting: StrategyParameterSettingEnum;

  /** Value of the internal setting represented as a string */
  Value: string;

  /** If non-zero represents an override of the setting for that Security ID */
  Symbol: JSON_Security;

  /** Override for the setting */
  Override: string;
}

/** Whitelist for unused enums to be generated */
export interface IWhitelist {
  /** Lookback */
  Lookback: PnlLookbackEnum;

  /** OnPlatformAnalyticsTier */
  OnPlatformAnalyticsTier: OnPlatformAnalyticsTierEnum;

  /** SubAccountSMPCheckType */
  SubAccountSMPCheckType: SubAccountSMPCheckTypeEnum;

  /** SubAccountTradeRoutingMode */
  SubAccountTradeRoutingMode: SubAccountTradeRoutingModeEnum;

  /** TransactionAutoProposalMode */
  TransactionAutoProposalMode: TransactionAutoProposalModeEnum;

  /** PreciseDec */
  PreciseDec: JSON_Decimal;

  /** PayoffType */
  PayoffType: PayoffTypeEnum;

  /** OTCSettlementType */
  OTCSettlementType: OTCSettlementTypeEnum;

  /** LoanSide */
  LoanSide: LoanSideEnum;

  /** CounterpartyWorkflowType */
  CounterpartyWorkflowType: CounterpartyWorkflowTypeEnum;

  /** DateOnly */
  DateOnly: JSON_DateOnly;

  /** TimeOnly */
  TimeOnly: JSON_TimeOnly;

  /** DealDefaultableValues */
  DealDefaultableValues: DealDefaultableValuesEnum;

  /** PrepaymentOption */
  PrepaymentOption: PrepaymentOptionEnum;

  /** ExerciseStyle */
  ExerciseStyle: ExerciseStyleEnum;

  /** StrikeType */
  StrikeType: StrikeTypeEnum;

  /** DayCountConvention */
  DayCountConvention: DayCountConventionEnum;

  /** CommissionCalculationType */
  CommissionCalculationType: CommissionCalculationTypeEnum;

  /** IndexValueType */
  IndexValueType: IndexValueTypeEnum;

  /** PositionAssetType */
  PositionAssetType: PositionAssetTypeEnum;

  /** RepoDirection */
  RepoDirection: RepoDirectionEnum;

  /** WorkingAmountAllocMode */
  WorkingAmountAllocMode: WorkingAmountAllocModeEnum;

  /** LoanPaymentType */
  LoanPaymentType: LoanPaymentTypeEnum;

  /** LoanSecurityType */
  LoanSecurityType: LoanSecurityTypeEnum;
}

/** Different statistics per security and per market */
export interface ISecurityStats {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Average top of book bid size */
  AvgBidSize: JSON_Decimal;

  /** Average top of book ask size */
  AvgAskSize: JSON_Decimal;

  /** Average daily volume */
  AvgDailyVolume: JSON_Decimal;

  /** Revision */
  Revision: number;

  /** Keep alive interval in seconds after which the security should be considered stale */
  KeepAliveInterval: JSON_Decimal;

  /** Average bid size on level (JSON list of Dec). */
  AvgBidSizeOnLevel: ISecurityStats4880AvgBidSizeOnLevel[];

  /** Average ask size on level (JSON list of Dec). */
  AvgAskSizeOnLevel: ISecurityStats4880AvgAskSizeOnLevel[];
}

/** Average ask size on level (JSON list of Dec). */
export interface ISecurityStats4880AvgAskSizeOnLevel {
  /** Average ask size on level */
  Size: JSON_Decimal;
}

/** Average bid size on level (JSON list of Dec). */
export interface ISecurityStats4880AvgBidSizeOnLevel {
  /** Average bid size on level */
  Size: JSON_Decimal;
}

/** Configured fee snapshot request from EXCHANGE or OVERRIDE */
export interface IFeeConfigSnapshotRequest {
  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** Source of the fee event, i.e. EXCHANGE/OVERRIDE */
  Source: FeeSourceEnum;

  /** Organization ID */
  OrgID: number;
}

/** Fee request */
export interface IFeeSnapshotRequest {
  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** Organization ID */
  OrgID: number;
}

/** Get market fee rates response */
export interface IFeeEvent {
  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** MarketID for this fee */
  Market: JSON_Market;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Maker fee rate */
  MakerFeeRate: JSON_Decimal;

  /** Taker fee rate */
  TakerFeeRate: JSON_Decimal;

  /** Security ID */
  Symbol: JSON_Security;

  /** Source of the fee event, i.e. EXCHANGE/OVERRIDE */
  Source: FeeSourceEnum;

  /** Internal time in number of nanoseconds since Unix epoch representing when the message was sent */
  Timestamp: JSON_UTCTimestamp;

  /** How the market charges fees */
  MarketFeeMode: MarketFeeModeEnum;

  /** Only specified (non-zero) if fees are charged in the exchange token */
  ExchangeTokenID: string;

  /** The maximum maker fee (always in quote currency) */
  MaxMakerFee: JSON_Decimal;

  /** The maximum taker fee (always in quote currency) */
  MaxTakerFee: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Parent prediction outcome event series identifier, 0 when the fee is not series scoped */
  SeriesID: JSON_Int64ID;

  /** Prediction outcome event identifier, 0 when the fee is not event scoped */
  EventID: JSON_Int64ID;

  /** How the fee is calculated for this market */
  FeeCalcBasis: FeeCalcBasisEnum;
}

/** Fee request */
export interface IFeeUpdateConfigRequest {
  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Maker fee rate */
  MakerFeeRate: JSON_Decimal;

  /** Taker fee rate */
  TakerFeeRate: JSON_Decimal;

  /** Security ID */
  Symbol: JSON_Security;

  /** Action */
  Action: FeeConfigUpdateActionEnum;

  /** The maximum maker fee (always in quote currency) */
  MaxMakerFee: JSON_Decimal;

  /** The maximum taker fee (always in quote currency) */
  MaxTakerFee: JSON_Decimal;

  /** Organization ID */
  OrgID: number;
}

/** Response from Fee service */
export interface IFeeResponse {
  /** Request correlation ID */
  RequestID: JSON_Int64ID;

  /** Status of the update request */
  Status: FeeResponseStatusEnum;

  /** Error while fetching fees */
  Text: string;

  /** Maker fee rate */
  MakerFeeRate: JSON_Decimal;

  /** Taker fee rate */
  TakerFeeRate: JSON_Decimal;

  /** Security ID */
  Symbol: JSON_Security;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** The maximum maker fee (always in quote currency) */
  MaxMakerFee: JSON_Decimal;

  /** The maximum taker fee (always in quote currency) */
  MaxTakerFee: JSON_Decimal;

  /** Organization ID */
  OrgID: number;
}

/** Parameters for strategies */
export interface IStrategyParameters {
  /** Price offset from the reference price, positive offsets are more passive prices */
  PriceOffset: JSON_Decimal;

  /** Size to show on the market when resting */
  ShowQty: JSON_Decimal;

  /** Datetime when order is closed */
  EndTime: JSON_UTCTimestamp;

  /** Duration of the order */
  Duration: JSON_DurationMillis;

  /** Size for crossing orders */
  ClipSize: JSON_Decimal;

  /** Value between 0 and 1 applied to randomize child order sizes */
  Variance: JSON_Decimal;

  /** Interval to send clip sizes */
  ClipInterval: JSON_DurationMillis;

  /** Max amount of time order is paused after spread widening */
  SpreadWideningWaitPeriod: JSON_DurationMillis;

  /** Allowed percentage deviation from average spread */
  SpreadWideningDeviation: JSON_Decimal;

  /** Trigger price market must hit to activate an order */
  TriggerPrice: JSON_Decimal;

  /** Type of trigger e.g stop or cross */
  TriggerType: TriggerTypeEnum;

  /** Action to take in response to passing a threshold of certain error responses. e.g cancel or pause */
  ErrorAction: ErrorActionEnum;

  /** Datetime when order should start */
  StartTime: JSON_UTCTimestamp;

  /** Reference price by which to compare the gateway prices against */
  ReferencePrice: JSON_Decimal;

  /** Source aggregation-id of trigger reference prices. */
  TriggerSource: number;

  /** The minimum spread to be maintained when appying price-offset */
  MinPriceOffsetSpread: JSON_Decimal;

  /** The type/units of the PriceOffset and MinPriceOffsetSpread, e.g. Price or BasisPoints */
  PriceOffsetUnits: PriceOffsetUnitsEnum;

  /** Source aggregation-id of price protection reference prices. */
  PriceProtectionSource: number;

  /** The index of the enum value chosen for BoundsControl. The allowed values are provided on the API. */
  BoundsControl: number;

  /** The index of the enum value chosen for Urgency. The allowed values are provided on the API. */
  Urgency: number;

  /** Type of the algo defined by the strategy. */
  AlgoType: AlgoTypeEnum;

  /** Algo instruction flags. */
  AlgoInstructions: Record<AlgoInstructionsEnum, boolean>;

  /** Determines how to peg resting orders */
  PegReferenceType: PegReferenceTypeEnum;

  /** Control price protection check. Error excludes market, Disabled does not run logic. */
  PriceProtection: PriceProtectionEnum;

  /** Enable or disable unified liquidity feature. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** Target participation rate. */
  TargetParticipationRate: JSON_Decimal;

  /** Maximum amount to allow the legs to be imbalanced */
  MaxImbalanceAmt: JSON_Decimal;

  /** Currency for the max imbalanced amount */
  MaxImbalanceAmtCurrency: string;

  /** Max amount of time to wait for hedge fills passively */
  HedgePassiveTimeout: JSON_DurationMillis;

  /** Percent above the limit price willing to pay up to hedge out. Decimal value between 0 and 1 */
  HedgePayExtra: JSON_Decimal;

  /** Max allocation allowed for each market (value should be between 0 and 1), must be >= order qty divided by number of markets */
  MaxAllocationPerMarket: JSON_Decimal;

  /** order will only reduce open positions */
  ReduceOnly: ReduceOnlyEnum;

  /** order will reduce open positions when possible */
  ReduceFirst: ReduceFirstEnum;

  /** Percent further away the limit price willing to hedge out at market. Decimal value between 0 and 1 */
  MarketHedgeTrigger: JSON_Decimal;

  /** Dynamic delta hedge strategy (consumed by hedger) */
  DynamicDeltaHedgeStrategy: JSON_Strategy;

  /** Dynamic delta hedge instrument used to hedge (consumed by hedger) */
  DynamicDeltaHedgeSymbol: JSON_Security;

  /** Lower bound of prices to place scaled orders */
  ScaleEndPrice: JSON_Decimal;

  /** Number of orders to place between upper and lower scaled order bounds */
  NumPriceLevels: number;

  /** Parameter for skewing the quantity of a scaled order towards the agressive or passive side in a linear fashion. */
  SizeDistribution: JSON_Decimal;

  /** Target participation rate. */
  ParticipationRateCap: JSON_Decimal;

  /** Whether adaptive crossing is enabled for this strategy */
  IWouldEnabled: ModeEnum;

  /** Reference side for determining the opportunistic threshold for dealers */
  IWouldRefSide: PriceReferenceTypeEnum;

  /** Offset on threshold to aggress on dealers */
  IWouldOffset: JSON_Decimal;

  /** Offset units for opportunistic threshold */
  IWouldOffsetUnits: PriceOffsetUnitsEnum;

  /** Whether a scaled order can send crossing orders. */
  ScaledOrderCrossingEnabled: ModeEnum;

  /** Aggregation to use for Dynamic delta hedging (consumed by hedger) */
  DynamicDeltaHedgeAggregation: JSON_Aggregation;

  /** Whether arrival aware sweeping/sniping is enabled */
  SnipingEnabled: ModeEnum;

  /** User specified arrival aware bound to take on price worsening (0-1 percentage) */
  SweepBound: JSON_Decimal;

  /** User specified arrival aware bound to take on price improvement (0-1 percentage) */
  SnipeBound: JSON_Decimal;

  /** Whether arrival aware sweeping is enabled */
  SweepingEnabled: ModeEnum;

  /** Enables resting on full amount orders and rests all quantity on a single exchange */
  FullAmountRestingEnabled: ModeEnum;

  /** Aggregation ID containing markets eligible for IWould opportunistic crossing, bypassing the dealer market restriction. */
  IWouldAggregation: JSON_Aggregation;

  /** Quantity held back from allocation/execution, order pauses when LeavesQty == HoldQty */
  HoldQty: JSON_Decimal;

  /** Units for SnipeBound: BasisPoints or PriceUnits */
  SnipeBoundUnits: PriceOffsetUnitsEnum;

  /** Units for SweepBound: BasisPoints or PriceUnits */
  SweepBoundUnits: PriceOffsetUnitsEnum;

  /** Dynamic delta hedging params consumed by hedger */
  DynamicDeltaHedgeStrategyParams: IStrategyParameters;

  /** Leg specific parameters */
  LegParameters: IStrategyParameters4900LegParameters[];
}

/** Leg specific parameters */
export interface IStrategyParameters4900LegParameters {
  /** Index of the leg these parameters apply to */
  LegIndex: number;

  /** Whether the leg is allowed to initiate */
  Initiating: boolean;

  /** A percentage discount to apply to the legs sizes in market data when decision-making. Example: a value of 0.25 reduces the sizes by 25% */
  HaircutRatio: JSON_Decimal;

  /** Size to show to the market when resting */
  ShowQty: JSON_Decimal;

  /** Order will only reduce open positions */
  ReduceOnly: boolean;
}

/** SnapshotBlock indicates the start or end of service snapshot */
export interface ISnapshotBlock {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** EntryType */
  EntryType: SnapshotBlockEntryTypeEnum;

  /** Snapshot version number */
  Version: number;
}

/** DeprecatedApplicationEvent is no longer used */
export interface IDeprecatedApplicationEvent {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** EventType */
  EventType: DeprecatedApplicationEventTypeEnum;
}

/** SnapshotSection indicates the start or end of specific snapshot section */
export interface ISnapshotSection {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** EntryType */
  EntryType: SnapshotBlockEntryTypeEnum;

  /** Name */
  Name: string;
}

/** Request injection of values into an injection site */
export interface IInjectionRequest {
  /** ID of the targeted service */
  ServiceID: JSON_ServiceIdentifier;

  /** The action to take when reaching the injection site */
  Action: InjectionActionEnum;

  /** Inject this many times before removing the request, use 0 to keep request permanently */
  Count: number;

  /** Only process this request before this time (in nanoseconds since Unix epoch) */
  SetBefore: number;

  /** Clear injection after this time (in nanoseconds since Unix epoch) */
  ClearAfter: number;

  /** Fully qualified name of the function that contains the injection site */
  Function: string;

  /** Key of the injection site. Leave blank to match all keys. */
  Key: string;

  /** Message to be logged and passed to the injection site (optional) */
  Message: string;
}

/** Remove all injection requests for a specific service */
export interface IInjectionClear {
  /** ID of the targeted service */
  ServiceID: JSON_ServiceIdentifier;
}

/** A security traded */
export interface ITradedSecurity {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Security ID of the position entry (if non-zero) */
  Symbol: JSON_Security;
}

/** Sent to cause a security to be re-subscribed in a gateway as it may be crossed or stale */
export interface IMarketSecurityMode {
  /** Time of last update */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** The connection mode (Up / Down) */
  Mode: ConnectionModeEnum;

  /** The restart counter, increasing this number will cause a restart */
  RestartCounter: number;

  /** Type of functionality supported by this market security */
  Capabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Market price increment */
  MinPriceIncrement: JSON_Decimal;

  /** Market size increment */
  MinSizeIncrement: JSON_Decimal;

  /** Market size increment */
  MinimumSize: JSON_Decimal;

  /** Market size increment */
  MaximumSize: JSON_Decimal;

  /** Minimum amount required to place an order */
  MinimumAmount: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;

  /** Market amount increment */
  MinAmountIncrement: JSON_Decimal;

  /** Maximum amount required to place an order */
  MaximumAmount: JSON_Decimal;

  /** The user who updated this record */
  UpdateUser: JSON_User;

  /** Default list of size buckets (Display Field) */
  SizeBuckets: IMarketSecurityMode4911SizeBuckets[];
}

/** Default list of size buckets (Display Field) */
export interface IMarketSecurityMode4911SizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** Book message for delivery of streamed data out of AVA */
export interface IMDBookLevel {
  /** Internal time in number of nanoseconds since Unix epoch */
  SystemTimestamp: JSON_UTCTimestamp;

  /** Security ID */
  Symbol: JSON_Security;

  /** MarketID for requested Market */
  Market: JSON_Market;

  /** Latest exchange message timestamp from the markets used on this snapshot. Number of nanoseconds since the Unix epoch. */
  MarketExchangeTime: JSON_UTCTimestamp;

  /** Bid Price */
  BidPrice: JSON_Decimal;

  /** Bid Size */
  BidSize: JSON_Decimal;

  /** Bid Amount */
  BidAmount: JSON_Decimal;

  /** Internal time in number of nanoseconds since Unix epoch */
  BidLevelSystemTime: JSON_UTCTimestamp;

  /** Latest exchange message timestamp from the markets used on this snapshot. Number of nanoseconds since the Unix epoch. */
  BidLevelExchangeTime: JSON_UTCTimestamp;

  /** Offer Price */
  AskPrice: JSON_Decimal;

  /** Offer Size */
  AskSize: JSON_Decimal;

  /** Offer Amount */
  AskAmount: JSON_Decimal;

  /** Internal time in number of nanoseconds since Unix epoch */
  AskLevelSystemTime: JSON_UTCTimestamp;

  /** Latest exchange message timestamp from the markets used on this snapshot. Number of nanoseconds since the Unix epoch. */
  AskLevelExchangeTime: JSON_UTCTimestamp;

  /** Market Data entry tupe used to track also MD Books behavior */
  Flags: MDEntryTypeEnum;

  /** Capture id */
  Capture: string;
}

/** Trade message for delivery of streamed data out of AVA */
export interface IMDTrade {
  /** Internal time in number of nanoseconds since Unix epoch */
  SystemTimestamp: JSON_UTCTimestamp;

  /** Security ID */
  Symbol: JSON_Security;

  /** MarketID for requested Market */
  Market: JSON_Market;

  /** Latest exchange message timestamp from the markets used on this snapshot. Number of nanoseconds since the Unix epoch. */
  MarketExchangeTime: JSON_UTCTimestamp;

  /** Bid Price */
  Price: JSON_Decimal;

  /** Bid Size */
  Size: JSON_Decimal;

  /** ExecID */
  TradeID: string;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** Capture id */
  Capture: string;
}

/** Approval or Rejection of Customer Order Risk Check */
export interface ICustomerRiskResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** OrderID */
  OrderID: string;

  /** Internal unique ID for customer quote request */
  RFQID: string;

  /** Status of customer risk request */
  ApprovalStatus: CustomerRiskApprovalStatusEnum;

  /** Side */
  Side: SideEnum;

  /** Approval Rejection Reason */
  Text: string;
}

/** A request to initiate negotiations with one or more responders. */
export interface ILoanQuoteRequest {
  /** Timestamp of when the request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the initiator referring to the overall request to all responders. */
  QuoteReqID: string;

  /** ID of the participant representing the borrower. */
  Borrower: JSON_Participant;

  /** The ID of the requesting user. */
  User: JSON_User;

  /** Currency ID for the borrowed currency. */
  PrincipalCurrency: string;

  /** Currency ID for the collateral currency, if secured. */
  CollateralCurrency: string;

  /** The quantity of principal to be borrowed. */
  Qty: JSON_Decimal;

  /** The interest rate due on borrowed Qty per the term sheet conventions. */
  Rate: JSON_Decimal;

  /** The ratio of collateral value to principal value. */
  CollateralRatio: JSON_Decimal;

  /** The termination type of this loan quote, fixed or open. */
  TerminationType: LoanQuoteTerminationTypeEnum;

  /** The date and time when the loan would terminate. */
  TerminationTime: JSON_UTCTimestamp;

  /** Indicates the desired state resulting from this request. */
  RequestType: LoanQuoteRequestTypeEnum;

  /** A message relevant to the terms of this request. It will be sent to all Lenders. */
  Comments: string;

  /** The responders who should receive the request */
  Lenders: ILoanQuoteRequest8001Lenders[];
}

/** The responders who should receive the request */
export interface ILoanQuoteRequest8001Lenders {
  /** ID of the participant representing a target responder. */
  Lender: JSON_Participant;
}

/** A request by the responder to set firm terms on a LoanQuote. */
export interface ILoanQuoteLenderUpdate {
  /** Timestamp of when the request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this request. */
  QuoteReqID: string;

  /** The ID of the LoanQuote to be updated. */
  NegotiationID: JSON_Int64ID;

  /** The revision of the LoanQuote to be updated. It's only possible to update the most recent revision. */
  TargetRevision: number;

  /** ID of the updating participant. */
  Participant: JSON_Participant;

  /** The ID of the updating user. */
  User: JSON_User;

  /** Currency ID for the collateral currency, if secured. */
  CollateralCurrency: string;

  /** The quantity of principal to be borrowed. */
  Qty: JSON_Decimal;

  /** The interest rate due on borrowed Qty per the term sheet conventions. */
  Rate: JSON_Decimal;

  /** The ratio of collateral value to principal value. */
  CollateralRatio: JSON_Decimal;

  /** The termination type of this loan quote, fixed or open. */
  TerminationType: LoanQuoteTerminationTypeEnum;

  /** The date and time when the loan would terminate. */
  TerminationTime: JSON_UTCTimestamp;

  /** A message relevant to the terms of this update. */
  Comments: string;
}

/** A request by the initiator to accept the firm terms of a LoanQuote. */
export interface ILoanQuoteBorrowerAccept {
  /** Timestamp of when the request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this request. */
  QuoteReqID: string;

  /** The ID of the LoanQuote to accept. */
  NegotiationID: JSON_Int64ID;

  /** The revision of the LoanQuote to accept. It's only possible to accept the most recent revision. */
  TargetRevision: number;

  /** ID of the accepting participant. */
  Participant: JSON_Participant;

  /** The ID of the accepting user. */
  User: JSON_User;
}

/** Lock request that Talos sends to dealer external server for customer RFQ/order */
export interface IExternalLockRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** LockID */
  LockID: string;

  /** Type of Lock Request. Either Lock to lock funds or Release to release funds */
  RequestType: LockRequestTypeEnum;

  /** User ID for that lock request */
  CustomerUser: JSON_CustomerUser | undefined;

  /** customer quantity */
  CustomerQuantity: JSON_Decimal;

  /** customer currency */
  CustomerCurrency: string;

  /** dealer quantity */
  DealerQuantity: JSON_Decimal;

  /** dealer currency */
  DealerCurrency: string;

  /** Type of underlying object: Order or RFQ */
  Type: LockUnderlyingObjectTypeEnum;

  /** ID of the counterparty for this lock */
  CustomerID: number;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Organization ID */
  OrgID: number;

  /** underlying customer order */
  Order: ICustomerExecutionReport;

  /** underlying customer RFQ */
  RFQ: ICustomerQuote;
}

/** A request to cancel a LoanQuote. */
export interface ILoanQuoteCancel {
  /** Timestamp of when the request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this request. */
  QuoteReqID: string;

  /** The ID of the LoanQuote to be canceled. */
  NegotiationID: JSON_Int64ID;

  /** ID of the canceling participant. */
  Participant: JSON_Participant;

  /** The ID of the canceling user. */
  User: JSON_User;

  /** A message relevant to this cancelation. */
  Comments: string;
}

/** Market data plane voltrace request */
export interface IVoltraceRequest {
  /** Market filter; -1 means all markets. */
  Market: JSON_Market;

  /** Security filter; zero means all securities. */
  Symbol: JSON_Security;

  /** Requested voltrace options. */
  Options: Record<VoltraceOptionsEnum, boolean>;

  /** Hostname of the forwarding node; empty for the initial CLI request. */
  SrcHostname: string;

  /** Environment of the forwarding node (e.g. uat, prod); empty for the initial CLI request. */
  SrcEnvironment: string;

  /** Process name of the forwarding node; empty for the initial CLI request. */
  SrcProcessName: string;

  /** Maximum topology discovery duration in milliseconds; zero or null uses the server default. */
  Timeout: JSON_DurationMillis;
}

/** Response from external dealer server for lock request */
export interface IExternalLockResponse {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** LockID */
  LockID: string;

  /** Status for external risk request */
  ApprovalStatus: CustomerRiskApprovalStatusEnum;

  /** Approval Rejection Reason */
  Text: string;
}

/** A request to reject a LoanQuote. */
export interface ILoanQuoteReject {
  /** Timestamp of when the request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this request. */
  QuoteReqID: string;

  /** The ID of the LoanQuote to be rejected. */
  NegotiationID: JSON_Int64ID;

  /** ID of the rejecting participant. */
  Participant: JSON_Participant;

  /** The ID of the rejecting user. */
  User: JSON_User;

  /** A message relevant to this rejection. */
  Comments: string;
}

/** Common metadata for a voltrace response */
export interface IVoltraceResponseHeader {
  /** Time sent in nanoseconds since Unix epoch. */
  Timestamp: JSON_UTCTimestamp;

  /** Hostname of the node producing the response. */
  Hostname: string;

  /** Environment of the node producing the response. */
  Environment: string;

  /** Process name of the node producing the response. */
  ProcessName: string;

  /** Git revision of the node producing the response. */
  Revision: string;

  /** Release version of the node producing the response. */
  BuildVersion: string;
}

/** Holds information about status and encumbered quantities for customer lock */
export interface ICustomerLock {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** LockID */
  LockID: string;

  /** Revision of the customer lock */
  Revision: number;

  /** User ID for that lock request */
  CustomerUser: JSON_CustomerUser | undefined;

  /** customer quantity */
  CustomerQuantity: JSON_Decimal;

  /** customer currency */
  CustomerCurrency: string;

  /** dealer quantity */
  DealerQuantity: JSON_Decimal;

  /** dealer currency */
  DealerCurrency: string;

  /** Type of underlying object: Order or RFQ */
  Type: LockUnderlyingObjectTypeEnum;

  /** ID of the counterparty for this lock */
  CustomerID: number;

  /** Status of Customer */
  Status: CustomerLockStatusEnum;

  /** Source of Customer */
  Source: CustomerLockSourceEnum;

  /** customer outstanding sell quantity */
  CustomerOutstandingSell: JSON_Decimal;

  /** customer outstanding buy quantity */
  CustomerOutstandingBuy: JSON_Decimal;

  /** Unique ID of the customer account */
  MarketAccount: JSON_CustomerMarketAccount;

  /** quantity of related transaction */
  TransactionQuantity: JSON_Decimal;

  /** currency of related transaction */
  TransactionCurrency: string;

  /** Indicator if fees are included in CustomerQuantity and CustomerOutstandingSell */
  FeesIncluded: boolean;

  /** Security ID */
  Symbol: JSON_Security;

  /** Price with fees included */
  HedgeReferencePrice: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Index of the leg */
  LegIndex: number;

  /** underlying customer order */
  Order: ICustomerExecutionReport;

  /** underlying customer RFQ */
  RFQ: ICustomerQuote;

  /** underlying customer transaction */
  Transaction: ICustomerBalanceTransaction;
}

/** The current state of a loan negotiation from the lender's perspective. */
export interface ILoanQuoteLender {
  /** Timestamp of when the most recent request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID for the responses between one responder and the initiator for the full lifecycle of this QuoteReqID. Generated by Talos. */
  NegotiationID: JSON_Int64ID;

  /** An increasing sequence number for this NegotiationID. A new value indicates state has changed. Generated by Talos. */
  Revision: number;

  /** An increasing sequence number for this NegotiationID and revision. A new value for the same Revision indicates updated information is available without negotiation state changing. Commonly used to report errors on commands received since the last state change. Generated by Talos. */
  AmendmentCount: number;

  /** A unique ID corresponding to the borrower's OrigQuoteReqID. For the lender 1:1 with NegotiationID. Generated by Talos. */
  ReqID: JSON_Int64ID;

  /** The QuoteReqID from the most recent lender request reflected in this message. */
  QuoteReqID: string;

  /** Timestamp of when the first message for this negotiation was processed. */
  SubmitTime: JSON_UTCTimestamp;

  /** The current status of this loan quote. */
  QuoteStatus: LoanQuoteStatusEnum;

  /** ID of the participant representing the lender. May be omitted on error conditions. */
  Lender: JSON_Participant;

  /** ID of the participant representing the borrower. May be omitted on error conditions. */
  Borrower: JSON_Participant;

  /** The ID of the most recent user at the lender to submit a request. */
  User: JSON_User | undefined;

  /** The user at the lender that owns this quote. */
  Owner: JSON_User | undefined;

  /** Currency ID for the borrowed currency. */
  PrincipalCurrency: string;

  /** Currency ID for the collateral currency, if secured. */
  CollateralCurrency: string | undefined;

  /** The quantity of principal to be borrowed. */
  Qty: JSON_Decimal;

  /** The interest rate due on borrowed Qty per the term sheet conventions. */
  Rate: JSON_Decimal;

  /** The ratio of collateral value to principal value. */
  CollateralRatio: JSON_Decimal;

  /** The termination type of this loan quote, fixed or open. */
  TerminationType: LoanQuoteTerminationTypeEnum;

  /** The date and time when the loan would terminate. */
  TerminationTime: JSON_UTCTimestamp | undefined;

  /** If present, the reason validation failed for the QuoteReqID. */
  ValidationError: LoanQuoteValidationErrorEnum;

  /** Unique identifier of the term sheet for this quote provided to the document service. */
  TermSheetDocID: JSON_Int64ID;

  /** The date and time when the quote will expire if negotiations haven't concluded. */
  EndTime: JSON_UTCTimestamp;

  /** Esign platform identifier of the term sheet template for this loan quote. */
  TermSheetTemplateID: string;

  /** The ID of the document gateway to use for the term sheet. */
  TermSheetGateway: JSON_ESignGateway;

  /** The Qty on this loan quote must be an even multiple of this increment. */
  QtyIncrement: JSON_Decimal;

  /** The Rate on this loan quote must be an even multiple of this increment. */
  RateIncrement: JSON_Decimal;

  /** The CollateralRatio on this loan quote must be an even multiple of this increment. */
  CollateralRatioIncrement: JSON_Decimal;

  /** Minimum quantity of principal allowed to be borrowed. */
  MinQty: JSON_Decimal;

  /** Summary of the current quote state suitable for display. Will be populated if ValidationError is present. */
  Text: string;

  /** A message relevant to the terms of this Revision. */
  Comments: string;

  /** The set of collateral currencies allowed for this loan quote. */
  EnabledCollateralCurrencies: ILoanQuoteLender8006EnabledCollateralCurrencies[];

  /** States for each of the recipients of of the term sheet for this quote. */
  TermSheetRecipients: ILoanQuoteLender8006TermSheetRecipients[];
}

/** The set of collateral currencies allowed for this loan quote. */
export interface ILoanQuoteLender8006EnabledCollateralCurrencies {
  /** Currency ID */
  Currency: string;
}

/** States for each of the recipients of of the term sheet for this quote. */
export interface ILoanQuoteLender8006TermSheetRecipients {
  /** Timestamp when this entry was last updated. */
  Timestamp: JSON_UTCTimestamp;

  /** Latest status in the documentation workflow for this entry's participant. */
  Status: ESignRecipientStatusEnum;

  /** ID of the participant this entry applies to. */
  Participant: JSON_Participant;

  /** Name of the entry's recipient. */
  DisplayName: string;

  /** Delivery identifier used by esign platforms for this recipient. */
  DeliveryID: string;
}

/** One directed edge in the market data plane topology graph, emitted as a streaming partial response per edge discovered */
export interface IVoltraceTopologyEdge {
  /** Time sent in nanoseconds since Unix epoch. */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID of the downstream (publisher) node. */
  Market: JSON_Market;

  /** Aeron stream ID of this edge. */
  StreamID: number;

  /** Type of the downstream node. */
  HopType: VoltraceHopTypeEnum;

  /** Whether the downstream node responded within the deadline. */
  Status: VoltraceHopStatusEnum;

  /** Hostname of the subscriber (upstream requester) end. */
  SrcHostname: string;

  /** Environment of the subscriber end. */
  SrcEnvironment: string;

  /** Process name of the subscriber end. */
  SrcProcessName: string;

  /** Aeron channel of this edge. */
  Channel: string;
}

/** Customer lock release request is used to manually release customer lock */
export interface ICustomerLockReleaseRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** LockID */
  LockID: string;

  /** optional customer quantity to release in case of External risk evaluation mode */
  ReleaseCustomerQuantity: JSON_Decimal;

  /** optional dealer quantity to release in case of External risk evaluation mode */
  ReleaseDealerQuantity: JSON_Decimal;

  /** User who release the lock */
  User: JSON_User;
}

/** The current state of a loan negotiation from the borrower's perspective. */
export interface ILoanQuoteBorrower {
  /** Timestamp of when the most recent request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID for the responses between one responder and the initiator for the full lifecycle of this QuoteReqID. Generated by Talos. */
  NegotiationID: JSON_Int64ID;

  /** An increasing sequence number for this NegotiationID. A new value indicates state has changed. Generated by Talos. */
  Revision: number;

  /** An increasing sequence number for this NegotiationID and revision. A new value for the same Revision indicates updated information is available with out Negotiation state changing. Commonly used to report errors on commands received since the last state change. Generated by Talos. */
  AmendmentCount: number;

  /** A unique ID corresponding to the OrigQuoteReqID. Generated by Talos. */
  ReqID: JSON_Int64ID;

  /** The original QuoteReqID from the initiating LoanQuoteRequest. Refers to the overall request to all responders */
  OrigQuoteReqID: string;

  /** The QuoteReqID from the most recent borrower request reflected in this message. */
  QuoteReqID: string;

  /** Timestamp of when the first message for this negotiation was processed. */
  SubmitTime: JSON_UTCTimestamp;

  /** The current status of this loan quote. */
  QuoteStatus: LoanQuoteStatusEnum;

  /** ID of the participant representing the lender. May be omitted on error conditions. */
  Lender: JSON_Participant;

  /** ID of the participant representing the borrower. May be omitted on error conditions. */
  Borrower: JSON_Participant;

  /** The ID of the most recent user at the borrower to submit a request. */
  User: JSON_User | undefined;

  /** The user at the borrower that owns this quote. */
  Owner: JSON_User;

  /** Currency ID for the borrowed currency. */
  PrincipalCurrency: string;

  /** Currency ID for the collateral currency, if secured. */
  CollateralCurrency: string | undefined;

  /** The quantity of principal to be borrowed. */
  Qty: JSON_Decimal;

  /** The interest rate due on borrowed Qty per the term sheet conventions. */
  Rate: JSON_Decimal;

  /** The ratio of collateral value to principal value. */
  CollateralRatio: JSON_Decimal;

  /** The termination type of this loan quote, fixed or open. */
  TerminationType: LoanQuoteTerminationTypeEnum;

  /** The date and time when the loan would terminate. */
  TerminationTime: JSON_UTCTimestamp | undefined;

  /** If present, the reason validation failed for the QuoteReqID. */
  ValidationError: LoanQuoteValidationErrorEnum;

  /** Unique identifier of the term sheet for this quote provided to the document service. */
  TermSheetDocID: JSON_Int64ID;

  /** The date and time when the quote will expire if negotiations haven't concluded. */
  EndTime: JSON_UTCTimestamp;

  /** Esign platform identifier of the term sheet template for this loan quote. */
  TermSheetTemplateID: string;

  /** The ID of the document gateway to use for the term sheet. */
  TermSheetGateway: JSON_ESignGateway;

  /** The Qty on this loan quote must be an even multiple of this increment. */
  QtyIncrement: JSON_Decimal;

  /** The Rate on this loan quote must be an even multiple of this increment. */
  RateIncrement: JSON_Decimal;

  /** The CollateralRatio on this loan quote must be an even multiple of this increment. */
  CollateralRatioIncrement: JSON_Decimal;

  /** Minimum quantity of principal allowed to be borrowed. */
  MinQty: JSON_Decimal;

  /** Summary of the current quote state suitable for display. Will be populated if ValidationError is present. */
  Text: string;

  /** A message relevant to the terms of this Revision. */
  Comments: string;

  /** The set of collateral currencies allowed for this loan quote. */
  EnabledCollateralCurrencies: ILoanQuoteBorrower8007EnabledCollateralCurrencies[];

  /** States for each of the recipients of of the term sheet for this quote. */
  TermSheetRecipients: ILoanQuoteBorrower8007TermSheetRecipients[];
}

/** The set of collateral currencies allowed for this loan quote. */
export interface ILoanQuoteBorrower8007EnabledCollateralCurrencies {
  /** Currency ID */
  Currency: string;
}

/** States for each of the recipients of of the term sheet for this quote. */
export interface ILoanQuoteBorrower8007TermSheetRecipients {
  /** Timestamp when this entry was last updated. */
  Timestamp: JSON_UTCTimestamp;

  /** Latest status in the documentation workflow for this entry's participant. */
  Status: ESignRecipientStatusEnum;

  /** ID of the participant this entry applies to. */
  Participant: JSON_Participant;

  /** Name of the entry's recipient. */
  DisplayName: string;

  /** Delivery identifier used by esign platforms for this recipient. */
  DeliveryID: string;
}

/** A request by the initiator to set firm terms on a LoanQuote. */
export interface ILoanQuoteBorrowerUpdate {
  /** Timestamp of when the request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this request. */
  QuoteReqID: string;

  /** The ID of the LoanQuote to be updated. */
  NegotiationID: JSON_Int64ID;

  /** The revision of the LoanQuote to be updated. It's only possible to update the most recent revision. */
  TargetRevision: number;

  /** ID of the updating participant. */
  Participant: JSON_Participant;

  /** The ID of the updating user. */
  User: JSON_User;

  /** Currency ID for the collateral currency, if secured. */
  CollateralCurrency: string;

  /** The quantity of principal to be borrowed. */
  Qty: JSON_Decimal;

  /** TThe interest rate due on borrowed Qty per the term sheet conventions. */
  Rate: JSON_Decimal;

  /** The ratio of collateral value to principal value. */
  CollateralRatio: JSON_Decimal;

  /** The termination type of this loan quote, fixed or open. */
  TerminationType: LoanQuoteTerminationTypeEnum;

  /** The date and time when the loan would terminate. */
  TerminationTime: JSON_UTCTimestamp;

  /** A message relevant to the terms of this update. */
  Comments: string;
}

/** A request by the responder to accept the firm terms of a LoanQuote. */
export interface ILoanQuoteLenderAccept {
  /** Timestamp of when the request was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this request. */
  QuoteReqID: string;

  /** The ID of the LoanQuote to accept. */
  NegotiationID: JSON_Int64ID;

  /** The revision of the LoanQuote to accept. It's only possible to accept the most recent revision. */
  TargetRevision: number;

  /** ID of the accepting participant. */
  Participant: JSON_Participant;

  /** The ID of the accepting user. */
  User: JSON_User;
}

/** A record configuring the relationship between a lender and a borrower. More specific values take precedence. */
export interface ILendingRelationship {
  /** ID of the lender participant for this relationship. */
  Lender: JSON_Participant;

  /** ID of the borrower participant for this relationship. If zero, applies to all borrowers this lender faces. */
  Borrower: JSON_Participant;

  /** Indicates the status of the relationship. */
  RelationshipStatus: LendingRelationshipStatusEnum;

  /** Update timestamp for DB Poller Infrastructure */
  Timestamp: JSON_UTCTimestamp;

  /** Esign platform identifier of the term sheet template for this relationship. */
  TermSheetTemplateID: string;

  /** The ID of the document gateway to use for the term sheet. */
  TermSheetGateway: JSON_ESignGateway;

  /** An increasing sequence number for this relationship. A new value indicates state has changed. Generated by Talos. */
  Revision: number;

  /** ID of user who created this revision, i.e. updated the lending relationship. */
  RevisionBy: number;

  /** Indicates whether transfer automation should be used for the lender in this relationship. */
  LenderTransferAutomationStatus: TransferAutomationStatusEnum;

  /** Indicates whether transfer automation should be used for the borrower in this relationship. */
  BorrowerTransferAutomationStatus: TransferAutomationStatusEnum;

  /** The settings for currencies lent by this lender. */
  PrincipalCurrencies: ILendingRelationship8010PrincipalCurrencies[];

  /** The settings for currencies accepted as collateral by this lender. */
  CollateralCurrencies: ILendingRelationship8010CollateralCurrencies[];

  /** Recipients of the term sheet for this relationship. */
  TermSheetRecipients: ILendingRelationship8010TermSheetRecipients[];
}

/** The settings for currencies accepted as collateral by this lender. */
export interface ILendingRelationship8010CollateralCurrencies {
  /** Currency ID for these settings. If zero, applies to all currencies. */
  Currency: string;

  /** The status of this currency for use as collateral with this lender. */
  Status: LoanCollateralCurrencyStatusEnum;
}

/** The settings for currencies lent by this lender. */
export interface ILendingRelationship8010PrincipalCurrencies {
  /** Currency ID for these settings. If zero, applies to all currencies. */
  Currency: string;

  /** The status of this currency for borrowing from this lender. */
  Status: LoanPrincipalCurrencyStatusEnum;

  /** The Qty requested must be equal to or greater than this value which is denominated in CurrencyID. */
  MinQty: JSON_Decimal;
}

/** Recipients of the term sheet for this relationship. */
export interface ILendingRelationship8010TermSheetRecipients {
  /** ID of the Participant this recipient is associated with. */
  Participant: JSON_Participant;

  /** The name to refer this recipient as in the esign platform envelope. */
  DisplayName: string;

  /** Delivery identifier used by esign platforms for this recipient. */
  DeliveryID: string;
}

/** A participant in the loan marketplace */
export interface IParticipant {
  /** Update timestamp for DB Poller Infrastructure */
  Timestamp: JSON_UTCTimestamp;

  /** ID of a participant in the loan marketplace */
  Participant: JSON_Int64ID;

  /** Name of participant in the loan marketplace */
  Name: string;

  /** The underlying participant entity identifier */
  EntityID: number;

  /** The type of the underlying participant entity */
  EntityType: ParticipantEntityTypeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Friendly participant name for display */
  DisplayName: string;

  /** Revision */
  Revision: number;
}

/** Header for RPC message passed along every request/response */
export interface IRPCHeader {
  /** Correlation ID to associate RPC request/response */
  RequestID: JSON_Int64ID;

  /** Bitmap of message characteristics */
  Indicator: Record<RPCHeaderIndicatorEnum, boolean>;
}

/** Historical positions captured from snapshots */
export interface IHistoricalAccountPosition {
  /** Internal as-of time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Asset of this position entry */
  Asset: string;

  /** Historical position amount */
  Position: JSON_Decimal;

  /** Latest time this position was updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Currency ID for equivalence. No rates if zero */
  EquivalentCurrency: string;

  /** Position converted to equivalent currency */
  EquivalentPosition: JSON_Decimal;

  /** Time resolution of this position snapshot */
  Resolution: ResolutionEnum;

  /** Organization ID */
  OrgID: number;

  /** ConversionRate in equivalent currency */
  EquivalentRate: JSON_Decimal;

  /** Equity at the timestamp */
  Equity: JSON_Decimal;

  /** InitialMargin at the timestamp */
  InitialMargin: JSON_Decimal;

  /** MaintenanceMargin at the timestamp */
  MaintenanceMargin: JSON_Decimal;

  /** Implied asset price in equivalent currency at the timestamp */
  EquivalentMarkPrice: JSON_Decimal;

  /** Revision of this as-of position; bumped on every user update */
  Revision: number;

  /** ID of user who performed the most recent update, if user-initiated */
  UpdateUser: JSON_User;
}

/** config setting for loan user configs */
export interface ILoanUserConfig {
  /** Time in nanos since epoch at which this config was updated */
  Timestamp: JSON_UTCTimestamp;

  /** User ID */
  LoanUser: JSON_User;

  /** Config Status */
  Mode: ModeEnum;

  /** Revision */
  Revision: number;

  /** Key in Key-Value Marketplace User Config Pairs */
  Key: string;

  /** Value in Key-Value Marketplace User Config Pairs */
  Value: string;
}

/** Admin action to control loan quote */
export interface ILoanQuoteAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch that this command was received. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this request. */
  QuoteReqID: string;

  /** The NegotiationID of the LoanQuote to be acted upon. */
  NegotiationID: JSON_Int64ID;

  /** The ID of the rejecting user. */
  User: JSON_User;

  /** Action type to carry out */
  Action: LoanQuoteAdminActionEnum;
}

/** RawMessage */
export interface IRawMessage {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** RequestID this message was received for. */
  RequestID: number;

  /** Direction */
  Direction: MessageDirectionEnum;

  /** Data */
  Data: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Status messages around a FIX Connection */
export interface IRawConnectionEvent {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** RequestID this message was received for. */
  RequestID: number;

  /** Data */
  Data: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Fill journal for a client FIX connection. UpdateAction.Update records a fill retained for redelivery after a session reset; UpdateAction.Remove discards every entry at or below Seq */
export interface IClientFillJournal {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update records an entry, Remove discards everything at or below Seq */
  UpdateAction: UpdateActionEnum;

  /** Unique ID of this connection */
  ConnectionID: number;

  /** Journal-local sequence, monotonic per connection. On Remove this is the discard high-water mark */
  Seq: number;

  /** Highest Seq already handed to QuickFIX when this was written. On restore, entries at or below it were sent and await confirmation; entries above it were never sent and must still go out */
  SentThroughSeq: number;

  /** When the fill was journalled, drives age expiry across a restart. Unset on Remove */
  JournalledAt: JSON_UTCTimestamp;

  /** Template ID of the embedded execution report. Unset on Remove */
  FillTemplateID: number;

  /** ExecID of the fill, for reconciliation when a replay is short. Unset on Remove */
  ExecID: string;

  /** The execution report to redeliver */
  Fill: number;
}

/** Represents a loan whose negotiation has successfully concluded. */
export interface ILoan {
  /** Timestamp of when the most recent update was applied. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID for the loan. Generated by Talos. */
  LoanID: JSON_Int64ID;

  /** An increasing sequence number for this LoanID. A new value indicates state has changed. Generated by Talos. */
  Revision: number;

  /** ID of user who created this revision, i.e. sent the command changing the state. */
  RevisionBy: number;

  /** The NegotiationID of the LoanQuote whose negotiation led to this Loan. */
  NegotiationID: JSON_Int64ID;

  /** Timestamp of when the the loan was committed to. */
  OriginationTime: JSON_UTCTimestamp;

  /** The ClientID from the most recent state change command applied to this message. */
  ClientID: string;

  /** The current status of this loan. */
  Status: LoanStatusEnum;

  /** ID of the participant representing the lender. */
  Lender: JSON_Participant;

  /** ID of the participant representing the borrower. */
  Borrower: JSON_Participant;

  /** Currency ID for the borrowed currency. */
  PrincipalCurrency: string;

  /** Currency ID for the collateral currency, if secured. */
  CollateralCurrency: string | undefined;

  /** The quantity of principal to be borrowed. */
  Qty: JSON_Decimal;

  /** The interest rate due on borrowed Qty per the term sheet conventions. */
  Rate: JSON_Decimal;

  /** The ratio of collateral value to principal value. */
  CollateralRatio: JSON_Decimal;

  /** The termination type of this loan, fixed or open. */
  TerminationType: LoanQuoteTerminationTypeEnum;

  /** The date and time when the loan will terminate. Omitted if termination type is Open and termination notice has not been given. */
  TerminationTime: JSON_UTCTimestamp | undefined;

  /** An increasing sequence number for this LoanID and Revision. A new value for the same Revision indicates updated information is available without the Loan changing. Commonly used to report errors on commands received since the last state change. Generated by Talos. */
  AmendmentCount: number;

  /** If present, the reason an attempt at handling the loan failed. */
  HandlingError: LoanHandlingErrorEnum;

  /** Summary of the current quote state suitable for display. Will be populated if HandlingError is present. */
  Text: string;

  /** Loan Participants who should receive this message */
  EligibleRecipients: ILoan8050EligibleRecipients[];
}

/** Loan Participants who should receive this message */
export interface ILoan8050EligibleRecipients {
  /** ID of a participant receiving the loan error. */
  Participant: JSON_Participant;
}

/** Normalized Message */
export interface INormalizedLogData {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Current position in this sequencer's recording */
  Position: number;

  /** Market ID */
  MarketID: number;

  /** Identifier linking log with its ids */
  NormalizedLogID: string;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** RequestID this message was received for. */
  RequestID: number;

  /** Direction */
  Direction: MessageDirectionEnum;

  /** LogType */
  LogType: NormalizedLogTypeEnum;

  /** Data */
  Data: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** List of the IDs relating to a raw log */
export interface INormalizedLogIDs {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Identifier linking log with its ids */
  NormalizedLogID: string;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** ChildIDGroups */
  ChildIDGroups: INormalizedLogIDs6006ChildIDGroups[];
}

/**  */
export interface INormalizedLogIDs6006ChildIDGroups {
  /** Parent OMS order OrderID, may be blank for orders that do not belong to an OMS order */
  ParentOrderID: string;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** ExecID */
  ExecID: string;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** Security ID */
  SecurityID: number;
}

/** A transaction from one participant to another to be resolved with the help of an account link. */
export interface ILoanTransaction {
  /** Timestamp of when the most recent update was applied. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID for the transaction. Generated by Talos. */
  TransactionID: JSON_Int64ID;

  /** The ID of the Loan this transaction relates to. */
  LoanID: JSON_Int64ID;

  /** An increasing sequence number for this TransactionID. A new value indicates state has changed. Generated by Talos. */
  Revision: number;

  /** ID of user who created this revision, i.e. sent the command changing the state. */
  RevisionBy: number;

  /** Timestamp of when the first message for this transaction ID was created. */
  CreateTime: JSON_UTCTimestamp;

  /** The ClientID from the most recent state change command applied to this message. */
  ClientID: string;

  /** The current status of this transaction. */
  Status: LoanTransactionStatusEnum;

  /** ID of the participant sending the transaction. */
  FromParticipant: JSON_Participant;

  /** ID of the participant receiving the transaction. */
  ToParticipant: JSON_Participant;

  /** The amount of currency to be transacted. */
  Amount: JSON_Decimal;

  /** The exchange rate fixing, if any, used to calculate the Amount. */
  ConversionRate: JSON_Decimal;

  /** Currency ID to be transacted. */
  Currency: string;

  /** Which facet of the instrument the transaction applies to. */
  Type: LoanTransactionTypeEnum;

  /** The ClientID used to request a transfer for this transaction. */
  TransferClientID: string;

  /** ID of the transfer returned by the transfer subsystem in response to our request for this transaction. */
  SenderTransferID: JSON_Int64ID | undefined;

  /** The sender's market account id to be used as a source of funds. */
  SendersFromMarketAccount: JSON_MarketAccount | undefined;

  /** The sender's market account id to be used as the funds' destination. */
  SendersToMarketAccount: JSON_MarketAccount | undefined;

  /** The recipient's market account id to be used as the funds' destination. */
  RecipientsToMarketAccount: JSON_MarketAccount | undefined;

  /** The ViewID assigned to this transaction's conversion rate request. */
  ConversionRateViewID: JSON_Int64ID | undefined;

  /** An increasing sequence number for this TransactionID and Revision. A new value for the same Revision indicates updated information is available without the Transaction changing. Commonly used to report errors on commands received since the last state change. Generated by Talos. */
  AmendmentCount: number;

  /** If present, the reason an attempt at handling the Loan Transaction failed. */
  HandlingError: LoanTransactionHandlingErrorEnum;

  /** Summary of the current quote state suitable for display. Will be populated if HandlingError is present. */
  Text: string;

  /** A note from the sender to be shared with the recipient. */
  Comments: string;

  /** Loan Participants who should receive this message */
  EligibleRecipients: ILoanTransaction8060EligibleRecipients[];
}

/** Loan Participants who should receive this message */
export interface ILoanTransaction8060EligibleRecipients {
  /** ID of a participant receiving the transaction error. */
  Participant: JSON_Participant;
}

/** A command to advance the transaction by initiating a transfer. */
export interface ILoanTransactionSubmission {
  /** Timestamp of when the command was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this command. */
  ClientID: string;

  /** The ID of the ParticipantLinkTransaction to submit. */
  TransactionID: JSON_Int64ID;

  /** The revision of the ParticipantLinkTransaction to accept. It's only possible to accept the most recent revision. */
  TargetRevision: number;

  /** ID of the submitting participant. */
  Participant: JSON_Participant;

  /** The ID of the submitting user. */
  User: JSON_User;

  /** A note from the sender to be shared with the recipient. */
  Comments: string;
}

/** A command to modify the transaction. */
export interface ILoanTransactionUpdate {
  /** Timestamp of when the command was received by Talos. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this command. */
  ClientID: string;

  /** The ID of the ParticipantLinkTransaction to update. */
  TransactionID: JSON_Int64ID;

  /** The revision of the ParticipantLinkTransaction to update. It's only possible to update the most recent revision. */
  TargetRevision: number;

  /** The revised exchange rate fixing for the transaction. */
  ConversionRate: JSON_Decimal;

  /** ID of the updating participant. */
  Participant: JSON_Participant;

  /** The ID of the updating user. */
  User: JSON_User;
}

/** Relates the source and destination market accounts to be used between two participants. */
export interface IParticipantTransferConfig {
  /** Timestamp of when the config was last updated. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID for the config. Generated by Talos. */
  ConfigID: JSON_Int64ID;

  /** Account IDs will be from the perspective of this participant. */
  OwnerParticipant: JSON_Participant;

  /** Config applies when the participant with this ID is sending. */
  FromParticipant: JSON_Participant;

  /** Config applies when the participant with this ID is receiving.. */
  ToParticipant: JSON_Participant;

  /** Config applies to the Currency with this ID. */
  Currency: string;

  /** An increasing sequence number for this ConfigID. A new value indicates state has changed. Generated by Talos. */
  Revision: number;

  /** ID of user who created this revision, i.e. sent the command changing the state. */
  RevisionBy: number;

  /** ID from the owner's API of the MarketAccount to source sender's funds from. */
  FromMarketAccount: JSON_MarketAccount | undefined;

  /** ID from the owner's API of the recipient's MarketAccount to send funds to. */
  ToMarketAccount: JSON_MarketAccount | undefined;

  /** Update action to identify in and out of scope events. */
  UpdateAction: UpdateActionEnum;

  /** The blockchain address associated with the ToMarketAccountID. */
  ToBlockchainAddress: string;
}

/** (TenantID:OrgID)(ResourceName:MarketExecutionReport ResourceTag:E DatabaseName:market_execution_reports_new PartitionKey:EID Key:EID TimestampField:Timestamp AeronCols:true ConstantGroupLength:true PrimaryKey:Generated IDQueryFields:OrderID,ParentOrderID IsPrimaryResource:true DBType:OrgDB)(ResourceName:MarketOrder ResourceTag:O DatabaseName:market_orders_new PartitionKey:OID Key:OID TimestampField:SubmitTime,Timestamp AeronCols:true ConstantGroupLength:true PrimaryKey:Generated IDQueryFields:ParentOrderID DBType:OrgDB) */
export interface IExecutionReport {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** OrderID of this order at the market */
  OrderID: string;

  /** ClOrdID of this order at the market */
  ClOrdID: string;

  /** OrigClOrdID of this order at the market */
  OrigClOrdID: string;

  /** Order Submission Time in nanoseconds since Unix epoc */
  SubmitTime: JSON_UTCTimestamp;

  /** ExecID of this execution at the market */
  ExecID: string;

  /** Side */
  Side: SideEnum;

  /** Timestamp of the last update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Cumulative quantity */
  CumQty: JSON_Decimal;

  /** Average price */
  AvgPx: JSON_Decimal;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last amount */
  LastAmt: JSON_Decimal;

  /** Last fee */
  LastFee: JSON_Decimal;

  /** Cumulative amount */
  CumAmt: JSON_Decimal;

  /** Cumulative fee */
  CumFee: JSON_Decimal;

  /** Currency ID for the cumulative fee */
  FeeCurrency: string;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** ClOrdID of the request we're responding to */
  ClOID: JSON_Int64ID;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Trade capture info */
  TradeStatus: TradeStatusEnum;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** Internal ID of the quote; optional */
  QID: JSON_Int64ID;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Parent OMS order OrderID, may be blank for orders that do not belong to an OMS order */
  ParentOrderID: string;

  /** Internal ID of request for quote */
  RID: JSON_Int64ID;

  /** Expected average filled price */
  ExpectedFillPrice: JSON_Decimal;

  /** Expected filled quantity in units of Currency */
  ExpectedFillQty: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** The service originating the child order */
  ParentService: JSON_ServiceIdentifier;

  /** If present determines the units of PricingReference. Price is always in quote currency */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** User ID */
  User: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Bitmap of execution instructions */
  ExecutionInstructions: Record<ExecutionInstructionsEnum, boolean>;

  /** Child order RequestIndicator */
  RequestIndicator: RequestIndicatorTypeEnum;

  /** Additional reason for ExecType */
  ExecTypeReason: ExecTypeReasonEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Template ID of the Metadata SBE message */
  MetadataTemplateID: number;

  /** MarketAccountID of the market account that is the clearing venue for the originating quote; unset if unspecified */
  ClearingAccount: JSON_MarketAccount;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Text */
  Text: string;

  /** Market parameters */
  Parameters: IMarketParameters;

  /** Gateway-owned order metadata */
  Metadata: number;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** End-user action to control loan */
export interface ILoanRequest {
  /** Internal time in number of nanoseconds since Unix epoch that this command was received. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this command. */
  ClientID: string;

  /** The ID of the Loan this request relates to. */
  LoanID: JSON_Int64ID;

  /** The revision of the Loan to be modified. It's only possible to update the most recent revision. */
  TargetRevision: number;

  /** ID of the participant the user issuing the command belongs to. */
  Participant: JSON_Participant;

  /** The ID of the user issuing the command. */
  User: JSON_User;

  /** Action type to carry out */
  Action: LoanActionEnum;
}

/** Talos admin action to control loan. */
export interface ILoanAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch that this command was received. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this command. */
  ClientID: string;

  /** The ID of the Loan this transaction relates to. */
  LoanID: JSON_Int64ID;

  /** The revision of the Loan to be modified. It's only possible to update the most recent revision. */
  TargetRevision: number;

  /** The ID of the user issuing the command. */
  User: JSON_User;

  /** Action type to carry out */
  Action: LoanAdminActionEnum;
}

/** Information about OMS Decision */
export interface IOMSDecisionInfo {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** DecisionID */
  OrderID: string;

  /** Target leaves quantity */
  TargetLeavesQty: JSON_Decimal;

  /** Target price */
  TargetPrice: JSON_Decimal;

  /** Type of decision */
  DecisionLogType: DecisionLogTypeEnum;

  /** Leg Index in Legs array */
  LegIndex: number;

  /** Multileg reporting type */
  MultilegReportingType: MultilegReportingTypeEnum;

  /** Target pricing reference */
  TargetPricingReference: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Nanoseconds taken for order evaluation for this decision */
  OrderEvalTime: number;

  /** Number of decision action logs */
  Messages: IOMSDecisionInfo5010Messages[];

  /** Number of markets used for this order */
  Markets: IOMSDecisionInfo5010Markets[];

  /** Number of crossing and resting decisions */
  Decisions: IOMSDecisionInfo5010Decisions[];

  /** Number of open orders */
  OpenOrders: IOMSDecisionInfo5010OpenOrders[];

  /** Number of pending parent orders */
  PendingRequests: IOMSDecisionInfo5010PendingRequests[];

  /** Order properties */
  Properties: IOMSDecisionInfo5010Properties[];

  /** Expected prices and sizes for each liquidity bucket and its child markets considered for the decision. */
  LiquidityBuckets: IOMSDecisionInfo5010LiquidityBuckets[];
}

/** Balances */
export interface IMarketsBalances {
  /** Currency ID for the dealt currency */
  Currency: string;

  /** Available amount */
  Amount: JSON_Decimal;

  /** Amount */
  AvailableAmount: JSON_Decimal;
}

/** Number of child orders */
export interface IPendingRequestsChildOrders {
  /** OrderID */
  OID: JSON_Int64ID;

  /** Number of requested cancel orders */
  CancelRequestCount: number;

  /** Number of accepted cancel orders */
  CancelAcceptedCount: number;

  /** Number of reejected cancel orders */
  CancelRejectedCount: number;
}

/** Number of crossing and resting decisions */
export interface IOMSDecisionInfo5010Decisions {
  /** Market ID */
  Market: JSON_Market;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Limit price */
  Price: JSON_Decimal;

  /** Show quantity */
  ShowQty: JSON_Decimal;

  /** Resting, crossing etc */
  AllocationType: AllocationTypeEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Fee allocated */
  Fee: JSON_Decimal;

  /** Level index */
  LevelIndex: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** Reason for the allocation, ie.: spread collapsed, etc */
  AllocationReason: Record<AllocationReasonEnum, boolean>;

  /** Reduce only flag */
  ReduceOnly: boolean;

  /** Open child orders for this decision */
  Orders: IDecisionsOrders[];
}

/** Expected prices and sizes for each liquidity bucket and its child markets considered for the decision. */
export interface IOMSDecisionInfo5010LiquidityBuckets {
  /** Market ID of the provider this record applies to. If zero this record is aggregate data for a Liquidity Bucket. */
  Market: JSON_Market;

  /** Expected fill price fee inclusive */
  ExpectedFillPrice: JSON_Decimal;

  /** Expected fill qty */
  ExpectedFillQty: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** If the record is a Liquidity bucket, the bucket's index. Otherwise the index of the Liquidity Bucket this provider was part of. */
  LiquidityBucketIdx: number;
}

/** Number market order book levels */
export interface IMarketsMarketLevels {
  /** Market Data entry price */
  MDEntryPx: JSON_Decimal;

  /** Market Data entry size */
  MDEntrySize: JSON_Decimal;

  /** Market Data entry type */
  MDEntryType: MDEntryTypeEnum;

  /** Aggregate number of orders at given price level */
  NumberOfOrders: number;
}

/** Number of markets used for this order */
export interface IOMSDecisionInfo5010Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Number of times new order rejected */
  NewCount: number;

  /** First new order error time */
  FirstNewTime: JSON_UTCTimestamp;

  /** Last new order error time */
  LastNewTime: JSON_UTCTimestamp;

  /** Last price update receive time in nanoseconds */
  PriceUpdateTime: JSON_UTCTimestamp;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  PriceTransactTime: JSON_UTCTimestamp;

  /** Last price update SessionID. */
  PriceSessionID: JSON_Int64ID;

  /** Last price update SequenceNo. */
  PriceSequenceNo: number;

  /** Average spread in bps */
  MASpread: JSON_Decimal;

  /** Period of MA for the spread */
  MASpreadPeriod: JSON_DurationMillis;

  /** Maker fee */
  MakerFeeRate: JSON_Decimal;

  /** Taker fee */
  TakerFeeRate: JSON_Decimal;

  /** Current available quantity to buy */
  AvailableBuy: JSON_Decimal;

  /** Current available quantity to sell */
  AvailableSell: JSON_Decimal;

  /** Current available quantity to buy respecting trading windows */
  MaxBuyOrderSize: JSON_Decimal;

  /** Current available quantity to sell respecting trading windows */
  MaxSellOrderSize: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Number of skipped resting levels */
  SkippedRestingLevels: number;

  /** Size of the skipped resting levels */
  SkippedRestingSize: JSON_Decimal;

  /** Currency ID for the skipped resting sizes */
  SkippedRestingSizeCurrency: string;

  /** Security ID */
  Symbol: JSON_Security;

  /** Median spread in bps */
  MedianSpread: JSON_Decimal;

  /** Period of median spread */
  MedianSpreadPeriod: JSON_DurationMillis;

  /** Max allocation available to this market */
  MaxAllocationSize: JSON_Decimal;

  /** Open position on current symbol/market from gateway */
  OpenPosition: JSON_Decimal;

  /** Leaves quantity of all open orders on current symbol/market with same trading direction across the current OMS instance */
  AggregatedOpenOrderLeavesQty: JSON_Decimal;

  /** Leaves quantity of all open orders originated from current order */
  OpenOrderLeavesQty: JSON_Decimal;

  /** Available quantity to send ReduceOnly orders */
  AvailableToReduce: JSON_Decimal;

  /** Position last updated time */
  PositionUpdatedTime: JSON_UTCTimestamp;

  /** Most recent time of position related exchange feedback time */
  LastPosFeedbackTime: JSON_UTCTimestamp;

  /** Number of times child orders got rate limited */
  RateLimitCount: number;

  /** Equity reported by the venue */
  Equity: JSON_Decimal;

  /** Maintenance margin reported by the venue */
  MaintenanceMargin: JSON_Decimal;

  /** Equity margin ratio limit */
  EquityMarginRatioLimit: JSON_Decimal;

  /** Factor used on market levels to adjust prices when comparing */
  PriceAdjustmentFactor: JSON_Decimal;

  /** Conversion rate for unified liquidity symbols */
  UnifiedLiquidityConversionRate: JSON_Decimal;

  /** Initial margin reported by the venue */
  InitialMargin: JSON_Decimal;

  /** Latency of last market tick at receipt time in microseconds */
  LastTickMarketLatencyMicros: number;

  /** Configured floor for feed latency in microseconds */
  FeedLatencyFloorMicros: number;

  /** Derivative position risk limit */
  PositionRiskLimit: JSON_Decimal;

  /** Currency ID of the position risk limit */
  PositionRiskLimitCurrency: string;

  /** Exposure limit factor */
  ExposureLimitFactor: JSON_Decimal;

  /** Average daily volume for the market, denominated in the parent order's base currency, after fallback logic has been applied */
  AverageDailyVolume: JSON_Decimal;

  /** How the fee is calculated for this market */
  FeeCalcBasis: FeeCalcBasisEnum;

  /** Most recent best bid price received from a separate BBO update, not derived from the order book levels */
  BestBid: JSON_Decimal;

  /** Most recent best offer price received from a separate BBO update, not derived from the order book levels */
  BestOffer: JSON_Decimal;

  /** Open long position on the current symbol and market */
  OpenLongPosition: JSON_Decimal;

  /** Open short position on the current symbol and market */
  OpenShortPosition: JSON_Decimal;

  /** Number market order book levels */
  MarketLevels: IMarketsMarketLevels[];

  /** Balances */
  Balances: IMarketsBalances[];

  /** Real-time moving averages of the market where the order would rest */
  MovingAverages: IMarketsMovingAverages[];
}

/** Number of decision action logs */
export interface IOMSDecisionInfo5010Messages {
  /** Log Message */
  Text: string;
}

/** Real-time moving averages of the market where the order would rest */
export interface IMarketsMovingAverages {
  /** Index of the market level */
  LevelIndex: number;

  /** Average level size */
  AverageSize: JSON_Decimal;
}

/** Number of open orders */
export interface IOMSDecisionInfo5010OpenOrders {
  /** OrderID */
  OID: JSON_Int64ID;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Limit price */
  Price: JSON_Decimal;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Time order last acted upon */
  LastActionTime: JSON_UTCTimestamp;

  /** Times trying to cancel */
  CancelCount: number;

  /** First cancel time */
  FirstCancelTime: JSON_UTCTimestamp;

  /** Last cancel time */
  LastCancelTime: JSON_UTCTimestamp;

  /** Amount matched */
  MatchedSize: JSON_Decimal;

  /** Reduce only flag */
  ReduceOnly: boolean;
}

/** Open child orders for this decision */
export interface IDecisionsOrders {
  /** OrderID */
  OID: JSON_Int64ID;
}

/** Number of pending parent orders */
export interface IOMSDecisionInfo5010PendingRequests {
  /** ClOrdID */
  ClOrdID: string;

  /** Request type */
  RequestType: ExecTypeEnum;

  /** Number of requested new orders */
  NewRequestCount: number;

  /** Number of accepted new orders */
  NewAcceptedCount: number;

  /** Number of reejected new orders */
  NewRejectedCount: number;

  /** Number of child orders */
  ChildOrders: IPendingRequestsChildOrders[];
}

/** Order properties */
export interface IOMSDecisionInfo5010Properties {
  /** Property */
  Property: OMSOrderPropertyEnum;

  /** Value of property */
  Value: JSON_Decimal;

  /** Market ID (valid only if property is market dependent) */
  Market: JSON_Market;

  /** Property value represented as string */
  ValueText: string;
}

/** Talos admin action to control loan transaction. */
export interface ILoanTransactionAdminRequest {
  /** Internal time in number of nanoseconds since Unix epoch that this command was received. */
  Timestamp: JSON_UTCTimestamp;

  /** A unique ID provided by the sender of this command. */
  ClientID: string;

  /** The ID of the LoanTransaction this request relates to. */
  TransactionID: JSON_Int64ID;

  /** The revision of the LoanTransaction to be modified. It's only possible to update the most recent revision. */
  TargetRevision: number;

  /** The ID of the user issuing the command. */
  User: JSON_User;

  /** Action type to carry out */
  Action: LoanTransactionAdminActionEnum;
}

/** Represents the membership of a Subaccount (any type) in a particular Rollup, without cycles. */
export interface IRollupMembership {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of this parent rollup SubAccount */
  ParentID: number;

  /** ID of this member SubAccount */
  ChildID: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision of this rollupmembership */
  Revision: number;

  /** ID of user who last updated rollup membership record */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;
}

/** Position constraint for limiting subaccount orders */
export interface ISubaccountPositionLimit {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this Limit */
  LimitID: JSON_Int64ID;

  /** Side of the position limit */
  Direction: PositionSideTypeEnum;

  /** Position threshold to emit a warning (optional) */
  WarnThreshold: JSON_Decimal;

  /** Position threshold to prevent submitting the order */
  RejectThreshold: JSON_Decimal;

  /** The asset of the threshold definitions */
  ThresholdAsset: string;

  /** SubaccountID (book or rollup) of this position limit */
  SubAccount: JSON_SubAccount;

  /** Asset for which this limit applies */
  MatchAsset: string;

  /** Enable or disable this limit */
  Mode: ModeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision of this subaccount position limit */
  Revision: number;

  /** ID of user who last updated this subaccount position limit */
  UpdateUser: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Application scope of this limit */
  Scope: PositionLimitScopeEnum;

  /** Cross asset risk group for which this limit applies; 0 = single-asset mode (uses MatchAssetID) */
  MatchCrossAssetRiskGroup: JSON_CrossAssetRiskGroup;

  /** Description of this limit */
  Description: string;
}

/** (ResourceName:ServiceConfigurationSnapshot ResourceTag:S DatabaseName:service_configuration_snapshots Key:ServiceConfigurationSnapshotID TimestampField:Timestamp AeronCols:false ConstantGroupLength:true PrimaryKey:Generated DBType:OrgDB) */
export interface IServiceConfigurationSnapshot {
  /** The service originating this transaction */
  SourceService: JSON_ServiceIdentifier;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Snapshot ID */
  ServiceConfigurationSnapshotID: number;

  /** Git hash */
  GitHash: string;

  /** Release version */
  ReleaseVersion: string;

  /** Schema version */
  SchemaVersion: number;

  /** Org ID */
  OrgID: number;

  /** List of configs */
  ServiceConfig: IServiceConfigurationSnapshot8085ServiceConfig[];
}

/** List of configs */
export interface IServiceConfigurationSnapshot8085ServiceConfig {
  /** Configuration Key */
  Key: string;

  /** Configuration value as a string */
  DefaultValue: string;

  /** Configuration overrides */
  Overrides: string;
}

/** (ResourceName:OrderConfigurationSnapshot ResourceTag:O DatabaseName:order_configuration_snapshots Key:OrderConfigurationSnapshotID,OrderID TimestampField:Timestamp AeronCols:false ConstantGroupLength:true PrimaryKey:Generated DBType:OrgDB) */
export interface IOrderConfigurationSnapshot {
  /** The service originating this transaction */
  SourceService: JSON_ServiceIdentifier;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID */
  OrderConfigurationSnapshotID: number;

  /** ID */
  ServiceConfigurationSnapshotID: number;

  /** OrderID only present for order snapshots */
  OrderID: string;

  /** Leg Index in Legs array */
  LegIndex: number;

  /** Multileg reporting type */
  MultilegReportingType: MultilegReportingTypeEnum;

  /** Security ID */
  Symbol: JSON_Security;

  /** Org ID */
  OrgID: number;

  /** List of configs */
  OrderConfig: IOrderConfigurationSnapshot8086OrderConfig[];
}

/** List of configs */
export interface IOrderConfigurationSnapshot8086OrderConfig {
  /** Config name */
  Param: AlgoConfigurationParameterEnum;

  /** Value */
  Value: JSON_Decimal;

  /** Market ID */
  Market: JSON_Market;
}

/** An aggregated statistic datapoint detailing the total trading volume for a set of dimensions. */
export interface ITotalTradingVolumeDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** Total trading volume */
  TotalVolume: JSON_Decimal;

  /** Currency that the Total trading volume is represented by */
  EquivalentCurrency: string;

  /** Market ID. Defaults to 0 if not set. */
  Market: JSON_Market;

  /** Asset ID. Both Currency and Security IDs default to 0 if not set. */
  Asset: string;

  /** The type of trade counted towards this datapoint. */
  TradeType: TradeTypeEnum;

  /** Whether the volume is from passively making liquidity or actively taking liquidity. */
  AggressorFlag: AggressorFlagEnum;

  /** The strategy considered towards this datapoint. Defaults to 0 if not set. */
  Strategy: JSON_Strategy;

  /** The type of strategy considered towards this datapoint. */
  StrategyType: StrategyTypeEnum;

  /** Whether or not the volume for the datapoint is calculated from entirely Marketable orders, or from at least partially Limited orders. Terminology is from current reports. */
  OrderMarketability: OrderMarketabilityEnum;

  /** Revision */
  Revision: number;

  /** The lower limit of the VP participation range for this datapoint. [lower, upper). 1.0 = 100% */
  LowerVPLimit: JSON_Decimal;

  /** The upper limit of the VP participation range for this datapoint. [lower, upper). 1.0 = 100% */
  UpperVPLimit: JSON_Decimal;

  /** Update action */
  UpdateAction: UpdateActionEnum;
}

/** Group of assets for cross-asset risk checks. */
export interface ICrossAssetRiskGroup {
  /** Internal time in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** Unique ID of this group */
  GroupID: JSON_Int64ID;

  /** Currency in which net exposure is measured for this group */
  ExposureCurrency: string;

  /** Settlement value type filter; NullValue means any settle type is matched */
  SettleValueType: SettleValueTypeEnum;

  /** Revision of this group */
  Revision: number;

  /** ID of user who last updated this group */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique name of this group */
  Name: string;

  /** Display name for this group */
  DisplayName: string;

  /** Description of this group */
  Description: string;

  /** Asset IDs in this risk group */
  Assets: ICrossAssetRiskGroup8087Assets[];
}

/** Asset IDs in this risk group */
export interface ICrossAssetRiskGroup8087Assets {
  /** Asset in this risk group */
  Asset: string;
}

/** An object denoting the availability of the full suite of analytics for a given resolution and start time. */
export interface IAnalyticsAvailabilityUpdate {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Start of the aggregation period (inclusive) */
  StartTime: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** A categorization of the types of messages included in this release. */
  ScopeType: OPAScopeTypeEnum;

  /** End of the aggregation period (exclusive) */
  EndTime: JSON_UTCTimestamp;
}

/** An aggregated statistic datapoint detailing the number of orders for a set of dimensions. */
export interface INumOrdersDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** Number of orders for the specified set of dimensions */
  NumberOfOrders: number;

  /** If present, the market this datapoint's trades were routed through. */
  Market: JSON_Market;

  /** If present, the security traded for this datapoint */
  Asset: string;

  /** The depth of order counted towards this datapoint. */
  AnalyticsOrderDepth: AnalyticsOrderDepthEnum;

  /** If present, the strategy used for the orders counted towards this datapoint. */
  Strategy: JSON_Strategy;

  /** If present, the type of strategy considered towards this datapoint. */
  StrategyType: StrategyTypeEnum;

  /** Whether or not this datapoint is calculated from entirely Marketable orders, or from at least partially Limited orders. */
  OrderMarketability: OrderMarketabilityEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** An aggregated statistic datapoint detailing . */
export interface IExecutionMarkoutDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The seconds after the execution. Values may be negative to indicate markouts before the execution */
  SecondsFromExecution: number;

  /** The execution markout for the specified set of dimensions. 1.0 = 10000 Bps */
  MarkoutSpreadBps: JSON_Decimal;

  /** The value of the upper band of the execution markout range for the specified set of dimensions. 1.0 = 10000 Bps */
  TopMarkoutBps: JSON_Decimal;

  /** The value of the lower band of the execution markout range for the specified set of dimensions. 1.0 = 10000 Bps */
  BottomMarkoutBps: JSON_Decimal;

  /** The standard deviation of the execution markout range for the specified set of dimensions. 1.0 = 10000 Bps */
  MarkoutStdDevBps: JSON_Decimal;

  /** The strategy considered towards this datapoint. Defaults to 0 if not set. */
  Strategy: JSON_Strategy;

  /** The type of execution counted towards these datapoints. */
  ExecutionType: AggressorFlagEnum;

  /** Market ID. Defaults to 0 if not set. */
  Market: JSON_Market;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** An aggregated statistic datapoint detailing the round trip times with a dealer by dimension set. */
export interface IDealerRTTDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The median amount of millis for the specified set of dimensions. 1.0 = 1 Millisecond */
  MedianMillis: JSON_Decimal;

  /** The standard deviation RTT in millis for the specified set of dimensions. 1.0 = 1 Millisecond */
  StdDevMillis: JSON_Decimal;

  /** The 25th percentile RTT in millis for the specified set of dimensions. 1.0 = 1 Millisecond */
  Pct25thMillis: JSON_Decimal;

  /** The 75th percentile RTT in millis for the specified set of dimensions. 1.0 = 1 Millisecond */
  Pct75thMillis: JSON_Decimal;

  /** The 5th percentile RTT in millis for the specified set of dimensions. 1.0 = 1 Millisecond */
  Pct5thMillis: JSON_Decimal;

  /** The 95th percentile RTT in millis for the specified set of dimensions. 1.0 = 1 Millisecond */
  Pct95thMillis: JSON_Decimal;

  /** The market this datapoint's RTT concerns. */
  Market: JSON_Market;

  /** Order status for this datapoint */
  OrderStatus: OrdStatusEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** An aggregated statistic datapoint detailing the percent of order outcomes by a dimension set. */
export interface IMarketOrderOutcomeDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The percentage of outcomes matching the specified set of dimensions. 1.0 = 100% */
  OutcomePct: JSON_Decimal;

  /** The market this datapoint concerns. */
  Market: JSON_Market;

  /** Order status for this datapoint */
  OrderStatus: OrdStatusEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** An aggregated statistic datapoint detailing the percentage of time a market was available by a dimension set. */
export interface IMarketUptimeDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The percentage of time the market was available for the specified set of dimensions. 1.0 = 100% */
  UptimePct: JSON_Decimal;

  /** The market this datapoint concerns. */
  Market: JSON_Market;

  /** The type of market for this datapoint */
  MarketType: MarketTypeEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** SubAccount enables categorization of trades to a child entity */
export interface ISubaccount {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID of this SubAccount */
  SubaccountID: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Subaccount type either Book or Rollup */
  Type: SubAccountTypeEnum;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;

  /** ID of user who last updated this subaccount */
  UpdateUser: JSON_User;

  /** Purpose of this subaccount. Omitted on create defaults to GeneralTrading for a book and Rollup for a rollup. Omitted on update leaves the stored value unchanged. Rollups accept only Rollup. */
  Purpose: SubAccountPurposeEnum;

  /** Canonical name for this subaccount */
  Name: string;

  /** Display name for this subaccount */
  DisplayName: string;

  /** A map of system-name to external-identifier */
  ExternalIDs: unknown;
}

/** An aggregated statistic datapoint detailing the slippage of orders conforming to a dimension set. */
export interface ISlippageDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The slippage in Bps for the specified set of dimensions. 1.0 = 10000 Bps */
  SlippageBps: JSON_Decimal;

  /** The reference price of this datapoint. */
  ReferencePrice: SlippageReferencePriceEnum;

  /** The depth of order counted towards this datapoint. */
  AnalyticsOrderDepth: AnalyticsOrderDepthEnum;

  /** If present, the market this datapoint's trades were routed through */
  Market: JSON_Market;

  /** If present, the strategy used for the orders counted towards this datapoint. */
  Strategy: JSON_Strategy;

  /** If present, the type of strategy considered towards this datapoint. */
  StrategyType: StrategyTypeEnum;

  /** Whether or not this datapoint is calculated from entirely Marketable orders, or from at least partially Limited orders. */
  OrderMarketability: OrderMarketabilityEnum;

  /** The asset traded for this slippage */
  Asset: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** An aggregated statistic datapoint detailing Bid / Ask spreads for a dimension set. */
export interface IBidAskSpreadsDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The spread for the specified set of dimensions. 1.0 = 10000 Bps */
  SpreadBps: JSON_Decimal;

  /** The size for this spread datapoint */
  SizeBucket: JSON_Decimal;

  /** The type of spread represented in this datapoint. */
  SpreadType: AnalyticsSpreadTypeEnum;

  /** The market this datapoint's spreads were calculated for */
  Market: JSON_Market;

  /** The asset considered for this datapoint */
  Asset: string;

  /** Market account associated with this datapoint. */
  MarketAccount: JSON_MarketAccount;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;
}

/** An aggregated statistic datapoint detailing execution spreads for a dimension set. */
export interface IExecutionSpreadsDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The average spread wrt the market's fair price and the all-in price paid for the specified set of dimensions. 1.0 = 10000bps */
  AvgSpreadPaid: JSON_Decimal;

  /** The median units traded for this datapoint */
  MedianQuantity: JSON_Decimal;

  /** The market this datapoint's execution spreads were calculated for */
  Market: JSON_Market;

  /** The asset considered for this datapoint */
  Asset: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** An aggregated statistic datapoint detailing the number of orders for a set of dimensions. */
export interface IParentOrdersDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** Average amount traded for the specified set of dimensions. 1.0 = 1 unit of currency */
  AvgAmount: JSON_Decimal;

  /** Average duration of the parent order in minutes for the specified set of dimensions */
  AvgOrderMinutes: JSON_Decimal;

  /** Currency that the average amount is calculated with */
  EquivalentCurrency: string;

  /** If present, the strategy used for the orders counted towards this datapoint. */
  Strategy: JSON_Strategy;

  /** If present, the type of strategy considered towards this datapoint. */
  StrategyType: StrategyTypeEnum;

  /** Whether or not this datapoint is calculated from entirely Marketable orders, or from at least partially Limited orders. */
  OrderMarketability: OrderMarketabilityEnum;

  /** Volume executed in exchanges for this order divided by total volume executed at exchanges over the execution horizon of this order. 1.0 = 100% */
  ParticipationRate: JSON_Decimal;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** Custodian bus EVM tx request */
export interface ICustodianEvmTxRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Client order id used as request id */
  RequestID: string;

  /** Organization ID */
  OrgID: number;

  /** Market ID for the requesting gateway */
  RequestMarket: JSON_Market;

  /** Market account ID for the requesting gateway */
  RequestMarketAccount: JSON_MarketAccount;

  /** Market ID for the custodian gateway */
  CustodianMarket: JSON_Market;

  /** Market account ID for the custodian gateway */
  CustodianMarketAccount: JSON_MarketAccount;

  /** Transaction value in wei (integer, exponent 0) */
  ValueWei: JSON_Decimal;

  /** Gas limit */
  GasLimit: number;

  /** Gas tip cap in wei (integer, exponent 0) */
  GasTipCapWei: JSON_Decimal;

  /** Gas fee cap in wei (integer, exponent 0) */
  GasFeeCapWei: JSON_Decimal;

  /** Custodian action */
  Action: CustodianTxActionEnum;

  /** Chain symbol */
  ChainSymbol: string;

  /** Destination address */
  ToAddress: string;

  /** Call data hex */
  DataHex: string;
}

/** An aggregated statistic datapoint detailing the number of executions for a set of dimensions. */
export interface INumExecutionsDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** Number of executions for the specified set of dimensions */
  NumberOfExecutions: number;

  /** If present, the market this datapoint's executions were routed through. */
  Market: JSON_Market;

  /** If present, the security executed for this datapoint */
  Asset: string;

  /** If present, the strategy used for the orders counted towards this datapoint. */
  Strategy: JSON_Strategy;

  /** The type of execution counted towards these datapoints. */
  ExecutionType: AggressorFlagEnum;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;
}

/** Custodian bus EVM tx update */
export interface ICustodianEvmTxUpdate {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Client order id used as request id */
  RequestID: string;

  /** Organization ID */
  OrgID: number;

  /** Market ID for the requesting gateway */
  RequestMarket: JSON_Market;

  /** Market account ID for the requesting gateway */
  RequestMarketAccount: JSON_MarketAccount;

  /** Market ID for the custodian gateway */
  CustodianMarket: JSON_Market;

  /** Market account ID for the custodian gateway */
  CustodianMarketAccount: JSON_MarketAccount;

  /** Custodian transaction status */
  Status: CustodianTxStatusEnum;

  /** Confirmations */
  Confirmations: number;

  /** Block number */
  BlockNumber: number;

  /** Gas fee in wei (integer, exponent 0) */
  GasFeeWei: JSON_Decimal;

  /** Transaction hash */
  TxHash: string;

  /** Custodian activity id */
  ActivityID: string;

  /** Error details */
  Error: string;

  /** Fee currency symbol */
  FeeCurrencySymbol: string;
}

/** An aggregated statistic datapoint summarizing some statistics of orders conforming to a dimension set. */
export interface IOrdersSummaryDatapoint {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** Time resolution of analytics */
  AggregationWindow: AggregationWindowEnum;

  /** Start of the aggregation period */
  StartTime: JSON_UTCTimestamp;

  /** The average order amount traded for the specified set of dimensions. 1.0 = 1 unit of currency */
  AvgOrderAmount: JSON_Decimal;

  /** The total exchange fees paid for the specified set of dimensions. 1.0 = 1 unit of currency */
  TotalExchangeFees: JSON_Decimal;

  /** The percentage of exchange volume paid in fees across venues, not including Talos fees or transfer fees, for the specified set of dimensions. 1.0 = 10000bps */
  EffectiveFeeRate: JSON_Decimal;

  /** The currency this datapoint's spreads were calculated for */
  EquivalentCurrency: string;

  /** The asset considered for this datapoint */
  Asset: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** If present, the strategy used for the orders counted towards this datapoint. */
  Strategy: JSON_Strategy;
}

/** Custodian bus payload signing request */
export interface ICustodianSignRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique identifier for this signing request */
  RequestID: string;

  /** Organization ID */
  OrgID: number;

  /** Market ID of the gateway requesting the signature */
  RequestMarket: JSON_Market;

  /** Market account ID of the requesting gateway */
  RequestMarketAccount: JSON_MarketAccount;

  /** Market ID of the custodian gateway */
  CustodianMarket: JSON_Market;

  /** Custodian market account whose key must sign */
  CustodianMarketAccount: JSON_MarketAccount;

  /** Signing scheme and payload interpretation */
  SignScheme: CustodianSignSchemeEnum;

  /** Chain associated with this signing request */
  ChainSymbol: string;

  /** Exact payload to sign */
  Payload: string;
}

/** ChildOrder relates a child ClOrdID to a parent OrderID */
export interface IChildOrder {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** OrderID of the parent order */
  OrderID: string;

  /** OrderID */
  OID: JSON_Int64ID;
}

/** Post-trade analytics for an order. */
export interface IPostTradeOrderAnalytics {
  /** Internal time when this message was created in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** The revision of the release (currently the timestamp at which this datapoint was inserted into the source DB in nanoseconds since epoch) */
  ReleaseRevision: JSON_UTCTimestamp;

  /** DEPRECATED. Should be completely ignored as of 2.45 */
  AggregationWindow: AggregationWindowEnum;

  /** DEPRECATED. Should be completely ignored as of 2.45 */
  StartTime: JSON_UTCTimestamp;

  /** Start time of the order in number of nanoseconds since Unix epoch */
  OrderStartTime: JSON_UTCTimestamp;

  /** End time of the order in number of nanoseconds since Unix epoch */
  OrderEndTime: JSON_UTCTimestamp;

  /** OrderID */
  OrderID: string;

  /** Currency that the total trading amount is represented by */
  EquivalentCurrency: string;

  /** Strategy used for this order */
  Strategy: JSON_Strategy;

  /** Asset traded */
  Asset: string;

  /** Product Type associated with the AssetID on this message */
  ProductType: ProductTypeEnum;

  /** Order side */
  Side: SideEnum;

  /** Total amount traded as part of this order as of the end of the aggregation period (StartTime datetime + resolution) */
  TotalTradedAmt: JSON_Decimal;

  /** Duration of the order. 1 = one millisecond */
  OrderDurationMillis: number;

  /** The percentage of the total volume during the execution horizon this order was responsible for. 1.0 = 100% */
  ParticipationRate: JSON_Decimal;

  /** The percentage of the volume executed while paying maker fees. 1.0 = 100% */
  MakerPct: JSON_Decimal;

  /** The arrival slippage of the order. 1.0 = 10000 bps */
  ArrivalSlippageBps: JSON_Decimal;

  /** The TWAP slippage of the order. 1.0 = 10000 bps */
  TWAPSlippageBps: JSON_Decimal;

  /** The VWAP slippage of the order. 1.0 = 10000 bps */
  VWAPSlippageBps: JSON_Decimal;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** The timestamp in number of nanoseconds since Unix epoch after which (and including) events are not considered for the calculation of statistics on this datapoint */
  AsOfTimestamp: JSON_UTCTimestamp;

  /** Strategy parameters */
  Parameters: IStrategyParameters;
}

/** Custodian bus payload signing response */
export interface ICustodianSignResponse {
  /** Result creation time in nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the request this response corresponds to */
  RequestID: string;

  /** Organization ID */
  OrgID: number;

  /** Status indicating whether this signing request was successful */
  Status: CustodianSignStatusEnum;

  /** Scheme-specific signature, empty is status is not Success */
  Signature: string;

  /** Human-readable error details, empty if status is Success */
  ErrorText: string;
}

/** OMSRequestRecord request record indicates that a parent request has been acked */
export interface IOMSRequestRecord {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** OrderID of the parent order */
  OrderID: string;

  /** ClOrdID of the parent request */
  ClOrdID: string;

  /** ExecType */
  ExecType: ExecTypeEnum;
}

/** Context when evaluating customer order */
export interface ICustomerContext {
  /** Internal time in number of nanoseconds since Unix epoch when this message was generated */
  Timestamp: JSON_UTCTimestamp;

  /** OrderID */
  OrderID: string;

  /** RFQID */
  RFQID: string;

  /** ExecID */
  ExecID: string;

  /** Side */
  Side: SideEnum;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Security ID */
  Symbol: JSON_Security;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Currency ID */
  Currency: string;

  /** Order price. Null for market orders */
  Price: JSON_Decimal;

  /** Assigned counterparty */
  Counterparty: JSON_Counterparty;

  /** Assigned customer user */
  CustomerUser: JSON_CustomerUser;

  /** Assigned MarketAccount */
  MarketAccount: JSON_CustomerMarketAccount;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Internal Order reject reason */
  InternalOrdRejReason: OrdRejReasonEnum;

  /** Risk evaluation mode */
  RiskEvaluationMode: RiskEvaluationModeEnum;

  /** OrderID */
  HedgeOrderID: string;

  /** Customer context type */
  ContextType: CustomerContextTypeEnum;

  /** Customer security min size. Might be null */
  CustomerSecurityMinSize: JSON_Decimal;

  /** Customer security max size. Might be null */
  CustomerSecurityMaxSize: JSON_Decimal;

  /** Customer security canonical size increment */
  CustomerSecurityMinSizeIncrement: JSON_Decimal;

  /** Customer security canonical price increment */
  CustomerSecurityMinPriceIncrement: JSON_Decimal;

  /** Currency ID for balance */
  BalanceCurrency: string;

  /** Security ID for balance */
  BalanceSymbol: JSON_Security;

  /** Available amount */
  BalanceAmount: JSON_Decimal;

  /** Amount */
  BalanceAvailableAmount: JSON_Decimal;

  /** Exact or estimated paying amount */
  PayingAmount: JSON_Decimal;

  /** Customer security canonical amount increment */
  CustomerSecurityMinAmtIncrement: JSON_Decimal;

  /** Enable or disable unified liquidity feature. */
  CustomerSecurityUnifiedLiquidity: UnifiedLiquidityEnum;

  /** Customer security min amount. Might be null */
  CustomerSecurityMinAmount: JSON_Decimal;

  /** Customer security min size fill increment. Might be null */
  CustomerSecurityMinSizeFillIncrement: JSON_Decimal;

  /** Customer security min amt fill increment. Might be null */
  CustomerSecurityMinAmtFillIncrement: JSON_Decimal;

  /** Derivative position */
  PositionAmount: JSON_Decimal;

  /** The Currency units of the margin */
  MarginCurrency: string;

  /** Equity used for margin */
  Equity: JSON_Decimal;

  /** Margin amount available */
  AvailableMargin: JSON_Decimal;

  /** Account leverage */
  Leverage: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Maximum exposure setup for the account */
  MaximumExposure: JSON_Decimal;

  /** User expressed outcome for prediction outcome orders. (optional) */
  ExpressedOutcome: ExpressedOutcomeEnum;

  /** Reason for rejection */
  Text: string;

  /** Internal reason for rejection */
  InternalText: string;

  /** Order parameters */
  Parameters: IStrategyParameters;

  /** Effective pricing rule */
  EffectivePricingRule: IQuoteParameters;

  /** List of status and market data for aggregation markets */
  AggregationMarketStatus: ICustomerContext4010AggregationMarketStatus[];

  /** Bid Entries */
  Bids: ICustomerContext4010Bids[];

  /** Offer Entries */
  Offers: ICustomerContext4010Offers[];

  /** Additional list of internal configuration */
  InternalConfiguration: ICustomerContext4010InternalConfiguration[];

  /** List of unified symbol and markets */
  UnifiedMarkets: ICustomerContext4010UnifiedMarkets[];
}

/** List of status and market data for aggregation markets */
export interface ICustomerContext4010AggregationMarketStatus {
  /** MarketID */
  Market: JSON_Market;

  /** MarketAccountID */
  MarketAccount: JSON_MarketAccount;

  /** Status of market data for given market */
  Status: ConnectionStatusEnum;

  /** Hedge market bid entries */
  HedgeBids: IAggregationMarketStatusHedgeBids[];

  /** Hedge market offer entries */
  HedgeOffers: IAggregationMarketStatusHedgeOffers[];
}

/** Bid Entries */
export interface ICustomerContext4010Bids {
  /** Bid Price */
  Price: JSON_Decimal;

  /** Bid Size */
  Size: JSON_Decimal;
}

/** Hedge market bid entries */
export interface IAggregationMarketStatusHedgeBids {
  /** Bid Price */
  Price: JSON_Decimal;

  /** Bid Size */
  Size: JSON_Decimal;
}

/** Hedge market offer entries */
export interface IAggregationMarketStatusHedgeOffers {
  /** Offer Price */
  Price: JSON_Decimal;

  /** Offer Size */
  Size: JSON_Decimal;
}

/** Additional list of internal configuration */
export interface ICustomerContext4010InternalConfiguration {
  /** Configuration key */
  Key: string;

  /** Configuration value as a string */
  Value: string;
}

/** Offer Entries */
export interface ICustomerContext4010Offers {
  /** Offer Price */
  Price: JSON_Decimal;

  /** Offer Size */
  Size: JSON_Decimal;
}

/** List of unified symbol and markets */
export interface ICustomerContext4010UnifiedMarkets {
  /** MarketID */
  Market: JSON_Market;

  /** SecurityID */
  Symbol: JSON_Security;
}

/** DeprecatedSecurityDisplay has information about displaying a security to the user */
export interface IDeprecatedSecurityDisplay {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Security ID */
  Symbol: JSON_Security;

  /** Default price increment */
  DefaultPriceIncrement: JSON_Decimal;

  /** Default size increment */
  DefaultSizeIncrement: JSON_Decimal;

  /** Display spec for prices */
  PriceDisplaySpec: string;

  /** Display spec for sizes */
  SizeDisplaySpec: string;

  /** Normal size for display */
  NormalSize: JSON_Decimal;

  /** DisplaySymbol */
  DisplaySymbol: string;

  /** Default list of size buckets */
  SizeBuckets: IDeprecatedSecurityDisplay4027SizeBuckets[];
}

/** Default list of size buckets */
export interface IDeprecatedSecurityDisplay4027SizeBuckets {
  /** Size bucket */
  Size: JSON_Decimal;
}

/**  */
export interface IRemoteOrder {
  /** Unique name the remote, e.g. a FIX session specifier */
  Remote: string;

  /** ClOrdID specified by the remote party */
  RemoteClOrdID: string;

  /** OrigClOrdID specified by the remote party */
  RemoteOrigClOrdID: string;

  /** System ClOrdID */
  LocalClOrdID: string;
}

/** MarketCurrency represents a currency on a market */
export interface IMarketCurrency {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Currency ID */
  Currency: string;

  /** Date it was delisted */
  EndTime: JSON_UTCTimestamp;

  /** Dis-ambiguity tag for market currency */
  Tag: string;

  /** Revision */
  Revision: number;

  /** Symbol used by this market */
  MarketSymbol: string;

  /** Alias for Currency ID */
  AliasForCurrency: string;

  /** Alias for Chain Symbol */
  AliasForChainSymbol: string;

  /** Symbols for this currency's supported chain currencies */
  ChainCurrencySymbols: unknown;

  /** Metadata for this market currency */
  Metadata: unknown;
}

/**  */
export interface IRemoteOrderPosition {
  /** Unique name the remote, e.g. a FIX session specifier */
  Remote: string;

  /** The position processed */
  Position: number;
}

/** Currency represents a fiat currency or token */
export interface ICurrency {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Currency ID */
  CurrencyID: number;

  /** Canonical symbol for this currency */
  Symbol: string;

  /** Minimum increment for an amount of this currency. */
  MinIncrement: JSON_Decimal;

  /** Canonical increment for an amount of this currency */
  DefaultIncrement: JSON_Decimal;

  /** Date it was delisted */
  EndTime: JSON_UTCTimestamp;

  /** Revision */
  Revision: number;

  /** Alias for Currency ID */
  AliasForCurrency: string;

  /** Alias for Chain Symbol */
  AliasForChainSymbol: string;

  /** Optional pegged currency */
  PeggedCurrency: string;

  /** Defines RebaseMode for TokenizedAssets */
  RebaseMode: CurrencyRebaseModeEnum;

  /** Defines the rebase multiplier for the underlying TokenizedAsset */
  RebaseMultiplier: JSON_Decimal;

  /** Description of the currency */
  Description: string;

  /** Metadata for this currency */
  Metadata: unknown;

  /** List of Tags for this Currency */
  Tags: ICurrency4029Tags[];
}

/** List of Tags for this Currency */
export interface ICurrency4029Tags {
  /** Currency Tag value */
  Tag: CurrencyTagEnum;
}

/** Blockchain represents specific details for a blockchain including the ChainID, block explorer base link, and other onchain details */
export interface IBlockchain {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Chain ID */
  ChainID: number;

  /** Chain Symbol */
  ChainSymbol: string;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Specified when source=User or on user updates. */
  UpdateUser: JSON_User;

  /** Block Explorer Base Link */
  ChainExplorerBaseLink: string;

  /** Description of the blockchain */
  Description: string;

  /** Data integrity hash. Used for ensuring data integrity of details stored in DB */
  DataIntegrityHash: string;
}

/** Token info for on-chain assets */
export interface IToken {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Currency ID for this token */
  Currency: string;

  /** Blockchain chain symbol */
  ChainSymbol: string;

  /** Token decimals */
  Decimals: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Specified when source=User or on user updates. */
  UpdateUser: JSON_User;

  /** On-chain token address */
  Address: string;
}

/** Request for a connection to an aggregator */
export interface IAggregatorConnectRequest {
  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;
}

/** MarketDataRequest */
export interface IMarketDataRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Must be unique, or the ID of previous MarketDataRequest to unsubscribe */
  MDReqID: number;

  /** SubscriptionRequestType, e.g. where to subscribe or unsubscribe */
  SubscriptionRequestType: SubscriptionRequestTypeEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Organization ID */
  OrgID: number;

  /** Number of requests */
  Symbols: IMarketDataRequest4033Symbols[];

  /** Number of markets to be used for this order */
  Markets: IMarketDataRequest4033Markets[];
}

/** Number of markets to be used for this order */
export interface IMarketDataRequest4033Markets {
  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** Number of requests */
export interface IMarketDataRequest4033Symbols {
  /** Security ID */
  Symbol: JSON_Security;

  /** Market depth to subscribe to, 0 - full book depth, 1 - top of book, 2 - book depth (number of levels) */
  MarketDepth: number;
}

/** Response to an aggregator connect request */
export interface IAggregatorConnectResponse {
  /** The request ID that this response is for. */
  RequestID: number;

  /** Stream ID the client should use to consume messages from the aggregator */
  OutgoingDataStreamID: number;

  /** Channel the client should subscribe to for messages from the aggregator */
  OutgoingDataChannel: string;
}

/** Security represents something that is tradeable, like a currency pair */
export interface ISecurity {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Security ID */
  SecurityID: number;

  /** Canonical symbol for this security */
  Symbol: string;

  /** Canonical price increment */
  MinPriceIncrement: JSON_Decimal;

  /** Canonical size increment */
  MinSizeIncrement: JSON_Decimal;

  /** Canonical size increment */
  MinimumSize: JSON_Decimal;

  /** Canonical size increment */
  MaximumSize: JSON_Decimal;

  /** The quote currency for this symbol, i.e USD for BTC-USD. This is the currency that the price is quoted in. */
  QuoteCurrency: string;

  /** The base currency for this symbol, i.e BTC for BTC-USD. */
  BaseCurrency: string;

  /** Date it was delisted */
  EndTime: JSON_UTCTimestamp;

  /** Default price increment (Display Field) */
  DefaultPriceIncrement: JSON_Decimal;

  /** Default size increment (Display Field) */
  DefaultSizeIncrement: JSON_Decimal;

  /** Display spec for prices (Display Field) */
  PriceDisplaySpec: string;

  /** Display spec for sizes (Display Field) */
  SizeDisplaySpec: string;

  /** Normal size for display (Display Field) */
  NormalSize: JSON_Decimal;

  /** Product Type */
  ProductType: ProductTypeEnum;

  /** The position currency for this security. This is the default currency for quantities of this instrument. May be missing if quantities don't correspond to any currency, i.e. derivatives contracts. For spot, this will be the same as `BaseCurrency`. */
  PositionCurrency: string;

  /** The settlement currency for this security. This is the currency that trading this instrument takes PnL in by default. For spot, this will be the same as `QuoteCurrency`. */
  SettlementCurrency: string;

  /** The notional multiplier for this security. `Quantity * Price * PriceNormalizationFactor * NotionalMultiplier = Total in SettlementCurrency`. */
  NotionalMultiplier: JSON_Decimal;

  /** Expiration */
  Expiration: JSON_UTCTimestamp;

  /** The type of calculation used to compute the settlement value of this security */
  SettleValueType: SettleValueTypeEnum;

  /** The rank of this security, primarily used for UI ordering */
  Rank: number;

  /** Instrument composition */
  Composition: InstrumentCompositionEnum;

  /** Strike price for an options contract */
  StrikePrice: JSON_Decimal;

  /** Option type */
  OptionType: OptionTypeEnum;

  /** ID of the underlying security for an options contract */
  UnderlyingSymbol: JSON_Security;

  /** Owner of this security */
  Owner: SecurityOwnerEnum;

  /** Revision */
  Revision: number;

  /** The quote currency of the underlying security for an options contract */
  UnderlyingQuoteCurrency: string;

  /** Pricing modes supported by this security */
  SupportedPricingModes: Record<PricingModesEnum, boolean>;

  /** Market amount increment */
  MinAmountIncrement: JSON_Decimal;

  /** The underlying code for security */
  UnderlyingCode: string;

  /** Organization ID */
  OrgID: number;

  /** Date it was listed */
  StartTime: JSON_UTCTimestamp;

  /** Sub Product Type */
  SubProductType: SubProductTypeEnum;

  /** The inverse price-multiplier for this security. E.g., for derivatives with prices that are pre-scaled based on NotionalMultiplier */
  PriceNormalizationFactor: JSON_Decimal;

  /** Settlement type for derivatives (Cash or Physical) */
  DerivativeSettlementType: DerivativeSettlementTypeEnum;

  /** Links this security to its parent prediction outcome event */
  PredictionOutcomeEventID: JSON_Int64ID | undefined;

  /** DisplaySymbol field (Display Field) */
  DisplaySymbol: string;

  /** Description of the security */
  Description: string;

  /** MultiLeg configuration */
  MultilegDetails: string;

  /** Custom Instrument Details */
  ProductDetails: unknown;

  /** Metadata for this security */
  Metadata: unknown;

  /** Default list of size buckets (Display Field) */
  SizeBuckets: ISecurity4034SizeBuckets[];

  /** The legs if this is a calendar spread instrument product or a compound product (e.g. basket of currencies for a multi-token ETF) */
  Legs: ISecurity4034Legs[];
}

/** The legs if this is a calendar spread instrument product or a compound product (e.g. basket of currencies for a multi-token ETF) */
export interface ISecurity4034Legs {
  /** Security ID */
  Symbol: JSON_Security;

  /** Direction this leg will trade compared to the parent order side (Same, Opposite) */
  Direction: LegDirectionEnum;

  /** The amount of this leg in one unit of a composite asset */
  SizeRatio: JSON_Decimal;
}

/** Default list of size buckets (Display Field) */
export interface ISecurity4034SizeBuckets {
  /** Size bucket (Display Field) */
  Size: JSON_Decimal;
}

/** MarketSecurity */
export interface IMarketSecurity {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Market price increment */
  MinPriceIncrement: JSON_Decimal;

  /** Market size increment */
  MinSizeIncrement: JSON_Decimal;

  /** Market size increment */
  MinimumSize: JSON_Decimal;

  /** Market size increment */
  MaximumSize: JSON_Decimal;

  /** Symbol used by this market */
  MarketSymbol: string;

  /** Date it was delisted */
  EndTime: JSON_UTCTimestamp;

  /** Type of functionality supported by this market security */
  Capabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** Minimum amount required to place an order */
  MinimumAmount: JSON_Decimal;

  /** Revision */
  Revision: number;

  /** Market amount increment */
  MinAmountIncrement: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Date it was listed */
  StartTime: JSON_UTCTimestamp;

  /** Maximum amount required to place an order */
  MaximumAmount: JSON_Decimal;

  /** Metadata for this market security */
  Metadata: unknown;

  /** Number of alternative symbols, these are ordered and meaning is exchange dependent */
  AltSymbols: IMarketSecurity4035AltSymbols[];
}

/** Number of alternative symbols, these are ordered and meaning is exchange dependent */
export interface IMarketSecurity4035AltSymbols {
  /** Alternative symbol used by this market */
  Symbol: string;
}

/** Market */
export interface IMarket {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  MarketID: number;

  /** Canonical name for this market */
  Name: string;

  /** Short display name for this market */
  ShortName: string;

  /** Date it was delisted */
  EndTime: JSON_UTCTimestamp;

  /** Type of functionality supported by this market */
  Capabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** Type of the market */
  Type: MarketTypeEnum;

  /** Additional properties of market */
  Flags: Record<MarketFlagsEnum, boolean>;

  /** Revision */
  Revision: number;

  /** DisplayName */
  DisplayName: string;

  /** List of supported TimeInForce values for this market */
  SupportedTimeInForce: IMarket4036SupportedTimeInForce[];
}

/** List of supported TimeInForce values for this market */
export interface IMarket4036SupportedTimeInForce {
  /** Supported time in force value */
  TimeInForce: TimeInForceEnum;
}

/** Market */
export interface IMarketOverride {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  MarketID: number;

  /** Type of functionality supported by this market */
  Capabilities: Record<ConnectionCapabilitiesEnum, boolean>;

  /** Additional properties of market */
  Flags: Record<MarketFlagsEnum, boolean>;

  /** Revision */
  Revision: number;

  /** List of supported TimeInForce values for this market */
  SupportedTimeInForce: IMarketOverride4037SupportedTimeInForce[];
}

/** List of supported TimeInForce values for this market */
export interface IMarketOverride4037SupportedTimeInForce {
  /** Supported time in force value */
  TimeInForce: TimeInForceEnum;
}

/** Groups the outcome securities for a single prediction outcome event question */
export interface IPredictionOutcomeEvent {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Specified when source=User or on user updates. */
  UpdateUser: JSON_User;

  /** Unique event identifier */
  EventID: JSON_Int64ID;

  /** Parent series identifier (optional) */
  SeriesID: JSON_Int64ID | undefined;

  /** Market-agnostic symbol identifying this event */
  EventSymbol: string;

  /** Event category */
  Category: string;

  /** Lifecycle status of this event */
  Status: EventStatusEnum;

  /** Expected resolution timestamp in nanoseconds since Unix epoch */
  ResolutionTime: JSON_UTCTimestamp;

  /** Outcome structure of this event */
  EventType: PredictionOutcomeEventTypeEnum;

  /** Human-readable title for this event */
  EventName: string;

  /** Resolution rules for this event */
  Description: string;
}

/** MarketRequest */
export interface IMarketRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** SessionID for this subscription. */
  SessionID: JSON_Int64ID;

  /** Unique RequestID for this subscription. */
  RequestID: number;

  /** Type of request to make */
  RequestType: RequestTypeEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Connection ID */
  ConnectionID: number;

  /** Credential ID */
  CredentialID: number;

  /** Security ID (optional) */
  Symbol: JSON_Security;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;
}

/** Groups recurring prediction outcome events of the same type */
export interface IPredictionOutcomeEventSeriesRecord {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision */
  Revision: number;

  /** Specified when source=User or on user updates. */
  UpdateUser: JSON_User;

  /** Unique series identifier */
  SeriesID: JSON_Int64ID;

  /** Market-agnostic symbol identifying this series */
  SeriesSymbol: string;

  /** Event category */
  Category: string;

  /** Human-readable title for this series */
  SeriesName: string;

  /** Resolution rules for this series */
  Description: string;
}

/** Minimal identity for a security that is past its delisted retention period */
export interface IDelistedSecurity {
  /** Security ID */
  SecurityID: number;

  /** Canonical symbol for this security */
  Symbol: string;
}

/** MDIncrementalRefreshOrderBook */
export interface IMDIncrementalRefreshOrderBook {
  /** Internal processing time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Credential ID that this stream is associated with */
  CredentialID: number;

  /** Depth type */
  DepthType: DepthTypeEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Latest exchange message timestamp from the market used on this snapshot. Number of nanoseconds since the Unix epoch. */
  ExchangeTime: JSON_UTCTimestamp;

  /** Type of book */
  BookType: BookTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of entries in Market Data message */
  Entries: IMDIncrementalRefreshOrderBook4043Entries[];
}

/** Number of entries in Market Data message */
export interface IMDIncrementalRefreshOrderBook4043Entries {
  /** Order ID */
  OrderID: string;

  /** Order price */
  MDEntryPx: JSON_Decimal;

  /** Market Data entry size */
  MDEntrySize: JSON_Decimal;

  /** Order book update action to be applied to the order referenced by OrderID */
  MDUpdateAction: MDUpdateActionEnum;

  /** Market Data entry type */
  MDEntryType: MDEntryTypeEnum;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;
}

/** MDIncrementalRefreshBook */
export interface IMDIncrementalRefreshBook {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Credential ID that this stream is associated with */
  CredentialID: number;

  /** Depth type */
  DepthType: DepthTypeEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Latest exchange message timestamp from the market used on this snapshot. Number of nanoseconds since the Unix epoch. */
  ExchangeTime: JSON_UTCTimestamp;

  /** Type of book */
  BookType: BookTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of entries in Market Data message */
  Entries: IMDIncrementalRefreshBook4046Entries[];
}

/** Number of entries in Market Data message */
export interface IMDIncrementalRefreshBook4046Entries {
  /** Market Data entry price */
  MDEntryPx: JSON_Decimal;

  /** Market Data entry size */
  MDEntrySize: JSON_Decimal;

  /** Market Data update action */
  MDUpdateAction: MDUpdateActionEnum;

  /** Market Data entry type */
  MDEntryType: MDEntryTypeEnum;

  /** Aggregate number of orders at given price level */
  NumberOfOrders: number;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;
}

/** MDIncrementalRefreshTradeSummary */
export interface IMDIncrementalRefreshTradeSummary {
  /** Internal processing time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Bitmap field of eight Boolean type indicators reflecting the end of updates for a given event */
  EventIndicator: Record<EventIndicatorEnum, boolean>;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;

  /** Number of Trade Summary entries */
  Entries: IMDIncrementalRefreshTradeSummary4048Entries[];
}

/** Number of Trade Summary entries */
export interface IMDIncrementalRefreshTradeSummary4048Entries {
  /** Trade price */
  MDEntryPx: JSON_Decimal;

  /** Trade quantity */
  MDEntrySize: JSON_Decimal;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** Market Data update action */
  MDUpdateAction: MDUpdateActionEnum;

  /** Market Data entry type */
  MDEntryType: MDEntryTypeEnum;

  /** Market Data Trade entry ID */
  MDTradeEntryID: string;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;
}

/** NewOrderSingle */
export interface INewOrderSingle {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OID for this request */
  ClOID: JSON_Int64ID;

  /** Side */
  Side: SideEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Internal ID of the quote; optional */
  QID: JSON_Int64ID;

  /** Parent OMS order OrderID */
  ParentOrderID: string;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** Expected average filled price */
  ExpectedFillPrice: JSON_Decimal;

  /** Expected filled quantity in units of Currency */
  ExpectedFillQty: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Internal time the message was sent in number of nanoseconds since Unix epoch */
  SubmitTime: JSON_UTCTimestamp;

  /** The service originating the child order */
  ParentService: JSON_ServiceIdentifier;

  /** If present, Price is expressed in units determined by PricingMode, otherwise Price is in quote currency */
  PricingMode: PricingModeEnum;

  /** User ID */
  User: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Bitmap of execution instructions */
  ExecutionInstructions: Record<ExecutionInstructionsEnum, boolean>;

  /** Child order RequestIndicator */
  RequestIndicator: RequestIndicatorTypeEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Market parameters */
  Parameters: IMarketParameters;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** OrderCancelRequest */
export interface IOrderCancelRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** ClOrdID for this request */
  ClOID: JSON_Int64ID;

  /** OID of the order to cancel */
  OID: JSON_Int64ID;

  /** Parent OMS order OrderID */
  ParentOrderID: string;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Internal time the message was sent in number of nanoseconds since Unix epoch */
  SubmitTime: JSON_UTCTimestamp;

  /** The service originating the child order */
  ParentService: JSON_ServiceIdentifier;

  /** User ID */
  User: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Child order RequestIndicator */
  RequestIndicator: RequestIndicatorTypeEnum;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** OrderCancelReplaceRequest */
export interface IOrderCancelReplaceRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection to use */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** ClOrdID for this request */
  ClOID: JSON_Int64ID;

  /** OID of the order to replace */
  OID: JSON_Int64ID;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Limit price */
  Price: JSON_Decimal;

  /** Parent OMS order OrderID */
  ParentOrderID: string;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Internal time the message was sent in number of nanoseconds since Unix epoch */
  SubmitTime: JSON_UTCTimestamp;

  /** The service originating the child order */
  ParentService: JSON_ServiceIdentifier;

  /** User ID */
  User: JSON_User;

  /** Organization ID */
  OrgID: number;

  /** Child order RequestIndicator */
  RequestIndicator: RequestIndicatorTypeEnum;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** Request a connection to an RPC provider and return details for the session */
export interface IRPCSessionRequest {
  /** Client-generated request ID */
  RequestID: number;

  /** Session ID this request is acting on, if it's in relation to an existing session */
  SessionID: number;

  /** Action */
  Action: RPCSessionActionEnum;

  /** ResponseStreamID */
  ResponseStreamID: number;

  /** ResponseChannel */
  ResponseChannel: string;
}

/** Report of the RPC servers state for a given session */
export interface IRPCSessionStatus {
  /** The request ID that this status is in response to, if any. */
  RequestID: number;

  /** Server-generate session ID */
  SessionID: number;

  /** Status */
  Status: RPCSessionStatusEnum;
}

/** SimMarket configures a simulator to publish market data and accept orders */
export interface ISimMarket {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Normal market price */
  NormalPrice: JSON_Decimal;

  /** Normal market size */
  NormalSize: JSON_Decimal;

  /** Normal order count */
  NormalOrderCount: number;

  /** Normal market depth */
  NormalDepth: number;

  /** Normal market spread */
  NormalSpread: JSON_Decimal;

  /** Percentage drift (mu) */
  Drift: JSON_Decimal;

  /** Percentage volatility (sigma) */
  Volatility: JSON_Decimal;

  /** Percentage of open orders canceled */
  CancelRate: JSON_Decimal;

  /** Percentage of crossing orders */
  FillRate: JSON_Decimal;

  /** Market normal price increment */
  NormalPriceIncrement: JSON_Decimal;

  /** Market normal size increment */
  NormalSizeIncrement: JSON_Decimal;

  /** Market minimum size */
  NormalMinimumSize: JSON_Decimal;

  /** Market maximum size */
  NormalMaximumSize: JSON_Decimal;
}

/** (TenantID:OrgID) ExecutionReportNew indicates the order is acked or restated */
export interface IExecutionReportNew {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** OrderID of this order at the market */
  OrderID: string;

  /** ClOrdID of this order at the market */
  ClOrdID: string;

  /** ExecID of this execution at the market */
  ExecID: string;

  /** Side */
  Side: SideEnum;

  /** Order entry time as provided by the submitter of the order in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** ExecTypeNew */
  ExecType: number;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Order quantity */
  OrderQty: JSON_Decimal;

  /** Order type */
  OrdType: OrdTypeEnum;

  /** Limit price */
  Price: JSON_Decimal;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Time in force */
  TimeInForce: TimeInForceEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** If present determines the units of PricingReference. Price is always in quote currency */
  PricingMode: PricingModeEnum;

  /** Pricing reference in units of PricingMode */
  PricingReference: JSON_Decimal;

  /** Bitmap of execution instructions */
  ExecutionInstructions: Record<ExecutionInstructionsEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** Template ID of the Metadata SBE message */
  MetadataTemplateID: number;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Gateway-owned order metadata */
  Metadata: number;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID) */
export interface IExecutionReportTrade {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** ExecID */
  ExecID: string;

  /** Time of the trade as provided by remote in number of nanoseconds since Unix epoch. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecTypeTrade */
  ExecType: number;

  /** Side */
  Side: SideEnum;

  /** Last price */
  LastPx: JSON_Decimal;

  /** Last qty */
  LastQty: JSON_Decimal;

  /** Last amount */
  LastAmt: JSON_Decimal;

  /** Last fee */
  LastFee: JSON_Decimal;

  /** Last fee currency */
  LastFeeCurrency: string;

  /** Trade capture info */
  TradeStatus: TradeStatusEnum;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Talos fee */
  LastTalosFee: JSON_Decimal;

  /** Currency ID for the Talos fee */
  LastTalosFeeCurrency: string;

  /** Organization ID */
  OrgID: number;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Miscellaneous transaction attributes */
  Attributes: unknown;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID) */
export interface IExecutionReportReject {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecTypeRejected */
  ExecType: number;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID) */
export interface IExecutionReportCancel {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecTypeCanceled */
  ExecType: number;

  /** Canceled quantity */
  CanceledQty: JSON_Decimal;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Executed quantity, used if CanceledQty = 0 */
  ExecQty: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID) */
export interface IExecutionReportReplace {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecTypeReplaced */
  ExecType: number;

  /** Leaves quantity */
  LeavesQty: JSON_Decimal;

  /** Limit price */
  Price: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** An ID to help us dedup DeltaQty messages */
  ReplaceID: string;

  /** How much the qty has changed */
  DeltaQty: JSON_Decimal;

  /** New order qty */
  NewOrderQty: JSON_Decimal;

  /** Additional reason for ExecType */
  ExecTypeReason: ExecTypeReasonEnum;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID) */
export interface IOrderCancelReject {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Cancel reject response to */
  CxlRejResponseTo: CxlRejResponseToEnum;

  /** ClOrdID for this request */
  ClOID: JSON_Int64ID;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** Parent OMS order OrderID, may be blank for orders that do not belong to an OMS order */
  ParentOrderID: string;

  /** OrdStatus */
  OrdStatus: OrdStatusEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** The service originating the child order */
  ParentService: JSON_ServiceIdentifier;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID)(ResourceName:MarketTrade ResourceTag:T DatabaseName:market_trades_new Key:EID TimestampField:TransactTime AeronCols:true ConstantGroupLength:true PrimaryKey:Generated IDQueryFields:OrderID DBType:OrgDB) */
export interface ITradeCapture {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency ID for the dealt currency */
  Currency: string;

  /** OrderID */
  OrderID: string;

  /** ExecID */
  TradeID: string;

  /** Time of the trade as provided by remote in number of nanoseconds since Unix epoch. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecType */
  ExecType: ExecTypeEnum;

  /** Side */
  Side: SideEnum;

  /** Trade price */
  Price: JSON_Decimal;

  /** Trade quantity */
  Quantity: JSON_Decimal;

  /** Trade amount */
  Amount: JSON_Decimal;

  /** Trade fee */
  Fee: JSON_Decimal;

  /** Trade fee currency */
  FeeCurrency: string;

  /** Trade capture info */
  TradeStatus: TradeStatusEnum;

  /** Indicates which side is the aggressor */
  AggressorSide: SideEnum;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** EID of this execution */
  EID: JSON_Int64ID;

  /** ClOrdID */
  ClOrdID: string;

  /** Internal ID of the quote; optional */
  QID: JSON_Int64ID;

  /** Currency ID for amount */
  AmountCurrency: string;

  /** Currency ID for dealt currency */
  DealtCurrency: string;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** The service originating the child order */
  ParentService: JSON_ServiceIdentifier;

  /** Organization ID */
  OrgID: number;

  /** Talos fee */
  TalosFee: JSON_Decimal;

  /** Currency ID for the Talos fee */
  TalosFeeCurrency: string;

  /** The date and time desired for settlement in number of nanoseconds since Unix epoch. (optional) */
  SettleDate: JSON_UTCTimestamp;

  /** (optional) The concrete type of the Confirm field payload. */
  ConfirmType: string;

  /** Miscellaneous transaction attributes */
  Attributes: unknown;

  /** Fixing details for spread to fixing */
  FixingDetails: number;

  /** (required if ConfirmTypeID is set) Confirm payload message */
  Confirm: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/**  */
export interface IExecutionReportStale {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** Timestamp of the update as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** ExecTypeStale */
  ExecType: number;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** ExecutionReportRestate indicates that the order has changed */
export interface IExecutionReportRestate {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Security ID */
  Symbol: JSON_Security;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** OrderID of this order at the market */
  OrderID: string;

  /** ClOrdID of this order at the market */
  ClOrdID: string;

  /** ExecID of this execution at the market */
  ExecID: string;

  /** Order entry time as provided by the submitter of the order in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** ExecTypeRestated */
  ExecType: number;

  /** Limit price */
  Price: JSON_Decimal;

  /** Organization ID */
  OrgID: number;

  /** Source message for this update */
  MessageID: IMessageID;
}

/** (TenantID:OrgID) OrderRequest */
export interface IOrderRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** SessionID for this outgoing message. */
  SessionID: JSON_Int64ID;

  /** Unique RequestID for this outgoing message. */
  RequestID: number;

  /** Market ID */
  Market: JSON_Market;

  /** Connection ID */
  ConnectionID: number;

  /** Credential ID */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** ClOrdID of the request */
  ClOID: JSON_Int64ID;

  /** Type of request to make */
  RequestType: RequestTypeEnum;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Side */
  Side: SideEnum;

  /** QID */
  QID: JSON_Int64ID;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** The SubmitTime of the originating request, if available, in number of nanoseconds since Unix epoch */
  SubmitTime: JSON_UTCTimestamp;

  /** Organization ID */
  OrgID: number;

  /** QuoteID given by the venue */
  QuoteID: string;
}

/** OrderRequestReject */
export interface IOrderRequestReject {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Credential ID */
  CredentialID: number;

  /** Security ID */
  Symbol: JSON_Security;

  /** OID of the order */
  OID: JSON_Int64ID;

  /** ClOrdID of the request */
  ClOID: JSON_Int64ID;

  /** Type of request to make */
  RequestType: RequestTypeEnum;

  /** Order reject reason */
  OrdRejReason: OrdRejReasonEnum;

  /** Cancel reject reason */
  CxlRejReason: CxlRejReasonEnum;

  /** Cancel reject response to */
  CxlRejResponseTo: CxlRejResponseToEnum;

  /** Parent OMS order OrderID */
  ParentOrderID: string;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;
}

/** OrderRecord records that an unsolicited order was received */
export interface IOrderRecord {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Security ID */
  Symbol: JSON_Security;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** OrderID */
  OID: JSON_Int64ID;

  /** OrderID */
  OrderID: string;

  /** ClOrdID */
  ClOrdID: string;

  /** OrigClOrdID */
  OrigClOrdID: string;

  /** Execution time in number of nanoseconds since Unix epoch */
  TransactTime: JSON_UTCTimestamp;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;
}

/** TradesSnapshot indicates the start or end of a trades snapshot */
export interface ITradesSnapshot {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of the connection used */
  CredentialID: number;

  /** EntryType */
  EntryType: SnapshotBlockEntryTypeEnum;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;
}

/** Realtime balances generated by exchange balance snapshots and realtime trades */
export interface IRealtimeBalance {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Account ID of the account holding the balance */
  DeprecatedAccountID: number;

  /** Market ID */
  Market: JSON_Market;

  /** Used before Account ID's are used universally */
  CredentialID: number;

  /** Organization ID */
  OrgID: number;

  /** Number of balance entries */
  Balances: IRealtimeBalance5100Balances[];
}

/** Number of balance entries */
export interface IRealtimeBalance5100Balances {
  /** Latest time this balance was updated */
  LastUpdateTime: JSON_UTCTimestamp;

  /** Message type indicating snapshot or update */
  BalanceEntryType: BalanceEntryTypeEnum;

  /** The Currency of the balance entry, if non-zero */
  Currency: string;

  /** Realtime amount including all trade executions */
  Amount: JSON_Decimal;

  /** Available amount not tied up in open orders */
  AvailableAmount: JSON_Decimal;

  /** Available margin */
  AvailableMargin: JSON_Decimal;

  /** Amount of open orders on the buy side */
  OutstandingBuy: JSON_Decimal;

  /** Amount of open orders on the sell side */
  OutstandingSell: JSON_Decimal;

  /** Account */
  Account: string;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Pending withdrawal amount (currently used for customer balances) */
  PendingWithdrawal: JSON_Decimal;

  /** Initial Margin */
  InitialMargin: JSON_Decimal;

  /** Maintenance Margin */
  MaintenanceMargin: JSON_Decimal;

  /** Equity */
  Equity: JSON_Decimal;

  /** The total delta accross all options positions in this currency */
  OptionsDelta: JSON_Decimal;

  /** The total delta accross all positions in this currency */
  TotalDelta: JSON_Decimal;

  /** The total unsettled position in this currency */
  UnsettledAmount: JSON_Decimal;

  /** MarginReportingType */
  MarginReportingType: MarginReportingTypeEnum;

  /** The blockchain chain id on which this currency's balance exists */
  ChainID: number;

  /** Unavailable Amount tied up in some yielding position */
  YieldingAmount: JSON_Decimal;

  /** Borrowed amount for margin trading (principal only) */
  BorrowAmount: JSON_Decimal;
}

/** Deprecated CreditExposure5101 contains information about current credit limit against the venue */
export interface IDeprecratedCreditExposure {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Credential associated with this account. 0 if this is an external account */
  CredentialID: number;

  /** Unique ID of the account */
  MarketAccountID: number;

  /** Currency ID for exposure */
  ExposureCurrency: string;

  /** Total exposure with given market expressed in exposure currency */
  TotalExposure: JSON_Decimal;

  /** Exposure limit set by the venue expressed in exposure currency */
  ExposureLimit: JSON_Decimal;

  /** Organization ID */
  OrgID: number;
}

/** ExposureLimit5102 represents user defined exposure limit with the venue */
export interface IExposureLimit {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** CounterpartyID */
  Counterparty: JSON_Counterparty;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Enable/disable exposure limit */
  Mode: ModeEnum;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** Currency that all exposure values are expressed in */
  ExposureCurrency: string;

  /** Asset currency. May be 0 if limit is global. */
  Currency: string;

  /** Exposure limit expressed in ExposureCurrencyID */
  Qty: JSON_Decimal;

  /** Exposure limit ID */
  ExposureLimitID: JSON_Int64ID;

  /** Exposure definition ID */
  ExposureDefinition: JSON_ExposureDefinition;

  /** Revision */
  Revision: number;

  /** Organization ID */
  OrgID: number;

  /** User who performed an update of that entity */
  UpdateUser: JSON_User;

  /** Side of the Exposure */
  ExposureSide: ExposureLimitSideTypeEnum;
}

/** ExposureDefinition5103 represents client understanding of exposure */
export interface IExposureDefinition {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** ID of aggregation used to calculate total exposure. Currently always set to 0 */
  AggregationID: number;

  /** Exposure calculation type */
  CalculationType: ExposureCalculationTypeEnum;

  /** Exposure definition source */
  Source: ExposureSourceEnum;

  /** Exposure definition ID */
  ExposureDefinition: JSON_Int64ID;

  /** Revision */
  Revision: number;

  /** Name of the exposure definition */
  Name: string;

  /** DisplayName of the exposure definition */
  DisplayName: string;

  /** List of currency weights for exposure definition */
  CurrencyWeights: IExposureDefinition5103CurrencyWeights[];
}

/** List of currency weights for exposure definition */
export interface IExposureDefinition5103CurrencyWeights {
  /** Currency ID */
  Currency: string;

  /** Value between 0 and 1 indicating what friction of outstanding balance should be used in calculating total exposure. 0 means do not use balance with given currency ID (effectively home currency) */
  Weight: JSON_Decimal;
}

/** MarketConnection is a connection configured by the user */
export interface IMarketConnection {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Market ID */
  Market: JSON_Market;

  /** Unique ID of this connection */
  ConnectionID: number;

  /** Type of functionality supported by this connection */
  ConnectionType: Record<ConnectionTypeEnum, boolean>;

  /** Optional credential to be used by this connection, if 0 then this is a public connection */
  CredentialID: number;

  /** The connection mode (Up / Down) */
  Mode: ConnectionModeEnum;

  /** The restart counter, increasing this number will cause a restart */
  RestartCounter: number;

  /** If equal to requested RestartCounter, the gateway should force a seq num reset on FIX connections */
  ResetSeqNumOnRestart: number;

  /** Detailed functionality supported by this connection */
  ConnectionDetails: Record<ConnectionDetailsEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** Revision */
  Revision: number;

  /** The nudge counter, increasing this number will cause a nudge on the sub-connections that support it */
  NudgeCounter: number;
}

/** MarketExposure5104 contains information about current credit limit against the market */
export interface IMarketExposure {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Timestamp as provided by remote in number of nanoseconds since Unix epoch. May be zero if not provided by remote. */
  TransactTime: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Credential associated with this account. 0 if this is an external account */
  CredentialID: number;

  /** Unique ID of the account */
  MarketAccount: JSON_MarketAccount;

  /** CounterpartyID */
  Counterparty: JSON_Counterparty;

  /** Current exposure quantity expressed in exposure currency */
  Exposure: JSON_Decimal;

  /** Current exposure limit expressed in exposure limit currency */
  ExposureLimit: JSON_Decimal;

  /** Asset currency. May be 0 if exposure is global. */
  Currency: string;

  /** Currency that all exposure values are expressed in */
  ExposureCurrency: string;

  /** Status of exposure */
  Status: ExposureStatusEnum;

  /** Exposure definition ID */
  ExposureDefinition: JSON_ExposureDefinition;

  /** Side of the Exposure */
  ExposureSide: ExposureLimitSideTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** Asset for the market exposure. Can represent currency or symbol. Can be 0 if exposure is global. */
  Asset: string;
}

/** ConnectionStatus reports the status of a connection */
export interface IConnectionStatus {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** ConnectionID for this session */
  ConnectionID: number;

  /** Type of functionality supported by this connection */
  ConnectionType: Record<ConnectionTypeEnum, boolean>;

  /** Optional credential to be used by this connection, if 0 then this is a public connection */
  CredentialID: number;

  /** Status of this connection */
  Status: ConnectionStatusEnum;

  /** ErrorCode for this connection */
  ErrorCode: ConnectionErrorCodeEnum;

  /** Organization ID */
  OrgID: number;

  /** Error message text. Multiple errors are newline delimited. */
  Text: string;
}

/** View Request for Exposure feed */
export interface IExposureViewRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;

  /** Tolerance of Exposure Changes */
  Tolerance: JSON_Decimal;

  /** Frequency of exposure updates based on conversion rate change */
  Throttle: JSON_DurationMillis;

  /** Debug and additional flags */
  Debug: Record<AggregatorDebugFlagEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** List of counterparty IDs */
  CounterpartyIDs: IExposureViewRequest5105CounterpartyIDs[];

  /** List of calculation types */
  CalculationTypes: IExposureViewRequest5105CalculationTypes[];
}

/** List of calculation types */
export interface IExposureViewRequest5105CalculationTypes {
  /** Exposure calculation type */
  CalculationType: ExposureCalculationTypeEnum;
}

/** List of counterparty IDs */
export interface IExposureViewRequest5105CounterpartyIDs {
  /** ID of the counterparty */
  Counterparty: JSON_Counterparty;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** Request a replay */
export interface IReplayRequest {
  /** Unique RequestID */
  RequestID: number;

  /** ReplayRequestType */
  ReplayRequestType: ReplayRequestTypeEnum;

  /** StreamID */
  StreamID: number;

  /** ReplayStreamID */
  ReplayStreamID: number;

  /** Start RecordingID when replaying multiple recordings */
  StartRecordingID: number;

  /** Position to start the replay from, negative values indicate offsets from head */
  StartPosition: number;

  /** ReplayID of an existing recording if stopping */
  ReplayID: number;

  /** ResponseStreamID */
  ResponseStreamID: number;

  /** Aeron ClientID of the requestor */
  ClientID: number;

  /** Channel */
  Channel: string;

  /** ReplayChannel */
  ReplayChannel: string;

  /** ResponseChannel */
  ResponseChannel: string;
}

/** Exposure changes for the View */
export interface IExposureView {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of MarketView */
  ViewID: JSON_Int64ID;

  /** CounterpartyID */
  Counterparty: JSON_Counterparty;

  /** Current exposure quantity expressed in ExposureCurrency. Set only if CurrencyID is 0 */
  Exposure: JSON_Decimal;

  /** Current exposure limit expressed in exposure currency */
  ExposureLimit: JSON_Decimal;

  /** Current exposure quantity delivered by market */
  MarketExposure: JSON_Decimal;

  /** Current exposure limit delivered by market */
  MarketLimit: JSON_Decimal;

  /** Current available quantity expressed in exposure currency */
  Available: JSON_Decimal;

  /** Currency that all exposure values except Balance are expressed in */
  ExposureCurrency: string;

  /** Asset currency. May be 0 if exposure is in security or global. */
  Currency: string;

  /** Asset security. May be 0 if exposure is in currency or global. */
  Symbol: JSON_Security;

  /** Status of exposure */
  Status: ExposureStatusEnum;

  /** Exposure definition ID */
  ExposureDefinition: JSON_ExposureDefinition;

  /** Current available quantity to buy expressed in exposure currency */
  AvailableBuy: JSON_Decimal;

  /** Current available quantity to sell expressed in exposure currency */
  AvailableSell: JSON_Decimal;

  /** Current balance of the CurrencyID expressed in CurrencyID. Set only if CurrencyID is not 0 */
  Balance: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Side of the Exposure */
  ExposureSide: ExposureLimitSideTypeEnum;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;
}

/** Request the status of a connection for a market */
export interface IConnectionStatusRequest {
  /** The ID of the snapshot request */
  RequestID: number;

  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Market ID */
  Market: JSON_Market;

  /** Optional CredentialID for this Connection */
  ConnectionID: number;

  /** Organization ID */
  OrgID: number;
}

/** Ack for a replay request */
export interface IReplayAck {
  /** Unique RequestID */
  RequestID: number;

  /** ReplayAckType */
  ReplayAckType: ReplayAckTypeEnum;

  /** ReplayID */
  ReplayID: number;

  /** RecordingID being replayed */
  RecordingID: number;

  /** The original sessionID to be replayed */
  SessionID: number;

  /** The current head of the replay */
  HeadPosition: number;

  /** The end position of the replay, or -1 if the recording is live */
  EndPosition: number;

  /** Position that the replay starts from in the given recording */
  StartPosition: number;
}

/** View Request for BuyingPower feed */
export interface IBuyingPowerViewRequest {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Unique ID representing this Request */
  ViewRequestID: JSON_Int64ID;

  /** Stable ID of Requesting Client Process */
  ClientID: JSON_Int64ID;

  /** Unique ID of this session */
  SessionID: JSON_Int64ID;

  /** ID of Subscription */
  SubscriptionID: JSON_Int64ID;

  /** Security ID */
  Symbol: JSON_Security;

  /** Frequency of buying power updates */
  Throttle: JSON_DurationMillis;

  /** Enable or disable unified liquidity feature. */
  UnifiedLiquidity: UnifiedLiquidityEnum;

  /** Debug and additional flags */
  Debug: Record<AggregatorDebugFlagEnum, boolean>;

  /** Organization ID */
  OrgID: number;

  /** List of counterparty IDs */
  CounterpartyIDs: IBuyingPowerViewRequest5107CounterpartyIDs[];
}

/** List of counterparty IDs */
export interface IBuyingPowerViewRequest5107CounterpartyIDs {
  /** ID of the counterparty */
  Counterparty: JSON_Counterparty;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;
}

/** Query For Market Data Snapshot + Updates */
export interface IMarketDataQuery {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** Must be unique, or the ID of previous MarketDataRequest to unsubscribe */
  MDReqID: number;

  /** SubscriptionRequestType, e.g. where to subscribe or unsubscribe */
  SubscriptionRequestType: SubscriptionRequestTypeEnum;

  /** Query */
  Query: string;
}

/** Request a recording, requests are idempotent. */
export interface IRecordRequest {
  /** Unique RequestID */
  RequestID: number;

  /** RecordRequestType */
  RecordRequestType: RecordRequestTypeEnum;

  /** StreamID */
  StreamID: number;

  /** SessionID */
  SessionID: number;

  /** ResponseStreamID */
  ResponseStreamID: number;

  /** Aeron ClientID of the requestor */
  ClientID: number;

  /** Channel */
  Channel: string;

  /** ResponseChannel */
  ResponseChannel: string;
}

/** Buying power updates */
export interface IBuyingPowerView {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of MarketView */
  ViewID: JSON_Int64ID;

  /** CounterpartyID */
  Counterparty: JSON_Counterparty;

  /** Security ID */
  Symbol: JSON_Security;

  /** Currency that AvailableBuy and AvailableSell are expressed in */
  Currency: string;

  /** Current available quantity to buy expressed in currency */
  AvailableBuy: JSON_Decimal;

  /** Current available quantity to sell expressed in currency */
  AvailableSell: JSON_Decimal;

  /** Status of buying power */
  Status: ExposureStatusEnum;

  /** Current available quantity to buy respecting trading windows expressed in CurrencyID */
  MaxBuyOrderSize: JSON_Decimal;

  /** Current available quantity to sell respecting trading windows expressed in CurrencyID */
  MaxSellOrderSize: JSON_Decimal;

  /** Selected MarketAccount */
  MarketAccount: JSON_MarketAccount;

  /** Organization ID */
  OrgID: number;

  /** Text */
  Text: string;
}

/** An identifier for the underlying resources hosting orgs in a multi-tenant environment */
export interface ISystem {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of system */
  ID: number;

  /** Unique name for this system used as an external identifier */
  Name: string;

  /** Last updated by user */
  UpdateUser: JSON_User;

  /** Revision of the system to be updated */
  Revision: number;

  /** Unique human readable name for this system */
  DisplayName: string;
}

/** Ack for a record request indicating recording has started */
export interface IRecordAck {
  /** Unique RequestID */
  RequestID: number;

  /** RecordAckType */
  RecordAckType: RecordAckTypeEnum;

  /** The recordingID of the started recording */
  RecordingID: number;
}

/** Internal representation of a business entity or institution that uses Talos platform for trading activities */
export interface IOrganization {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of organization */
  ID: number;

  /** Unique name for this system used across infrastructure */
  Name: string;

  /** ID of a system hosting this organization. null field mean organization is not hosted in multi-tenant system. */
  SystemID: number;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Revision of the system to be updated */
  Revision: number;

  /** Attributes (e.g. hasOrgVM) of this organization */
  Attrs: unknown;

  /** Human readable name for this system */
  DisplayName: string;
}

/** A user that can authenticate and act within an organization on the Talos platform */
export interface IUser {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the user */
  ID: number;

  /** ID of the organization this user belongs to */
  OrganizationID: number;

  /** Last updated by user */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Unique Auth0 identifier for this user */
  Auth0ID: string;

  /** Name of the user */
  Name: string;

  /** Email address of the user */
  Email: string;

  /** Type of user (e.g. user, monitor) */
  Type: string;

  /** Audit comment for the most recent update */
  Comment: string;
}

/** A role granted to a user, controlling their permissions on the Talos platform */
export interface IUserRole {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the user role */
  ID: number;

  /** ID of the user this role belongs to */
  User: JSON_User;

  /** Last updated by user */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Name of the role (e.g. talos.admin, org.trader) */
  Name: string;

  /** Audit comment for the most recent update */
  Comment: string;
}

/** An API key/secret credential a user authenticates programmatic access with */
export interface IApiKey {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the API key */
  ID: number;

  /** ID of the user this API key belongs to */
  User: JSON_User;

  /** Last updated by user */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Public API key identifier */
  Key: string;

  /** API key secret */
  Secret: string;

  /** Comma-separated list of IPs allowed to use this key */
  WhitelistedIPs: string;

  /** Audit comment for the most recent update */
  Comment: string;
}

/** A role granted to an API key, controlling its permissions on the Talos platform */
export interface IApiKeyRole {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the API key role */
  ID: number;

  /** ID of the API key this role belongs to */
  APIKeyID: number;

  /** ID of the user that owns the API key */
  User: JSON_User;

  /** Last updated by user */
  UpdateUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Name of the role (e.g. org.trader) */
  Name: string;

  /** Audit comment for the most recent update */
  Comment: string;
}

/** An authenticated session for a user on the Talos platform */
export interface IUserSession {
  /** Internal time in number of nanoseconds since Unix epoch */
  Timestamp: JSON_UTCTimestamp;

  /** ID of the user session */
  ID: number;

  /** ID of the user this session belongs to */
  User: JSON_User;

  /** ID of the user this session has morphed into, or 0 if not morphed */
  MorphUser: JSON_User;

  /** Update action */
  UpdateAction: UpdateActionEnum;

  /** Internal time the session unmorphed in number of nanoseconds since Unix epoch, or 0 if still morphed */
  UnmorphedAt: JSON_UTCTimestamp;

  /** Opaque session identifier */
  SessionID: string;
}

/** Source message for this update */
export interface IMessageID {
  /** session */
  SessionID: JSON_Int64ID;

  /** system sequence number */
  SequenceNo: number;

  /** source sequence number */
  SourceSequenceNo: number;
}

/** Transaction subject contains authentication information about the entity that requested the transaction */
export interface ITransactionSubject {
  /** Counterparty is a subject for that transaction */
  CounterpartyID: number;

  /** Customer user is a subject for that transaction */
  CustomerUserID: number;

  /** User is a subject for that transaction */
  UserID: number;

  /** Organization is a subject for that transaction */
  OrgID: number;
}

/** ResourceKey identifying the resource */
export interface IResourceKey {
  /** SBE Template ID uniquely identifying message type */
  TemplateID: number;

  /** Single-letter tag uniquely identifying ResourceName within message */
  ResourceTag: number;
}

/*
 * These are hard-coded types to match the marshalling defined
 * in 'gocode/json/semanticmarshaller.go'.
 */

/** UTC Timestamp in ISO8601 format */
export type JSON_UTCTimestamp = string;

/** Human readable form, e.g. '72h3m0.5s' */
export type JSON_DurationMillis = string;

/**
 * Crockford Base 32 encoded number
 *
 * @description
 * Don't try to parse this value, treat it purely as an opaque string id
 */
export type JSON_Int64ID = string;

/** Decimal value in a string */
export type JSON_Decimal = string | undefined;

/** Decimal128 value in a string */
export type JSON_Dec128 = string | undefined;

/** Aggregation.name */
export type JSON_Aggregation = string;

/** Security.name
 * @link JSON_Security */
export type JSON_AllowedCrossCurrencies = JSON_Security[];

/** Market.name
 * @link JSON_Market */
export type JSON_AllowedCrossMarkets = JSON_Market[];

/** Counterparty.name */
export type JSON_Counterparty = string;

/** CustomerMarketDataSnapshot.Bids **/
export type JSON_CustomerBids = {
  Price: JSON_Decimal;
  Size: JSON_Decimal;
}[];

/** CustomerMarketDataSnapshot.SizeBuckets.Bucket **/
export type JSON_CustomerMarketDataSnapshotSizeBuckets = JSON_Decimal[];

/** CustomerMarketData.Offers **/
export type JSON_CustomerOffers = {
  Price: JSON_Decimal;
  Size: JSON_Decimal;
}[];

/** Bucket.size */
export type JSON_CustomerSecuritySizeBuckets = string[];

/** CustomerUser.email */
export type JSON_CustomerUser = string;

/** MarketAccount.name for principal; MarketAccount.source_account_id for customer */
export type JSON_CustomerMarketAccount = string;

/** StrategyParameter.EnumValues **/
export type JSON_EnumValues = {
  Index: number;
  Name: string;
  Description: string;
}[];

/** ESignCreateAndSend.Recipients **/
export type JSON_ESignCreateAndSendRecipients = {
  LegalName: string;
  DeliveryID: string;
  Role: string;
}[];

/** ESignCreateAndSend.Tabs **/
export type JSON_ESignCreateAndSendTabs = {
  Label: string;
  Value: string;
}[];

/** ESignStatus.Recipients **/
export type JSON_ESignRecipients = {
  LegalName: string;
  DeliveryID: string;
  Role: string;
  Status: string;
  Timestamp: JSON_UTCTimestamp;
};

/** IApiPermissionFilter.Subject **/
export type JSON_ApiPermissionSubject = {
  User: JSON_User | undefined;
  SubAccount: JSON_SubAccount | undefined;
};

/** IApiPermissionFilter.Filter **/
export type JSON_ApiPermissionFilterSpec = {
  SubAccount: JSON_SubAccount | undefined;
  MarketAccount: JSON_MarketAccount | undefined;
  ABORMarketAccount: JSON_MarketAccount | undefined;
};

/** ExposureDefinition.name */
export type JSON_ExposureDefinition = string;

/** Participant.name
 * @link JSON_Participant */
export type JSON_Lenders = JSON_Participant[];

/** Market.name */
export type JSON_Market = string;

/** MarketAccount.name */
export type JSON_MarketAccount = string;

/** ESignGateway.name */
export type JSON_ESignGateway = string;

/** Index.name */
export type JSON_Index = string;

/** UpdateMarketData.Bids **/
export type JSON_InternalBids = {
  Price: JSON_Decimal;
  Size: JSON_Decimal;
}[];

/** UpdateMarketData.Offers **/
export type JSON_InternalOffers = {
  Price: JSON_Decimal;
  Size: JSON_Decimal;
}[];

/** Participant.name */
export type JSON_Participant = string;

/** Security.symbol
 * @link JSON_Security */
export type JSON_PricingRuleAllowedCrossCurrencies = JSON_Security[];

/** Market.name
 * @link JSON_Market */
export type JSON_PricingRuleAllowedCrossMarkets = JSON_Market[];

/** Security.symbol */
export type JSON_Security = string;

/** MarketSecurityMode.SizeBuckets.Size */
export type JSON_SecurityModeSizeBuckets = string[];

/** Security.SizeBuckets.Size */
export type JSON_SecuritySizeBuckets = string[];

/** Strategy.Name */
export type JSON_Strategy = string;

/** SubAccount.name */
export type JSON_SubAccount = string;

/** User.name */
export type JSON_User = string;

/**
 * Extended duration format supporting calendar units (Y, M, D) and time units (h, m, s, ms)
 * @example "2Y5M3D", "30D", "1h30m", "-1Y"
 * @see https://github.com/talostrading/Ava/blob/staging/gocode/sbe/sbe_extendedduration_test.go
 * @note Use only the specific patterns your project requires - avoid unnecessary complexity
 */
export type JSON_ExtendedDuration = string;

/** Date-only format supporting "YYYY-MM-DD" */
export type JSON_DateOnly = string;

/** Time-only format supporting "HH:mm" and "HH:mm:ss" */
export type JSON_TimeOnly = string;

/** ServiceIdentifier **/
export type JSON_ServiceIdentifier = {
  ServiceID: number;
  PartitionID: number;
};

/** PricingTier */
export type JSON_PricingTier = string;

/** Base type for expandable RouteTargets options */
export interface JSON_RouteTarget_Base {
  Type: string;
}

/** Route Targets for Notifications */
export interface JSON_RouteTarget_User extends JSON_RouteTarget_Base {
  Type: 'User';
  Target: JSON_User;
}

/** Route to a saved notification destination (DeliveryType lives on the destination record) */
export interface JSON_RouteTarget_Destination extends JSON_RouteTarget_Base {
  Type: 'Destination';
  Target: JSON_Int64ID;
}

/** Discriminated Union of RouteTarget types */
export type JSON_RouteTarget = JSON_RouteTarget_User | JSON_RouteTarget_Destination;

/** CustomerNetAcquisitionLimit.name */
export type JSON_AcquisitionLimit = string;

/** CrossAssetRiskGroup.name */
export type JSON_CrossAssetRiskGroup = string;
